webpackJsonp([0],Array(500).concat([
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _config = __webpack_require__(547);

var cmsComponents = _interopRequireWildcard(_config);

var _utility = __webpack_require__(62);

var _cms = __webpack_require__(871);

var _cms2 = _interopRequireDefault(_cms);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentPage = function ContentPage(props) {
  var getClassName = function getClassName() {
    var pathname = props.location.pathname;

    var path = pathname === '/' ? 'home-page' : null;
    // set the page name as class name for the root level div.
    return (0, _utility.getPageName)(' ', path) || props.className;
  };

  return _react2.default.createElement(_cms2.default, _extends({}, props, {
    className: getClassName(),
    cmsComponents: cmsComponents
  }));
};

ContentPage.propTypes = {
  location: (0, _propTypes.shape)({}),
  className: _propTypes.string
};

ContentPage.defaultProps = {
  location: '',
  className: ''
};

exports.default = ContentPage;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _identity = __webpack_require__(564);

var _identity2 = _interopRequireDefault(_identity);

var _uniq = __webpack_require__(565);

var _uniq2 = _interopRequireDefault(_uniq);

var _flatten = __webpack_require__(604);

var _flatten2 = _interopRequireDefault(_flatten);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cache = {};

var makeClassList = function makeClassList(_ref) {
  var baseClass = _ref.baseClass,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === undefined ? [] : _ref$modifiers;

  if (!baseClass || typeof baseClass !== 'string') return baseClass;

  var mods = modifiers.filter(_identity2.default);
  var modifierClasses = mods.map(function (mod) {
    return baseClass + '--' + mod;
  });

  return [baseClass].concat(_toConsumableArray(modifierClasses)).join(' ');
};

var classNames = function classNames(_ref2) {
  var blk = _ref2.blk,
      elt = _ref2.elt,
      mix = _ref2.mix,
      _ref2$mods = _ref2.mods,
      mods = _ref2$mods === undefined ? [] : _ref2$mods,
      className = _ref2.className;

  var cacheKey = blk + '-' + elt + '-' + Array.from(mods || []).join('-') + '-' + mix + '-' + className;
  var fromCache = cache[cacheKey];
  if (fromCache) return fromCache;

  var classes = [];

  if (blk && elt) {
    classes.push(blk + '__' + elt);
  }

  if (blk && elt && mix) {
    var autoMix = mix + '__' + elt;
    classes.push(autoMix);

    if (mods.length) {
      classes.push(makeClassList({
        baseClass: autoMix,
        modifiers: mods
      }));
    }
  }

  if (!classes.length) {
    classes.push(blk);
  }

  if (mods.length) {
    classes[0] = makeClassList({
      baseClass: classes[0],
      modifiers: mods
    });
  }

  if (className) {
    classes.push(className);
  }

  var parsed = (0, _uniq2.default)((0, _flatten2.default)(classes.map(function (cls) {
    return cls.split(' ');
  }))).join(' ');
  cache[cacheKey] = parsed;
  return parsed;
};

exports.default = classNames;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _svgList = __webpack_require__(609);

var _svgList2 = _interopRequireDefault(_svgList);

__webpack_require__(738);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'asda-icon';

var Icon = function Icon(_ref) {
  var dataAutoId = _ref.dataAutoId,
      className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      asBrand = _ref.asBrand,
      name = _ref.name,
      rotate = _ref.rotate,
      children = _ref.children,
      onClickHandler = _ref.onClickHandler,
      style = _ref.style,
      id = _ref.id,
      label = _ref.label;

  var eltClass = (0, _classNames2.default)({
    blk: blk,
    className: className,
    mods: [color, size, 'rotate' + rotate, asBrand && 'brand']
  });
  return _react2.default.createElement('span', {
    role: 'button',
    tabIndex: '0',
    onClick: onClickHandler,
    onKeyPress: function onKeyPress(event) {
      return event.key === 13 ? onClickHandler() : null;
    },
    'data-auto-id': dataAutoId,
    className: eltClass
    // eslint-disable-next-line react/no-danger
    , dangerouslySetInnerHTML: { __html: _svgList2.default[name] || children },
    style: style,
    id: id,
    'aria-label': label
  });
};

Icon.propTypes = {
  children: _propTypes.node,
  dataAutoId: _propTypes.string,
  size: (0, _propTypes.oneOf)(['tiny', 'small', 'medium', 'regular', 'large']),
  color: (0, _propTypes.oneOf)(['green', 'red', 'blue', 'yellow', 'charcoal', 'dark-gray', 'gray', 'white']),
  asBrand: _propTypes.bool,
  className: _propTypes.string,
  name: _propTypes.string,
  rotate: (0, _propTypes.oneOf)(['0', '90', '180', '270']),
  onClickHandler: _propTypes.func,
  style: _propTypes.style,
  label: _propTypes.string
};

Icon.defaultProps = {
  children: null,
  dataAutoId: '',
  size: 'regular',
  asBrand: false,
  className: '',
  name: '',
  rotate: '0',
  color: 'charcoal',
  onClickHandler: function onClickHandler() {},
  style: {},
  label: ""
};

exports.default = (0, _react.memo)(Icon);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(527);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickHandlerPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(182);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

__webpack_require__(760);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var blk = 'asda-link';

var Link = function Link(_ref) {
  var category = _ref.category,
      asButton = _ref.asButton,
      asAnchor = _ref.asAnchor,
      type = _ref.type,
      href = _ref.href,
      target = _ref.target,
      align = _ref.align,
      disabled = _ref.disabled,
      standalone = _ref.standalone,
      clickHandler = _ref.clickHandler,
      dataAutoId = _ref.dataAutoId,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['category', 'asButton', 'asAnchor', 'type', 'href', 'target', 'align', 'disabled', 'standalone', 'clickHandler', 'dataAutoId', 'className', 'children']);

  var eltClass = (0, _classNames2.default)({
    blk: blk,
    className: className,
    mods: [category, disabled && 'disabled', standalone && 'standalone', standalone && align && 'align-' + align, asButton && 'button']
  });

  if (asButton) {
    return (
      // eslint-disable-next-line react/button-has-type
      _react2.default.createElement(
        'button',
        _extends({
          type: type,
          'data-auto-id': dataAutoId,
          className: eltClass,
          onClick: clickHandler,
          disabled: disabled,
          'aria-disabled': disabled
        }, rest),
        children
      )
    );
  }

  if (asAnchor) {
    return _react2.default.createElement(
      'a',
      _extends({
        'data-auto-id': dataAutoId,
        href: href,
        target: target,
        className: eltClass,
        onClick: clickHandler
      }, rest),
      children
    );
  }

  return _react2.default.createElement(
    _reactRouterDom.NavLink,
    {
      to: href,
      className: eltClass,
      'data-auto-id': dataAutoId
    },
    children
  );
};

var clickHandlerPropType = exports.clickHandlerPropType = function clickHandlerPropType(props) {
  var asButton = props.asButton,
      clickHandler = props.clickHandler;

  if (asButton && (clickHandler === undefined || typeof clickHandler !== 'function')) {
    return new Error('Required prop clickHandler was not specified in Link Component');
  }
  return null;
};

Link.propTypes = {
  category: (0, _propTypes.oneOf)(['primary', 'secondary', 'clear']),
  type: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  align: _propTypes.string,
  asButton: _propTypes.bool,
  asAnchor: _propTypes.bool,
  href: _propTypes.string,
  target: _propTypes.string,
  disabled: _propTypes.bool,
  standalone: _propTypes.bool,
  dataAutoId: _propTypes.string,
  className: _propTypes.string,
  children: _propTypes.node.isRequired,
  // eslint-disable-next-line react/require-default-props
  clickHandler: clickHandlerPropType
};

Link.defaultProps = {
  category: 'primary',
  align: '',
  type: 'button',
  asButton: false,
  asAnchor: false,
  href: '/',
  target: '_self',
  disabled: false,
  standalone: false,
  dataAutoId: '',
  className: ''
};

exports.default = (0, _react.memo)(Link);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(572),
    getValue = __webpack_require__(577);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(182);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _loading = __webpack_require__(844);

var _loading2 = _interopRequireDefault(_loading);

__webpack_require__(848);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var blk = 'asda-btn';

var Button = function Button(_ref) {
  var dataAutoId = _ref.dataAutoId,
      type = _ref.type,
      category = _ref.category,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      target = _ref.target,
      outline = _ref.outline,
      loading = _ref.loading,
      loadingWithLabel = _ref.loadingWithLabel,
      asAnchor = _ref.asAnchor,
      asLink = _ref.asLink,
      isIcon = _ref.isIcon,
      fluid = _ref.fluid,
      disabled = _ref.disabled,
      clickHandler = _ref.clickHandler,
      rest = _objectWithoutProperties(_ref, ['dataAutoId', 'type', 'category', 'children', 'className', 'href', 'target', 'outline', 'loading', 'loadingWithLabel', 'asAnchor', 'asLink', 'isIcon', 'fluid', 'disabled', 'clickHandler']);

  var eltClass = (0, _classNames2.default)({
    blk: blk,
    className: className,
    mods: [!outline && category, fluid && 'fluid', disabled && 'disabled', loading && 'loading', isIcon && 'icon', outline && !isIcon && category + '-outline', outline && isIcon && category + '-outline', outline && isIcon && 'icon-outline']
  });

  if (asAnchor) {
    return _react2.default.createElement(
      'a',
      _extends({
        'data-auto-id': dataAutoId,
        href: href,
        className: eltClass,
        target: target
      }, rest),
      children
    );
  }

  if (asLink) {
    return _react2.default.createElement(
      _reactRouterDom.NavLink,
      {
        'data-auto-id': dataAutoId,
        to: href,
        className: eltClass
      },
      children
    );
  }

  return (
    // eslint-disable-next-line react/button-has-type
    _react2.default.createElement(
      'button',
      {
        'data-auto-id': dataAutoId,
        type: type,
        className: eltClass,
        'aria-disabled': disabled,
        disabled: disabled,
        onClick: clickHandler
      },
      _react2.default.createElement(_loading2.default, {
        loading: loading,
        loadingWithLabel: loadingWithLabel,
        outline: outline,
        category: category
      }),
      children
    )
  );
};

Button.propTypes = {
  dataAutoId: _propTypes.string,
  type: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  category: (0, _propTypes.oneOf)(['primary', 'secondary', 'clear', 'plain']),
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  href: _propTypes.string,
  target: _propTypes.string,
  outline: _propTypes.bool,
  loading: _propTypes.bool,
  loadingWithLabel: _propTypes.bool,
  asAnchor: _propTypes.bool,
  asLink: _propTypes.bool,
  isIcon: _propTypes.bool,
  fluid: _propTypes.bool,
  disabled: _propTypes.bool,
  clickHandler: _propTypes.func
};

Button.defaultProps = {
  dataAutoId: '',
  type: 'button',
  category: 'primary',
  className: '',
  href: '/',
  target: '_self',
  outline: false,
  loading: false,
  loadingWithLabel: false,
  asAnchor: false,
  asLink: false,
  isIcon: false,
  fluid: false,
  disabled: false,
  clickHandler: function clickHandler() {}
};

exports.default = (0, _react.memo)(Button);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(510),
    getRawTag = __webpack_require__(573),
    objectToString = __webpack_require__(574);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BLOCK = exports.BLOCK = 'co-item';
var LINKTO = exports.LINKTO = window.location.host === 'www.asda.com' ? 'https://groceries.asda.com' : 'https://groceries-qa.asda.com';
var fsl = exports.fsl = BLOCK + '-fsl';
var UNAVAILABLE_BLOCK = exports.UNAVAILABLE_BLOCK = 'unavailable-banner';
var PILL_BLOCK = exports.PILL_BLOCK = 'asda-pill';

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(505);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(503);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(529);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(589);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 514 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkSavePrimaryBanner = exports.Price = exports.WasPrice = exports.PricePerUOM = exports.Promo = exports.Rating = exports.Title = exports.Volume = exports.default = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _volume = __webpack_require__(764);

var _volume2 = _interopRequireDefault(_volume);

var _title = __webpack_require__(765);

var _title2 = _interopRequireDefault(_title);

var _rating = __webpack_require__(766);

var _rating2 = _interopRequireDefault(_rating);

var _promo = __webpack_require__(781);

var _promo2 = _interopRequireDefault(_promo);

var _pricePerUom = __webpack_require__(827);

var _pricePerUom2 = _interopRequireDefault(_pricePerUom);

var _wasPrice = __webpack_require__(828);

var _wasPrice2 = _interopRequireDefault(_wasPrice);

var _price = __webpack_require__(829);

var _price2 = _interopRequireDefault(_price);

var _linkSavePrimaryBanner = __webpack_require__(830);

var _linkSavePrimaryBanner2 = _interopRequireDefault(_linkSavePrimaryBanner);

__webpack_require__(839);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'co-product';

var Product = function Product(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _classNames2.default)({ blk: blk, className: className }) },
    children
  );
};

Product.propTypes = { className: _propTypes.string, children: _propTypes.node };
Product.defaultProps = { className: '', children: null };

exports.default = Product;
exports.Volume = _volume2.default;
exports.Title = _title2.default;
exports.Rating = _rating2.default;
exports.Promo = _promo2.default;
exports.PricePerUOM = _pricePerUom2.default;
exports.WasPrice = _wasPrice2.default;
exports.Price = _price2.default;
exports.LinkSavePrimaryBanner = _linkSavePrimaryBanner2.default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(797);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _utility = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */


var RichText = function (_Component) {
  _inherits(RichText, _Component);

  function RichText() {
    _classCallCheck(this, RichText);

    return _possibleConstructorReturn(this, (RichText.__proto__ || Object.getPrototypeOf(RichText)).apply(this, arguments));
  }

  _createClass(RichText, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = this.props.content;

      this.execEmbeddedScript(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var content = this.props.content;

      var htmlcontent = (0, _utility.unescapeHtml)(content);
      return _react2.default.createElement('div', {
        'data-module': this.props.name,
        'data-module-name': this.props.name,
        'data-module-id': this.props.moduleId,
        'data-module-type': this.props.type,
        className: 'rich-text',
        dangerouslySetInnerHTML: {
          __html: htmlcontent
        }
      });
    }
  }, {
    key: 'execEmbeddedScript',
    value: function execEmbeddedScript(data) {
      var scriptRegx = /<script>[^>]*([\s\S]+?)<\/script>/gi;
      var embeddedScript = scriptRegx.exec(data);
      if (embeddedScript && embeddedScript[0]) {
        var script = embeddedScript[0];
        script = script.replace(/<script>|<\/script>/gi, '');
        try {
          window.eval(script); // eslint-disable-line
        } catch (error) {
          /* eslint-disable no-console */
          console.error('Error in RichText while \'eval()\' script :: ' + error);
        }
      }
    }
  }]);

  return RichText;
}(_react.Component);

RichText.propTypes = {
  content: _propTypes.string.isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

RichText.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = RichText;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _bannerStatic = __webpack_require__(549);

var _bannerStatic2 = _interopRequireDefault(_bannerStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner = function Banner(_ref) {
  var _ref$moduleData = _ref.moduleData,
      altText = _ref$moduleData.altText,
      value = _ref$moduleData.linkDestination.clickThrough.value,
      imageUrl = _ref$moduleData.mediaURL.clickThrough.value,
      trackingCode = _ref$moduleData.trackingCode,
      className = _ref.className,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  var linkPath = { path: value };
  return _react2.default.createElement(_bannerStatic2.default, {
    link: linkPath,
    trackingCode: trackingCode,
    imageAlt: altText,
    mediaURL: imageUrl,
    className: className,
    name: name,
    type: type,
    moduleId: moduleId
  });
};

Banner.propTypes = {
  moduleData: (0, _propTypes.shape)({
    altText: _propTypes.string,
    linkDestination: (0, _propTypes.shape)({
      clickThrough: (0, _propTypes.shape)({
        value: _propTypes.string
      })
    }),
    mediaURL: (0, _propTypes.shape)({
      clickThrough: (0, _propTypes.shape)({
        value: _propTypes.string
      })
    }),
    trackingCode: _propTypes.string
  }).isRequired,
  className: _propTypes.string,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

Banner.defaultProps = {
  className: '',
  name: null,
  moduleId: null,
  type: null
};

exports.default = Banner;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(783),
    baseKeys = __webpack_require__(791),
    isArrayLike = __webpack_require__(535);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _utility = __webpack_require__(62);

var _constants = __webpack_require__(37);

var _footerLogo = __webpack_require__(875);

var _footerLogo2 = _interopRequireDefault(_footerLogo);

var _george = __webpack_require__(876);

var _george2 = _interopRequireDefault(_george);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = function Logo(_ref) {
  var color = _ref.color,
      children = _ref.children,
      isGeorgeUser = _ref.isGeorgeUser,
      homeUrl = _ref.homeUrl;

  if (color !== 'white') {
    return _react2.default.createElement(
      'a',
      { id: 'logo', href: isGeorgeUser ? _constants.GEORGE_URL : (0, _utility.getLogoLinkByHomeUrl)(homeUrl) },
      _react2.default.createElement(_icon2.default, { name: (0, _utility.getLogoNameByHomeUrl)(homeUrl), color: 'green', size: 'large' }),
      children
    );
  }
  return _react2.default.createElement('img', { src: isGeorgeUser ? _george2.default : _footerLogo2.default, alt: isGeorgeUser ? 'George' : 'ASDA' });
};

Logo.propTypes = {
  color: _propTypes.string,
  children: _propTypes.node,
  isGeorgeUser: _propTypes.bool,
  homeUrl: _propTypes.string
};

Logo.defaultProps = {
  color: '',
  children: null,
  homeUrl: '',
  isGeorgeUser: false
};

exports.default = Logo;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HamburgerMenu = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
var HamburgerMenu = exports.HamburgerMenu = function HamburgerMenu(_ref) {
  var dispatch = _ref.dispatch;
  return _react2.default.createElement(
    'div',
    { className: 'menu-hamburger' },
    _react2.default.createElement(
      'a',
      {
        'aria-label': 'main menu',
        id: 'nav-toggle',
        onClick: function onClick() {
          return dispatch({ type: 'TOGGLE_NAV' });
        }
      },
      _react2.default.createElement(_icon2.default, { name: 'menu', size: 'large' })
    )
  );
};

HamburgerMenu.propTypes = {
  dispatch: _propTypes.func.isRequired
};

exports.default = (0, _reactRedux.connect)()(HamburgerMenu);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/no-array-index-key */


var CMSModules = function CMSModules(_ref) {
  var _ref$contents = _ref.contents,
      contents = _ref$contents === undefined ? [] : _ref$contents,
      cmsComponents = _ref.cmsComponents,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['contents', 'cmsComponents', 'className']);

  return contents.map(function (zoneData, index) {
    var type = zoneData.type,
        configs = zoneData.configs,
        name = zoneData.name,
        moduleId = zoneData.moduleId;

    var Component = cmsComponents[type];

    if (!Component) {
      return null;
    }

    return _react2.default.createElement(Component, _extends({
      moduleData: configs
    }, rest, {
      name: name,
      moduleId: moduleId,
      type: type,
      key: type + '-' + index,
      modules: cmsComponents,
      className: className
    }));
  });
};

CMSModules.propTypes = {
  cmsComponents: (0, _propTypes.shape)({}),
  contents: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
};

exports.default = CMSModules;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-danger */
var LinkPromotion = function LinkPromotion(_ref) {
  var link = _ref.link,
      iconClass = _ref.iconClass,
      linkText = _ref.linkText,
      customImage = _ref.customImage,
      trackingCode = _ref.trackingCode;
  return _react2.default.createElement(
    'a',
    {
      className: 'link-promotion globalLink',
      href: link.path,
      'data-trackingcode': trackingCode
    },
    iconClass ? _react2.default.createElement('i', { className: iconClass }) : null,
    !iconClass && customImage ? _react2.default.createElement('img', { alt: '', src: customImage }) : null,
    _react2.default.createElement('span', {
      className: 'promo-link',
      dangerouslySetInnerHTML: { __html: linkText }
    })
  );
};

LinkPromotion.propTypes = {
  link: (0, _propTypes.shape)({
    path: _propTypes.string
  }),
  linkText: _propTypes.string.isRequired,
  iconClass: _propTypes.string,
  trackingCode: _propTypes.string,
  customImage: _propTypes.string
};

LinkPromotion.defaultProps = {
  link: {
    path: ''
  },
  iconClass: '',
  trackingCode: '',
  customImage: ''
};

exports.default = LinkPromotion;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsdaCustomLink = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRouterDom = __webpack_require__(182);

var _reactRedux = __webpack_require__(181);

var _utility = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsdaCustomLink = exports.AsdaCustomLink = function AsdaCustomLink(_ref) {
  var link = _ref.link,
      linkName = _ref.linkName,
      dispatch = _ref.dispatch,
      linkClass = _ref.linkClass;
  return _react2.default.createElement(
    'li',
    { className: 'custom-link' },
    /AsdaDotCom/i.test(link.path) ? _react2.default.createElement(
      _reactRouterDom.NavLink,
      {
        to: link.path.replace(/\/pages\/AsdaDotCom/gi, ''),
        activeClassName: 'selected',
        onClick: function onClick() {
          return dispatch({ type: 'CLOSE_LEFT_NAV' });
        }
      },
      linkName
    ) : _react2.default.createElement(
      'a',
      {
        className: linkClass || '',
        href: link.path.replace(/cmpid-pagename/gi, (0, _utility.getPageName)()),
        id: linkName
      },
      linkName
    )
  );
};

AsdaCustomLink.propTypes = {
  link: (0, _propTypes.shape)().isRequired,
  linkName: _propTypes.string.isRequired,
  dispatch: _propTypes.func,
  linkClass: _propTypes.string
};

AsdaCustomLink.defaultProps = {
  dispatch: function dispatch(x) {
    return x;
  },
  linkClass: ''
};

exports.default = (0, _reactRedux.connect)()(AsdaCustomLink);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(507),
    isObject = __webpack_require__(511);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 528 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(505),
    root = __webpack_require__(503);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(505),
    root = __webpack_require__(503);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(608),
    isObjectLike = __webpack_require__(514);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(741);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(526),
    isLength = __webpack_require__(536);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(507),
    isObjectLike = __webpack_require__(514);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentOS = undefined;

var _getCurrentOs = __webpack_require__(776);

var _getCurrentOs2 = _interopRequireDefault(_getCurrentOs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getCurrentOS = _getCurrentOs2.default;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(805),
    deburr = __webpack_require__(806),
    words = __webpack_require__(809);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var priceLabelToNumber = exports.priceLabelToNumber = function priceLabelToNumber() {
  var pricelabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var price = pricelabel;
  if (!price) return 0;
  if (typeof price === 'number') return price;
  price = price.replace(/[-£,$]/g, '');
  if (price.includes('p') > -1) {
    price = price.replace(/p/gi, '');
    price = Math.round(price);
    price = price.length === 1 ? '0' + price : price;
    price = '0.' + price;
  }
  return !Number.isNaN(parseFloat(price)) ? parseFloat(price) : 0;
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _redux = __webpack_require__(78);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _button = __webpack_require__(506);

var _button2 = _interopRequireDefault(_button);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _actions = __webpack_require__(183);

var profileActions = _interopRequireWildcard(_actions);

var _accountMenu = __webpack_require__(878);

var _accountMenu2 = _interopRequireDefault(_accountMenu);

var _constants = __webpack_require__(37);

var _analytics = __webpack_require__(114);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Profile = function Profile(_ref) {
  var isSignedIn = _ref.isSignedIn,
      getProfile = _ref.getProfile,
      signOut = _ref.signOut,
      isBabyClubHeader = _ref.isBabyClubHeader,
      isBabyClubMember = _ref.isBabyClubMember;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAccountMenu = _useState2[0],
      setShowAccountMenu = _useState2[1];

  var handleClick = function handleClick(e) {
    var _ref2 = e.target || {},
        _ref2$innerText = _ref2.innerText,
        innerText = _ref2$innerText === undefined ? '' : _ref2$innerText;

    (0, _analytics.trackSignalEvent)('RegisterLoginLinkClick', { buttonText: innerText, pageName: document.title });
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    isBabyClubMember && isBabyClubHeader || !isBabyClubHeader && isSignedIn ? _react2.default.createElement(
      'li',
      { className: 'sign-in_btn' },
      _react2.default.createElement(
        _button2.default,
        {
          clickHandler: function clickHandler() {
            return setShowAccountMenu(!showAccountMenu);
          },
          className: 'asda-btn--plain profile-link acc-btn',
          disabled: showAccountMenu,
          dataAutoId: 'btnAccount'
        },
        'Your Account',
        _react2.default.createElement(_icon2.default, { name: 'chevron-down', size: 'small' })
      )
    ) : null,
    !isSignedIn || isBabyClubHeader && !isBabyClubMember ? _react2.default.createElement(
      _react.Fragment,
      null,
      !isBabyClubHeader && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _link2.default,
          {
            href: _constants.REGISTER_LINK,
            asAnchor: true,
            className: 'profile-link',
            onClick: handleClick,
            dataAutoId: 'btnRegister'
          },
          'Register'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'sign-in_btn' },
        _react2.default.createElement(
          _button2.default,
          {
            href: isBabyClubHeader && isSignedIn && !isBabyClubMember ? _constants.BTC_REGISTER_LINK : _constants.SIGNIN_LINK,
            asAnchor: true,
            className: 'asda-btn--secondary ' + (!isBabyClubHeader && 'profile-link'),
            onClick: handleClick,
            dataAutoId: 'btnSign'
          },
          isBabyClubHeader ? 'Join now' : 'Sign in'
        )
      )
    ) : null,
    showAccountMenu && isSignedIn ? _react2.default.createElement(_accountMenu2.default, {
      signOut: signOut,
      setShowAccountMenu: setShowAccountMenu
    }) : null
  );
};

Profile.propTypes = {
  isSignedIn: _propTypes.bool.isRequired,
  getProfile: _propTypes.func.isRequired,
  signOut: _propTypes.func.isRequired,
  isBabyClubHeader: _propTypes.bool,
  isBabyClubMember: _propTypes.bool
};

Profile.defaultProps = {
  isBabyClubHeader: false,
  isBabyClubMember: false
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var profile = _ref3.profile;
  var isBabyClubMember = profile.isBabyClubMember,
      isSignedIn = profile.isSignedIn;

  return {
    isSignedIn: isSignedIn,
    isBabyClubMember: isBabyClubMember
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getProfile: (0, _redux.bindActionCreators)(profileActions.getProfile, dispatch),
    signOut: (0, _redux.bindActionCreators)(profileActions.signOut, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Profile);

/***/ }),
/* 546 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bannerGrid = __webpack_require__(548);

Object.defineProperty(exports, 'BannerGrid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bannerGrid).default;
  }
});

var _bannerRow = __webpack_require__(552);

Object.defineProperty(exports, 'BannerRow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bannerRow).default;
  }
});

var _richText = __webpack_require__(555);

Object.defineProperty(exports, 'RichText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_richText).default;
  }
});
Object.defineProperty(exports, 'RichTextFooter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_richText).default;
  }
});
Object.defineProperty(exports, 'CustomHTML', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_richText).default;
  }
});

var _banner = __webpack_require__(519);

Object.defineProperty(exports, 'Banner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_banner).default;
  }
});

var _linkPromotions = __webpack_require__(556);

Object.defineProperty(exports, 'PromotionLinks', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_linkPromotions).default;
  }
});

var _linkIcons = __webpack_require__(559);

Object.defineProperty(exports, 'LinkIcons', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_linkIcons).default;
  }
});

var _guidedNav = __webpack_require__(562);

Object.defineProperty(exports, 'GuidedNav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_guidedNav).default;
  }
});

var _footerGlobal = __webpack_require__(740);

Object.defineProperty(exports, 'GlobalFooter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_footerGlobal).default;
  }
});

var _signUpTop = __webpack_require__(743);

Object.defineProperty(exports, 'SignUpTop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_signUpTop).default;
  }
});

var _signUpBottom = __webpack_require__(746);

Object.defineProperty(exports, 'SignUpBottom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_signUpBottom).default;
  }
});

var _placeholder = __webpack_require__(749);

Object.defineProperty(exports, 'Placeholder', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_placeholder).default;
  }
});

var _categoryArticles = __webpack_require__(750);

Object.defineProperty(exports, 'CategoryArticles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_categoryArticles).default;
  }
});

var _trendingArticles = __webpack_require__(753);

Object.defineProperty(exports, 'TrendingArticles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_trendingArticles).default;
  }
});

var _personalizedRecommendation = __webpack_require__(756);

Object.defineProperty(exports, 'ProductListingP13N', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_personalizedRecommendation).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _richText = __webpack_require__(518);

var _richText2 = _interopRequireDefault(_richText);

var _banner = __webpack_require__(519);

var _banner2 = _interopRequireDefault(_banner);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/no-array-index-key */
/* eslint-disable import/extensions */


var BannerGrid = function BannerGrid(_ref) {
  var _ref$moduleData = _ref.moduleData,
      Banners = _ref$moduleData.banners,
      props = _objectWithoutProperties(_ref$moduleData, ['banners']),
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  return _react2.default.createElement(
    'div',
    {
      className: 'banner-grid',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    Banners.map(function (banner, i) {
      var className = 'grid-item ' + props['internalColumnClass' + (i + 1)];
      if (banner.type === 'Banner') {
        return _react2.default.createElement(
          'div',
          { className: className, key: i },
          _react2.default.createElement(_banner2.default, { moduleData: banner })
        );
      }
      if (banner.type === 'RichText') {
        return _react2.default.createElement(_richText2.default, { className: className, key: i, content: banner.markup });
      }
      return null;
    })
  );
};

BannerGrid.propTypes = {
  moduleData: (0, _propTypes.shape)({
    containerClass: _propTypes.string,
    internalColumnClass1: _propTypes.string,
    internalColumnClass2: _propTypes.string,
    internalColumnClass3: _propTypes.string,
    internalColumnClass4: _propTypes.string,
    internalColumnClass5: _propTypes.string,
    internalColumnClass6: _propTypes.string,
    banners: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([(0, _propTypes.shape)({
      type: _propTypes.string,
      mediaURL: (0, _propTypes.shape)({
        clickThrough: (0, _propTypes.shape)({
          value: _propTypes.string
        })
      }),
      altText: _propTypes.string,
      linkDestination: (0, _propTypes.shape)({
        clickThrough: (0, _propTypes.shape)({
          value: _propTypes.string
        })
      })
    }), (0, _propTypes.shape)({
      type: _propTypes.string,
      markup: _propTypes.string
    })]))
  }).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

BannerGrid.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};
exports.default = BannerGrid;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerStatic = function BannerStatic(_ref) {
  var link = _ref.link,
      trackingCode = _ref.trackingCode,
      imageAlt = _ref.imageAlt,
      mediaURL = _ref.mediaURL,
      className = _ref.className,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  var enhancedClassName = className ? 'banner-static ' + className : 'banner-static';
  return _react2.default.createElement(
    'div',
    {
      className: enhancedClassName,
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    _react2.default.createElement(
      'a',
      {
        className: 'bannerLink',
        href: link.path,
        'data-trackingcode': trackingCode
      },
      _react2.default.createElement('img', { src: mediaURL, alt: imageAlt })
    )
  );
};

BannerStatic.propTypes = {
  imageAlt: _propTypes.string.isRequired,
  mediaURL: _propTypes.string.isRequired,
  link: (0, _propTypes.shape)({
    path: _propTypes.string
  }),
  trackingCode: _propTypes.string.isRequired,
  className: _propTypes.string,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

BannerStatic.defaultProps = {
  link: {
    path: ''
  },
  className: '',
  name: null,
  moduleId: null,
  type: null
};

exports.default = BannerStatic;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(551);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./banner-grid.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./banner-grid.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".banner-grid{overflow-x:auto;overflow-y:hidden;height:300px;margin:10px auto;white-space:nowrap;-webkit-overflow-scrolling:touch}.banner-grid.wrapper{padding:0}.grid-item{display:inline-block;vertical-align:top;padding:0 5px}.grid-item,.grid-item div{height:100%}.grid-item img{height:100%;max-width:unset}@media (min-width:481px){.grid-item:first-child{padding-left:10px}.grid-item:last-child{padding-right:10px}}@media (min-width:961px){.banner-grid{display:block;height:auto;max-width:1024px;margin:10px auto}.grid-item{display:block;float:left;padding:10px}.grid-item:first-child img{max-height:505px}.grid-item:last-child img{max-height:230px}.grid-item:nth-child(2) img,.grid-item:nth-child(3) img{max-height:255px}.bannerLink{display:flex;flex-direction:column}.w-100{width:100%}.w-50{width:50%}.w-25{width:25%}}@media (min-width:1201px){.banner-grid{max-width:1170px}.grid-item{display:block;float:left;padding:10px}.grid-item:first-child img{max-height:594px}.grid-item:not(:first-child) img{max-height:287px}}", ""]);

// exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

__webpack_require__(553);

var _richText = __webpack_require__(518);

var _richText2 = _interopRequireDefault(_richText);

var _banner = __webpack_require__(519);

var _banner2 = _interopRequireDefault(_banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */


var BannerRow = function BannerRow(_ref) {
  var _ref$moduleData = _ref.moduleData,
      Banners = _ref$moduleData.banners,
      props = _objectWithoutProperties(_ref$moduleData, ['banners']),
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  return _react2.default.createElement(
    'div',
    {
      className: 'banner-row',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    Banners.map(function (banner, i) {
      var className = '' + props['internalColumnClass' + (i + 1)];
      if (banner.type === 'Banner') {
        return _react2.default.createElement(_banner2.default, { moduleData: banner, className: className, key: i });
      }
      if (banner.type === 'RichText') {
        return _react2.default.createElement(_richText2.default, {
          key: i,
          content: banner.markup,
          className: 'banner-static ' + className
        });
      }
      return null;
    })
  );
};

BannerRow.propTypes = {
  moduleData: (0, _propTypes.shape)({
    containerClass: _propTypes.string,
    internalColumnClass1: _propTypes.string,
    internalColumnClass2: _propTypes.string,
    internalColumnClass3: _propTypes.string,
    internalColumnClass4: _propTypes.string,
    internalColumnClass5: _propTypes.string,
    internalColumnClass6: _propTypes.string,
    banners: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([(0, _propTypes.shape)({
      type: _propTypes.string,
      mediaURL: (0, _propTypes.shape)({
        clickThrough: (0, _propTypes.shape)({
          value: _propTypes.string
        })
      }),
      altText: _propTypes.string,
      linkDestination: (0, _propTypes.shape)({
        clickThrough: (0, _propTypes.shape)({
          value: _propTypes.string
        })
      })
    }), (0, _propTypes.shape)({
      type: _propTypes.string,
      markup: _propTypes.string
    })]))
  }).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

BannerRow.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = BannerRow;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(554);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./banner-row.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./banner-row.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".banner-row{display:none}@media (min-width:961px){.banner-row{flex-wrap:nowrap;margin:10px auto;display:flex;justify-content:flex-start;align-items:center;max-width:1170px}.banner-row.wrapper{padding:0}.banner-row .banner-static{padding:0 10px}}", ""]);

// exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _richText = __webpack_require__(518);

var _richText2 = _interopRequireDefault(_richText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RichText = function RichText(props) {
  var markup = props.moduleData.markup,
      name = props.name,
      type = props.type,
      moduleId = props.moduleId;

  return _react2.default.createElement(_richText2.default, { content: markup, name: name, type: type, moduleId: moduleId });
};

RichText.propTypes = {
  moduleData: (0, _propTypes.shape)({ markup: _propTypes.string }),
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

RichText.defaultProps = {
  moduleData: { markup: '' },
  name: null,
  moduleId: null,
  type: null
};

exports.default = RichText;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _LinkPromotion = __webpack_require__(524);

var _LinkPromotion2 = _interopRequireDefault(_LinkPromotion);

__webpack_require__(557);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */
var LinkPromotions = function LinkPromotions(_ref) {
  var Links = _ref.moduleData.Links,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  var promoLinks = Links.map(function (content, index) {
    var iconClass = content.iconClass,
        linkText = content.linkText,
        imageUrl = content.image.clickThrough.value,
        trackingCode = content.trackingCode,
        value = content.link.clickThrough.value;

    var linkPath = { path: value };
    return _react2.default.createElement(_LinkPromotion2.default, {
      link: linkPath,
      iconClass: iconClass,
      linkText: linkText,
      customImage: imageUrl,
      trackingCode: trackingCode,
      key: index
    });
  });
  return _react2.default.createElement(
    'div',
    {
      className: 'wrapper promo-links',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    promoLinks
  );
};

LinkPromotions.propTypes = {
  moduleData: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

LinkPromotions.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = LinkPromotions;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(558);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./link-promotion.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./link-promotion.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".promo-links{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;margin:10px auto}.promo-links.wrapper{padding:0}.promo-links .link-promotion{width:145px;height:86px;background-color:#fff;box-shadow:2px 2px 2px 0 rgba(0,0,0,.25);border:1px solid #e9e9e9;margin:5px;display:flex;flex-direction:column;justify-content:flex-end;align-items:center;position:relative}.promo-links .link-promotion i{font-size:30px;position:absolute;top:5px}.promo-links .link-promotion img{width:35px}.promo-links .link-promotion .promo-link{flex-basis:50%;font-family:fontRegular,sans-serif;font-size:14px;line-height:1.2;text-align:center;color:#474646;margin:0 10px}.promo-links .link-promotion .promo-link strong{font-family:fontBold,sans-serif}.promo-links .link-promotion .promo-link:hover{text-decoration:none}@media (min-width:481px){.promo-links .link-promotion{width:140px}}@media (min-width:961px){.promo-links{flex-wrap:nowrap;justify-content:space-between}.promo-links.wrapper{padding:0}.promo-links .link-promotion{flex-direction:row;height:60px;width:224px}.promo-links .link-promotion:first-child{margin-left:0}.promo-links .link-promotion:last-child{margin-right:0}.promo-links .link-promotion i{top:14px;left:13px}.promo-links .link-promotion .promo-link{flex-basis:70%;text-align:left}}", ""]);

// exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _LinkPromotion = __webpack_require__(524);

var _LinkPromotion2 = _interopRequireDefault(_LinkPromotion);

__webpack_require__(560);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */


var LinkIcons = function LinkIcons(_ref) {
  var _ref$moduleData = _ref.moduleData,
      Links = _ref$moduleData.Links,
      props = _objectWithoutProperties(_ref$moduleData, ['Links']),
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  var iconLinks = Links.map(function (content, index) {
    var iconClass = content.iconClass,
        linkText = content.linkText,
        imageUrl = content.image.clickThrough.value,
        trackingCode = content.trackingCode,
        value = content.link.clickThrough.value;

    var linkPath = { path: value };
    return _react2.default.createElement(_LinkPromotion2.default, {
      link: linkPath,
      iconClass: iconClass,
      linkText: linkText,
      customImage: imageUrl,
      trackingCode: trackingCode,
      key: index
    });
  });
  return _react2.default.createElement(
    'div',
    {
      className: 'fullwidth link-icons',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    _react2.default.createElement(
      'div',
      { className: 'wrapper link-group' },
      iconLinks
    )
  );
};

LinkIcons.propTypes = {
  moduleData: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

LinkIcons.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = LinkIcons;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(561);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./link-icons.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./link-icons.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".link-icons{background:#eff4f7;margin:10px auto}.link-group{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0}.link-group .link-promotion{width:100px;height:160px;color:#475152;display:flex;padding:10px 0;flex-direction:column;align-items:center;justify-content:center}.link-group .link-promotion i{font-size:35px;padding:2px 15px}.link-group .link-promotion span{color:#475152;text-decoration:none;font-size:13px;font-weight:300;text-align:center;padding:0 15px}@media (min-width:961px){.link-group{min-height:151px;align-items:center}}", ""]);

// exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */


var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _asdaCustomLink = __webpack_require__(525);

var _asdaCustomLink2 = _interopRequireDefault(_asdaCustomLink);

var _SubMenuHamBurger = __webpack_require__(563);

var _SubMenuHamBurger2 = _interopRequireDefault(_SubMenuHamBurger);

var _cms = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GuidedNav = function GuidedNav(_ref) {
  var sectionMain = _ref.moduleData.Menu,
      ui = _ref.ui,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      selectedMenuIndex = _useState2[0],
      setSelectedMenuIndex = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!ui.leftNavOpen) {
      setSelectedMenuIndex(-1);
    }
  }, [ui.leftNavOpen]);

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    selectedMenuIndex !== -1 && _react2.default.createElement('div', { className: 'background-shadow-large' }),
    _react2.default.createElement(
      'ul',
      {
        'data-module': name,
        'data-module-name': name,
        'data-module-id': moduleId,
        'data-module-type': type,
        role: 'none'
      },
      sectionMain.map(function (_ref2, index) {
        var _ref2$MainMenu = _ref2.MainMenu,
            _ref2$MainMenu$link = _ref2$MainMenu.link,
            value = _ref2$MainMenu$link.clickThrough.value,
            title = _ref2$MainMenu$link.title,
            isSubNav = _ref2$MainMenu.IsSubNav,
            SubNav = _ref2.SubNav;

        var linkObj = { path: value };
        return isSubNav === 'true' ? _react2.default.createElement(_SubMenuHamBurger2.default, {
          link: linkObj,
          linkName: (0, _cms.getModifiedStringForNav)(title, 20),
          ui: ui,
          key: 'SubMenuHamBurger-' + index,
          onMenuClick: function onMenuClick(isOpen) {
            return setSelectedMenuIndex(isOpen ? -1 : index);
          },
          SubNav: SubNav,
          isOpen: selectedMenuIndex === index
        }) : _react2.default.createElement(_asdaCustomLink2.default, {
          link: linkObj,
          linkName: (0, _cms.getModifiedStringForNav)(title, 20),
          key: 'AsdaCustomLink-' + index
        });
      })
    )
  );
};

GuidedNav.propTypes = {
  moduleData: (0, _propTypes.shape)({
    Menu: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired
  }).isRequired,
  ui: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

GuidedNav.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = GuidedNav;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuHamBurger = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(181);

var _propTypes = __webpack_require__(12);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _asdaCustomLink = __webpack_require__(525);

var _cms = __webpack_require__(184);

var _utility = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubMenuHamBurger = exports.SubMenuHamBurger = function SubMenuHamBurger(_ref) {
  var linkName = _ref.linkName,
      dispatch = _ref.dispatch,
      ui = _ref.ui,
      onMenuClick = _ref.onMenuClick,
      SubNav = _ref.SubNav,
      isOpen = _ref.isOpen;


  var wrapperRef = (0, _react.useRef)(null);
  var isOpenRef = (0, _react.useRef)(isOpen);

  (0, _react.useEffect)(function () {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (isOpenRef.current && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onMenuClick(isOpenRef);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  (0, _react.useEffect)(function () {

    var currentViewPort = (0, _utility.getCurrentViewPort)();
    var mobileDevicesPorts = ['small', 'large', 'medium'];

    if (isOpen && mobileDevicesPorts.includes(currentViewPort)) {

      var lastItem = SubNav[SubNav.length - 1];
      var lastItemTitle = (0, _cms.getModifiedStringForNav)(lastItem.link.title, 30);

      var firstEl = document.querySelector(".submenu-button");
      var lastEl = document.getElementById(lastItemTitle);

      firstEl.focus();

      var keydownHandlerLast = function keydownHandlerLast(e) {
        var evt = e || window.event;
        var keyCode = evt.which || evt.keyCode;
        if (keyCode === 9) {
          if (evt.preventDefault) evt.preventDefault();else evt.returnValue = false;
          firstEl.focus();
        }
      };

      var keydownHandlerFirst = function keydownHandlerFirst(e) {
        var evt = e || window.event;
        var keyCode = evt.which || evt.keyCode;
        if (keyCode === 9 && evt.shiftKey) {
          if (evt.preventDefault) evt.preventDefault();else evt.returnValue = false;
          lastEl.focus();
        }
      };

      if (lastEl.addEventListener) lastEl.addEventListener('keydown', keydownHandlerLast, false);
      if (firstEl.addEventListener) firstEl.addEventListener('keydown', keydownHandlerFirst, false);
    }
  }, [isOpen, window.innerWidth]);

  return _react2.default.createElement(
    'li',
    { className: 'sub-menu-container ' + (isOpen ? 'active' : ''), ref: wrapperRef },
    _react2.default.createElement(
      'div',
      { className: 'sub-menu custom-link ' + (ui.subMenuOpen ? 'active' : ''), tabIndex: window.innerWidth > 960 ? "-1" : "0" },
      _react2.default.createElement(
        'a',
        {
          className: 'sub-nav',
          id: 'nav-toggle',
          onClick: function onClick() {
            onMenuClick(isOpen);
            dispatch({ type: 'TOGGLE_SUBMENU' });
          },
          'aria-label': window.innerWidth > 960 ? "" : linkName + ', list ' + SubNav.length + ' items'
        },
        _react2.default.createElement(
          'span',
          { className: 'submenu-hamburger-label' },
          linkName || 'Menu'
        ),
        _react2.default.createElement(_icon2.default, { name: '' + (isOpen ? 'upArrow' : 'downArrow'), size: 'medium', id: 'icon', label: linkName + ', list ' + SubNav.length + ' items' })
      )
    ),
    isOpen && _react2.default.createElement(
      'button',
      { onClick: onMenuClick, className: 'submenu-button' },
      _react2.default.createElement(_icon2.default, { name: 'back', size: 'medium' }),
      'Back'
    ),
    _react2.default.createElement(
      'ul',
      { className: 'submenu-nav ' + (isOpen ? "open" : "") },
      SubNav.map(function (_ref2, index) {
        var _ref2$link = _ref2.link,
            value = _ref2$link.clickThrough.value,
            title = _ref2$link.title;

        var linkObj = { path: value };
        return _react2.default.createElement(_asdaCustomLink.AsdaCustomLink, {
          link: linkObj,
          linkName: (0, _cms.getModifiedStringForNav)(title, 30),
          key: 'AsdaCustomLink-' + index
        });
      })
    )
  );
}; /* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */


SubMenuHamBurger.propTypes = {
  linkName: _propTypes.string.isRequired,
  dispatch: _propTypes.func.isRequired,
  ui: (0, _propTypes.shape)({}).isRequired
};

exports.default = (0, _reactRedux.connect)()(SubMenuHamBurger);

/***/ }),
/* 564 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(566);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(567),
    arrayIncludes = __webpack_require__(595),
    arrayIncludesWith = __webpack_require__(600),
    cacheHas = __webpack_require__(601),
    createSet = __webpack_require__(602),
    setToArray = __webpack_require__(532);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(568),
    setCacheAdd = __webpack_require__(593),
    setCacheHas = __webpack_require__(594);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(569),
    mapCacheDelete = __webpack_require__(588),
    mapCacheGet = __webpack_require__(590),
    mapCacheHas = __webpack_require__(591),
    mapCacheSet = __webpack_require__(592);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(570),
    ListCache = __webpack_require__(582),
    Map = __webpack_require__(530);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(571),
    hashDelete = __webpack_require__(578),
    hashGet = __webpack_require__(579),
    hashHas = __webpack_require__(580),
    hashSet = __webpack_require__(581);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(509);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(526),
    isMasked = __webpack_require__(575),
    isObject = __webpack_require__(511),
    toSource = __webpack_require__(528);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(510);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(576);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(503);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(509);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(509);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(509);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(583),
    listCacheDelete = __webpack_require__(584),
    listCacheGet = __webpack_require__(585),
    listCacheHas = __webpack_require__(586),
    listCacheSet = __webpack_require__(587);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 583 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(512);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(512);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(512);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(512);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(513);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(513);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(513);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(513);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 594 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(596);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(597),
    baseIsNaN = __webpack_require__(598),
    strictIndexOf = __webpack_require__(599);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 597 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 598 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 600 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(531),
    noop = __webpack_require__(603),
    setToArray = __webpack_require__(532);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 603 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(605);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(606),
    isFlattenable = __webpack_require__(607);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 606 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(510),
    isArguments = __webpack_require__(533),
    isArray = __webpack_require__(515);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(507),
    isObjectLike = __webpack_require__(514);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _logo = __webpack_require__(610);

var _logo2 = _interopRequireDefault(_logo);

var _basic = __webpack_require__(614);

var _basic2 = _interopRequireDefault(_basic);

var _brands = __webpack_require__(637);

var _brands2 = _interopRequireDefault(_brands);

var _circular = __webpack_require__(644);

var _circular2 = _interopRequireDefault(_circular);

var _creditCards = __webpack_require__(657);

var _creditCards2 = _interopRequireDefault(_creditCards);

var _giftCard = __webpack_require__(669);

var _giftCard2 = _interopRequireDefault(_giftCard);

var _system = __webpack_require__(673);

var _system2 = _interopRequireDefault(_system);

var _labels = __webpack_require__(735);

var _labels2 = _interopRequireDefault(_labels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _logo2.default, _basic2.default, _brands2.default, _circular2.default, _creditCards2.default, _giftCard2.default, _system2.default, _labels2.default);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaLogo = __webpack_require__(611);

var _asdaLogo2 = _interopRequireDefault(_asdaLogo);

var _asdaPride = __webpack_require__(612);

var _asdaPride2 = _interopRequireDefault(_asdaPride);

var _babyClub = __webpack_require__(613);

var _babyClub2 = _interopRequireDefault(_babyClub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  logo: _asdaLogo2.default,
  prideLogo: _asdaPride2.default,
  babyClubLogo: _babyClub2.default
};

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 113 34\"><path class=\"asda-icon__draw\" fill-rule=\"evenodd\" d=\"M101.698 2.012H90.337l-6.479 18.752c.29-1.557.341-2.802.341-3.343 0-7.856-4.501-15.409-15.076-15.409H56.978l.036 18.653c-1.05-5.3-5.892-6.72-11.913-8.55-2.25-.693-3.486-1.794-3.035-2.82.385-.896 1.765-1.177 3.44-.946 2.554.366 4.594 1.22 6.558 2.289l2.684-6.651c-.605-.299-4.954-2.909-10.404-2.909-7.6 0-12.454 3.708-12.454 9.18 0 4.876 3.003 7.711 8.525 9.3 5.939 1.723 7.445 2.416 7.266 4.124-.154 1.472-3.835 3.265-12.841-2.276l-2.676 5.537-8.26-24.93H12.547L1.814 33.003h8.952L12.5 28H23l1.784 5.004h9.398l-1.066-3.031c3.177 1.836 7.117 3.517 11.83 3.517 7.22 0 11.123-3.943 12.054-7.722v7.236h12.11c7.219 0 10.995-3.442 12.968-7.126l-2.477 7.126h8.945L90.336 28H101l1.572 5.004h9.41L101.697 2.012zM14.5 21l3.338-10.648L21 21h-6.5zM66 25.012V10h2.135c3.043 0 6.365 1.232 6.365 7.506 0 5.557-2.934 7.506-6.339 7.506H66zM92.5 21l3.184-10.521L99 21h-6.5z\"></path></svg>"

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 1102 325\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Asda-pride</title><defs><path d=\"M661.738095,88.34 C692.390725,88.34 726.5,100.921491 726.5,163.486215 C726.5,218.908897 696.293388,239.34 662.005706,239.34 L641.5,239.34 L641.5,88.34 L661.738095,88.34 Z M937.555202,93.34 L970.5,203.34 L904.5,203.34 L937.555202,93.34 Z M160.315463,92.34 L193.5,203.34 L126.5,203.34 L160.315463,92.34 Z M425.152757,0.34 C349.267814,0.34 300.800509,37.298165 300.800509,91.823889 C300.800509,140.427467 330.783021,168.679194 385.916792,184.512094 C445.207431,201.681896 460.242909,208.587383 458.462974,225.613551 C456.915204,240.28633 420.166727,258.152205 330.241301,202.930408 L303.531217,258.10801 L221.068253,9.643072 L107.672003,9.643072 L0.5,318.511684 L89.883706,318.511684 L103.82469,274.769568 L216.513387,274.769568 L229.846319,318.511684 L323.674335,318.511684 L313.02789,288.293274 C344.757171,306.6011 384.092635,323.34 431.144837,323.34 C503.248799,323.34 542.208376,284.050543 551.50605,246.385256 L551.50605,318.500635 L672.431094,318.500635 C744.501889,318.500635 782.212195,284.194177 801.913094,247.490133 L777.170888,318.500635 L866.488261,318.500635 L880.993075,274.75852 L993.57122,274.75852 L1006.55037,318.511684 L1100.5,318.511684 L997.81653,9.643072 L884.376058,9.643072 L819.690335,196.522117 C822.586876,180.998582 823.095429,168.590804 823.095429,163.199 C823.095429,84.918402 778.143772,9.643072 672.552705,9.643072 L551.295996,9.643072 L551.649772,195.538775 C541.169159,142.725613 492.823464,128.572127 432.703662,110.330593 C410.238889,103.414058 397.900953,92.44262 402.400541,82.211451 C406.247854,73.295087 420.023005,70.488697 436.738919,72.786843 C462.25501,76.443989 482.619239,84.962597 502.231693,95.602571 L529.030222,29.320947 C522.993919,26.348825 479.567921,0.34 425.152757,0.34 Z\" id=\"path-1\"></path></defs><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Asda-pride\"><g id=\"Group\" transform=\"translate(0.500000, 0.500000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" xlink:href=\"#path-1\"></use><g mask=\"url(#mask-2)\" fill-rule=\"nonzero\" id=\"Rectangle\"><g transform=\"translate(-2.000000, -2.000000)\"><rect fill=\"#F90000\" transform=\"translate(549.000000, 31.000000) rotate(90.000000) translate(-549.000000, -31.000000) \" x=\"518.5\" y=\"-517.5\" width=\"61\" height=\"1097\"></rect><rect fill=\"#FF8600\" transform=\"translate(549.000000, 88.000000) rotate(90.000000) translate(-549.000000, -88.000000) \" x=\"522.5\" y=\"-460.5\" width=\"53\" height=\"1097\"></rect><rect fill=\"#FFEE00\" transform=\"translate(549.000000, 141.500000) rotate(90.000000) translate(-549.000000, -141.500000) \" x=\"522\" y=\"-407\" width=\"54\" height=\"1097\"></rect><rect fill=\"#00830D\" transform=\"translate(549.000000, 195.500000) rotate(90.000000) translate(-549.000000, -195.500000) \" x=\"522\" y=\"-353\" width=\"54\" height=\"1097\"></rect><rect fill=\"#0044FF\" transform=\"translate(549.000000, 250.500000) rotate(90.000000) translate(-549.000000, -250.500000) \" x=\"521\" y=\"-298\" width=\"56\" height=\"1097\"></rect><rect fill=\"#81008C\" transform=\"translate(554.500000, 302.000000) rotate(90.000000) translate(-554.500000, -302.000000) \" x=\"529.223502\" y=\"-252\" width=\"50.5529954\" height=\"1108\"></rect></g></g></g></g></g></svg>"

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 40\"><defs><path id=\"prefix__a\" d=\"M0.698 0L98.698 0 98.698 40 0.698 40z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(.302)\"><mask id=\"prefix__b\" fill=\"#fff\"><use xlink:href=\"#prefix__a\"></use></mask><path fill=\"#EBA453\" d=\"M30.495 28.346c.268-1.066.31-3.393.342-4.27.05-1.24-.171-4.193-.85-4.563-1.079-.569-2.632-.819-3.03-.08-.466.589-.149 2.814-.118 4.625.029 1.781-.107 2.24.194 4.887.477.68.975 1.086 1.79 1.028.725-.085 1.353-.317 1.672-1.627zm2.013-11.334c.25.233.976 1.115 1.113 1.564 1.042 3.077 1.082 9.69-.137 12.178-.85 1.75-2.5 2.198-4.744 2.152-1-.027-2.472.324-3.635-.936-.725-.821-1.006-1.99-1.087-2.622-.235-1.563-.382-8.657-.408-9.442-.053-2.475-.294-6.061-.401-8.354.151-.91.432-.648 1.672-.72.605-.02 1.597-.234 1.624.58.037 1.087.211 3.588.348 4.943 2.195-.466 4.312-.567 5.655.657z\" mask=\"url(#prefix__b)\"></path><path fill=\"#57C0DA\" d=\"M94.625 28.431c.28-1.063.349-3.39.39-4.266.063-1.24-.124-4.195-.798-4.573-1.073-.58-2.623-.848-3.03-.114-.472.584-.18 2.812-.17 4.624.01 1.782-.132 2.238.139 4.89.47.683.963 1.095 1.78 1.047.724-.077 1.355-.302 1.689-1.608zm2.14-11.311c.248.236.964 1.126 1.095 1.576 1.008 3.088.973 9.702-.274 12.176-.87 1.74-2.525 2.17-4.767 2.099-1-.038-2.476.296-3.624-.977-.716-.83-.984-2.001-1.059-2.634-.216-1.566-.283-8.66-.3-9.445-.025-2.476-.227-6.065-.308-8.358.162-.91.44-.645 1.68-.702.605-.013 1.6-.217 1.618.599.024 1.086.17 3.59.292 4.945 2.2-.44 4.318-.518 5.648.721z\" mask=\"url(#prefix__b)\"></path><path fill=\"#93C01F\" d=\"M21.164.44h-2.282L17.579 4.2c.06-.314.069-.563.069-.672 0-1.574-.904-3.088-3.03-3.088h-2.44l.008 3.739C11.974 3.116 11 2.833 9.792 2.465c-.453-.138-.702-.36-.611-.565.077-.18.356-.237.691-.19.512.073.924.246 1.318.46l.54-1.335c-.122-.059-.996-.583-2.09-.583-1.529 0-2.503.743-2.503 1.841 0 .976.602 1.545 1.713 1.863 1.193.346 1.495.485 1.46.828-.032.295-.771.654-2.58-.457l-.539 1.11L5.531.44H3.249L1.094 6.652h1.798l.28-.88H5.44l.269.88h1.888l-.214-.607c.637.367 1.43.704 2.377.704 1.451 0 2.234-.789 2.422-1.548v1.451h2.435c1.45 0 2.208-.69 2.605-1.429l-.5 1.429h1.8l.291-.88h2.266l.261.88h1.89L21.164.44zM3.633 4.328l.68-2.216.667 2.216H3.633zm10.792.721h-.408V2.015h.403c.61 0 1.292.252 1.292 1.51 0 1.114-.603 1.524-1.287 1.524zm4.865-.72l.666-2.192.663 2.191h-1.33z\" mask=\"url(#prefix__b)\"></path><path fill=\"#9DD0B5\" d=\"M36.071 19.005c-.095.394-.387 6.753-.41 7.16-.01.161-.043 1.292-.008 1.692.037.405.124.802.21 1.188.088.403.226.781.374 1.144.156.384.301.766.531 1.081.242.331.526.632.856.86.321.222.698.395 1.11.493.364.085.77.053 1.21.024.367-.025.774-.03 1.2-.147.358-.098.73-.261 1.13-.432.347-.148.716-.34 1.095-.546-.057.471-.123.925-.2 1.407-.066.417-.143.865-.256 1.387-.076.352-.145.711-.275 1.021-.15.357-.365.66-.575.888-.27.294-.586.42-.933.358-.529-.095-.812-.432-.966-.865-.158-.447-.158-.967-.134-1.362.021-.346-.237-.68-.577-.754-.838-.063-.846.048-1.683-.02-.431-.093-.836.19-.85.63-.012.347.04.763.092 1.217.045.384.117.785.24 1.193.114.382.215.783.422 1.145.199.346.441.684.746.976.281.268.643.462 1.032.657.34.17.718.299 1.151.393.426.091.826.213 1.213.207.427-.007.817-.156 1.194-.28.389-.128.782-.253 1.116-.501.315-.235.563-.565.827-.904.236-.305.493-.626.687-1.013.172-.346.335-.724.473-1.133.123-.368.221-.767.316-1.186.078-.349.13-.727.2-1.12.065-.359.173-.727.231-1.114.056-.366.069-.749.118-1.132.048-.372.081-.75.123-1.131.042-.376.117-.75.153-1.128.036-.38.016-.763.046-1.138.03-.384.056-.763.081-1.135.026-.388.087-.765.106-1.133.02-.395-.012-.777 0-1.138.015-.406.083-.785.087-1.135.003-.327-.028-.767-.04-1.267-.008-.394-.041-.824-.055-1.266-.013-.42-.007-.85-.023-1.269l-.05-1.267c-.02-.499-.009-.94-.023-1.268-.016-.345-.333-.59-.69-.588-.561.003-.561 0-1.123.002-.562.002-.563-.053-1.125-.051-.398.002-.724.38-.671.761.011.085-.008.766-.005.81l-.01 4.136c.041.37.06.92.06 1.473.001.503-.065 1.024-.073 1.454-.008.427-.018.785-.047 1.081-.067.685-.142 1.033-.152 1.073-.337.34-.641.629-.93.852-.406.311-.78.49-1.1.61-.504.188-.922.22-1.243.073-.385-.176-.65-.564-.826-.948-.203-.448-.249-.941-.255-1.226-.006-.323-.058-6.156.119-6.45l.066-1.154s.077-.363-.485-.424c-.563-.06-2.286-.13-2.286-.13s-.46 0-.536.309\" mask=\"url(#prefix__b)\"></path></g><path fill=\"#E75B9B\" d=\"M15.21 29.822c.077-.341.263-.618.48-.879.209-.25.43-.513.73-.705.275-.176.594-.311.915-.45.308-.133.64-.223.962-.332.327-.111.672-.259.985-.356-.007.37-.018.793-.008 1.191.01.397.04.799.063 1.17-.136.217-.382.452-.616.717-.199.225-.412.461-.653.666-.246.209-.507.386-.77.522-.304.157-.6.288-.887.273-.19-.01-.48-.136-.72-.354-.186-.17-.351-.406-.446-.668-.085-.234-.101-.507-.035-.795zm2.766-10.7c-.302-.018-.613-.031-.917.02-.298.052-.578.193-.869.293-.29.1-.579.198-.85.33-.283.137-.568.26-.82.412-.278.168-.504.387-.732.549-.297.212-.558.387-.738.536-.197.163-.236.42-.117.646.24.454.187.481.427.935.24.454.254.447.494.9.162.307.601.395.861.166.187-.163.391-.385.656-.568.227-.157.477-.319.745-.449.259-.125.54-.222.822-.288.281-.066.573-.055.864-.028.233.022.468.089.697.223.195.114.399.249.543.497.196.34.207.556.222.651-.326.055-.638.119-.943.187-.322.072-.625.18-.925.268-.318.092-.64.14-.932.248-.31.116-.6.259-.881.392-.3.143-.564.327-.828.49-.282.174-.543.356-.784.552-.256.208-.48.432-.69.664-.219.242-.412.492-.58.76-.17.272-.33.547-.447.845-.116.295-.227.597-.29.916-.064.33-.111.68-.114 1.035 0 .31.024.614.082.897.06.3.216.565.337.831.125.276.252.544.435.776.185.236.41.43.647.613.234.182.486.332.763.457.266.12.54.243.84.305.285.058.584.083.893.084.292.001.6-.055.923-.11.295-.052.597-.121.9-.22.292-.094.583-.2.864-.337.28-.136.573-.256.826-.433.257-.18.488-.42.7-.642.116.382.394.75.637.997.209.213.575.244.787.035.302-.296.3-.297.603-.594.302-.297.255-.343.557-.64.303-.297.316-.283.618-.58.195-.191.243-.505.074-.72-.147-.188-.353-.45-.521-.855-.11-.263-.172-.59-.263-.969-.07-.292-.133-.616-.18-.985-.04-.306-.137-.634-.155-.997-.016-.312.044-.648.048-1.007.004-.316.003-.65.025-1.005.019-.313-.022-.613-.023-.898-.001-.315.007-.613-.018-.896-.028-.315-.08-.608-.136-.885-.061-.312-.125-.603-.218-.868-.106-.301-.256-.556-.399-.8-.159-.272-.291-.545-.491-.75-.254-.257-.557-.459-.9-.607-.307-.132-.669-.166-1.058-.232-.327-.056-.68-.124-1.071-.147z\"></path><path fill=\"#E35F9E\" d=\"M71.454 34.013c.56-.067.561-.06 1.121-.126.56-.066.569.007 1.129-.058.337-.04.544-.37.54-.709-.013-.583.017-.584.002-1.167-.014-.583-.04-.583-.055-1.166s.015-.584 0-1.167c-.014-.584-.037-.583-.051-1.166-.015-.584.023-.585.009-1.168-.014-.584-.048-.583-.062-1.166-.015-.583.026-.584.011-1.168-.014-.583.008-.583-.006-1.167-.015-.583-.088-.581-.102-1.165-.014-.583.053-.585.038-1.168-.014-.583-.022-.583-.036-1.167-.014-.583-.04-.582-.054-1.165-.015-.584-.037-.583-.051-1.167-.015-.584-.026-.584-.04-1.168-.015-.584.043-.586.03-1.17-.005-.366-.33-.686-.697-.68-.559.01-.557.072-1.116.08-.56.01-.56.003-1.118.012-.367.007-.638.283-.63.65.015.59.02.59.034 1.18.014.592.017.592.032 1.183l.028 1.181c.014.591-.047.593-.033 1.184.014.59.029.59.043 1.181.014.591.034.59.048 1.182.014.59.051.59.066 1.18.014.591-.03.592-.017 1.183.014.591-.018.592-.003 1.183.014.59.036.59.05 1.181.015.591.063.59.078 1.181.014.592.007.592.02 1.183.015.59-.037.592-.023 1.183.014.592.049.591.063 1.183.014.59-.028.592-.014 1.184.01.389.379.649.766.604\"></path><path fill=\"#EBA453\" d=\"M86.173 33.578c.351-.045.617-.338.588-.69-.025-.305-.016-.71-.041-1.185-.02-.358-.092-.754-.11-1.18-.017-.376-.058-.772-.074-1.183-.016-.385.03-.785.016-1.187-.015-.392-.045-.788-.058-1.185-.014-.398-.04-.794-.052-1.185-.013-.405-.061-.801-.073-1.184-.013-.415-.006-.813-.017-1.185-.013-.436.003-.837-.008-1.187-.015-.525-.032-.936-.04-1.183-.015-.47-.046-.469-.06-.938-.012-.372-.3-.663-.672-.642-.469.027-.467.064-.935.091-.468.027-.472-.027-.94 0-.348.02-.617.323-.62.671-.007.613-.052.478-.056 1.226-.001.356.071.772.071 1.227 0 .385-.023.799-.021 1.227.001.399-.032.812-.027 1.226.004.41.048.823.056 1.227.007.422-.01.83.003 1.22-.227.302-.466.567-.715.807-.282.271-.563.506-.845.677-.363.221-.709.334-1.012.345-.274.006-.5-.035-.66-.215-.138-.153-.203-.556-.275-1.12-.044-.338-.098-.73-.123-1.165-.02-.367-.012-.762-.021-1.173-.01-.38-.076-.774-.077-1.173-.002-.39-.086-1.314-.075-1.683.013-.433.04-.83.053-1.173.021-.56.005-.98.016-1.175.02-.391-.289-.746-.68-.726-.552.03-.548.097-1.099.129-.55.031-.552-.001-1.103.03-.34.017-.617.29-.634.63-.021.576.006.45-.015 1.153-.01.334-.011.726-.024 1.154-.011.362.014 1.24.003 1.618-.011.4.016.79.006 1.155l-.033 1.154c-.014.517-.006.922-.01 1.153-.007.342.01.708.06 1.084.049.357.121.716.218 1.065.102.363.173.732.326 1.043.176.356.403.661.643.886.298.279.661.435 1.036.565.36.124.738.18 1.16.166.352-.011.72-.023 1.095-.1.348-.07.72-.123 1.076-.258.332-.127.653-.318.983-.51.306-.178.606-.399.903-.64.01.254.072.618.094.992.02.34-.006.697.012.991.024.381.375.688.754.64.51-.07.514-.045 1.023-.122.509-.078.5-.136 1.01-.205\"></path><path fill=\"#57C0DA\" d=\"M7.745 28.494c.302-1.057.419-3.382.479-4.257.089-1.238-.037-4.197-.704-4.588-1.06-.603-2.604-.902-3.027-.177-.483.575-.238 2.808-.265 4.62-.028 1.781-.179 2.234.037 4.89.455.694.94 1.116 1.757 1.085.727-.062 1.362-.274 1.723-1.573zM10.12 17.23c.243.242.94 1.146 1.062 1.599.943 3.109.771 9.72-.527 12.168-.905 1.722-2.57 2.117-4.81 2-.999-.06-2.481.245-3.603-1.052-.698-.844-.942-2.021-1.003-2.655-.184-1.57-.104-8.665-.105-9.45.026-2.475-.1-6.068-.134-8.362.18-.906.453-.635 1.694-.667.606-.001 1.604-.184 1.605.632.002 1.086.097 3.592.19 4.95 2.209-.395 4.327-.429 5.631.837z\"></path><path fill=\"#AFCA2A\" d=\"M57.598 22.253c-.082-.147.024-.328.193-.328h1.198c-.025.138-.038.279-.038.423 0 .358.049.701.154 1.013-.777-.017-1.273-.69-1.507-1.108zm8.026 7.1c-.332.17-.69.295-1.076.365-1.511.27-3.385-.036-4.439-1.231-.168-.191-.345-.466-.5-.78-.373-.757-.431-1.635-.158-2.433.161-.47.293-1.086.066-1.479-.237-.413-.348-.914-.348-1.447 0-1.387 1.222-2.51 2.728-2.51 1.462 0 2.653 1.059 2.722 2.39.018.06.041.115.055.18 0 0 .059.345.488.24.43-.105 2.013-1.077 2.449-1.21.436-.132.924-.369.902-.778-.024-.41-.354-.744-.354-.744-.213-.362-.528-.652-.812-.96-.34-.37-.673-.732-1.083-.99-.415-.26-.859-.494-1.336-.633-.46-.135-.959-.192-1.467-.21-.437-.012-.864.045-1.276.107-.43.065-.848.153-1.245.295-.404.144-.77.366-1.134.584-.364.219-.719.452-1.038.739-.314.28-.634.568-.9.91-.257.329-.452.713-.66 1.094-.2.365-.415.737-.566 1.146-.144.39-.191.819-.288 1.244-.125.551-.223 1.12-.263 1.72-.028.434-.055.855-.03 1.265.024.434.02.864.102 1.269.087.424.24.825.389 1.213.153.4.333.787.552 1.145.22.362.508.676.794.99.296.326.62.6.97.845.354.247.71.494 1.107.665.393.168.805.312 1.23.414.414.098.844.187 1.28.229.496.047.976-.004 1.422-.083.478-.085.94-.221 1.36-.415.436-.2.84-.464 1.213-.742.388-.29.737-.622 1.054-.95.349-.361.646-.74.905-1.089.338-.453.638-.847.818-1.159.182-.315.05-.722-.23-.954-.367-.304-.551-.325-.725-.494 0 0-.254-.143-.397.064-.608.875-1.342 1.7-2.281 2.179z\"></path><path fill=\"#AFCA2A\" d=\"M60.607 21.68c-.23 0-.417.186-.417.416 0 .23.187.416.417.416.23 0 .418-.186.418-.416 0-.23-.187-.417-.418-.417\"></path></g></svg>"

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaBrowse = __webpack_require__(615);

var _asdaBrowse2 = _interopRequireDefault(_asdaBrowse);

var _asdaChange = __webpack_require__(616);

var _asdaChange2 = _interopRequireDefault(_asdaChange);

var _asdaCheck = __webpack_require__(617);

var _asdaCheck2 = _interopRequireDefault(_asdaCheck);

var _asdaClose = __webpack_require__(618);

var _asdaClose2 = _interopRequireDefault(_asdaClose);

var _asdaFilter = __webpack_require__(619);

var _asdaFilter2 = _interopRequireDefault(_asdaFilter);

var _asdaMenu = __webpack_require__(620);

var _asdaMenu2 = _interopRequireDefault(_asdaMenu);

var _asdaPlus = __webpack_require__(621);

var _asdaPlus2 = _interopRequireDefault(_asdaPlus);

var _asdaMinus = __webpack_require__(622);

var _asdaMinus2 = _interopRequireDefault(_asdaMinus);

var _asdaPause = __webpack_require__(623);

var _asdaPause2 = _interopRequireDefault(_asdaPause);

var _asdaReload = __webpack_require__(624);

var _asdaReload2 = _interopRequireDefault(_asdaReload);

var _asdaSearch = __webpack_require__(625);

var _asdaSearch2 = _interopRequireDefault(_asdaSearch);

var _asdaSort = __webpack_require__(626);

var _asdaSort2 = _interopRequireDefault(_asdaSort);

var _asdaSwap = __webpack_require__(627);

var _asdaSwap2 = _interopRequireDefault(_asdaSwap);

var _asdaZoom = __webpack_require__(628);

var _asdaZoom2 = _interopRequireDefault(_asdaZoom);

var _asdaCaretDown = __webpack_require__(629);

var _asdaCaretDown2 = _interopRequireDefault(_asdaCaretDown);

var _asdaChevronDown = __webpack_require__(630);

var _asdaChevronDown2 = _interopRequireDefault(_asdaChevronDown);

var _asdaMoreActions = __webpack_require__(631);

var _asdaMoreActions2 = _interopRequireDefault(_asdaMoreActions);

var _asdaSortAscending = __webpack_require__(632);

var _asdaSortAscending2 = _interopRequireDefault(_asdaSortAscending);

var _asdaSortDescending = __webpack_require__(633);

var _asdaSortDescending2 = _interopRequireDefault(_asdaSortDescending);

var _asdaBack = __webpack_require__(634);

var _asdaBack2 = _interopRequireDefault(_asdaBack);

var _asdaUpwardsArrow = __webpack_require__(635);

var _asdaUpwardsArrow2 = _interopRequireDefault(_asdaUpwardsArrow);

var _asdaDownArrow = __webpack_require__(636);

var _asdaDownArrow2 = _interopRequireDefault(_asdaDownArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  browse: _asdaBrowse2.default,
  change: _asdaChange2.default,
  check: _asdaCheck2.default,
  close: _asdaClose2.default,
  filter: _asdaFilter2.default,
  menu: _asdaMenu2.default,
  plus: _asdaPlus2.default,
  minus: _asdaMinus2.default,
  pause: _asdaPause2.default,
  reload: _asdaReload2.default,
  search: _asdaSearch2.default,
  sort: _asdaSort2.default,
  swap: _asdaSwap2.default,
  zoom: _asdaZoom2.default,
  'caret-down': _asdaCaretDown2.default,
  'chevron-down': _asdaChevronDown2.default,
  'more-actions': _asdaMoreActions2.default,
  'sort-ascending': _asdaSortAscending2.default,
  'sort-descending': _asdaSortDescending2.default,
  back: _asdaBack2.default,
  upArrow: _asdaUpwardsArrow2.default,
  downArrow: _asdaDownArrow2.default
};

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 12l8 8h-3.5l.7 1.32c.587 1.121 1.392 2.7 1.8 3.68.146.35-.075.8-.398.945-.323.145-.875.145-1.161-.246L22 21l-3 3zM5.5 20h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-7h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-7h19a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.352 10.233l1.414 1.415a.5.5 0 010 .707L14.33 19.79a.5.5 0 01-.133.095l-2.675 1.32a.5.5 0 01-.675-.659l1.266-2.738a.5.5 0 01.1-.144l7.432-7.432a.5.5 0 01.707 0zM21.049 6l-2 2H8.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V12.949l2-2V24a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2zm3.183.354l1.414 1.414a.5.5 0 01.058.638l-.058.07-1.759 1.757a.5.5 0 01-.707 0L21.766 8.82a.5.5 0 010-.707l1.759-1.758a.5.5 0 01.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.803 19.339l9.193-9.193a.5.5 0 01.707 0l.707.708a.5.5 0 010 .707l-9.546 9.546a2 2 0 01-2.828 0l-3.89-3.89a.5.5 0 010-.707l.708-.707a.5.5 0 01.707 0l3.535 3.536a.5.5 0 00.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 17.414L8.575 24.84a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L14.586 16 7.16 8.575a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L16 14.586l7.425-7.425a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L17.414 16l7.425 7.425a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 20c1.306 0 2.418.835 2.83 2h8.67a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-8.671a3.001 3.001 0 01-5.658 0H6.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4.67A3.001 3.001 0 0114 20zm0 2a1 1 0 00-.117 1.993L14 24a1 1 0 00.117-1.993zm7-9c1.306 0 2.418.835 2.83 2h1.67a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1.671a3.001 3.001 0 01-5.658 0H6.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11.67A3.001 3.001 0 0121 13zm0 2a1 1 0 00-.117 1.993L21 17a1 1 0 00.117-1.993zM11 6c1.306 0 2.418.835 2.83 2H25.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13.829a3.001 3.001 0 01-5.658 0H6.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.67A3.001 3.001 0 0111 6zm0 2a1 1 0 00-.117 1.993L11 10a1 1 0 00.117-1.993z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.5 23a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-16a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-6-8a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm9-8a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5 8a.5.5 0 01.5.5v6.499l6.5.001a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H17v6.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V17H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H15V8.5a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.5 15h15a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.5 10a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 6c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.966 9.966 0 01-6.918-2.78 1.024 1.024 0 01-.346-.763 1 1 0 011.76-.65 8 8 0 10-.846-10.673h1.855a1 1 0 110 2H7.763a1.5 1.5 0 01-1.5-1.5V7.89a1 1 0 112 0L8.26 9.666A9.98 9.98 0 0116 6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 5a9 9 0 017.032 14.617l5.1 5.1a.5.5 0 010 .708l-.707.707a.5.5 0 01-.707 0l-5.1-5.1A9 9 0 1114 5zm0 2a7 7 0 100 14 7 7 0 000-14z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.5 22a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm5-7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm7-7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.373 16.103l.652.652a.5.5 0 010 .707L11.487 19H23.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H11.448l1.577 1.577a.5.5 0 010 .707l-.652.652a.5.5 0 01-.707 0l-2.502-2.502a2 2 0 010-2.829l2.502-2.502a.5.5 0 01.707 0zm7.832-8a.5.5 0 01.638-.058l.069.058 2.502 2.502a2 2 0 01.117 2.701l-.117.128-2.502 2.502a.5.5 0 01-.638.058l-.07-.058-.651-.652a.5.5 0 01-.058-.638l.058-.07L21.13 13H9.078a.5.5 0 01-.492-.41l-.008-.09v-1a.5.5 0 01.41-.492l.09-.008H21.09l-1.538-1.538a.5.5 0 01-.058-.638l.058-.069z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 5a9 9 0 017.032 14.617l5.1 5.1a.5.5 0 010 .708l-.707.707a.5.5 0 01-.707 0l-5.1-5.1A9 9 0 1114 5zm0 2a7 7 0 100 14 7 7 0 000-14zm.5 3a.5.5 0 01.5.5v2.499l2.5.001a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H15v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V15h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H13v-2.5a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.546 12h10.91c.462 0 .714.565.418.937l-5.454 6.857a.53.53 0 01-.838 0l-5.455-6.857c-.296-.372-.043-.937.42-.937z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.46 19.339l9.193-9.193a.5.5 0 01.707 0l.707.708a.5.5 0 010 .707l-9.546 9.546a2 2 0 01-2.829 0L5.146 11.56a.5.5 0 010-.707l.708-.708a.5.5 0 01.707 0l9.192 9.193a.5.5 0 00.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 14a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zM8 14a2 2 0 110 4 2 2 0 010-4z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 27 12\"><defs><path id=\"asda_sort_ascending_3\" d=\"M0 10.667h5.333V12H0v-1.333zm0-5.334h8.667v1.334H0V5.333zM0 0h13.333v1.333H0V0z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#68A51C\" class=\"asda-icon__draw\" fill-rule=\"nonzero\" d=\"M5.671 3.414l1.293 1.293A1 1 0 008.38 3.293L5.732.646A1.518 1.518 0 005.62.544C5.486.228 5.112 0 4.671 0c-.44 0-.814.228-.947.544a1.518 1.518 0 00-.113.102L.964 3.293A1 1 0 102.38 4.707l1.29-1.293V11.2c0 .442.448.8 1 .8.553 0 1-.358 1-.8V3.414z\"></path><g transform=\"matrix(1 0 0 -1 13.333 12)\"><mask id=\"asda_sort_ascending_4\" fill=\"#fff\" class=\"asda-icon__draw\"><use xlink:href=\"#asda_sort_ascending_3\"></use></mask><use fill=\"#68A51C\" class=\"asda-icon__draw\" xlink:href=\"#asda_sort_ascending_3\"></use><g fill=\"#68A51C\" class=\"asda-icon__draw\" mask=\"url(#asda_sort_ascending_4)\"><path d=\"M-3.333-4.667h20v20h-20z\"></path></g></g></g></svg>"

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 27 12\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path d=\"M0 10.667h5.333V12H0v-1.333zm0-5.334h8.667v1.334H0V5.333zM0 0h13.333v1.333H0V0z\" id=\"asda_sort_descending_1\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M5.671 8.586l1.293-1.293A1 1 0 018.38 8.707l-2.647 2.647c-.036.036-.074.07-.113.102-.133.316-.507.544-.948.544-.44 0-.814-.228-.947-.544a1.518 1.518 0 01-.113-.102L.964 8.707A1 1 0 112.38 7.293l1.29 1.293V.8c0-.442.448-.8 1-.8.553 0 1 .358 1 .8v7.786z\" fill=\"#68A51C\" class=\"asda-icon__draw\" fill-rule=\"nonzero\"></path><g transform=\"translate(13.333)\"><mask id=\"asda_sort_descending_2\" fill=\"#fff\" class=\"asda-icon__draw\"><use xlink:href=\"#asda_sort_descending_1\"></use></mask><use fill=\"#68A51C\" class=\"asda-icon__draw\" xlink:href=\"#asda_sort_descending_1\"></use><g mask=\"url(#asda_sort_descending_2)\" fill=\"#68A51C\" class=\"asda-icon__draw\"><path d=\"M-3.333-4.667h20v20h-20z\"></path></g></g></g></svg>"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 10 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.46967 17.5303C8.76256 17.8232 9.23744 17.8232 9.53033 17.5303C9.82322 17.2374 9.82322 16.7626 9.53033 16.4697L8.46967 17.5303ZM9.53033 1.53033C9.82322 1.23744 9.82322 0.762563 9.53033 0.46967C9.23744 0.176777 8.76256 0.176777 8.46967 0.46967L9.53033 1.53033ZM9.53033 16.4697L2.23744 9.17678L1.17678 10.2374L8.46967 17.5303L9.53033 16.4697ZM2.23744 8.82322L9.53033 1.53033L8.46967 0.46967L1.17678 7.76256L2.23744 8.82322ZM2.23744 9.17678C2.13981 9.07915 2.13981 8.92086 2.23744 8.82322L1.17678 7.76256C0.49336 8.44598 0.493358 9.55402 1.17678 10.2374L2.23744 9.17678Z\" fill=\"#767676\"></path></svg>"

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.469669 8.46967C0.176775 8.76256 0.176775 9.23744 0.469669 9.53033C0.762562 9.82322 1.23744 9.82322 1.53033 9.53033L0.469669 8.46967ZM16.4697 9.53033C16.7626 9.82322 17.2374 9.82322 17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967L16.4697 9.53033ZM1.53033 9.53033L8.82322 2.23744L7.76256 1.17678L0.469669 8.46967L1.53033 9.53033ZM9.17678 2.23744L16.4697 9.53033L17.5303 8.46967L10.2374 1.17678L9.17678 2.23744ZM8.82322 2.23744C8.92085 2.13981 9.07914 2.13981 9.17678 2.23744L10.2374 1.17678C9.55402 0.49336 8.44598 0.493358 7.76256 1.17678L8.82322 2.23744Z\" fill=\"#3D3D3D\"></path></svg>"

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.5303 1.53033C17.8232 1.23744 17.8232 0.762562 17.5303 0.469669C17.2374 0.176775 16.7626 0.176775 16.4697 0.469669L17.5303 1.53033ZM1.53033 0.469669C1.23744 0.176776 0.762563 0.176776 0.46967 0.469669C0.176776 0.762563 0.176776 1.23744 0.46967 1.53033L1.53033 0.469669ZM16.4697 0.469669L9.17678 7.76256L10.2374 8.82322L17.5303 1.53033L16.4697 0.469669ZM8.82322 7.76256L1.53033 0.469669L0.46967 1.53033L7.76256 8.82322L8.82322 7.76256ZM9.17678 7.76256C9.07915 7.86019 8.92086 7.86019 8.82322 7.76256L7.76256 8.82322C8.44598 9.50664 9.55402 9.50664 10.2374 8.82322L9.17678 7.76256Z\" fill=\"#3D3D3D\"></path></svg>"

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaBrandDeliveryPassSmall = __webpack_require__(638);

var _asdaBrandDeliveryPassSmall2 = _interopRequireDefault(_asdaBrandDeliveryPassSmall);

var _asdaBrandDeliveryPassLarge = __webpack_require__(639);

var _asdaBrandDeliveryPassLarge2 = _interopRequireDefault(_asdaBrandDeliveryPassLarge);

var _asdaBrandExpressLarge = __webpack_require__(640);

var _asdaBrandExpressLarge2 = _interopRequireDefault(_asdaBrandExpressLarge);

var _asdaBrandExpressMedium = __webpack_require__(641);

var _asdaBrandExpressMedium2 = _interopRequireDefault(_asdaBrandExpressMedium);

var _asdaBrandExpressSmall = __webpack_require__(642);

var _asdaBrandExpressSmall2 = _interopRequireDefault(_asdaBrandExpressSmall);

var _asdaBrandExpressSmallWhite = __webpack_require__(643);

var _asdaBrandExpressSmallWhite2 = _interopRequireDefault(_asdaBrandExpressSmallWhite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Brands
exports.default = {
  'delivery-pass-small': _asdaBrandDeliveryPassSmall2.default,
  'delivery-pass-large': _asdaBrandDeliveryPassLarge2.default,
  'express-large': _asdaBrandExpressLarge2.default,
  'express-medium': _asdaBrandExpressMedium2.default,
  'express-small': _asdaBrandExpressSmall2.default,
  'express-small-white': _asdaBrandExpressSmallWhite2.default
};

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 40 24\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\"><path d=\"M4.848 0H38.8A1.2 1.2 0 0140 1.2v21.6a1.2 1.2 0 01-1.2 1.2H1.2A1.2 1.2 0 010 22.8V5.143C0 2.298 2.186 0 4.848 0z\" fill=\"#538316\"></path><path d=\"M1.2 24A1.2 1.2 0 010 22.8v-3.6h40v3.6a1.2 1.2 0 01-1.2 1.2z\" fill=\"#68a51c\"></path><path d=\"M21.75 6a2 2 0 012 2v9.25l-6.788.001a1.876 1.876 0 01-3.674 0L13 17.25a2 2 0 01-2-2V8a2 2 0 012-2zm0 1.5H13a.5.5 0 00-.5.5v7.25a.5.5 0 00.5.5h.625a1.872 1.872 0 013 0h5.125a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zm4.39.75a1.5 1.5 0 011.275.71l1.36 2.2a1.5 1.5 0 01.225.79v3.8a1.5 1.5 0 01-1.5 1.5l-.788.001a1.876 1.876 0 01-3.674 0l-.788-.001v-9zm-.112 1.5H23.75v5.625a1.872 1.872 0 012.625.374l.75.001a.375.375 0 00.375-.375v-3.243a.375.375 0 00-.046-.18l-1.097-2.007a.375.375 0 00-.33-.195zm-10.903 7.5a.375.375 0 100-.75.375.375 0 000 .75zm9.75 0a.375.375 0 100-.75.375.375 0 000 .75z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 69 40\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\"><path d=\"M8.364 0H67a2 2 0 012 2v36a2 2 0 01-2 2H2a2 2 0 01-2-2V8.571C0 3.83 3.77 0 8.364 0z\" fill=\"#538316\"></path><path d=\"M2 40a2 2 0 01-2-2v-6h69v6a2 2 0 01-2 2z\" fill=\"#68a51c\"></path><path d=\"M9.162 16V6.844h2.45c2.8 0 4.452 1.512 4.452 4.536 0 3.038-1.652 4.62-4.368 4.62zm1.624-1.316h.714c1.848 0 2.898-1.05 2.898-3.304 0-2.24-1.05-3.22-2.898-3.22h-.714zm10.126 1.484c-1.904 0-3.388-1.33-3.388-3.598 0-2.24 1.554-3.612 3.164-3.612 1.862 0 2.842 1.344 2.842 3.262 0 .308-.028.616-.07.784h-4.368c.14 1.218.924 1.918 2.03 1.918.588 0 1.092-.182 1.596-.504l.546 1.008c-.658.434-1.484.742-2.352.742zm-1.834-4.256h3.052c0-1.064-.462-1.708-1.4-1.708-.812 0-1.512.602-1.652 1.708zm7.76 4.256c-1.148 0-1.568-.742-1.568-1.932v-8.12h1.61v8.204c0 .392.182.532.35.532.07 0 .126 0 .252-.028l.21 1.204c-.196.084-.476.14-.854.14zM29.264 16V9.126h1.61V16zm.812-8.078c-.574 0-.966-.364-.966-.924 0-.546.392-.91.966-.91s.966.364.966.91c0 .56-.392.924-.966.924zM34.672 16l-2.394-6.874h1.638l1.092 3.57c.182.672.392 1.372.574 2.072h.056c.196-.7.392-1.4.588-2.072l1.092-3.57h1.554L36.534 16zm8.446.168c-1.904 0-3.388-1.33-3.388-3.598 0-2.24 1.554-3.612 3.164-3.612 1.862 0 2.842 1.344 2.842 3.262 0 .308-.028.616-.07.784h-4.368c.14 1.218.924 1.918 2.03 1.918.588 0 1.092-.182 1.596-.504l.546 1.008c-.658.434-1.484.742-2.352.742zm-1.834-4.256h3.052c0-1.064-.462-1.708-1.4-1.708-.812 0-1.512.602-1.652 1.708zM47.476 16V9.126h1.33l.112 1.218h.056c.49-.896 1.218-1.386 1.946-1.386.35 0 .574.042.784.14l-.28 1.4a2.247 2.247 0 00-.714-.112c-.546 0-1.204.378-1.624 1.414V16zm6.108 2.828c-.378 0-.644-.056-.896-.14l.294-1.26c.126.042.322.098.49.098.728 0 1.148-.49 1.372-1.176l.126-.434-2.702-6.79h1.638l1.19 3.374c.196.602.392 1.288.602 1.932h.056c.168-.63.35-1.316.518-1.932l1.036-3.374h1.554l-2.492 7.182c-.574 1.554-1.288 2.52-2.786 2.52zM9.162 29v-9.156h2.884c2.03 0 3.542.7 3.542 2.828 0 2.03-1.512 2.968-3.486 2.968h-1.316V29zm1.624-4.662h1.19c1.358 0 2.016-.546 2.016-1.666 0-1.148-.714-1.526-2.072-1.526h-1.134zm7.718 4.83c-1.204 0-2.03-.812-2.03-2.016 0-1.47 1.218-2.24 4.046-2.548-.028-.728-.322-1.344-1.26-1.344-.672 0-1.316.308-1.932.672l-.588-1.078c.756-.476 1.736-.896 2.828-.896 1.708 0 2.562 1.05 2.562 2.968V29H20.8l-.112-.756h-.056c-.616.518-1.316.924-2.128.924zm.518-1.26c.56 0 .98-.28 1.498-.756v-1.54c-1.876.238-2.492.728-2.492 1.414 0 .616.42.882.994.882zm7.158 1.26c-.938 0-1.932-.406-2.604-.952l.756-1.036c.616.476 1.204.77 1.904.77.742 0 1.092-.35 1.092-.826 0-.574-.742-.826-1.47-1.106-.91-.336-1.89-.854-1.89-2.002 0-1.204.952-2.058 2.492-2.058.966 0 1.736.392 2.296.826l-.742.98c-.49-.35-.966-.588-1.512-.588-.686 0-1.022.322-1.022.756 0 .546.658.756 1.4 1.022.938.35 1.974.798 1.974 2.086 0 1.176-.938 2.128-2.674 2.128zm6.234 0c-.938 0-1.932-.406-2.604-.952l.756-1.036c.616.476 1.204.77 1.904.77.742 0 1.092-.35 1.092-.826 0-.574-.742-.826-1.47-1.106-.91-.336-1.89-.854-1.89-2.002 0-1.204.952-2.058 2.492-2.058.966 0 1.736.392 2.296.826l-.742.98c-.49-.35-.966-.588-1.512-.588-.686 0-1.022.322-1.022.756 0 .546.658.756 1.4 1.022.938.35 1.974.798 1.974 2.086 0 1.176-.938 2.128-2.674 2.128zM51.75 21a2 2 0 012 2v9.25l-6.788.001a1.876 1.876 0 01-3.674 0L43 32.25a2 2 0 01-2-2V23a2 2 0 012-2zm0 1.5H43a.5.5 0 00-.5.5v7.25a.5.5 0 00.5.5h.625a1.872 1.872 0 013 0h5.125a.5.5 0 00.5-.5V23a.5.5 0 00-.5-.5zm4.39.75a1.5 1.5 0 011.275.71l1.36 2.2a1.5 1.5 0 01.225.79v3.8a1.5 1.5 0 01-1.5 1.5l-.788.001a1.876 1.876 0 01-3.674 0l-.788-.001v-9zm-.112 1.5H53.75v5.625a1.872 1.872 0 012.625.374l.75.001a.375.375 0 00.375-.375v-3.243a.375.375 0 00-.046-.18l-1.097-2.007a.375.375 0 00-.33-.195zm-10.903 7.5a.375.375 0 100-.75.375.375 0 000 .75zm9.75 0a.375.375 0 100-.75.375.375 0 000 .75z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 147 20\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 20H5.172a2 2 0 110-4h6.31a2 2 0 100-4H2a2 2 0 110-4h7.897a2 2 0 000-4H7.552a2 2 0 110-4H24c5.523 0 10 4.477 10 10s-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1.097-8.33l2.213 2.237a.992.992 0 010 1.395.971.971 0 01-1.381 0l-2.35-2.375A2 2 0 0123 9.52V5.976a.976.976 0 111.953 0V9.32a.5.5 0 00.144.352z\" fill=\"#68a51c\"></path><path d=\"M42.478 5.152l-.286 3.63h5.61c.499 0 .876.106 1.133.319.257.213.385.517.385.913 0 .953-.565 1.43-1.694 1.43h-5.632l-.308 3.894h6.05c.484 0 .858.11 1.122.33s.396.528.396.924c0 .939-.58 1.408-1.738 1.408h-7.788c-.513 0-.898-.14-1.155-.418-.257-.279-.363-.675-.319-1.188l.968-12.298c.044-.513.216-.91.517-1.188s.708-.418 1.221-.418h7.788c.499 0 .876.11 1.133.33.257.22.385.52.385.902 0 .953-.572 1.43-1.716 1.43zM63.426 2.93c.323-.381.711-.572 1.166-.572.396 0 .74.147 1.034.44s.44.645.44 1.056c0 .381-.147.748-.44 1.1l-4.576 5.214 4.026 5.368c.22.279.33.587.33.924 0 .44-.176.832-.528 1.177s-.748.517-1.188.517c-.425 0-.785-.19-1.078-.572l-3.74-5.126-4.356 5.126c-.323.381-.711.572-1.166.572-.396 0-.74-.147-1.034-.44s-.44-.645-.44-1.056c0-.396.154-.77.462-1.122l4.73-5.456-3.718-5.126a1.43 1.43 0 01-.308-.902c0-.44.176-.832.528-1.177s.748-.517 1.188-.517.8.19 1.078.572l3.432 4.774zm13.6-.44c1.643 0 2.919.407 3.828 1.221s1.364 1.918 1.364 3.311c0 1.657-.488 2.93-1.463 3.817-.975.887-2.372 1.331-4.191 1.331h-3.762l-.33 4.268c-.044.513-.231.924-.561 1.232-.33.308-.759.462-1.287.462s-.935-.154-1.221-.462-.407-.726-.363-1.254l.968-12.32c.044-.513.216-.91.517-1.188s.708-.418 1.221-.418zm-.77 7.084c1.833 0 2.75-.785 2.75-2.354 0-.719-.198-1.25-.594-1.595s-1.005-.517-1.826-.517h-3.234L73 9.574zm21.344 6.38c.117.264.176.499.176.704 0 .425-.18.788-.539 1.089s-.766.451-1.221.451c-.308 0-.59-.08-.847-.242-.257-.161-.466-.403-.627-.726l-2.046-4.18c-.19-.381-.425-.656-.704-.825s-.638-.253-1.078-.253h-1.76l-.33 4.466c-.044.513-.227.924-.55 1.232s-.74.462-1.254.462c-.528 0-.935-.154-1.221-.462s-.407-.726-.363-1.254l.968-12.32c.044-.513.216-.91.517-1.188s.708-.418 1.221-.418h5.588c1.613 0 2.867.396 3.762 1.188s1.342 1.877 1.342 3.256c0 1.364-.334 2.442-1.001 3.234-.667.792-1.69 1.305-3.069 1.54.381.103.704.282.968.539.264.257.513.62.748 1.089zm-4.818-6.578c.865 0 1.522-.19 1.969-.572s.671-.939.671-1.672c0-.69-.19-1.199-.572-1.529s-.968-.495-1.76-.495h-3.63l-.308 4.268zm13.6-4.224l-.286 3.63h5.61c.499 0 .876.106 1.133.319s.385.517.385.913c0 .953-.565 1.43-1.694 1.43h-5.632l-.308 3.894h6.05c.484 0 .858.11 1.122.33s.396.528.396.924c0 .939-.58 1.408-1.738 1.408h-7.788c-.513 0-.898-.14-1.155-.418s-.363-.675-.319-1.188l.968-12.298c.044-.513.216-.91.517-1.188s.708-.418 1.221-.418h7.788c.499 0 .876.11 1.133.33s.385.52.385.902c0 .953-.572 1.43-1.716 1.43zm15.69 13.046c-1.159 0-2.215-.121-3.168-.363s-1.738-.561-2.354-.957c-.25-.176-.44-.385-.572-.627s-.198-.488-.198-.737c0-.367.11-.682.33-.946s.506-.396.858-.396c.293 0 .587.088.88.264.513.323 1.148.587 1.903.792s1.573.308 2.453.308c.953 0 1.683-.147 2.189-.44s.759-.711.759-1.254a1.24 1.24 0 00-.407-.935c-.271-.257-.62-.466-1.045-.627s-1.005-.352-1.738-.572c-1.085-.323-1.969-.634-2.651-.935s-1.269-.752-1.76-1.353c-.491-.601-.737-1.379-.737-2.332s.264-1.793.792-2.519 1.276-1.287 2.244-1.683 2.097-.594 3.388-.594c1.085 0 2.097.132 3.036.396s1.687.623 2.244 1.078c.367.279.55.66.55 1.144 0 .367-.117.69-.352.968s-.535.418-.902.418c-.308 0-.616-.103-.924-.308-.455-.293-1.012-.539-1.672-.737s-1.342-.297-2.046-.297c-.924 0-1.646.161-2.167.484s-.781.77-.781 1.342c0 .396.143.726.429.99s.645.48 1.078.649 1.03.363 1.793.583c1.056.308 1.921.612 2.596.913.675.3 1.25.737 1.727 1.309s.715 1.32.715 2.244c0 1.496-.568 2.658-1.705 3.487s-2.732 1.243-4.785 1.243zm15.822 0c-1.159 0-2.215-.121-3.168-.363s-1.738-.561-2.354-.957c-.25-.176-.44-.385-.572-.627s-.198-.488-.198-.737c0-.367.11-.682.33-.946s.506-.396.858-.396c.293 0 .587.088.88.264.513.323 1.148.587 1.903.792s1.573.308 2.453.308c.953 0 1.683-.147 2.189-.44s.759-.711.759-1.254a1.24 1.24 0 00-.407-.935c-.271-.257-.62-.466-1.045-.627s-1.005-.352-1.738-.572c-1.085-.323-1.969-.634-2.651-.935s-1.269-.752-1.76-1.353c-.491-.601-.737-1.379-.737-2.332s.264-1.793.792-2.519 1.276-1.287 2.244-1.683 2.097-.594 3.388-.594c1.085 0 2.097.132 3.036.396s1.687.623 2.244 1.078c.367.279.55.66.55 1.144 0 .367-.117.69-.352.968s-.535.418-.902.418c-.308 0-.616-.103-.924-.308-.455-.293-1.012-.539-1.672-.737s-1.342-.297-2.046-.297c-.924 0-1.646.161-2.167.484s-.781.77-.781 1.342c0 .396.143.726.429.99s.645.48 1.078.649 1.03.363 1.793.583c1.056.308 1.921.612 2.596.913.675.3 1.25.737 1.727 1.309s.715 1.32.715 2.244c0 1.496-.568 2.658-1.705 3.487s-2.732 1.243-4.785 1.243z\" fill=\"#3d3d3d\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 93 12\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M25.486 2.824l-.182 2.31h3.57c.317 0 .558.068.721.203.163.135.245.329.245.581 0 .607-.36.91-1.078.91h-3.584l-.196 2.478h3.85c.308 0 .546.07.714.21s.252.336.252.588c0 .597-.369.896-1.106.896h-4.956c-.327 0-.572-.089-.735-.266-.163-.177-.231-.43-.203-.756l.616-7.826c.028-.327.138-.579.329-.756s.45-.266.777-.266h4.956c.317 0 .558.07.721.21.163.14.245.331.245.574 0 .607-.364.91-1.092.91zM38.862 1.41c.205-.243.453-.364.742-.364.252 0 .471.093.658.28s.28.41.28.672c0 .243-.093.476-.28.7L37.35 6.016l2.562 3.416c.14.177.21.373.21.588 0 .28-.112.53-.336.749s-.476.329-.756.329c-.27 0-.5-.121-.686-.364l-2.38-3.262-2.772 3.262c-.205.243-.453.364-.742.364-.252 0-.471-.093-.658-.28s-.28-.41-.28-.672c0-.252.098-.49.294-.714l3.01-3.472-2.366-3.262a.91.91 0 01-.196-.574c0-.28.112-.53.336-.749s.476-.329.756-.329.509.121.686.364l2.184 3.038zm8.7-.28c1.045 0 1.857.259 2.436.777s.868 1.22.868 2.107c0 1.055-.31 1.864-.931 2.429s-1.51.847-2.667.847h-2.394l-.21 2.716c-.028.327-.147.588-.357.784-.21.196-.483.294-.819.294s-.595-.098-.777-.294-.259-.462-.231-.798l.616-7.84c.028-.327.138-.579.329-.756s.45-.266.777-.266zm-.49 4.508c1.167 0 1.75-.5 1.75-1.498 0-.457-.126-.796-.378-1.015s-.64-.329-1.162-.329h-2.058L45 5.638zM60.7 9.698c.075.168.112.317.112.448 0 .27-.114.502-.343.693s-.488.287-.777.287a.993.993 0 01-.539-.154 1.118 1.118 0 01-.399-.462l-1.302-2.66c-.121-.243-.27-.418-.448-.525s-.406-.161-.686-.161h-1.12l-.21 2.842c-.028.327-.145.588-.35.784s-.471.294-.798.294c-.336 0-.595-.098-.777-.294s-.259-.462-.231-.798l.616-7.84c.028-.327.138-.579.329-.756s.45-.266.777-.266h3.556c1.027 0 1.825.252 2.394.756s.854 1.195.854 2.072c0 .868-.212 1.554-.637 2.058s-1.076.83-1.953.98c.243.065.448.18.616.343s.327.394.476.693zm-3.066-4.186c.55 0 .968-.121 1.253-.364s.427-.597.427-1.064c0-.439-.121-.763-.364-.973s-.616-.315-1.12-.315h-2.31l-.196 2.716zm8.7-2.688l-.182 2.31h3.57c.317 0 .558.068.721.203.163.135.245.329.245.581 0 .607-.36.91-1.078.91h-3.584l-.196 2.478h3.85c.308 0 .546.07.714.21s.252.336.252.588c0 .597-.369.896-1.106.896h-4.956c-.327 0-.572-.089-.735-.266-.163-.177-.231-.43-.203-.756l.616-7.826c.028-.327.138-.579.329-.756s.45-.266.777-.266h4.956c.317 0 .558.07.721.21.163.14.245.331.245.574 0 .607-.364.91-1.092.91zm10.03 8.302c-.737 0-1.41-.077-2.016-.231s-1.106-.357-1.498-.609a1.18 1.18 0 01-.364-.399.97.97 0 01-.126-.469c0-.233.07-.434.21-.602s.322-.252.546-.252c.187 0 .373.056.56.168.327.205.73.373 1.211.504s1.001.196 1.561.196c.607 0 1.071-.093 1.393-.28s.483-.453.483-.798c0-.233-.086-.432-.259-.595s-.394-.296-.665-.399-.64-.224-1.106-.364c-.69-.205-1.253-.404-1.687-.595s-.807-.478-1.12-.861-.469-.877-.469-1.484.168-1.141.504-1.603.812-.819 1.428-1.071 1.335-.378 2.156-.378c.69 0 1.335.084 1.932.252s1.073.397 1.428.686c.233.177.35.42.35.728 0 .233-.075.439-.224.616s-.34.266-.574.266c-.196 0-.392-.065-.588-.196-.29-.187-.644-.343-1.064-.469s-.854-.189-1.302-.189c-.588 0-1.048.103-1.379.308s-.497.49-.497.854c0 .252.091.462.273.63s.41.306.686.413.656.231 1.141.371c.672.196 1.223.39 1.652.581s.796.469 1.099.833c.303.364.455.84.455 1.428 0 .952-.362 1.692-1.085 2.219-.723.527-1.738.791-3.045.791zm10.114 0c-.737 0-1.41-.077-2.016-.231s-1.106-.357-1.498-.609a1.18 1.18 0 01-.364-.399.97.97 0 01-.126-.469c0-.233.07-.434.21-.602s.322-.252.546-.252c.187 0 .373.056.56.168.327.205.73.373 1.211.504s1.001.196 1.561.196c.607 0 1.071-.093 1.393-.28s.483-.453.483-.798c0-.233-.086-.432-.259-.595s-.394-.296-.665-.399-.64-.224-1.106-.364c-.69-.205-1.253-.404-1.687-.595s-.807-.478-1.12-.861-.469-.877-.469-1.484.168-1.141.504-1.603.812-.819 1.428-1.071 1.335-.378 2.156-.378c.69 0 1.335.084 1.932.252s1.073.397 1.428.686c.233.177.35.42.35.728 0 .233-.075.439-.224.616s-.34.266-.574.266c-.196 0-.392-.065-.588-.196-.29-.187-.644-.343-1.064-.469s-.854-.189-1.302-.189c-.588 0-1.048.103-1.379.308s-.497.49-.497.854c0 .252.091.462.273.63s.41.306.686.413.656.231 1.141.371c.672.196 1.223.39 1.652.581s.796.469 1.099.833c.303.364.455.84.455 1.428 0 .952-.362 1.692-1.085 2.219-.723.527-1.738.791-3.045.791z\" fill=\"#3d3d3d\" fill-rule=\"nonzero\"></path><path d=\"M14.4 12H3.103a1.2 1.2 0 110-2.4H6.89a1.2 1.2 0 100-2.4H1.2a1.2 1.2 0 110-2.4h4.738a1.2 1.2 0 100-2.4H4.53a1.2 1.2 0 110-2.4h9.87a6 6 0 110 12zm0-1.2a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zm.658-4.997l1.328 1.341c.23.232.23.605 0 .837a.583.583 0 01-.824.005l-.005-.005-1.41-1.425a1.2 1.2 0 01-.347-.844V3.586a.586.586 0 111.172 0v2.006a.3.3 0 00.086.21z\" fill=\"#68a51c\"></path></g></svg>"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 21 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.4 12H3.103a1.2 1.2 0 110-2.4H6.89a1.2 1.2 0 100-2.4H1.2a1.2 1.2 0 110-2.4h4.738a1.2 1.2 0 100-2.4H4.53a1.2 1.2 0 110-2.4h9.87a6 6 0 110 12zm0-1.2a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zm.658-4.997l1.328 1.341c.23.232.23.605 0 .837a.583.583 0 01-.824.005l-.005-.005-1.41-1.425a1.2 1.2 0 01-.347-.844V3.586a.586.586 0 111.172 0v2.006a.3.3 0 00.086.21z\" fill=\"#68a51c\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 93 12\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#fff\" fill-rule=\"evenodd\"><path d=\"M14.4 12H3.103a1.2 1.2 0 110-2.4H6.89a1.2 1.2 0 100-2.4H1.2a1.2 1.2 0 110-2.4h4.738a1.2 1.2 0 100-2.4H4.53a1.2 1.2 0 110-2.4h9.87a6 6 0 110 12zm0-1.2a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zm.658-4.997l1.328 1.341c.23.232.23.605 0 .837a.583.583 0 01-.824.005l-.005-.005-1.41-1.425a1.2 1.2 0 01-.347-.844V3.586a.586.586 0 111.172 0v2.006a.3.3 0 00.086.21z\"></path><path d=\"M25.486 2.824l-.182 2.31h3.57c.317 0 .558.068.721.203.163.135.245.329.245.581 0 .607-.36.91-1.078.91h-3.584l-.196 2.478h3.85c.308 0 .546.07.714.21s.252.336.252.588c0 .597-.369.896-1.106.896h-4.956c-.327 0-.572-.089-.735-.266-.163-.177-.231-.43-.203-.756l.616-7.826c.028-.327.138-.579.329-.756s.45-.266.777-.266h4.956c.317 0 .558.07.721.21.163.14.245.331.245.574 0 .607-.364.91-1.092.91zM38.862 1.41c.205-.243.453-.364.742-.364.252 0 .471.093.658.28s.28.41.28.672c0 .243-.093.476-.28.7L37.35 6.016l2.562 3.416c.14.177.21.373.21.588 0 .28-.112.53-.336.749s-.476.329-.756.329c-.27 0-.5-.121-.686-.364l-2.38-3.262-2.772 3.262c-.205.243-.453.364-.742.364-.252 0-.471-.093-.658-.28s-.28-.41-.28-.672c0-.252.098-.49.294-.714l3.01-3.472-2.366-3.262a.91.91 0 01-.196-.574c0-.28.112-.53.336-.749s.476-.329.756-.329.509.121.686.364l2.184 3.038zm8.7-.28c1.045 0 1.857.259 2.436.777s.868 1.22.868 2.107c0 1.055-.31 1.864-.931 2.429s-1.51.847-2.667.847h-2.394l-.21 2.716c-.028.327-.147.588-.357.784-.21.196-.483.294-.819.294s-.595-.098-.777-.294-.259-.462-.231-.798l.616-7.84c.028-.327.138-.579.329-.756s.45-.266.777-.266zm-.49 4.508c1.167 0 1.75-.5 1.75-1.498 0-.457-.126-.796-.378-1.015s-.64-.329-1.162-.329h-2.058L45 5.638zM60.7 9.698c.075.168.112.317.112.448 0 .27-.114.502-.343.693s-.488.287-.777.287a.993.993 0 01-.539-.154 1.118 1.118 0 01-.399-.462l-1.302-2.66c-.121-.243-.27-.418-.448-.525s-.406-.161-.686-.161h-1.12l-.21 2.842c-.028.327-.145.588-.35.784s-.471.294-.798.294c-.336 0-.595-.098-.777-.294s-.259-.462-.231-.798l.616-7.84c.028-.327.138-.579.329-.756s.45-.266.777-.266h3.556c1.027 0 1.825.252 2.394.756s.854 1.195.854 2.072c0 .868-.212 1.554-.637 2.058s-1.076.83-1.953.98c.243.065.448.18.616.343s.327.394.476.693zm-3.066-4.186c.55 0 .968-.121 1.253-.364s.427-.597.427-1.064c0-.439-.121-.763-.364-.973s-.616-.315-1.12-.315h-2.31l-.196 2.716zm8.7-2.688l-.182 2.31h3.57c.317 0 .558.068.721.203.163.135.245.329.245.581 0 .607-.36.91-1.078.91h-3.584l-.196 2.478h3.85c.308 0 .546.07.714.21s.252.336.252.588c0 .597-.369.896-1.106.896h-4.956c-.327 0-.572-.089-.735-.266-.163-.177-.231-.43-.203-.756l.616-7.826c.028-.327.138-.579.329-.756s.45-.266.777-.266h4.956c.317 0 .558.07.721.21.163.14.245.331.245.574 0 .607-.364.91-1.092.91zm10.03 8.302c-.737 0-1.41-.077-2.016-.231s-1.106-.357-1.498-.609a1.18 1.18 0 01-.364-.399.97.97 0 01-.126-.469c0-.233.07-.434.21-.602s.322-.252.546-.252c.187 0 .373.056.56.168.327.205.73.373 1.211.504s1.001.196 1.561.196c.607 0 1.071-.093 1.393-.28s.483-.453.483-.798c0-.233-.086-.432-.259-.595s-.394-.296-.665-.399-.64-.224-1.106-.364c-.69-.205-1.253-.404-1.687-.595s-.807-.478-1.12-.861-.469-.877-.469-1.484.168-1.141.504-1.603.812-.819 1.428-1.071 1.335-.378 2.156-.378c.69 0 1.335.084 1.932.252s1.073.397 1.428.686c.233.177.35.42.35.728 0 .233-.075.439-.224.616s-.34.266-.574.266c-.196 0-.392-.065-.588-.196-.29-.187-.644-.343-1.064-.469s-.854-.189-1.302-.189c-.588 0-1.048.103-1.379.308s-.497.49-.497.854c0 .252.091.462.273.63s.41.306.686.413.656.231 1.141.371c.672.196 1.223.39 1.652.581s.796.469 1.099.833c.303.364.455.84.455 1.428 0 .952-.362 1.692-1.085 2.219-.723.527-1.738.791-3.045.791zm10.114 0c-.737 0-1.41-.077-2.016-.231s-1.106-.357-1.498-.609a1.18 1.18 0 01-.364-.399.97.97 0 01-.126-.469c0-.233.07-.434.21-.602s.322-.252.546-.252c.187 0 .373.056.56.168.327.205.73.373 1.211.504s1.001.196 1.561.196c.607 0 1.071-.093 1.393-.28s.483-.453.483-.798c0-.233-.086-.432-.259-.595s-.394-.296-.665-.399-.64-.224-1.106-.364c-.69-.205-1.253-.404-1.687-.595s-.807-.478-1.12-.861-.469-.877-.469-1.484.168-1.141.504-1.603.812-.819 1.428-1.071 1.335-.378 2.156-.378c.69 0 1.335.084 1.932.252s1.073.397 1.428.686c.233.177.35.42.35.728 0 .233-.075.439-.224.616s-.34.266-.574.266c-.196 0-.392-.065-.588-.196-.29-.187-.644-.343-1.064-.469s-.854-.189-1.302-.189c-.588 0-1.048.103-1.379.308s-.497.49-.497.854c0 .252.091.462.273.63s.41.306.686.413.656.231 1.141.371c.672.196 1.223.39 1.652.581s.796.469 1.099.833c.303.364.455.84.455 1.428 0 .952-.362 1.692-1.085 2.219-.723.527-1.738.791-3.045.791z\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaClock = __webpack_require__(645);

var _asdaClock2 = _interopRequireDefault(_asdaClock);

var _asdaFacebook = __webpack_require__(646);

var _asdaFacebook2 = _interopRequireDefault(_asdaFacebook);

var _asdaHelp = __webpack_require__(647);

var _asdaHelp2 = _interopRequireDefault(_asdaHelp);

var _asdaInfo = __webpack_require__(648);

var _asdaInfo2 = _interopRequireDefault(_asdaInfo);

var _asdaOffer = __webpack_require__(649);

var _asdaOffer2 = _interopRequireDefault(_asdaOffer);

var _asdaPrice = __webpack_require__(650);

var _asdaPrice2 = _interopRequireDefault(_asdaPrice);

var _asdaTwitter = __webpack_require__(651);

var _asdaTwitter2 = _interopRequireDefault(_asdaTwitter);

var _asdaUnavailable = __webpack_require__(652);

var _asdaUnavailable2 = _interopRequireDefault(_asdaUnavailable);

var _asdaIngredient = __webpack_require__(653);

var _asdaIngredient2 = _interopRequireDefault(_asdaIngredient);

var _asdaCircleMinus = __webpack_require__(654);

var _asdaCircleMinus2 = _interopRequireDefault(_asdaCircleMinus);

var _asdaCirclePlus = __webpack_require__(655);

var _asdaCirclePlus2 = _interopRequireDefault(_asdaCirclePlus);

var _asdaPound = __webpack_require__(656);

var _asdaPound2 = _interopRequireDefault(_asdaPound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  clock: _asdaClock2.default,
  facebook: _asdaFacebook2.default,
  help: _asdaHelp2.default,
  info: _asdaInfo2.default,
  offer: _asdaOffer2.default,
  price: _asdaPrice2.default,
  twitter: _asdaTwitter2.default,
  unavailable: _asdaUnavailable2.default,
  ingredient: _asdaIngredient2.default,
  'circle-minus': _asdaCircleMinus2.default,
  'circle-plus': _asdaCirclePlus2.default,
  circlePound: _asdaPound2.default
};

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm0 11a1 1 0 01-1-1v-5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5l-.001 4.5H19.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm1.817 4c.405 0 .826.015 1.264.046a.5.5 0 01.464.499v.947a.5.5 0 01-.5.5l-.686.001c-.93 0-1.11.421-1.11 1.038v1.363h1.646a.5.5 0 01.5.5v.033l-.158 1.167a.5.5 0 01-.495.433h-1.493v4.99a.483.483 0 01-.483.483h-1.331a.5.5 0 01-.5-.5v-4.974H13.5a.5.5 0 01-.5-.5v-1.133a.5.5 0 01.5-.5h1.435V12.82c0-1.826 1.17-2.82 2.882-2.82z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm0 13c.564 0 1 .429 1 1s-.436 1-1 1-1-.429-1-1 .436-1 1-1zm.016-9.016c.42 0 .813.058 1.176.174s.68.296.947.54c.269.245.48.556.632.934.153.378.229.822.229 1.334 0 .36-.058.683-.174.968-.115.285-.26.55-.434.794a9.83 9.83 0 01-.361.477l-.192.23a7.358 7.358 0 00-.536.706 3.392 3.392 0 00-.387.776c-.034.098-.046.288-.035.571a.5.5 0 01-.48.519h-1.042a.5.5 0 01-.495-.428c-.06-.407-.073-.677-.04-.81a3.87 3.87 0 01.34-.907c.147-.28.312-.535.497-.768l.528-.671a4.63 4.63 0 00.419-.628c.11-.204.166-.416.166-.637 0-.36-.098-.634-.292-.82-.195-.186-.45-.279-.766-.279-.295 0-.555.076-.782.227a2.99 2.99 0 00-.31.25.5.5 0 01-.689-.022l-.59-.595a.5.5 0 01-.055-.638l.06-.07c.382-.377.705-.641.968-.791a3.37 3.37 0 011.698-.436z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm.5 8a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm-.5-4a1 1 0 110 2 1 1 0 010-2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c1.038 0 2.001.426 2.696 1.144a3.751 3.751 0 014.768 2.522 3.756 3.756 0 013.05 4.454 3.755 3.755 0 01.646 5.362 3.756 3.756 0 01-1.902 5.053 3.754 3.754 0 01-4.024 3.593 3.749 3.749 0 01-5.234 1.3 3.749 3.749 0 01-5.234-1.3 3.754 3.754 0 01-4.025-3.594 3.756 3.756 0 01-1.901-5.053 3.755 3.755 0 01.646-5.361 3.756 3.756 0 013.05-4.454 3.751 3.751 0 014.768-2.522A3.747 3.747 0 0116 4zm0 2c-.865 0-1.668.355-2.247.953A3.126 3.126 0 009.78 9.055a3.13 3.13 0 00-2.541 3.711 3.13 3.13 0 00-.538 4.468 3.13 3.13 0 001.584 4.212 3.128 3.128 0 003.354 2.994 3.124 3.124 0 004.36 1.084 3.121 3.121 0 004.362-1.084 3.128 3.128 0 003.354-2.995 3.13 3.13 0 001.584-4.211 3.13 3.13 0 00-.537-4.468 3.13 3.13 0 00-2.542-3.711 3.126 3.126 0 00-3.973-2.102A3.122 3.122 0 0016 6zm.89 4c.66 0 1.236.13 1.727.39.253.134.579.387.976.76a.5.5 0 01.078.636l-.059.074-.718.752a.5.5 0 01-.702.02 1.744 1.744 0 00-.293-.23 1.493 1.493 0 00-.762-.195c-.472 0-.847.142-1.125.427s-.416.723-.416 1.317c0 .222.018.445.053.667s.083.445.142.668h2.122a.5.5 0 01.5.5v.688a.5.5 0 01-.5.5h-1.785a4.048 4.048 0 01.035.519c0 .445-.062.828-.186 1.15l-.185.506c-.097.25-.218.512-.38.703v.074H19.5a.5.5 0 01.5.5V21.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-.916a.5.5 0 01.223-.416c.531-.353.903-.672 1.114-.96.36-.488.54-1.066.54-1.734a3.419 3.419 0 00-.035-.5h-1.271a.5.5 0 01-.5-.5v-.632a.5.5 0 01.461-.499l.743-.057h.107a6.935 6.935 0 01-.204-.742 3.522 3.522 0 01-.08-.742c0-.581.095-1.106.284-1.576a3.43 3.43 0 01.788-1.197 3.526 3.526 0 011.196-.76c.46-.18.968-.269 1.523-.269z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm.89 4c.66 0 1.237.13 1.727.39.253.134.579.387.976.76a.5.5 0 01.078.636l-.059.074-.718.752a.5.5 0 01-.702.02 1.744 1.744 0 00-.293-.23 1.493 1.493 0 00-.762-.195c-.472 0-.847.142-1.124.427s-.417.723-.417 1.317c0 .222.018.445.053.667s.083.445.142.668h2.122a.5.5 0 01.5.5v.688a.5.5 0 01-.5.5h-1.785a4.048 4.048 0 01.035.519c0 .445-.062.828-.186 1.15l-.185.506c-.097.25-.218.512-.38.703v.074H19.5a.5.5 0 01.5.5V21.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-.916a.5.5 0 01.223-.416c.532-.353.903-.672 1.115-.96.36-.488.54-1.066.54-1.734a3.419 3.419 0 00-.036-.5h-1.271a.5.5 0 01-.5-.5v-.632a.5.5 0 01.461-.499l.743-.057h.107a6.935 6.935 0 01-.204-.742 3.522 3.522 0 01-.08-.742c0-.581.095-1.106.284-1.576.189-.47.452-.869.788-1.197a3.526 3.526 0 011.196-.76c.46-.18.968-.269 1.523-.269z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm1.919 6c.59 0 1.123.25 1.509.635.459-.092.903-.26 1.294-.49-.152.47-.474.87-.904 1.12A4.05 4.05 0 0021 12.941a4.12 4.12 0 01-1.02 1.048v.265c0 2.668-2.061 5.745-5.83 5.745-1.158 0-2.247-.25-3.15-.822.161.024.322.034.488.034.957 0 1.85-.41 2.544-.957a2.04 2.04 0 01-1.909-1.404 2.047 2.047 0 00.928-.034 2.03 2.03 0 01-1.64-1.819l-.006-.185c.279.149.591.24.928.25a2.002 2.002 0 01-.918-1.674c0-.375.107-.682.278-.98 1.02 1.22 2.525 1.98 4.224 2.072a2.073 2.073 0 01-.044-.467c0-1.115.913-2.014 2.046-2.014z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm7.744 5.672L9.672 23.744A9.959 9.959 0 0016 26c5.523 0 10-4.477 10-10 0-2.4-.846-4.604-2.256-6.328zM16 6C10.477 6 6 10.477 6 16c0 2.4.846 4.604 2.256 6.328L22.328 8.256A9.959 9.959 0 0016 6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\"><path class=\"asda-icon__draw\" fill-rule=\"evenodd\" d=\"M15 25C9.477 25 5 20.523 5 15S9.477 5 15 5s10 4.477 10 10-4.477 10-10 10zm0-1a9 9 0 100-18 9 9 0 000 18zm-4-12h8a1 1 0 010 2h-8a1 1 0 010-2zm0 4h8a1 1 0 010 2h-8a1 1 0 010-2z\"></path></svg>"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm3 9a1 1 0 010 2h-6a1 1 0 010-2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6zm.5 6a.5.5 0 01.5.5V15h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.501L17 19.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5l-.001-2.5H12.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H15v-2.5a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\"><defs><path id=\"2cs7a5ml1a\" d=\"M12 0c1.038 0 2.001.426 2.696 1.144.953-.31 2.008-.235 2.927.254.913.486 1.563 1.312 1.841 2.268.973.165 1.86.709 2.447 1.55.603.861.804 1.912.603 2.904.794.602 1.332 1.507 1.458 2.535.127 1.035-.181 2.048-.812 2.826.43.911.486 1.974.111 2.952-.369.963-1.103 1.707-2.013 2.102-.04.992-.471 1.948-1.237 2.638-.776.7-1.785 1.029-2.787.955-.501.863-1.332 1.509-2.338 1.76-1.008.252-2.048.07-2.896-.46-.848.53-1.888.712-2.896.46-1.006-.251-1.837-.897-2.338-1.76-1.002.074-2.01-.255-2.787-.955-.766-.69-1.197-1.646-1.237-2.638-.91-.395-1.644-1.14-2.013-2.102-.375-.978-.319-2.04.111-2.952-.631-.778-.939-1.791-.812-2.826.126-1.028.664-1.933 1.458-2.535-.201-.992 0-2.043.603-2.905.587-.84 1.474-1.384 2.447-1.549.278-.956.928-1.782 1.84-2.268.92-.49 1.975-.565 2.928-.254C9.999.426 10.962 0 12 0zm0 2c-.865 0-1.668.355-2.247.953-.794-.259-1.673-.196-2.439.212-.76.405-1.302 1.093-1.534 1.89-.81.138-1.55.59-2.04 1.291-.502.718-.67 1.594-.502 2.42-.661.503-1.11 1.256-1.215 2.113-.105.862.151 1.706.677 2.355-.358.76-.405 1.646-.093 2.46.308.802.92 1.423 1.678 1.752.033.827.392 1.623 1.031 2.199.647.583 1.487.857 2.323.795.417.72 1.11 1.257 1.947 1.467.84.21 1.707.059 2.414-.383.707.442 1.573.592 2.414.383.837-.21 1.53-.747 1.947-1.467.836.062 1.676-.212 2.323-.795.639-.576.998-1.372 1.031-2.2.758-.328 1.37-.949 1.678-1.75.312-.815.265-1.701-.093-2.46.526-.65.782-1.494.677-2.356-.106-.857-.554-1.61-1.215-2.113.167-.826 0-1.702-.502-2.42-.49-.7-1.23-1.153-2.04-1.291-.232-.797-.773-1.485-1.534-1.89-.766-.408-1.645-.47-2.44-.212C13.669 2.355 12.866 2 12 2zm.89 4c.66 0 1.237.13 1.727.39.253.134.579.387.976.76.201.19.211.506.022.707l-.003.003-.718.752c-.189.198-.502.207-.702.02-.115-.107-.213-.184-.293-.23-.224-.13-.478-.195-.762-.195-.472 0-.847.142-1.124.427-.278.284-.417.723-.417 1.317 0 .222.018.445.053.667.036.223.083.445.142.668h2.122c.276 0 .5.224.5.5v.688c0 .276-.224.5-.5.5h-1.785c.011.086.02.17.026.25.006.08.01.17.01.269 0 .445-.063.828-.187 1.15-.124.321-.282.875-.565 1.209v.074H15.5c.276 0 .5.224.5.5V17.5c0 .276-.224.5-.5.5h-7c-.276 0-.5-.224-.5-.5v-.916c0-.167.084-.323.223-.416.532-.353.903-.672 1.115-.96.36-.488.54-1.066.54-1.734 0-.086-.003-.17-.009-.25-.006-.08-.015-.164-.027-.25H8.571c-.276 0-.5-.224-.5-.5v-.632c0-.262.201-.479.461-.499l.743-.057h.107c-.083-.247-.15-.495-.204-.742-.053-.247-.08-.495-.08-.742 0-.581.095-1.106.284-1.576.189-.47.452-.869.788-1.197.337-.327.735-.58 1.196-.76.46-.18.968-.269 1.523-.269z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><g><g><g transform=\"translate(-48 -2015) translate(48 2015) translate(4 4)\"><mask id=\"wvpb2l6ftb\" fill=\"#fff\"><use xlink:href=\"#2cs7a5ml1a\"></use></mask><use fill=\"#3D3D3D\" fill-rule=\"nonzero\" xlink:href=\"#2cs7a5ml1a\"></use><g fill=\"#3D3D3D\" mask=\"url(#wvpb2l6ftb)\"><path d=\"M0 0H32V32H0z\" transform=\"translate(-4 -4)\"></path></g></g></g></g></g></svg>"

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaCreditCardBlank = __webpack_require__(658);

var _asdaCreditCardBlank2 = _interopRequireDefault(_asdaCreditCardBlank);

var _asdaCreditCardAddNew = __webpack_require__(659);

var _asdaCreditCardAddNew2 = _interopRequireDefault(_asdaCreditCardAddNew);

var _asdaCreditCardAmex = __webpack_require__(660);

var _asdaCreditCardAmex2 = _interopRequireDefault(_asdaCreditCardAmex);

var _asdaCreditCardCirrus = __webpack_require__(661);

var _asdaCreditCardCirrus2 = _interopRequireDefault(_asdaCreditCardCirrus);

var _asdaCreditCardCvv = __webpack_require__(662);

var _asdaCreditCardCvv2 = _interopRequireDefault(_asdaCreditCardCvv);

var _asdaCreditCardDiners = __webpack_require__(663);

var _asdaCreditCardDiners2 = _interopRequireDefault(_asdaCreditCardDiners);

var _asdaCreditCardDiscover = __webpack_require__(664);

var _asdaCreditCardDiscover2 = _interopRequireDefault(_asdaCreditCardDiscover);

var _asdaCreditCardMaestro = __webpack_require__(665);

var _asdaCreditCardMaestro2 = _interopRequireDefault(_asdaCreditCardMaestro);

var _asdaCreditCardMastercard = __webpack_require__(666);

var _asdaCreditCardMastercard2 = _interopRequireDefault(_asdaCreditCardMastercard);

var _asdaCreditCardPlus = __webpack_require__(667);

var _asdaCreditCardPlus2 = _interopRequireDefault(_asdaCreditCardPlus);

var _asdaCreditCardVisa = __webpack_require__(668);

var _asdaCreditCardVisa2 = _interopRequireDefault(_asdaCreditCardVisa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  'credit-card-blank': _asdaCreditCardBlank2.default,
  'credit-card-add-new': _asdaCreditCardAddNew2.default,
  'credit-card-amex': _asdaCreditCardAmex2.default,
  'credit-card-cirrus': _asdaCreditCardCirrus2.default,
  'credit-card-cvv': _asdaCreditCardCvv2.default,
  'credit-card-diners': _asdaCreditCardDiners2.default,
  'credit-card-discover': _asdaCreditCardDiscover2.default,
  'credit-card-maestro': _asdaCreditCardMaestro2.default,
  'credit-card-master-card': _asdaCreditCardMastercard2.default,
  'credit-card-plus': _asdaCreditCardPlus2.default,
  'credit-card-visa': _asdaCreditCardVisa2.default
};

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M32 5H0V2a2 2 0 012-2h28a2 2 0 012 2zm0 4v11a2 2 0 01-2 2H2a2 2 0 01-2-2V9z\" fill=\"#ccc\"></path><path d=\"M0 5h32v4H0z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#0073b1\"></path><path d=\"M16.5 16h-1a.5.5 0 01-.5-.5V12h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H15V6.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V10h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H17v3.5a.5.5 0 01-.5.5z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#007ecd\"></path><path d=\"M10.72 14H9.47l-.498-1.363H6.69L6.222 14H5l2.22-6h1.218zm-2.119-2.374L7.816 9.4l-.77 2.226zM11.316 14V8h1.723l1.034 4.093L15.096 8h1.727v6h-1.07V9.277L14.622 14h-1.109l-1.128-4.723V14zm6.65 0V8h4.228v1.015h-3.077v1.33h2.863v1.011h-2.863v1.633h3.186V14zm4.733 0l1.949-3.131L22.882 8h1.346l1.143 1.928L26.491 8h1.334l-1.773 2.914L28 14h-1.388l-1.264-2.075L24.08 14z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#000052\"></path><circle cx=\"12\" cy=\"11\" fill=\"#339\" r=\"6\"></circle><circle cx=\"21\" cy=\"11\" fill=\"#06c\" r=\"6\"></circle><path d=\"M16.597 7a5.731 5.731 0 011.596 4 5.731 5.731 0 01-1.596 4A5.731 5.731 0 0115 11a5.73 5.73 0 011.597-4z\" fill=\"#0154a7\"></path></g></svg>"

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2 .5A1.5 1.5 0 00.5 2v18A1.5 1.5 0 002 21.5h28a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0030 .5z\" fill=\"#fff\" stroke=\"#ccc\"></path><g fill-rule=\"nonzero\"><path d=\"M18 11h9a2 2 0 012 2v4a2 2 0 01-2 2h-9a2 2 0 01-2-2v-4a2 2 0 012-2z\" fill=\"#eeacac\"></path><path d=\"M18.474 17v-.408h.876v-2.82h-.696v-.318c.348-.06.6-.156.81-.282h.378v3.42h.792V17zm2.748 0v-.294c1.152-1.146 1.8-1.836 1.8-2.454 0-.438-.24-.75-.726-.75-.318 0-.594.204-.816.462l-.282-.282c.318-.348.66-.582 1.158-.582.708 0 1.146.45 1.146 1.128 0 .72-.654 1.434-1.56 2.382.21-.018.444-.036.642-.036h1.11V17zm4.158.072c-.612 0-1.002-.258-1.26-.54l.252-.324c.228.24.528.456.978.456.462 0 .792-.276.792-.702 0-.456-.312-.762-1.224-.762v-.378c.816 0 1.086-.312 1.086-.714 0-.372-.252-.606-.66-.606-.318 0-.588.162-.816.39l-.264-.312c.294-.276.648-.48 1.098-.48.666 0 1.146.354 1.146.972 0 .462-.282.756-.696.912v.024c.462.108.828.444.828.972 0 .678-.558 1.092-1.26 1.092z\" fill=\"#191919\"></path><path d=\"M1 5h30v4H1z\" fill=\"#ccc\"></path></g></g></svg>"

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2 0h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z\" fill=\"#2183cb\"></path><path d=\"M17.068 17H14.64c-3.673-.052-6.635-2.713-6.635-5.947-.12-3.235 2.724-5.948 6.338-6.053h2.725c3.792-.052 6.873 2.66 6.932 6v.052C23.882 14.339 20.86 17 17.068 17zM14 6c-2.737 0-5 2.263-5 5s2.263 5 5 5 5-2.263 5-5-2.263-5-5-5zm.857 1.571c1.8.486 2.93 2.376 2.468 4.266-.309 1.296-1.234 2.268-2.468 2.592zm-4.176 2.538c.314-1.242 1.257-2.214 2.462-2.538v6.858c-1.834-.486-2.934-2.43-2.462-4.32z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#ffeeda\"></path><path d=\"M32 11v9a2 2 0 01-2 2H15c8.13-1.958 14.436-6.001 17-11z\" fill=\"#ffa200\"></path><circle cx=\"16\" cy=\"11\" fill=\"#fa9a06\" r=\"4\"></circle></g></svg>"

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#000052\"></path><circle cx=\"12\" cy=\"11\" fill=\"#06c\" r=\"6\"></circle><circle cx=\"21\" cy=\"11\" fill=\"#c00\" r=\"6\"></circle><path d=\"M16.597 7a5.731 5.731 0 011.596 4 5.731 5.731 0 01-1.596 4A5.731 5.731 0 0115 11a5.73 5.73 0 011.597-4z\" fill=\"#c70b8c\"></path></g></svg>"

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#353a48\"></path><circle cx=\"12\" cy=\"11\" fill=\"#ed0006\" r=\"6\"></circle><circle cx=\"21\" cy=\"11\" fill=\"#f9a000\" r=\"6\"></circle><path d=\"M16.5 7a5.731 5.731 0 011.597 4 5.731 5.731 0 01-1.597 4 5.731 5.731 0 01-1.597-4c0-1.567.612-2.983 1.597-4z\" fill=\"#ff8150\"></path></g></svg>"

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#0056a2\"></path><path d=\"M14 4l5 7h-7zm-1 0l-2 7H5zM9.286 18L5 12h6z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2 0h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z\" fill=\"#224dba\"></path><path d=\"M10.25 14.945H8.433L7.07 9.515c-.065-.25-.202-.47-.404-.575A5.743 5.743 0 005 8.366v-.21h2.928c.404 0 .707.315.757.68l.707 3.917 1.817-4.596h1.767zm3.736 0H12.27l1.413-6.788h1.716zm3.634-4.908c.05-.365.354-.574.707-.574a3.08 3.08 0 011.666.313l.303-1.462A4.183 4.183 0 0018.731 8c-1.666 0-2.878.94-2.878 2.245 0 .993.859 1.515 1.465 1.829.656.313.908.522.858.835 0 .47-.505.679-1.01.679a4.175 4.175 0 01-1.767-.418l-.303 1.462a4.762 4.762 0 001.868.366c1.868.052 3.029-.888 3.029-2.298 0-1.776-2.373-1.88-2.373-2.663zM26 14.945l-1.363-6.788h-1.464a.762.762 0 00-.707.522l-2.523 6.266h1.766l.353-.991h2.171l.202.991zm-2.574-4.96l.504 2.558h-1.413z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaGiftCard = __webpack_require__(670);

var _asdaGiftCard2 = _interopRequireDefault(_asdaGiftCard);

var _asdaGiftCardCode = __webpack_require__(671);

var _asdaGiftCardCode2 = _interopRequireDefault(_asdaGiftCardCode);

var _asdaGiftCardXmas = __webpack_require__(672);

var _asdaGiftCardXmas2 = _interopRequireDefault(_asdaGiftCardXmas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  'gift-card': _asdaGiftCard2.default,
  'gift-card-code': _asdaGiftCardCode2.default,
  'gift-card-xmas': _asdaGiftCardXmas2.default
};

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\"><path d=\"M2 0h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z\" fill=\"#68a51c\"></path><path d=\"M26.573 7.23h-2.681l-1.53 4.629a4.81 4.81 0 00.081-.825c0-1.94-1.062-3.803-3.558-3.803H16.02l.008 4.604c-.247-1.308-1.39-1.66-2.811-2.11-.531-.172-.823-.444-.716-.697.09-.221.416-.29.811-.233.603.09 1.085.301 1.548.565l.634-1.642C15.35 7.644 14.323 7 13.037 7c-1.793 0-2.939.915-2.939 2.266 0 1.203.709 1.903 2.012 2.295 1.402.426 1.757.597 1.715 1.018-.037.364-.905.806-3.03-.562l-.632 1.367-1.95-6.153h-2.68L3 14.88h2.113l.409-1.236H8l.421 1.235h2.218l-.252-.748c.75.453 1.68.868 2.792.868 1.704 0 2.625-.973 2.845-1.906v1.786h2.858c1.704 0 2.595-.85 3.06-1.759l-.584 1.76h2.111l.423-1.236h2.516l.371 1.235H29zM6 12l1.027-3L8 12zm12 1V9h.502C19.218 9 20 9.328 20 11c0 1.48-.69 2-1.492 2zm6-1l.98-3L26 12z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2 .5A1.5 1.5 0 00.5 2v18A1.5 1.5 0 002 21.5h28a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0030 .5z\" fill=\"#fff\" stroke=\"#ccc\"></path><g fill-rule=\"nonzero\"><path d=\"M15 3h12a2 2 0 012 2v4a2 2 0 01-2 2H15a2 2 0 01-2-2V5a2 2 0 012-2z\" fill=\"#eeacac\"></path><path d=\"M15.474 9v-.408h.876v-2.82h-.696v-.318c.348-.06.6-.156.81-.282h.378v3.42h.792V9zm2.748 0v-.294c1.152-1.146 1.8-1.836 1.8-2.454 0-.438-.24-.75-.726-.75-.318 0-.594.204-.816.462l-.282-.282c.318-.348.66-.582 1.158-.582.708 0 1.146.45 1.146 1.128 0 .72-.654 1.434-1.56 2.382.21-.018.444-.036.642-.036h1.11V9zm4.158.072c-.612 0-1.002-.258-1.26-.54l.252-.324c.228.24.528.456.978.456.462 0 .792-.276.792-.702 0-.456-.312-.762-1.224-.762v-.378c.816 0 1.086-.312 1.086-.714 0-.372-.252-.606-.66-.606-.318 0-.588.162-.816.39l-.264-.312c.294-.276.648-.48 1.098-.48.666 0 1.146.354 1.146.972 0 .462-.282.756-.696.912v.024c.462.108.828.444.828.972 0 .678-.558 1.092-1.26 1.092zm2.19-1.524h1.2v-1.11c0-.204.018-.534.03-.738h-.024c-.096.186-.204.354-.312.54zM25.77 9V7.944h-1.722V7.62l1.638-2.448h.552v2.376h.522v.396h-.522V9z\" fill=\"#191919\"></path><path d=\"M3.408 10v-.568c.512-.256.848-.744.848-1.328 0-.112-.016-.216-.032-.328h-.8v-.552l.536-.04h.096c-.088-.28-.168-.552-.168-.816 0-.96.656-1.552 1.6-1.552.584 0 .992.24 1.312.624l-.512.504c-.2-.232-.416-.376-.72-.376-.496 0-.792.312-.792.848 0 .264.064.512.136.768h1.232v.592H5.048c.016.104.024.216.024.336 0 .472-.136.768-.424 1.072v.032h2.16V10z\" fill=\"#3d3d3d\"></path><path d=\"M5 15h22a2 2 0 110 4H5a2 2 0 110-4z\" fill=\"#ccc\"></path></g></g></svg>"

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\"><path d=\"M2 0h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z\" fill=\"#d43030\"></path><path d=\"M4.486 12L6.07 8.994 4.576 6.15h1.728l.396.954c.126.27.252.594.414.972h.036c.126-.378.252-.702.36-.972l.342-.954h1.656L8.014 9.066 9.598 12H7.87l-.468-1.044c-.144-.306-.27-.612-.414-.972h-.036c-.126.36-.252.666-.378.972L6.142 12zm6.05 0V6.15h1.656l.882 2.394c.108.324.198.684.306 1.026h.036c.108-.342.198-.702.306-1.026l.846-2.394h1.656V12H14.82v-1.728c0-.594.126-1.503.198-2.088h-.036l-.486 1.404-.72 1.935h-.828l-.72-1.935-.468-1.404h-.036c.072.585.198 1.494.198 2.088V12zm8.696-2.844l-.099.405h1.08l-.099-.405c-.144-.558-.288-1.269-.432-1.854h-.036c-.126.594-.27 1.296-.414 1.854zM16.982 12l1.782-5.85h1.872L22.418 12H20.78l-.288-1.242h-1.638L18.566 12zm8.048.108c-.738 0-1.584-.27-2.214-.837l.882-1.062c.414.333.936.567 1.368.567.468 0 .666-.153.666-.414 0-.279-.297-.369-.792-.567l-.729-.306c-.63-.252-1.179-.783-1.179-1.629 0-.999.9-1.818 2.178-1.818.666 0 1.404.252 1.944.783l-.774.972c-.396-.279-.738-.423-1.17-.423-.378 0-.612.135-.612.396 0 .279.333.378.864.585l.711.279c.729.288 1.143.792 1.143 1.602 0 .99-.828 1.872-2.286 1.872zM6.034 18.084a2.499 2.499 0 01-1.687-.658l.588-.707c.329.28.749.476 1.127.476.427 0 .637-.168.637-.441 0-.287-.259-.378-.658-.546l-.595-.252c-.469-.189-.917-.581-.917-1.246 0-.756.672-1.358 1.624-1.358.525 0 1.078.21 1.47.602l-.525.651c-.301-.231-.581-.364-.945-.364-.357 0-.581.154-.581.413 0 .28.301.378.693.539l.588.238c.553.224.903.595.903 1.239 0 .756-.63 1.414-1.722 1.414zm4.57-2.394l-.112.42h.973l-.105-.42c-.126-.455-.252-.994-.371-1.47h-.028c-.112.483-.231 1.015-.357 1.47zM8.952 18l1.428-4.564h1.239L13.047 18h-1.092l-.28-1.085h-1.393L10.002 18zm6.257 0l-1.379-4.564h1.092l.546 2.128c.14.497.231.959.371 1.463h.028c.133-.504.231-.966.364-1.463l.539-2.128h1.05L16.448 18zm4.101 0v-4.564h2.856v.868h-1.827v.917h1.554v.861h-1.554v1.05h1.897V18zm4.836 0v-4.564h1.645c.966 0 1.757.336 1.757 1.421 0 .672-.322 1.099-.812 1.316L27.772 18h-1.155l-.875-1.645h-.567V18zm1.029-2.464h.532c.539 0 .833-.231.833-.679s-.294-.602-.833-.602h-.532z\" fill=\"#fff\"></path></g></svg>"

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaAccount = __webpack_require__(674);

var _asdaAccount2 = _interopRequireDefault(_asdaAccount);

var _asdaAddToList = __webpack_require__(675);

var _asdaAddToList2 = _interopRequireDefault(_asdaAddToList);

var _asdaAddress = __webpack_require__(676);

var _asdaAddress2 = _interopRequireDefault(_asdaAddress);

var _asdaAlert = __webpack_require__(677);

var _asdaAlert2 = _interopRequireDefault(_asdaAlert);

var _asdaBag = __webpack_require__(678);

var _asdaBag2 = _interopRequireDefault(_asdaBag);

var _asdaBarcode = __webpack_require__(679);

var _asdaBarcode2 = _interopRequireDefault(_asdaBarcode);

var _asdaCalendar = __webpack_require__(680);

var _asdaCalendar2 = _interopRequireDefault(_asdaCalendar);

var _asdaCamera = __webpack_require__(681);

var _asdaCamera2 = _interopRequireDefault(_asdaCamera);

var _asdaClickCollect = __webpack_require__(682);

var _asdaClickCollect2 = _interopRequireDefault(_asdaClickCollect);

var _asdaConversation = __webpack_require__(683);

var _asdaConversation2 = _interopRequireDefault(_asdaConversation);

var _asdaCook = __webpack_require__(684);

var _asdaCook2 = _interopRequireDefault(_asdaCook);

var _asdaDeliveryPass = __webpack_require__(685);

var _asdaDeliveryPass2 = _interopRequireDefault(_asdaDeliveryPass);

var _asdaEvents = __webpack_require__(686);

var _asdaEvents2 = _interopRequireDefault(_asdaEvents);

var _asdaFeedback = __webpack_require__(687);

var _asdaFeedback2 = _interopRequireDefault(_asdaFeedback);

var _asdaGroceries = __webpack_require__(688);

var _asdaGroceries2 = _interopRequireDefault(_asdaGroceries);

var _asdaHeartFilled = __webpack_require__(689);

var _asdaHeartFilled2 = _interopRequireDefault(_asdaHeartFilled);

var _asdaHeartOutlined = __webpack_require__(690);

var _asdaHeartOutlined2 = _interopRequireDefault(_asdaHeartOutlined);

var _asdaHome = __webpack_require__(691);

var _asdaHome2 = _interopRequireDefault(_asdaHome);

var _asdaList = __webpack_require__(692);

var _asdaList2 = _interopRequireDefault(_asdaList);

var _asdaLock = __webpack_require__(693);

var _asdaLock2 = _interopRequireDefault(_asdaLock);

var _asdaLockers = __webpack_require__(694);

var _asdaLockers2 = _interopRequireDefault(_asdaLockers);

var _asdaMail = __webpack_require__(695);

var _asdaMail2 = _interopRequireDefault(_asdaMail);

var _asdaMap = __webpack_require__(696);

var _asdaMap2 = _interopRequireDefault(_asdaMap);

var _asdaMarket = __webpack_require__(697);

var _asdaMarket2 = _interopRequireDefault(_asdaMarket);

var _asdaMic = __webpack_require__(698);

var _asdaMic2 = _interopRequireDefault(_asdaMic);

var _asdaNoAlcohol = __webpack_require__(699);

var _asdaNoAlcohol2 = _interopRequireDefault(_asdaNoAlcohol);

var _asdaOrders = __webpack_require__(700);

var _asdaOrders2 = _interopRequireDefault(_asdaOrders);

var _asdaParkRide = __webpack_require__(701);

var _asdaParkRide2 = _interopRequireDefault(_asdaParkRide);

var _asdaPayment = __webpack_require__(702);

var _asdaPayment2 = _interopRequireDefault(_asdaPayment);

var _asdaPetrol = __webpack_require__(703);

var _asdaPetrol2 = _interopRequireDefault(_asdaPetrol);

var _asdaPizza = __webpack_require__(704);

var _asdaPizza2 = _interopRequireDefault(_asdaPizza);

var _asdaPreferences = __webpack_require__(705);

var _asdaPreferences2 = _interopRequireDefault(_asdaPreferences);

var _asdaPrinter = __webpack_require__(706);

var _asdaPrinter2 = _interopRequireDefault(_asdaPrinter);

var _asdaRecipes = __webpack_require__(707);

var _asdaRecipes2 = _interopRequireDefault(_asdaRecipes);

var _asdaSettings = __webpack_require__(708);

var _asdaSettings2 = _interopRequireDefault(_asdaSettings);

var _asdaShow = __webpack_require__(709);

var _asdaShow2 = _interopRequireDefault(_asdaShow);

var _asdaTrash = __webpack_require__(710);

var _asdaTrash2 = _interopRequireDefault(_asdaTrash);

var _asdaTrolley = __webpack_require__(711);

var _asdaTrolley2 = _interopRequireDefault(_asdaTrolley);

var _asdaTruck = __webpack_require__(712);

var _asdaTruck2 = _interopRequireDefault(_asdaTruck);

var _asdaTube = __webpack_require__(713);

var _asdaTube2 = _interopRequireDefault(_asdaTube);

var _asdaVoucher = __webpack_require__(714);

var _asdaVoucher2 = _interopRequireDefault(_asdaVoucher);

var _asdaSummer = __webpack_require__(715);

var _asdaSummer2 = _interopRequireDefault(_asdaSummer);

var _asdaSupport = __webpack_require__(716);

var _asdaSupport2 = _interopRequireDefault(_asdaSupport);

var _asdaAutomatedCollection = __webpack_require__(717);

var _asdaAutomatedCollection2 = _interopRequireDefault(_asdaAutomatedCollection);

var _asdaInternalCollection = __webpack_require__(718);

var _asdaInternalCollection2 = _interopRequireDefault(_asdaInternalCollection);

var _asdaMapPinChecked = __webpack_require__(719);

var _asdaMapPinChecked2 = _interopRequireDefault(_asdaMapPinChecked);

var _asdaMapPinExpress = __webpack_require__(720);

var _asdaMapPinExpress2 = _interopRequireDefault(_asdaMapPinExpress);

var _asdaMapPinFilled = __webpack_require__(721);

var _asdaMapPinFilled2 = _interopRequireDefault(_asdaMapPinFilled);

var _asdaMapPinOutlined = __webpack_require__(722);

var _asdaMapPinOutlined2 = _interopRequireDefault(_asdaMapPinOutlined);

var _asdaMapPinYourStore = __webpack_require__(723);

var _asdaMapPinYourStore2 = _interopRequireDefault(_asdaMapPinYourStore);

var _asdaNearMeFilled = __webpack_require__(724);

var _asdaNearMeFilled2 = _interopRequireDefault(_asdaNearMeFilled);

var _asdaNearMeOutlined = __webpack_require__(725);

var _asdaNearMeOutlined2 = _interopRequireDefault(_asdaNearMeOutlined);

var _asdaStarFilled = __webpack_require__(726);

var _asdaStarFilled2 = _interopRequireDefault(_asdaStarFilled);

var _asdaStarHalfFilled = __webpack_require__(727);

var _asdaStarHalfFilled2 = _interopRequireDefault(_asdaStarHalfFilled);

var _asdaStarOutlined = __webpack_require__(728);

var _asdaStarOutlined2 = _interopRequireDefault(_asdaStarOutlined);

var _asdaThumbsDownFilled = __webpack_require__(729);

var _asdaThumbsDownFilled2 = _interopRequireDefault(_asdaThumbsDownFilled);

var _asdaThumbsDownOutlined = __webpack_require__(730);

var _asdaThumbsDownOutlined2 = _interopRequireDefault(_asdaThumbsDownOutlined);

var _asdaThumbsUpFilled = __webpack_require__(731);

var _asdaThumbsUpFilled2 = _interopRequireDefault(_asdaThumbsUpFilled);

var _asdaThumbsUpOutlined = __webpack_require__(732);

var _asdaThumbsUpOutlined2 = _interopRequireDefault(_asdaThumbsUpOutlined);

var _asdaVerticalArrowSmall = __webpack_require__(733);

var _asdaVerticalArrowSmall2 = _interopRequireDefault(_asdaVerticalArrowSmall);

var _asdaFavList = __webpack_require__(734);

var _asdaFavList2 = _interopRequireDefault(_asdaFavList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  account: _asdaAccount2.default,
  addToList: _asdaAddToList2.default,
  address: _asdaAddress2.default,
  alert: _asdaAlert2.default,
  bag: _asdaBag2.default,
  barcode: _asdaBarcode2.default,
  calendar: _asdaCalendar2.default,
  camera: _asdaCamera2.default,
  conversation: _asdaConversation2.default,
  cook: _asdaCook2.default,
  events: _asdaEvents2.default,
  feedback: _asdaFeedback2.default,
  groceries: _asdaGroceries2.default,
  home: _asdaHome2.default,
  list: _asdaList2.default,
  lock: _asdaLock2.default,
  lockers: _asdaLockers2.default,
  mail: _asdaMail2.default,
  map: _asdaMap2.default,
  market: _asdaMarket2.default,
  mic: _asdaMic2.default,
  orders: _asdaOrders2.default,
  parkRide: _asdaParkRide2.default,
  payment: _asdaPayment2.default,
  petrol: _asdaPetrol2.default,
  pizza: _asdaPizza2.default,
  preferences: _asdaPreferences2.default,
  printer: _asdaPrinter2.default,
  recipes: _asdaRecipes2.default,
  settings: _asdaSettings2.default,
  show: _asdaShow2.default,
  summer: _asdaSummer2.default,
  support: _asdaSupport2.default,
  trash: _asdaTrash2.default,
  trolley: _asdaTrolley2.default,
  truck: _asdaTruck2.default,
  tube: _asdaTube2.default,
  voucher: _asdaVoucher2.default,
  'automated-collection': _asdaAutomatedCollection2.default,
  'click-collect': _asdaClickCollect2.default,
  'delivery-pass': _asdaDeliveryPass2.default,
  'heart-filled': _asdaHeartFilled2.default,
  'heart-outlined': _asdaHeartOutlined2.default,
  'internal-collection': _asdaInternalCollection2.default,
  'map-pin-checked': _asdaMapPinChecked2.default,
  'map-pin-express': _asdaMapPinExpress2.default,
  'map-pin-filled': _asdaMapPinFilled2.default,
  'map-pin-outlined': _asdaMapPinOutlined2.default,
  'map-pin-your-store': _asdaMapPinYourStore2.default,
  'near-me-filled': _asdaNearMeFilled2.default,
  'near-me-outlined': _asdaNearMeOutlined2.default,
  'no-alcohol': _asdaNoAlcohol2.default,
  'star-filled': _asdaStarFilled2.default,
  'star-half-filled': _asdaStarHalfFilled2.default,
  'star-outlined': _asdaStarOutlined2.default,
  'thumbs-down-filled': _asdaThumbsDownFilled2.default,
  'thumbs-down-outlined': _asdaThumbsDownOutlined2.default,
  'thumbs-up-filled': _asdaThumbsUpFilled2.default,
  'thumbs-up-outlined': _asdaThumbsUpOutlined2.default,
  'vertical-arrow-small': _asdaVerticalArrowSmall2.default,
  'fav-list': _asdaFavList2.default
};

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 14a5 5 0 100-10 5 5 0 000 10zm0 2a8 8 0 018 8v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V24a6 6 0 10-12 0v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V24a8 8 0 018-8zm0-10a3 3 0 110 6 3 3 0 010-6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 14a5 5 0 110-10 5 5 0 010 10zm1-6V6.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V8h-1.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H20v1.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V10h1.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm2 7.326a7.018 7.018 0 002-1.427V26a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2h8.101a7.018 7.018 0 00-1.427 2H8.5a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zM25.899 4H26v.101A7.044 7.044 0 0025.899 4zm-8.507 11c1.054.635 2.288 1 3.608 1v.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM11.5 15h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0 5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0h5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-10h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.498 4a.5.5 0 01.5.5L13.997 8h9.042a2 2 0 011.561.75l2.4 3a2 2 0 010 2.5l-2.4 3a2 2 0 01-1.561.75h-9.042v9.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V19h2l-.001-1H6a2 2 0 01-2-2v-6a2 2 0 012-2h7.996V7h-1.998V4.5a.5.5 0 01.5-.5zm.498 6H6.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h7.496zm8.802 0h-8.801v6h8.801a.5.5 0 00.39-.188l2-2.5a.5.5 0 000-.624l-2-2.5a.5.5 0 00-.39-.188z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 30\"><defs><path id=\"asda_alert_1\" d=\"M24.763 20.992a2.075 2.075 0 01-.069 2.012 2.1 2.1 0 01-1.777.996H7.077a2.1 2.1 0 01-1.777-.996c-.371-.606-.39-1.367-.098-2.012l7.918-14.83A2.098 2.098 0 0114.995 5c.79 0 1.504.44 1.855 1.162l7.913 14.83zM14.998 18.5c-.847 0-1.5.643-1.5 1.5s.653 1.5 1.5 1.5c.846 0 1.5-.643 1.5-1.5s-.654-1.5-1.5-1.5zm1-1.5v-7h-2v7h2z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"asda_alert_2\" fill=\"#fff\" class=\"asda-icon__draw\"><use xlink:href=\"#asda_alert_1\"></use></mask><use fill=\"#DB6751\" class=\"asda-icon__draw\" xlink:href=\"#asda_alert_1\"></use><g fill=\"#68A51C\" class=\"asda-icon__draw\" mask=\"url(#asda_alert_2)\"><path d=\"M0 0h30v30H0z\"></path></g></g></svg>"

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a6 6 0 016 5.999l1.205.001c1.603 0 2.93 1.232 3.03 2.813l.759 12c.105 1.653-1.167 3.078-2.84 3.181l-.095.005L8.036 28C6.359 28 5 26.657 5 25c0-.062.002-.125.006-.187l.759-12C5.865 11.232 7.19 10 8.795 10l1.204-.001.005-.224A6 6 0 0116 4zm7.225 8H8.775c-.535 0-.979.41-1.012.938L7 24.968V25c0 .552.454 1 1.015 1l16.034-.002c.559-.034.984-.51.949-1.06l-.76-12A1.008 1.008 0 0023.224 12zM16 6a4 4 0 00-4 3.999h7.999l-.004-.199A4 4 0 0016 6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2zm-.5 2h-19a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zm-15 3a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm8 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 24a2 2 0 01-2 2H8a2 2 0 01-2-2V6.5a.5.5 0 01.5-.5h19a.5.5 0 01.5.5zm-2-12H8v11.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zm-11.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM24 8H8v2h16z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.5 6a.5.5 0 01.5.5L11.999 8H26a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h1.999L8 6.5a.5.5 0 01.5-.5zm14 4h-19a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zM20 12a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4zm-9.5-2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.691 6H14.309a.5.5 0 00-.447.276l-.79 1.578a.439.439 0 00.08.503l.06.052a.498.498 0 00.677-.095l.016-.022.015-.026A.5.5 0 0114.362 8h2.286a.5.5 0 01.394.192l.05.077c.024.047.05.082.079.107a.498.498 0 00.642.014.38.38 0 00.093-.122.5.5 0 01.443-.268h2.304a.5.5 0 01.442.268c.03.058.064.1.1.128a.498.498 0 00.615-.004.32.32 0 00.066-.073l.03-.051A.5.5 0 0122.349 8h2.297a.5.5 0 01.393.192l.05.077c.021.04.044.072.068.095a.498.498 0 00.595.068l.07-.049a.432.432 0 00.108-.523l-.792-1.584A.5.5 0 0024.691 6zM27 10v14.5a.5.5 0 01-.5.5h-3.133a.5.5 0 01-.5-.5l.003-.056.01-.055c.064-.283.102-.523.115-.72L23 23.5a.5.5 0 01.5-.5H25V10.45a2.5 2.5 0 01-1.5-.95c-.456.607-1.182 1-2 1s-1.544-.393-2-1c-.456.607-1.182 1-2 1s-1.544-.393-2-1a2.5 2.5 0 01-1.5.95v3.128a.5.5 0 01-.588.492 3.826 3.826 0 00-.648-.07H12.5a.5.5 0 01-.5-.5V10a2.503 2.503 0 01-.91-1.332 3.119 3.119 0 01-.079-.525.5.5 0 01.051-.267l1.385-2.77A2 2 0 0114.237 4h10.527a2 2 0 011.789 1.106l1.383 2.767a.5.5 0 01.05.273 3.189 3.189 0 01-.11.635 2.516 2.516 0 01-.876 1.22zM15 26h-5a1.5 1.5 0 01-3 0H6c-1.333-.597-2-1.264-2-2v-1.675a2 2 0 01.103-.633l1.441-4.324A2 2 0 017.442 16h6.322a2 2 0 011.789 1.106l1.309 2.618a.5.5 0 00.447.276H19a2 2 0 012 2v1.528a2 2 0 01-.211.894l-.65 1.302a.5.5 0 01-.448.276H18a1.5 1.5 0 01-3 0zm-9-3.594V23.5a.5.5 0 00.5.5h12c.162 0 .31-.091.382-.236l.065-.13A.5.5 0 0019 23.41v-.91a.5.5 0 00-.5-.5h-2.427a.5.5 0 01-.447-.276l-1.724-3.448a.5.5 0 00-.447-.276H7.802a.5.5 0 00-.474.342l-1.302 3.906a.5.5 0 00-.026.158z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 12h4a2 2 0 012 2v4h3.172l-1.026-1.025A.5.5 0 0122 16.62V7.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5zm0 2v3.5a.5.5 0 00.5.5H18v-3.5a.5.5 0 00-.5-.5zm6 6v5a2 2 0 01-2 2H5.207a.5.5 0 01-.353-.854L8 23v-9a2 2 0 012-2h2V7a2 2 0 012-2h8a2 2 0 012 2v9l3.146 3.146a.5.5 0 01-.353.854zm-2 0h-4a2 2 0 01-2-2v-4h-1.5a.5.5 0 00-.5.5v9.121a.5.5 0 01-.146.354L8.828 25H17.5a.5.5 0 00.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 15v3.5c0 1.933 1.99 3.5 4.444 3.5h11.112C24.01 22 26 20.433 26 18.5V15zm13.7 10c.76 0 1.435.393 1.859 1 .108.059.246.338.416.84a.5.5 0 01-.383.652l-.08.007h-1.015a.454.454 0 01-.365-.19l-.046-.077a.379.379 0 00-.089-.124.443.443 0 00-.571-.005.314.314 0 00-.064.076l-.03.053a.47.47 0 01-.326.26l-.085.008H16.78a.454.454 0 01-.365-.191l-.047-.077a.377.377 0 00-.086-.122.443.443 0 00-.597.014l-.038.045-.036.062a.47.47 0 01-.327.26l-.085.009h-2.125a.453.453 0 01-.364-.19l-.047-.077a.452.452 0 00-.39-.234.44.44 0 00-.267.092.327.327 0 00-.077.089l-.035.064a.5.5 0 01-.21.224l-.072.033h-1.113l-.05-.003-.05-.008a.5.5 0 01-.4-.5l.01-.09.016-.068c.139-.539.44-1.005.846-1.332s1.291-.574 1.858-.45 1.06.47 1.395.95c.424-.607 1.098-1 1.858-1s1.435.393 1.86 1c.423-.607 1.098-1 1.858-1zm-2.2-15a2.5 2.5 0 012.45 3h7.505c.3 0 .545.205.545.458V18.5c0 3.038-2.93 5.5-6.545 5.5h-10.91C6.93 24 4 21.538 4 18.5v-5.042c0-.253.244-.458.545-.458H15.05a2.5 2.5 0 012.45-3zm0 2a.5.5 0 100 1 .5.5 0 000-1zm7-5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-19-1.464a1 1 0 011.302.268l.064.098 3.5 6.062-.054.03H8.075l-2.94-5.092A1 1 0 015.5 5.536zM24.5 9a.5.5 0 100 1 .5.5 0 000-1zM19 6a1 1 0 100-2 1 1 0 000 2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 8a2 2 0 012 2v2h4a2 2 0 011.6.8l2 2.667a2 2 0 01.4 1.2V21a2 2 0 01-2 2h-1a2 2 0 01-3.995.15L21 23h-9a2 2 0 11-3.983-.259A1.997 1.997 0 017 21v-.5a.5.5 0 01.5-.5h1a.5.5 0 01.492.41L9 20.5a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5H5a1 1 0 110-2zm5.75 6H20v7h5.5a.5.5 0 00.5-.5v-3.667a.5.5 0 00-.1-.3L24.15 14.2a.5.5 0 00-.4-.2zM10 16v2H7a1 1 0 010-2zm0-4v2H6a1 1 0 010-2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.5 6a.5.5 0 01.5.5V24a2 2 0 01-2 2H8a2 2 0 01-2-2V6.5a.5.5 0 01.5-.5zM24 11.999H8V23.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zm-3.403 2.528l.707.707a.5.5 0 010 .707l-5.298 5.298a2 2 0 01-2.828 0l-2.122-2.121-.352-.35a.5.5 0 01-.005-.707l.71-.71a.5.5 0 01.704-.002l2.125 2.123a.5.5 0 00.707 0l4.945-4.945a.5.5 0 01.707 0zM24 8H8v1.999h16z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 8a2 2 0 012 2v12a2 2 0 01-2 2H13l-5.223 3.482A.5.5 0 017 27.066V24H6a2 2 0 01-2-2V10a2 2 0 012-2zm-.5 2h-19a.5.5 0 00-.5.5v11a.5.5 0 00.5.5H9v1.796a.25.25 0 00.389.208L12.394 22H25.5a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zm-9 2a.5.5 0 01.492.41l.008.09V15h2.5a.5.5 0 01.492.41l.008.09v1a.5.5 0 01-.41.492L19.5 17H17v2.5a.5.5 0 01-.41.492L16.5 20h-1a.5.5 0 01-.492-.41L15 19.5V17h-2.5a.5.5 0 01-.492-.41L12 16.5v-1a.5.5 0 01.41-.492L12.5 15H15v-2.5a.5.5 0 01.41-.492L15.5 12z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.597 12.946l.04.021 4.792 2.766a1.5 1.5 0 001.398 1.773 2 2 0 003.724 1.184l7.315 4.224a.5.5 0 01.183.683l-.025.039-.152.21a6.78 6.78 0 01-.126.166c-3.176 4.036-8.917 5.232-13.494 2.589-4.499-2.597-6.348-8.02-4.601-12.732l.138-.353.144-.325a.5.5 0 01.664-.245zM24.5 4a.5.5 0 01.5.5V6l2.6 3.467a2 2 0 01.4 1.2V26a2 2 0 01-2 2h-4.698c.86-.556 1.66-1.225 2.375-2H25.5a.5.5 0 00.5-.5V10.987a.5.5 0 00-.092-.288L24.15 8.21a.5.5 0 00-.409-.21H20.26a.5.5 0 00-.408.211L18.09 10.7a.5.5 0 00-.091.288v6.808l-2-1.155v-5.973a2 2 0 01.4-1.2L19 6V4.5a.5.5 0 01.5-.5zM6.214 15.609a8.506 8.506 0 004.038 9.26 8.506 8.506 0 0010.038-1.133l-4.47-2.581a3.998 3.998 0 01-5.794-2.194 3.488 3.488 0 01-1.494-2.013zm10.31 7.516l.26.966a.5.5 0 01-.966.259l-.26-.966a.5.5 0 01.967-.259zm-4.772-.854a.5.5 0 01.183.683l-.5.866a.5.5 0 11-.866-.5l.5-.866a.5.5 0 01.683-.183zm-2.41-3.292a.5.5 0 01-.353.612l-.966.259a.5.5 0 11-.259-.966l.966-.259a.5.5 0 01.613.354z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 25C9.333 19.9 6 15.7 6 12.4 6 9.7 7.818 7 11 7c1.333 0 3 .9 5 2.7C18 7.9 19.667 7 21 7c3.182 0 5 2.7 5 5.4 0 3.3-3.333 7.5-10 12.6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 12.4c0-1.934-1.234-3.4-3-3.4-.724 0-1.996.687-3.662 2.187L16 12.39l-1.338-1.204C12.996 9.687 11.724 9 11 9c-1.766 0-3 1.466-3 3.4 0 2.303 2.62 5.76 8 10.062 5.38-4.303 8-7.759 8-10.062zM16 25C9.333 19.9 6 15.7 6 12.4 6 9.7 7.818 7 11 7c1.333 0 3 .9 5 2.7C18 7.9 19.667 7 21 7c3.182 0 5 2.7 5 5.4 0 3.3-3.333 7.5-10 12.6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.435 4.707L27.688 14.96a.5.5 0 010 .707l-.795.796a.5.5 0 01-.708 0L25 15.276V26a2 2 0 01-2 2h-5.447a.5.5 0 01-.5-.5v-6.003a.5.5 0 00-.5-.5h-1.034a.5.5 0 00-.5.498l-.018 6.006a.5.5 0 01-.5.499H9a2 2 0 01-2-2V15.32l-1.144 1.143a.5.5 0 01-.707 0l-.795-.796a.5.5 0 010-.707L14.607 4.707a2 2 0 012.828 0zm-1.768 1.945L9 13.319V25.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V21a2 2 0 012-2h2a2 2 0 012 2v4.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V13.276l-6.626-6.624a.5.5 0 00-.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 4a2 2 0 012 2v20a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2zm-.5 2h-15a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5zm-11 14a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8-5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8-5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 3.999a6 6 0 016 6v1h3.5a.5.5 0 01.5.5V26a2 2 0 01-2 2H8a2 2 0 01-2-2V11.499a.5.5 0 01.5-.5H10v-1a6 6 0 016-6zm8 9H8v12.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zm-8 2a2 2 0 011.001 3.732L17 23.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-4.769A2 2 0 0116 15zm0-9a4 4 0 00-4 4v1h8v-1a4 4 0 00-4-4z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 6.5v17a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5zm-2 17v-17a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h6a.5.5 0 00.5-.5zm8.5 2.5h-15a.5.5 0 00-.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6a2 2 0 012-2h16a2 2 0 012 2v21.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 00-.5-.5zm-13-18h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0 4h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm9-4h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0 4h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM11 18a1 1 0 110-2 1 1 0 010 2zm9 0a1 1 0 110-2 1 1 0 010 2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2zM6 11.603V21.5a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-9.895l-9.41 7.154a1 1 0 01-1.18 0L6.02 11.62zM24.807 10H7.193L16 16.713z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.224 4.112l7.5 3.75a.5.5 0 01.276.447v18.882a.5.5 0 01-.724.447l-7.052-3.526a.5.5 0 00-.448 0l-7.552 3.776a.5.5 0 01-.448 0l-7.5-3.75A.5.5 0 014 23.691V4.809a.5.5 0 01.724-.447l7.052 3.526a.5.5 0 00.448 0l7.552-3.776a.5.5 0 01.448 0zM20 6.236l-8 4-6-3v15.528l6 3 8-4 6 3v-6.559l-.037.017a1 1 0 01-1.27-.393l-.054-.104a1 1 0 01.497-1.324c.281-.127.569-.267.864-.418V9.236zm2.492 11.054a1 1 0 01.38 1.963 8.536 8.536 0 01-1.643.164 7.51 7.51 0 01-.658-.033 1 1 0 11.184-1.991c.163.015.324.023.478.024.408 0 .817-.042 1.26-.127zm-12.31-3.522l1.06 1.06 1.061-1.06a.5.5 0 01.707 0l.708.707a.5.5 0 010 .707l-1.06 1.06 1.06 1.061a.5.5 0 010 .707l-.708.708a.5.5 0 01-.707 0l-1.06-1.061-1.061 1.06a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l1.06-1.06-1.06-1.061a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0zm4.975 2.277a1 1 0 011.381-.304c.563.359 1.107.66 1.632.903a1 1 0 01-.84 1.815 15.86 15.86 0 01-1.868-1.033 1 1 0 01-.305-1.381z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.5 6a.5.5 0 01.5.5v19a.5.5 0 01-.5.5H17v-6h-2v6H6.5a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5zm-6.243 7.264a.5.5 0 00-.447.007c-.162.084-.29.148-.386.19A5.888 5.888 0 0116 14c-.813 0-1.617-.18-2.41-.532a7.861 7.861 0 01-.4-.197.5.5 0 00-.448-.006l-.103.05a8.812 8.812 0 01-.243.111c-.867.38-1.663.574-2.396.574-.62 0-1.285-.139-2-.411V24h5v-5.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V24h5V13.588c-.715.273-1.38.412-2 .412-.713 0-1.486-.184-2.326-.543-.1-.043-.24-.108-.417-.193zM24 8H8v3.403c.803.403 1.473.597 2 .597.634 0 1.475-.28 2.504-.868l.268-.154a.5.5 0 01.526.019l.257.17c.843.563 1.653.833 2.445.833s1.602-.27 2.445-.832l.257-.171a.5.5 0 01.526-.019l.268.154c1.029.587 1.87.868 2.504.868.527 0 1.198-.194 2-.597z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.5 13a.5.5 0 01.5.5V16a5 5 0 0010 0v-2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V16a7.002 7.002 0 01-5.999 6.929L17 25h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H15v-2.07A7.002 7.002 0 019 16v-2.5a.5.5 0 01.5-.5zM16 5a4 4 0 014 4v7a4 4 0 11-8 0V9a4 4 0 014-4zm0 2a2 2 0 00-2 2v7a2 2 0 104 0V9a2 2 0 00-2-2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.974 14.27l1.726-1.726.147.832c.102.601.153.976.153 1.124 0 .137-.005.273-.016.408L24 15h-.023c-.29 3.086-3.23 5.57-6.976 5.95L17 26h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H15v-4.758l2.362-2.36c2.472-.436 4.316-2.027 4.6-3.876l.028-.25c.007-.085.01-.17.01-.256l-.007-.084a4.692 4.692 0 00-.02-.146zm3.572-8.523l.707.707a.5.5 0 010 .707L7.161 26.253a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L24.839 5.747a.5.5 0 01.707 0zM21.592 4a.5.5 0 01.49.4l.218 1.058-1.696 1.696L20.369 6h-8.738l-.938 4.672c-.434 2.213-.675 3.545-.692 3.803l.001.155.013.184c.068.734.383 1.432.888 2.041l-1.419 1.417c-.822-.936-1.347-2.057-1.46-3.271L8 15l.016-.088-.012-.205L8 14.5c0-.523.64-3.89 1.918-10.1a.5.5 0 01.49-.4z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 8a2 2 0 012 2v16a2 2 0 01-2 2H8a2 2 0 01-2-2V10a2 2 0 012-2zm-.5 2h-11a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5zm-2 12a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM24 4a2 2 0 011.995 1.85L26 6v16a2 2 0 01-1.85 1.995l-.155.005L24 6.502a.5.5 0 00-.412-.492l-.09-.008L12 6.045h-2V6a2 2 0 011.85-1.995L12 4zm-6.5 14a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-5.656-6c.25 0 .467.043.652.13.184.086.353.21.504.37l-.535.495a.82.82 0 00-.24-.194.622.622 0 00-.287-.065c-.179 0-.32.047-.425.142s-.157.241-.157.439c0 .074.007.148.02.222.014.075.032.149.054.223h.989v.563h-.862l.01.083c.002.027.003.057.003.09 0 .148-.023.276-.07.383s-.124.216-.23.328v.024H13V16h-3v-.563c.2-.082.369-.205.504-.367a.874.874 0 00.204-.579l-.003-.083a1.198 1.198 0 00-.01-.083h-.668v-.532l.454-.031h.04a2.104 2.104 0 01-.077-.247 1.254 1.254 0 01.077-.773c.071-.157.17-.29.297-.399s.278-.194.451-.253c.174-.06.366-.09.575-.09z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#3d3d3d\" class=\"asda-icon__draw\"><path d=\"M16 24a8 8 0 100-16 8 8 0 000 16zm0 2c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10-4.477 10-10 10z\"></path><path d=\"M13 20.128V11h3.136c.504 0 .975.049 1.414.147s.821.261 1.148.49.586.532.777.91.287.842.287 1.393c0 .532-.096.994-.287 1.386s-.45.714-.777.966-.705.439-1.134.56-.887.182-1.372.182h-1.134v3.094zm2.058-4.732h1.008c1.12 0 1.68-.485 1.68-1.456 0-.476-.15-.812-.448-1.008s-.728-.294-1.288-.294h-.952z\"></path></g></svg>"

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 12v-1.5a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5V12zM4 13v-3a2 2 0 012-2h20a2 2 0 012 2v3zm22 2H6v6.5a.5.5 0 00.5.5h19a.5.5 0 00.5-.5zm0 9H6a2 2 0 01-2-2v-9h24v9a2 2 0 01-2 2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a2 2 0 012 2v10.996h2a2 2 0 012 2v4a1 1 0 102 0v-9a2 2 0 01-1.352-3.474l-3.295-3.296a.5.5 0 01.001-.706l.707-.706a.5.5 0 01.707 0l4.646 4.646A2 2 0 0126 11.874v11.122a3 3 0 11-6 0v-3.5a.5.5 0 00-.5-.5H18V26a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2zm-.5 2h-7a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5zm-2 2a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c2.819 0 5.524.486 8.036 1.378l.5.184.221.087a2 2 0 011.043 2.75l-9.353 18.707a.5.5 0 01-.894 0L6.2 8.4a2 2 0 01.894-2.683l.072-.035.374-.148A23.947 23.947 0 0116 4zm0 6c-1.764 0-3.498.207-5.177.612l-.242.06-.3.08a.5.5 0 00-.316.707l1.305 2.607a4 4 0 013.439 6.877L16 23.528l1.374-2.749a1 1 0 01.875-1.748l1.056-2.112a3.001 3.001 0 112.613-5.226l.117-.235a.5.5 0 00-.316-.706l-.472-.123A22.06 22.06 0 0016 10zm-3.755 6.015l1.49 2.98a2 2 0 00-1.49-2.98zM20 13a1 1 0 10.287 1.958l.65-1.306A1 1 0 0020 13zm-6-2a1 1 0 110 2 1 1 0 010-2zm2-5c-2.08 0-4.12.288-6.075.849l-.531.16c-.185.057-.477.159-.877.303a.5.5 0 00-.301.64l.023.054.36.722a.5.5 0 00.589.256l.558-.16c.107-.03.201-.054.284-.076A24.045 24.045 0 0116 8c1.996 0 3.935.244 5.789.703l.442.116c.17.047.365.103.582.166a.5.5 0 00.587-.257l.362-.725a.5.5 0 00-.223-.67l-.053-.023-.563-.2A21.976 21.976 0 0016 6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 14a3.001 3.001 0 01-2 2.829V27.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V16.829a3.001 3.001 0 010-5.658V4.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v6.671A3 3 0 0112 14zm-2 0a1 1 0 00-1.993-.117L8 14a1 1 0 001.993.117zm9 7a3.001 3.001 0 01-2 2.83v3.67a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3.671a3.001 3.001 0 010-5.658V4.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v13.67c1.165.412 2 1.524 2 2.83zm-2 0a1 1 0 00-1.993-.117L15 21a1 1 0 001.993.117zm9-10a3.001 3.001 0 01-2 2.83V27.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13.829a3.001 3.001 0 010-5.658V4.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3.67c1.165.412 2 1.524 2 2.83zm-2 0a1 1 0 00-1.993-.117L22 11a1 1 0 001.993.117z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 5c1.105 0 2 .82 2 1.833v1.834h4c1.105 0 2 .82 2 1.833v11c0 1.013-.895 1.833-2 1.833h-3v1.834C23 26.179 22.105 27 21 27H11c-1.105 0-2-.82-2-1.833v-1.834H6c-1.105 0-2-.82-2-1.833v-11c0-1.013.895-1.833 2-1.833h4V6.833C10 5.821 10.895 5 12 5zm1 15H11v4.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5zm4.5-9h-19c-.276 0-.5.187-.5.417v9.166c0 .23.224.417.5.417H9v-1.667h-.5a.5.5 0 01-.5-.5v-.666a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v.666a.5.5 0 01-.5.5H23V21h2.5c.276 0 .5-.187.5-.417v-9.166c0-.23-.224-.417-.5-.417zm-3 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-3-7h-7a.5.5 0 00-.5.5V9h8V7.5a.5.5 0 00-.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26.5 14a.5.5 0 01.5.5V20a6 6 0 01-6 6H11a6 6 0 01-6-6v-5.5a.5.5 0 01.5-.5zM25 16H7v4a4 4 0 004 4h10a4 4 0 004-4zm.366-9.263a1 1 0 01.366 1.366L22.904 13h-2.309L24 7.103a1 1 0 011.366-.366zM7.75 9.333L7.2 8.6a1 1 0 111.6-1.2l1 1.333a1 1 0 010 1.2l-.55.734.55.733a1 1 0 01-1.6 1.2l-1-1.333a1 1 0 010-1.2zm4-1L11.2 7.6a1 1 0 011.6-1.2l1 1.333a1 1 0 010 1.2l-.55.734.55.733a1 1 0 01-1.6 1.2l-1-1.333a1 1 0 010-1.2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.703 4a1 1 0 01.948.683l.845 2.529a1 1 0 00.494.574l1.616.824a1 1 0 00.77.058l2.399-.796a1 1 0 011.209.502l1.622 3.24a1 1 0 01-.336 1.277l-2.395 1.612a1 1 0 00-.442.83v1.335a1 1 0 00.442.83l2.395 1.611a1 1 0 01.336 1.277l-1.622 3.24a1 1 0 01-1.209.502l-2.4-.796a1 1 0 00-.769.058l-1.616.824a1 1 0 00-.494.574l-.845 2.529a1 1 0 01-.948.683h-3.367a1 1 0 01-.949-.683l-.844-2.529a1 1 0 00-.494-.574l-1.616-.824a1 1 0 00-.77-.058l-2.4.796a1 1 0 01-1.208-.502l-1.622-3.24a1 1 0 01.336-1.277l2.395-1.612a1 1 0 00.442-.83v-1.331a1 1 0 00-.446-.833l-2.42-1.61a1 1 0 01-.336-1.286l1.649-3.24a1 1 0 011.206-.496l2.404.797a1 1 0 00.77-.058l1.616-.824a1 1 0 00.494-.574l.845-2.529A1 1 0 0114.336 4zm-.72 2h-1.926l-.617 1.845a3 3 0 01-1.482 1.723l-1.617.824a3 3 0 01-2.307.175l-1.589-.527-.855 1.681 1.678 1.117a3 3 0 011.338 2.498v1.332a3 3 0 01-1.325 2.489l-1.666 1.12.84 1.68 1.579-.524a3 3 0 012.307.175l1.616.824a3 3 0 011.483 1.723L15.056 26h1.926l.617-1.845a3 3 0 011.482-1.723l1.617-.824a3 3 0 012.307-.175l1.578.524.841-1.68-1.666-1.12a3 3 0 01-1.325-2.49v-1.335a3 3 0 011.325-2.489l1.666-1.12-.84-1.68-1.579.524a3 3 0 01-2.307-.175l-1.617-.824A3 3 0 0117.6 7.845zM16 12c2.286 0 4 1.783 4 4s-1.738 4-4 4-4-1.714-4-4 1.714-4 4-4zm0 2c-1.181 0-2 .819-2 2 0 1.17.833 2 2 2 1.138 0 2-.869 2-2 0-1.142-.848-2-2-2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.06 15.766a2 2 0 002.652-2.8l-.11-.162a.5.5 0 01.316-.797L16 12a4 4 0 11-3.995 4.2L12 15.974a.5.5 0 01.826-.373c.08.07.159.125.234.165zM16 22c3.475 0 6.735-1.838 9.019-4.97l.141-.2c.079-.114.168-.247.268-.4l.103-.158a.5.5 0 000-.544l-.368-.554a9.397 9.397 0 00-.14-.2C22.737 11.84 19.476 10 16 10c-3.464 0-6.715 1.827-8.998 4.941l-.147.208a20.88 20.88 0 00-.278.414l-.108.165a.5.5 0 000 .544l.296.448c.088.13.164.239.23.328C9.276 20.17 12.531 22 16 22zm0-14c4.345 0 8.232 2.355 10.827 6.062.128.184.278.416.45.697l.133.22a2 2 0 01.003 2.049c-.143.24-.267.438-.372.596C24.45 21.511 20.466 24 16 24c-4.435 0-8.393-2.454-10.986-6.294l-.154-.235a17.24 17.24 0 01-.175-.283l-.095-.16a2 2 0 01.002-2.05l.235-.384c.148-.237.279-.437.394-.6C7.815 10.327 11.681 8 16 8z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.5 4a.5.5 0 01.5.5v1.499L25.5 6a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-.6L24 26a2 2 0 01-2 2H10a2 2 0 01-2-2L7.1 8h-.6a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5l6.5-.001V4.5a.5.5 0 01.5-.5zM23 8H9l.974 17.528a.5.5 0 00.499.472h11.054a.5.5 0 00.5-.472zm-8.5 3a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.678 6A2 2 0 017.61 7.482L8.016 9h18.746a.5.5 0 01.483.63l-2.382 8.888A2 2 0 0122.931 20H10.964l.3 1.119c.498.16.928.471 1.235.88h9.002A2.5 2.5 0 1121.05 24h-8.1a2.5 2.5 0 11-3.7-2.666L5.777 8.371A.5.5 0 005.294 8H4.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm19.129 5H8.552l1.876 7h12.12a.5.5 0 00.482-.37z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 8a2 2 0 012 2v13h-9.05a2.5 2.5 0 01-4.9 0H6a2 2 0 01-2-2V10a2 2 0 012-2zm-.5 2h-12a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h1c.456-.607 1.182-1 2-1 .818 0 1.544.393 2 1h7a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5zm5.686 1a2 2 0 011.7.948l1.815 2.932A2 2 0 0128 15.932V21a2 2 0 01-2 2h-1.05a2.5 2.5 0 01-4.9 0H19V11zm-.15 2H21v7.5a2.496 2.496 0 013.5.5h1a.5.5 0 00.5-.5v-4.325a.5.5 0 00-.061-.24l-1.463-2.675a.5.5 0 00-.44-.26zM9.5 23a.5.5 0 100-1 .5.5 0 000 1zm13 0a.5.5 0 100-1 .5.5 0 000 1z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 6c4.838 0 8.873 3.436 9.8 8h1.7a.5.5 0 01.5.5v3a.5.5 0 01-.5.5l-1.7.001C24.873 22.565 20.838 26 16 26s-8.873-3.435-9.8-7.999L4.5 18a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h1.7c.927-4.564 4.962-8 9.8-8zm7.748 12H8.252a8.003 8.003 0 0015.496 0zM16 8a8.003 8.003 0 00-7.748 6h15.496c-.888-3.45-4.02-6-7.748-6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-4a2 2 0 00.15-3.995L4 14v-4a2 2 0 012-2zm-.5 2h-19a.5.5 0 00-.492.41L6 10.5v2.035c1.196.692 2 1.984 2 3.465a3.997 3.997 0 01-1.815 3.35L6 19.466V21.5a.5.5 0 00.41.492L6.5 22h19a.5.5 0 00.492-.41L26 21.5v-11a.5.5 0 00-.5-.5zm-6 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-2-3l.866.5a.5.5 0 01.183.683l-2.5 4.33a.5.5 0 01-.683.183l-.866-.5a.5.5 0 01-.183-.683l2.5-4.33A.5.5 0 0117.5 13zm-4 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 22a6 6 0 110-12 6 6 0 010 12zm0-2a4 4 0 100-8 4 4 0 000 8zm-.5-16h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm0 20h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm8.632-16.839l.707.707a.5.5 0 010 .707l-2.121 2.122a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.708l2.122-2.12a.5.5 0 01.707 0zM9.99 21.303l.707.707a.5.5 0 010 .708l-2.122 2.12a.5.5 0 01-.707 0l-.707-.706a.5.5 0 010-.707l2.121-2.122a.5.5 0 01.708 0zM28 15.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5zm-20 0v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5zm16.839 8.632l-.707.707a.5.5 0 01-.707 0l-2.122-2.121a.5.5 0 010-.708l.707-.707a.5.5 0 01.708 0l2.12 2.122a.5.5 0 010 .707zM10.697 9.99l-.707.707a.5.5 0 01-.708 0l-2.12-2.122a.5.5 0 010-.707l.706-.707a.5.5 0 01.707 0l2.122 2.121a.5.5 0 010 .708z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.95 13h-2.012a8.001 8.001 0 00-15.876 0H9.5a.5.5 0 01.5.5v7a.5.5 0 01-.5.5H6a2 2 0 01-2-2v-4a2 2 0 012-2h.05c.5-5.053 4.764-9 9.95-9s9.449 3.947 9.95 9H26a2 2 0 012 2v4a2 2 0 01-2 2 5.5 5.5 0 01-5.5 5.5h-.708a2.5 2.5 0 110-2h.708A3.5 3.5 0 0024 21h-1.5a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h1.438a8.001 8.001 0 00-15.876 0H6.049C6.551 7.947 10.815 4 16 4s9.449 3.947 9.95 9zm.05 2.5a.5.5 0 00-.5-.5H24v4h1.5a.5.5 0 00.5-.5zM17.5 26a.5.5 0 100-1 .5.5 0 000 1zM6 15.5v3a.5.5 0 00.5.5H8v-4H6.5a.5.5 0 00-.5.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 5a2 2 0 012 2v19.5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5V7a2 2 0 012-2zm-6 2H8.5a.5.5 0 00-.5.5V25h10zm5.5 0H20v18h4V7.5a.5.5 0 00-.5-.5zm-12 12a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 16h-5a2 2 0 01-2-2V6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2h-5v2h1a2 2 0 012 2v6h1.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H12v-6a2 2 0 012-2h1zm2.5 4h-3a.5.5 0 00-.5.5V26h4v-5.5a.5.5 0 00-.5-.5zm4-14h-11a.5.5 0 00-.5.5v7a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a8 8 0 018 8c0 2.789-2.39 7.718-7.172 14.788a1 1 0 01-1.656 0C10.39 19.718 8 14.788 8 12a8 8 0 018-8zm3.132 5.475l-4.243 4.243a.5.5 0 01-.707 0l-1.414-1.415a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .708l1.767 1.767a2 2 0 002.829 0l4.596-4.596a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a8 8 0 018 8c0 2.789-2.39 7.718-7.172 14.788a1 1 0 01-1.656 0l-.677-1.01C11.857 21.8 10.023 18.54 8.992 16h2.536A6 6 0 1016 6H9.7c-.387 0-.7-.224-.7-.5v-1c0-.276.313-.5.7-.5zm.5 4a.5.5 0 01.5.5v2.879a.5.5 0 00.146.353l1.622 1.622a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L15.586 13A2 2 0 0115 11.586V8.5a.5.5 0 01.5-.5zM10 12c0 .701.12 1.374.341 2H7.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm1.528-4a5.996 5.996 0 00-1.187 2H5.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a8 8 0 018 8c0 2.789-2.39 7.718-7.172 14.788a1 1 0 01-1.656 0C10.39 19.718 8 14.788 8 12a8 8 0 018-8zm0 5a2 2 0 100 4 2 2 0 000-4z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a8 8 0 018 8c0 2.789-2.39 7.718-7.172 14.788a1 1 0 01-1.656 0C10.39 19.718 8 14.788 8 12a8 8 0 018-8zm0 2a6 6 0 00-6 6c0 2.736 2 6.879 6 12.427l.6-.842C20.2 18.458 22 14.596 22 12a6 6 0 00-6-6zm0 3a2 2 0 110 4 2 2 0 010-4z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a8 8 0 018 8c0 2.789-2.39 7.718-7.172 14.788a1 1 0 01-1.656 0C10.39 19.718 8 14.788 8 12a8 8 0 018-8zm2 5c-.533 0-1.2.35-2 1.05-.8-.7-1.467-1.05-2-1.05-1.273 0-2 1.05-2 2.1 0 1.283 1.333 2.917 4 4.9l.551-.42C18.851 13.785 20 12.292 20 11.1c0-1.05-.727-2.1-2-2.1z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.684 8.949l-5.935 17.803a.5.5 0 01-.934.04l-3.403-7.942a.5.5 0 00-.262-.262l-7.941-3.403a.5.5 0 01.039-.934L23.05 8.316a.5.5 0 01.633.633z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.684 8.949l-5.935 17.803a.5.5 0 01-.934.04l-3.403-7.942a.5.5 0 00-.262-.262l-7.941-3.403a.5.5 0 01.039-.934L23.05 8.316a.5.5 0 01.633.633zM9.623 14.9l5.05 2.164a.5.5 0 01.262.262l2.164 5.05 3.739-11.215z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 23.5l-6.744 3.546a.5.5 0 01-.726-.527l1.288-7.51-5.456-5.32a.5.5 0 01.277-.852l7.54-1.096 3.373-6.833a.5.5 0 01.896 0l3.373 6.833 7.54 1.096a.5.5 0 01.277.853l-5.456 5.319 1.288 7.51a.5.5 0 01-.726.527z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.267 21.381l4.718 2.48-.908-5.292a.5.5 0 01.144-.442l3.845-3.748-5.313-.772a.5.5 0 01-.377-.273L16 8.519v12.42a.5.5 0 00.267.442zM16 23.5l-6.744 3.546a.5.5 0 01-.726-.527l1.288-7.51-5.456-5.32a.5.5 0 01.277-.852l7.54-1.096 3.373-6.833a.5.5 0 01.896 0l3.373 6.833 7.54 1.096a.5.5 0 01.277.853l-5.456 5.319 1.288 7.51a.5.5 0 01-.726.527z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.233 21.363l4.752 2.498-.908-5.292a.5.5 0 01.144-.442l3.845-3.748-5.313-.772a.5.5 0 01-.377-.273L16 8.519l-2.376 4.815a.5.5 0 01-.377.273l-5.313.772 3.845 3.748a.5.5 0 01.144.442l-.908 5.292 4.752-2.498a.5.5 0 01.466 0zM16 23.5l-6.744 3.546a.5.5 0 01-.726-.527l1.288-7.51-5.456-5.32a.5.5 0 01.277-.852l7.54-1.096 3.373-6.833a.5.5 0 01.896 0l3.373 6.833 7.54 1.096a.5.5 0 01.277.853l-5.456 5.319 1.288 7.51a.5.5 0 01-.726.527z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 16V9a2 2 0 012-2h3.041c.536-.012.851-.125 2.538-.855C14.367 5.37 15.74 5 17.5 5h4.75c1.628 0 2.91 1.255 3.192 2.842.02.11.036.267.049.47a.5.5 0 00.119.293c.134.157.232.283.296.38.382.58.594 1.282.594 2.015 0 .087-.007.208-.022.362a.5.5 0 00.053.277c.104.2.177.358.22.474a3.959 3.959 0 01.075 2.549 4.658 4.658 0 01-.204.51.5.5 0 00-.03.325c.105.43.158.764.158 1.003 0 1.991-1.735 3.5-3.75 3.5h-2.5a.5.5 0 00-.5.5V24c0 1.716-1.07 3-3 3-1.517 0-2.535-1.019-2.97-2.757-.42-1.426-.743-2.395-.94-2.828C12.445 19.999 11.479 18.9 10 18H7a2 2 0 01-2-2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 16V9a2 2 0 012-2h3.041c.536-.012.851-.125 2.538-.855C15.367 5.37 16.74 5 18.5 5h4.75c1.628 0 2.91 1.255 3.192 2.842.02.11.036.267.049.47a.5.5 0 00.119.293c.134.157.232.283.296.38.382.58.594 1.282.594 2.015 0 .087-.007.208-.022.362a.5.5 0 00.053.277c.104.2.177.358.22.474a3.959 3.959 0 01.075 2.549 4.658 4.658 0 01-.204.51.5.5 0 00-.03.325c.105.43.158.764.158 1.003 0 1.991-1.735 3.5-3.75 3.5h-2.5a.5.5 0 00-.5.5V24c0 1.716-1.07 3-3 3-1.517 0-2.535-1.019-2.97-2.757-.42-1.426-.743-2.395-.94-2.828C13.445 19.999 12.479 18.9 11 18H8a2 2 0 01-2-2zm17.25-9H18.5c-1.438 0-2.567.305-4.126.98-1.997.865-2.374 1-3.289 1.02H8.5a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h3.04l.232.133c1.97 1.133 3.288 2.587 4.138 4.452.25.548.593 1.579 1.05 3.133.242.967.557 1.282 1.04 1.282.737 0 1-.316 1-1v-4a2 2 0 012-2h3c.968 0 1.75-.68 1.75-1.5 0-.258-.071-.522-.22-.83l-.133-.273a.5.5 0 01.05-.518l.182-.244c.24-.32.371-.713.371-1.135 0-.439-.139-.844-.39-1.166l-.154-.197a.5.5 0 01-.088-.439l.065-.241c.045-.163.067-.315.067-.457 0-.547-.248-1.034-.636-1.295l-.26-.175a.5.5 0 01-.216-.485l.044-.31a1.84 1.84 0 01.066-.291C24.472 7.63 23.908 7 23.25 7z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 16v7a2 2 0 002 2h3.041l.142.007c.463.03.863.184 2.396.848C14.367 26.63 15.74 27 17.5 27h4.75c1.628 0 2.91-1.255 3.192-2.842.015-.083.028-.191.038-.326l.01-.144a.5.5 0 01.12-.293l.174-.212c.05-.064.09-.12.122-.167A3.668 3.668 0 0026.5 21l-.006-.156-.016-.206a.5.5 0 01.053-.277c.104-.2.177-.358.22-.474a3.959 3.959 0 00.075-2.549 3.63 3.63 0 00-.149-.386l-.055-.124a.5.5 0 01-.03-.325c.105-.43.158-.764.158-1.003 0-1.991-1.735-3.5-3.75-3.5h-2.5a.5.5 0 01-.5-.5V8c0-1.716-1.07-3-3-3-1.517 0-2.535 1.019-2.97 2.757l-.24.8c-.304.992-.542 1.682-.7 2.028C12.445 12.001 11.479 13.1 10 14H7a2 2 0 00-2 2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 16v7a2 2 0 002 2h3.041l.142.007c.463.03.863.184 2.396.848C14.367 26.63 15.74 27 17.5 27h4.75c1.628 0 2.91-1.255 3.192-2.842.015-.083.028-.191.038-.326l.01-.144a.5.5 0 01.12-.293l.174-.212c.05-.064.09-.12.122-.167A3.668 3.668 0 0026.5 21l-.006-.156-.016-.206a.5.5 0 01.053-.277c.104-.2.177-.358.22-.474a3.959 3.959 0 00.075-2.549 3.63 3.63 0 00-.149-.386l-.055-.124a.5.5 0 01-.03-.325c.105-.43.158-.764.158-1.003 0-1.991-1.735-3.5-3.75-3.5h-2.5a.5.5 0 01-.5-.5V8c0-1.716-1.07-3-3-3-1.517 0-2.535 1.019-2.97 2.757l-.24.8c-.304.992-.542 1.682-.7 2.028C12.445 12.001 11.479 13.1 10 14H7a2 2 0 00-2 2zm17.25 9H17.5c-1.328 0-2.392-.26-3.774-.831l-1.258-.537c-1.173-.493-1.583-.603-2.266-.628L10 23H7.5a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5h3.04l.232-.133c1.97-1.133 3.288-2.587 4.138-4.452.25-.548.593-1.579 1.05-3.133C16.202 7.315 16.517 7 17 7c.737 0 1 .316 1 1v4a2 2 0 002 2h3c.968 0 1.75.68 1.75 1.5 0 .258-.071.522-.22.83l-.133.273a.5.5 0 00.05.518l.182.244c.24.32.371.713.371 1.135 0 .439-.139.844-.39 1.166l-.154.197a.5.5 0 00-.088.439l.065.241c.045.163.067.315.067.457 0 .547-.248 1.034-.636 1.295l-.26.175a.5.5 0 00-.216.485l.044.31c.015.106.031.171.066.291-.026.813-.59 1.444-1.248 1.444z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke=\"#FFF\" class=\"asda-icon__stroke\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M14.5 18a.5.5 0 001 0v-6.5a.5.5 0 00-1 0V18z\"></path><path d=\"M12 14l2.646-2.646a.5.5 0 01.708 0L18 14\" stroke-width=\"2\" stroke-linecap=\"round\"></path></g></svg>"

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 35 23\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"asda_fav_list_1\" d=\"M7.02 2C7 2.344 7 2.685 7 3h6c0-.315 0-.656-.02-1H18c1 0 2 .784 2 1.667v17.667C20 22.167 19 23 18 23H2c-1 0-2-.833-2-1.666V3.667C0 2.833 1 2 2 2h5.02zM12 2H8c0-1 1-2 2-2s2 1 2 2zM7 17v2h10v-2H7zm-4-5v2h2v-2H3zm0-5v2h2V7H3zm0 10v2h2v-2H3zm4-5v2h10v-2H7zm0-5v2h10V7H7z\"></path><path id=\"asda_fav_list_2\" d=\"M24 21c-1.818-1.8-10-7.65-10-12.6C14 5.7 15.818 3 19 3c2 0 4 .82 5 3.295C25 3.82 27 3 29 3c3.182 0 5 2.7 5 5.4 0 4.95-8.182 10.8-10 12.6z\"></path></defs><g class=\"asda-icon__draw\" fill=\"none\" fill-rule=\"evenodd\"><use fill=\"#3d3d3d\" xlink:href=\"#asda_fav_list_1\"></use><use class=\"asda-icon__draw\" fill=\"#FFF\" stroke=\"#3d3d3d\" stroke-width=\"1.9\" xlink:href=\"#asda_fav_list_2\"></use></g></svg>"

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asdaSale = __webpack_require__(736);

var _asdaSale2 = _interopRequireDefault(_asdaSale);

var _lowPriceEveryDay = __webpack_require__(737);

var _lowPriceEveryDay2 = _interopRequireDefault(_lowPriceEveryDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  sale: _asdaSale2.default,
  'price-every-day': _lowPriceEveryDay2.default
};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 16\"><path d=\"M37.36 12.648l.332.325v2.666l-.4.303H28.84l-.377-.368V1.073c0-.116.059-.206.177-.271a.695.695 0 01.333-.098h2.552c.074 0 .18.055.322.163.14.108.21.199.21.27v11.51h5.304zM40 1.009l.288-.305h9.424L50 1.01v2.678l-.333.348H43.57v2.547h5.1l.332.479v2.33l-.332.478h-5.1v2.83h6.208l.222.305v2.634l-.288.304h-9.49L40 15.725zM18.85 7.117c-.073.06-.191.242-.356.548-.166.306-.328.642-.486 1.007-.159.366-.3.709-.421 1.03-.123.32-.184.533-.184.637v.067h2.893v-.134a44.449 44.449 0 01-.637-1.633 6.076 6.076 0 00-.81-1.522zm-7.298 8.347c.072-.313.177-.638.314-.974a24.924 24.924 0 01.928-2.014c.165-.32.313-.63.442-.928a294.054 294.054 0 012.321-5.091 169.737 169.737 0 002.278-5.091c.043-.12.093-.258.151-.414a4.03 4.03 0 01.194-.448c.072-.141.162-.26.27-.358a.576.576 0 01.4-.145c.216 0 .37.07.464.212a3.1 3.1 0 01.248.46l6.585 14.679c0 .075-.022.183-.065.324-.043.142-.115.213-.216.213h-2.914c-.101 0-.209-.1-.324-.302a9.526 9.526 0 01-.356-.694c-.123-.26-.234-.51-.335-.75-.1-.238-.194-.402-.28-.492h-5.614c-.086 0-.173.116-.259.347a117.9 117.9 0 01-.291.772c-.108.284-.235.54-.378.772-.144.232-.303.347-.475.347h-2.807l-.28-.425zM.068 13.817c0-.133.056-.328.168-.587.112-.258.25-.52.416-.786a4.35 4.35 0 01.517-.687c.18-.191.344-.287.494-.287.135 0 .303.063.506.188.202.126.445.266.73.42.285.156.603.296.955.421.352.126.753.189 1.203.189a1.97 1.97 0 001.056-.277c.3-.184.45-.498.45-.941 0-.399-.162-.745-.484-1.04a6.526 6.526 0 00-1.214-.853 56.035 56.035 0 00-1.584-.853 9.907 9.907 0 01-1.584-1.018A5.158 5.158 0 01.483 6.344C.161 5.82 0 5.18 0 4.428 0 3.72.146 3.09.438 2.535A4.302 4.302 0 011.596 1.14 5.069 5.069 0 013.248.288 6.56 6.56 0 015.19 0c.24 0 .637.048 1.192.144.554.096 1.115.233 1.685.41.57.177 1.071.391 1.506.642.434.25.651.524.651.819 0 .133-.067.332-.202.598a5.792 5.792 0 01-1.1 1.494c-.211.2-.383.3-.518.3-.225 0-.464-.067-.719-.2a16.191 16.191 0 01-.81-.454 7.317 7.317 0 00-.898-.454 2.519 2.519 0 00-.989-.199c-.33 0-.622.096-.876.288-.255.192-.382.458-.382.797 0 .37.168.694.505.974.337.28.764.558 1.281.83.517.274 1.071.558 1.663.853a9.71 9.71 0 011.663 1.052c.517.406.944.882 1.281 1.428.337.546.506 1.21.506 1.993 0 .708-.157 1.347-.472 1.915a4.862 4.862 0 01-1.236 1.461 5.564 5.564 0 01-1.73.93 6.176 6.176 0 01-1.956.321 7.41 7.41 0 01-.764-.055c-.33-.037-.685-.096-1.067-.177a14.25 14.25 0 01-1.169-.299 7.256 7.256 0 01-1.079-.41 2.894 2.894 0 01-.786-.53c-.202-.2-.303-.418-.303-.654\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 95 30\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#2E8800\" d=\"M51 0v19.796L72.115 27 95 19.197V0z\"></path><path fill=\"#FFCE00\" d=\"M72.115 27.079L51 19.626v1.92L72.115 29 95 20.921V19z\"></path><path d=\"M0 .508h3.375v11.944h7.312v2.776H0zM20.27 11.98a4.28 4.28 0 001.636-1.672c.396-.715.594-1.528.594-2.44 0-.91-.198-1.724-.594-2.439a4.281 4.281 0 00-1.636-1.671c-.694-.4-1.472-.6-2.333-.6-.861 0-1.639.2-2.333.6a4.275 4.275 0 00-1.636 1.671c-.396.715-.593 1.528-.593 2.44 0 .91.197 1.724.593 2.439a4.275 4.275 0 001.636 1.671c.694.4 1.472.6 2.333.6.861 0 1.639-.2 2.333-.6m-6.427 2.513a7.297 7.297 0 01-2.854-2.723c-.687-1.156-1.03-2.457-1.03-3.9 0-1.444.343-2.745 1.03-3.901a7.297 7.297 0 012.854-2.724c1.216-.658 2.58-.988 4.094-.988 1.514 0 2.875.33 4.083.988a7.394 7.394 0 012.855 2.724c.694 1.156 1.041 2.457 1.041 3.9 0 1.444-.347 2.745-1.041 3.901a7.394 7.394 0 01-2.855 2.723c-1.208.66-2.57.989-4.083.989-1.514 0-2.878-.33-4.094-.989M48.562.508l-4.771 14.72h-3.625l-3.208-9.967-3.313 9.967h-3.604L25.25.508h3.5l3.291 10.346L35.478.51h3.126l3.333 10.43L45.333.509zM7.096 23.5c.443-.371.664-.897.664-1.58 0-.693-.221-1.225-.664-1.596-.443-.37-1.09-.556-1.94-.556H2.85v4.287h2.307c.85 0 1.497-.185 1.94-.556m1.04-5.512c.798.365 1.412.882 1.843 1.553.431.67.647 1.464.647 2.38 0 .906-.216 1.697-.647 2.373-.43.676-1.045 1.194-1.843 1.552-.798.36-1.74.538-2.822.538H2.849v3.405H.02V17.44h5.295c1.083 0 2.024.183 2.822.547m10.353 2.337c-.443-.37-1.09-.556-1.94-.556h-2.307v4.305h2.307c.85 0 1.497-.189 1.94-.565.442-.376.664-.905.664-1.587 0-.694-.222-1.226-.664-1.597zm.716 9.464l-2.359-3.44h-2.604v3.44h-2.83V17.44h5.294c1.084 0 2.024.183 2.823.547.797.365 1.412.882 1.843 1.553.43.67.647 1.464.647 2.38 0 .918-.219 1.709-.656 2.373-.437.665-1.057 1.173-1.86 1.526l2.743 3.969h-3.04zm3.827-.001h2.83V17.44h-2.83zm6.981-.608a6.088 6.088 0 01-2.377-2.275c-.576-.97-.865-2.067-.865-3.29 0-1.223.289-2.32.865-3.29a6.092 6.092 0 012.377-2.275c1.007-.547 2.14-.82 3.399-.82 1.06 0 2.018.188 2.875.564a5.764 5.764 0 012.158 1.623l-1.818 1.693c-.827-.964-1.852-1.446-3.075-1.446-.758 0-1.433.167-2.027.503a3.555 3.555 0 00-1.39 1.402c-.332.6-.498 1.282-.498 2.046 0 .764.166 1.446.498 2.046a3.55 3.55 0 001.39 1.402c.594.336 1.27.503 2.027.503 1.223 0 2.248-.488 3.075-1.464l1.818 1.694a5.672 5.672 0 01-2.167 1.64c-.863.376-1.824.564-2.884.564-1.246 0-2.374-.273-3.381-.82m18.584-1.685v2.294h-9.471V17.44h9.244v2.293h-6.43v2.681h5.679v2.223h-5.68v2.857z\" fill=\"#6F6F6F\"></path><text fill=\"#FFF\" font-family=\"Helvetica,arial,sans-serif\" font-size=\"11\" font-weight=\"bold\" letter-spacing=\"-.279\"><tspan x=\"55\" y=\"11\">EVERY</tspan><tspan x=\"61.676\" y=\"21\">DAY</tspan></text></g></svg>"

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(739);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".asda-icon{display:inline-block}.asda-icon--red .asda-icon__draw{fill:#d43030}.asda-icon--red .asda-icon__stroke{stroke:#d43030}.asda-icon--green .asda-icon__draw{fill:#68a51c}.asda-icon--green .asda-icon__stroke{stroke:#68a51c}.asda-icon--blue .asda-icon__draw{fill:#0073b1}.asda-icon--blue .asda-icon__stroke{stroke:#0073b1}.asda-icon--yellow .asda-icon__draw{fill:#f7cc00}.asda-icon--yellow .asda-icon__stroke{stroke:#f7cc00}.asda-icon--charcoal .asda-icon__draw{fill:#3d3d3d}.asda-icon--charcoal .asda-icon__stroke{stroke:#3d3d3d}.asda-icon--dark-gray .asda-icon__draw{fill:#767676}.asda-icon--dark-gray .asda-icon__stroke{stroke:#767676}.asda-icon--gray .asda-icon__draw{fill:#ccc}.asda-icon--gray .asda-icon__stroke{stroke:#ccc}.asda-icon--light-gray .asda-icon__draw{fill:#eee}.asda-icon--light-gray .asda-icon__stroke{stroke:#eee}.asda-icon--white .asda-icon__draw{fill:#fff}.asda-icon--white .asda-icon__stroke{stroke:#fff}.asda-icon--tiny,.asda-icon--tiny svg{width:14px;height:14px}.asda-icon--small,.asda-icon--small svg{width:20px;height:20px}.asda-icon--medium,.asda-icon--medium svg{width:24px;height:24px}.asda-icon--regular,.asda-icon--regular svg{width:30px;height:30px}.asda-icon--large,.asda-icon--large svg{width:32px;height:32px}.asda-icon--rotate0{transform:rotate(0deg)}.asda-icon--rotate90{transform:rotate(90deg)}.asda-icon--rotate180{transform:rotate(180deg)}.asda-icon--rotate270{transform:rotate(270deg)}.asda-icon--brand,.asda-icon--brand svg{width:100%;height:100%}", ""]);

// exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

__webpack_require__(534);

var _footerItem = __webpack_require__(742);

var _footerItem2 = _interopRequireDefault(_footerItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalFooter = function GlobalFooter(_ref) {
  var section = _ref.moduleData.Section,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      {
        className: 'footer-wrapper',
        'data-module': name,
        'data-module-name': name,
        'data-module-id': moduleId,
        'data-module-type': type
      },
      _react2.default.createElement(
        'div',
        { className: 'global-footer-wrapper', 'data-testid': 'global-footer' },
        _react2.default.createElement(
          'div',
          { className: 'global-footer-wrapper-links' },
          section.map(function (subSection) {
            return _react2.default.createElement(
              'div',
              { className: 'global-footer-inner-wrapper', key: subSection.uid },
              _react2.default.createElement(_footerItem2.default, { subSection: subSection })
            );
          }),
          _react2.default.createElement(
            'div',
            { className: 'cookies-settings-strip' },
            _react2.default.createElement(
              'button',
              { type: 'button', id: 'ot-sdk-btn', className: 'optanon-toggle-display' },
              'Cookie Settings'
            )
          )
        )
      )
    )
  );
};

GlobalFooter.propTypes = {
  moduleData: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

GlobalFooter.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = GlobalFooter;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".footer-wrapper{background-color:#383838;max-width:100%;margin:0}.global-footer-wrapper{font-family:Montserrat;background-color:#383838;max-width:1150px;margin:0 auto;height:auto}.global-footer-wrapper-links{padding:0 10px}.global-footer-inner-wrapper ul{display:none;list-style:none}.global-footer-inner-wrapper ul.open{margin:0 55px;display:block}.global-footer__heading{font-family:Montserrat;display:inline-block;color:#78be20;font-size:14px;font-weight:400;margin-left:20px;line-height:25px}.global-footer__list-wrapper{display:block;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0;margin-inline-end:0;padding-inline-start:0;list-style-type:none}.global-footer__list{display:list-item;line-height:36px;margin-left:20px}.global-footer__list .global-footer__link:hover{color:#78be20}.global-footer__link{color:#fff;text-decoration:none;font-family:Montserrat;font-size:12px}.global-footer__icon-link{font-size:.5rem;color:#fff;border-radius:50% 0;margin:0;flex-basis:60px;flex-grow:0}.mini-footer-wrapper{max-width:100%;background-color:#383838}.mini-footer{margin:0 auto;max-width:1024px;box-sizing:border-box}.footer-logo-wrapper{margin:0 auto 30px;text-align:center;width:120px;height:35px;background-repeat:no-repeat;background-image:linear-gradient(transparent,transparent),url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA5Ni4xIDI4LjMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDk2LjEgMjguMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNzksMTcuNmwyLjktOS41bDIuOSw5LjVINzl6IE01Ny45LDIwLjhoLTEuOFY3LjZoMS44YzIuNywwLDUuNiwxLjEsNS42LDYuNkM2My41LDE5LDYwLjgsMjAuOCw1Ny45LDIwLjgKCSBNMTEsMTcuNkwxNCw4bDIuOSw5LjZIMTF6IE04Ny4xLDAuN2gtOS45TDcxLjUsMTdjMC4zLTEuNCwwLjMtMi40LDAuMy0yLjljMC02LjgtMy45LTEzLjQtMTMuMi0xMy40SDQ4LjFWMTcKCWMtMC45LTQuNi01LjEtNS45LTEwLjQtNy40Yy0yLTAuNi0zLTEuNi0yLjYtMi41YzAuMy0wLjgsMS41LTEsMy0wLjhjMi4yLDAuMyw0LDEuMSw1LjcsMmwyLjMtNS44QzQ1LjYsMi4yLDQxLjgsMCwzNywwCgljLTYuNiwwLTEwLjksMy4yLTEwLjksOGMwLDQuMiwyLjYsNi43LDcuNCw4LjFjNS4yLDEuNSw2LjUsMi4xLDYuMywzLjZjLTAuMSwxLjMtMy4zLDIuOC0xMS4yLTJsLTIuMSw0LjhMMTkuMywwLjhIOS40TDAsMjcuOGg3LjgKCUw5LDI0aDkuOGwxLjIsMy44aDguMmwtMC45LTIuNmMyLjgsMS42LDYuMiwzLjEsMTAuMywzLjFjNi4zLDAsOS43LTMuNCwxMC41LTYuN3Y2LjNoMTAuNmM2LjMsMCw5LjYtMywxMS4zLTYuMmwtMi4yLDYuMmg3LjgKCWwxLjMtMy44aDkuOGwxLjEsMy44SDk2TDg3LjEsMC43eiIvPgo8L3N2Zz4K)}.footer-social{display:flex;justify-content:space-around}.footer-social a{text-decoration:none;font-size:32px;color:#fff}.copy-right{padding-bottom:30px;text-align:center;color:#fff;font-size:13px}.footer-plus-icon{padding:0 5px}.footer-minus-icon,.footer-plus-icon{margin-left:30px;background:#fff;opacity:.8;border-radius:14px;font-size:16px;cursor:pointer;color:#767676;font-weight:700}.footer-minus-icon{padding:0 6px}.cookies-settings-strip{width:100%;padding:10px 0 0;border-top:1px solid #666}.cookies-settings-strip button{background:none;border:none;padding:0;color:#fff;cursor:pointer;font-family:Montserrat,Arial,Helvetica,sans-serif;font-size:12px}.cookies-settings-strip button:hover{color:#78be20}@media (min-width:481px){.footer-wrapper{margin:0}.global-footer-wrapper-links{display:flex;justify-content:flex-start;flex-wrap:wrap;margin:0 32px}.global-footer-inner-wrapper{flex-basis:22%;margin:10px;display:inline-block}.global-footer-inner-wrapper ul{display:block}.global-footer-inner-wrapper h3{margin-left:0;font-size:22px;display:block}.global-footer__list{margin-left:0}.mini-footer{display:-ms-flexbox;display:flex;padding:20px 0}.footer-logo-wrapper{margin:0 auto 0 0;flex-shrink:1;flex-basis:24%;text-align:left}.footer-social{flex-basis:51%;justify-content:flex-start}.footer-social a{margin-right:20px}.copy-right{padding:0;flex-basis:25%;text-align:left}.footer-plus-icon{display:none}}@media (min-width:1201px){.global-footer-wrapper-links{margin:0}.mini-footer{max-width:1150px}}@media (min-width:768px){.global-footer-inner-wrapper{flex-basis:33%;margin:0}}@media (min-width:961px){.global-footer-inner-wrapper{flex-basis:25%}}", ""]);

// exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable react/prop-types */


var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _utility = __webpack_require__(62);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterItem = function FooterItem(_ref) {
  var _ref$subSection = _ref.subSection,
      header = _ref$subSection.header,
      subSections = _ref$subSection.subSections;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      listOpen = _useState2[0],
      setListOpen = _useState2[1];

  var toggleList = function toggleList() {
    setListOpen(!listOpen);
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'span',
      {
        className: listOpen ? 'footer-minus-icon' : 'footer-plus-icon',
        onClick: function onClick() {
          return toggleList();
        },
        onKeyPress: function onKeyPress() {
          return toggleList();
        },
        role: 'presentation'
      },
      listOpen ? '-' : '+'
    ),
    _react2.default.createElement(
      'h3',
      { className: 'global-footer__heading' },
      header
    ),
    _react2.default.createElement(
      'ul',
      { className: 'global-footer__list-wrapper ' + (listOpen ? 'open' : '') },
      subSections.map(function (_ref2) {
        var _ref2$link = _ref2.link,
            value = _ref2$link.clickThrough.value,
            uid = _ref2$link.uid,
            title = _ref2$link.title;

        var content = value && value.replace(/cmpid-pagename/gi, (0, _utility.getPageName)());
        return _react2.default.createElement(
          'li',
          { className: 'global-footer__list', key: uid },
          _react2.default.createElement(
            'a',
            { className: 'global-footer__link', href: content },
            title
          )
        );
      })
    )
  );
};

exports.default = FooterItem;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

__webpack_require__(744);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpTop = function SignUpTop(_ref) {
  var name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;

  var link = function link() {
    window.location.href = '/baby-club/join-now';
  };
  return _react2.default.createElement(
    'div',
    {
      className: 'sign-up-top',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    _react2.default.createElement(
      'div',
      { className: 'sign-up-top-inner' },
      _react2.default.createElement(
        'h2',
        null,
        'Join the club'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Get the latest advice and offers from Asda by signing up to our Baby & Toddler Club'
      ),
      _react2.default.createElement(
        'button',
        { className: 'btn', onClick: link },
        'Sign up'
      )
    )
  );
};

SignUpTop.propTypes = {
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

SignUpTop.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = SignUpTop;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(745);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, "div.sign-up-top{width:calc(100% - 20px);height:240px;padding:10px;margin:20px auto;background-color:#fff}div.sign-up-top .sign-up-top-inner{border-radius:8px;padding:10px;box-sizing:border-box;border:2px dashed #f6d5b7;height:100%;position:relative}div.sign-up-top .sign-up-top-inner h2{font-size:48px;font-family:AmaticSC;padding-left:20px;margin:0 0 10px;text-align:center}div.sign-up-top .sign-up-top-inner p{padding:0 20px 10px;text-align:center;font-family:fontRegular,sans-serif;font-size:16px}div.sign-up-top .sign-up-top-inner button{position:relative;background-color:#68a51c;border-color:#68a51c;width:160px;height:44px;color:#fff;border-radius:4px;margin:0 auto 20px;display:block;font-family:fontRegular,sans-serif;font-size:18px;line-height:18px}@media (min-width:768px){div.sign-up-top{width:100%;max-width:984px;height:140px;margin:20px auto 30px}div.sign-up-top .sign-up-top-inner h2{margin:0;text-align:left}div.sign-up-top .sign-up-top-inner p{padding:0 0 0 20px;text-align:left}div.sign-up-top .sign-up-top-inner button{position:absolute;right:20px;bottom:0}}@media (min-width:1201px){div.sign-up-top{width:calc(100% - 20px);max-width:1110px;height:140px;margin:20px auto 30px}div.sign-up-top .sign-up-top-inner h2{margin:0;text-align:left}div.sign-up-top .sign-up-top-inner p{padding:0 0 0 20px;text-align:left}div.sign-up-top .sign-up-top-inner button{position:absolute;right:20px;bottom:0}}", ""]);

// exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

__webpack_require__(747);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpBottom = function SignUpBottom(_ref) {
  var name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;
  return _react2.default.createElement(
    'a',
    { href: '/baby-club/join-now' },
    _react2.default.createElement('div', {
      className: 'sign-up-bottom',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    })
  );
};

SignUpBottom.propTypes = {
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

SignUpBottom.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = SignUpBottom;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(748);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, "div.sign-up-bottom{width:100%;height:250px;padding:0;margin:0;background-image:url(\"https://placeholder.pics/svg/1400x267/46FFFC\");display:flex}", ""]);

// exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Placeholder = function Placeholder(props) {
  var _props$moduleData = props.moduleData,
      type = _props$moduleData.type,
      contents = _props$moduleData.contents,
      modules = props.modules,
      name = props.name,
      moduleId = props.moduleId;

  var Component = modules[type];
  if (!Component) {
    return null;
  }

  return _react2.default.createElement(Component, { contents: contents, name: name, type: type, moduleId: moduleId });
};

Placeholder.propTypes = {
  moduleData: (0, _propTypes.shape)({ type: _propTypes.string }).isRequired,
  modules: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

Placeholder.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = Placeholder;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

__webpack_require__(751);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryArticles = function CategoryArticles(_ref) {
  var contents = _ref.contents,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;
  return _react2.default.createElement(
    'div',
    {
      className: 'category-articles wrapper',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    contents.map(function (content, index) {
      return _react2.default.createElement('div', {
        className: 'rich-text',
        key: index
        // eslint-disable-next-line react/no-danger
        , dangerouslySetInnerHTML: {
          __html: content.content
        }
      });
    })
  );
}; /* eslint-disable react/no-array-index-key */


CategoryArticles.propTypes = {
  contents: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

CategoryArticles.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};

exports.default = CategoryArticles;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(752);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".category-articles{width:100%;height:auto;display:block;margin:20px auto 50px;background-color:#fffae6;box-sizing:border-box}.category-articles .rich-text .article-tile{width:100%;height:600px;margin:0 20px 20px 0;padding:10px;float:left;background-color:#fff;border-radius:8px;box-sizing:border-box;font-family:fontRegular,sans-serif}.category-articles .rich-text .article-tile .article-tile-inner{border-radius:8px;padding:10px;box-sizing:border-box;border:2px dashed #f6d5b7;height:100%}.category-articles .rich-text .article-tile .article-tile-inner:nth-child(4){margin-right:0}.category-articles .rich-text .article-tile .article-tile-inner img{border-radius:4px;width:100%;height:223px;object-fit:cover}.category-articles .rich-text .article-tile .article-tile-inner h4{text-align:center;margin:0;padding:20px;height:90px;font-family:fontSemiBold,sans-serif;font-size:22px}.category-articles .rich-text .article-tile .article-tile-inner p{text-align:center;margin:0;padding:10px 20px;height:160px;display:block;font-size:16px}.category-articles .rich-text .article-tile .article-tile-inner a{margin:0 auto;display:block;text-align:center;color:#177ab0;font-family:fontBold,sans-serif}@media (min-width:768px){.category-articles .rich-text .article-tile{width:calc(33.33333% - 15px)}.category-articles .rich-text .article-tile .article-tile-inner:nth-child(4){margin-right:0}.category-articles .rich-text:first-child .article-tile{width:100%;height:360px;margin-right:0}.category-articles .rich-text:first-child .article-tile .article-tile-inner h4{width:40%;float:left}.category-articles .rich-text:first-child .article-tile .article-tile-inner p{width:40%;padding:10px 40px;float:left}.category-articles .rich-text:first-child .article-tile .article-tile-inner a{width:40%;float:left}.category-articles .rich-text:first-child .article-tile .article-tile-inner .image-link{width:60%;height:100%;float:left;display:block}.category-articles .rich-text:first-child .article-tile .article-tile-inner .image-link img{width:100%;height:100%}.category-articles .rich-text:nth-child(3) .article-tile{width:calc(66.66666% - 5px);margin-right:0}.category-articles .rich-text:nth-child(3) .article-tile .article-tile-inner img{height:320px}.category-articles .rich-text:nth-child(3) .article-tile .article-tile-inner h4{height:auto;padding:20px 50px 10px}.category-articles .rich-text:nth-child(3) .article-tile .article-tile-inner p{height:105px;padding:10px 50px}.category-articles .rich-text:nth-child(6) .article-tile,.category-articles .rich-text:nth-child(9) .article-tile,.category-articles .rich-text:nth-child(12) .article-tile,.category-articles .rich-text:nth-child(15) .article-tile,.category-articles .rich-text:nth-child(18) .article-tile,.category-articles .rich-text:nth-child(21) .article-tile{margin-right:0}}@media (min-width:1201px){.category-articles .rich-text .article-tile{width:calc(33.33333% - 15px)}.category-articles .rich-text .article-tile .article-tile-inner:nth-child(4){margin-right:0}.category-articles .rich-text:first-child .article-tile{width:100%;height:360px;margin-right:0}.category-articles .rich-text:first-child .article-tile .article-tile-inner h4{width:40%;float:left}.category-articles .rich-text:first-child .article-tile .article-tile-inner p{width:40%;padding:10px 80px;float:left}.category-articles .rich-text:first-child .article-tile .article-tile-inner a{width:40%;float:left}.category-articles .rich-text:first-child .article-tile .article-tile-inner .image-link{width:60%;height:100%;float:left;display:block}.category-articles .rich-text:first-child .article-tile .article-tile-inner .image-link img{width:100%;height:100%}.category-articles .rich-text:nth-child(3) .article-tile{width:calc(66.66666% - 5px);margin-right:0}.category-articles .rich-text:nth-child(3) .article-tile .article-tile-inner img{height:320px}.category-articles .rich-text:nth-child(3) .article-tile .article-tile-inner h4{height:auto;padding:20px 50px 10px}.category-articles .rich-text:nth-child(3) .article-tile .article-tile-inner p{height:105px;padding:10px 50px}.category-articles .rich-text:nth-child(6) .article-tile,.category-articles .rich-text:nth-child(9) .article-tile,.category-articles .rich-text:nth-child(12) .article-tile,.category-articles .rich-text:nth-child(15) .article-tile,.category-articles .rich-text:nth-child(18) .article-tile,.category-articles .rich-text:nth-child(21) .article-tile{margin-right:0}}", ""]);

// exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

__webpack_require__(754);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendingArticles = function TrendingArticles(_ref) {
  var contents = _ref.contents,
      name = _ref.name,
      type = _ref.type,
      moduleId = _ref.moduleId;
  return _react2.default.createElement(
    'div',
    {
      className: 'homepage-articles wrapper',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    _react2.default.createElement(
      'h3',
      null,
      'Trending'
    ),
    contents.map(function (content, index) {
      return _react2.default.createElement('div', {
        className: 'rich-text',
        key: index
        // eslint-disable-next-line react/no-danger
        , dangerouslySetInnerHTML: {
          __html: content.content
        }
      });
    })
  );
}; /* eslint-disable react/no-array-index-key */


TrendingArticles.propTypes = {
  contents: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    content: _propTypes.string
  })).isRequired,
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string
};

TrendingArticles.defaultProps = {
  name: null,
  moduleId: null,
  type: null
};
exports.default = TrendingArticles;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(755);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".baby-club .homepage-articles{width:100%;height:auto;display:block;margin:0 auto 50px;background-color:#eef8fd;box-sizing:border-box}.baby-club .homepage-articles h3{text-align:center;padding:20px 0 30px;display:block;position:relative;line-height:.5;font-size:18px;font-family:fontSemiBold,sans-serif}.baby-club .homepage-articles h3:after,.baby-club .homepage-articles h3:before{content:\"\";position:absolute;height:5px;border-top:1px solid #ccc;top:25px;width:32%}.baby-club .homepage-articles h3:before{right:10px}.baby-club .homepage-articles h3:after{left:10px}.baby-club .homepage-articles .rich-text .article-tile{width:100%;height:560px;margin:0 0 20px;padding:10px;float:left;background-color:#fff;border-radius:8px;box-sizing:border-box;font-family:fontRegular,sans-serif}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner{border-radius:8px;padding:10px;box-sizing:border-box;border:2px dashed #bde6f7;height:100%}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner:nth-child(4){margin-right:0}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner img{border-radius:4px;width:100%;height:223px;object-fit:cover}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner h4{text-align:center;margin:0;padding:20px;height:90px;font-family:fontSemiBold,sans-serif;font-size:22px;overflow:hidden}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner p{text-align:center;margin:0;padding:10px 20px;height:160px;display:block;font-size:16px;overflow:hidden}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner a{margin:0 auto;display:block;text-align:center;color:#177ab0;font-family:fontBold,sans-serif}.baby-club .homepage-articles .rich-text:nth-child(4) .article-tile{margin-right:0}@media (min-width:768px){.baby-club .homepage-articles{height:auto}.baby-club .homepage-articles h3{font-size:24px}.baby-club .homepage-articles h3:after,.baby-club .homepage-articles h3:before{width:25%}.baby-club .homepage-articles h3:before{right:14%;margin-right:1%}.baby-club .homepage-articles h3:after{left:14%;margin-left:1%}.baby-club .homepage-articles .rich-text .article-tile{width:32.33333%;height:600px;margin:0 1% 20px 0}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner:nth-child(4){margin-right:0}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner img{height:166px}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner h4{height:120px;padding:20px 10px}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner p{height:220px;display:block;padding:10px}.baby-club .homepage-articles .rich-text:nth-child(4) .article-tile{margin-right:0}}@media (min-width:1201px){.baby-club .homepage-articles{height:auto}.baby-club .homepage-articles .rich-text .article-tile{height:560px}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner img{height:223px}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner h4{height:90px;padding:20px}.baby-club .homepage-articles .rich-text .article-tile .article-tile-inner p{height:160px;padding:10px 20px}.baby-club .homepage-articles .rich-text:nth-child(4) .article-tile{margin-right:0}}", ""]);

// exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(181);

var _redux = __webpack_require__(78);

var _propTypes = __webpack_require__(12);

var _personalizedRecommendation = __webpack_require__(187);

var _productList = __webpack_require__(757);

var _productList2 = _interopRequireDefault(_productList);

var _analytics = __webpack_require__(114);

var _env = __webpack_require__(539);

var _constants = __webpack_require__(37);

var _personalisationParser = __webpack_require__(859);

var _favouritesListParser = __webpack_require__(860);

var _actions = __webpack_require__(183);

var _button = __webpack_require__(506);

var _button2 = _interopRequireDefault(_button);

var _title = __webpack_require__(861);

var _title2 = _interopRequireDefault(_title);

__webpack_require__(869);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moduleType = 'ProductListingP13N';

var P13N = function P13N(props) {
  var isSignedIn = props.isSignedIn,
      profileId = props.profileId,
      isActive = props.isActive,
      lastLoginAt = props.lastLoginAt,
      postCode = props.postCode,
      storeId = props.storeId,
      moduleData = props.moduleData,
      _props$personalizedRe = props.personalizedRecommendation,
      _props$personalizedRe2 = _props$personalizedRe.items,
      items = _props$personalizedRe2 === undefined ? [] : _props$personalizedRe2,
      _props$personalizedRe3 = _props$personalizedRe.metadata,
      metadata = _props$personalizedRe3 === undefined ? {} : _props$personalizedRe3,
      serviceEligibilityAction = props.serviceEligibilityAction,
      personalisationActionsAPI = props.personalisationActionsAPI,
      name = props.name,
      type = props.type,
      moduleId = props.moduleId,
      placementId = props.placementId;


  if (!isSignedIn) return null;

  var getPersonalisationData = function getPersonalisationData(params) {
    var loadRecommendations = personalisationActionsAPI.loadRecommendations,
        fetchFavouritesItemList = personalisationActionsAPI.fetchFavouritesItemList,
        recommendationsAPISuccess = personalisationActionsAPI.recommendationsAPISuccess,
        recommendationsAPIFail = personalisationActionsAPI.recommendationsAPIFail;

    Promise.all([loadRecommendations(params), fetchFavouritesItemList()]).then(function (response) {
      var _response = _slicedToArray(response, 2),
          personalisationResponse = _response[0],
          favouritesItemResponse = _response[1];

      var favouritesItemIds = (0, _favouritesListParser.favouritesListParser)(favouritesItemResponse);
      var personalisationData = (0, _personalisationParser.parsePersonalisationData)(favouritesItemIds, personalisationResponse);
      var unavailableStatusList = ['O', 'I', 'C'];
      var availableProducts = personalisationData.items.filter(function (item) {
        return !unavailableStatusList.includes(item.priceDetails.availability) && !item.priceDetails.shouldHidePrice && !item.priceDetails.isUnavailable;
      });
      recommendationsAPISuccess({
        items: availableProducts.slice(0, parseInt(moduleData.recordsPerPage, 10)),
        metadata: personalisationData.metadata
      });
    }).catch(function (error) {
      recommendationsAPIFail(error);
    });
  };

  (0, _react.useEffect)(function () {
    if (storeId) {
      var params = {
        user_context_info: {
          user_id: profileId,
          store_id: storeId
        },
        page_info: {
          request_origin: 'asda'
        },
        modules_info: [{
          placement: placementId,
          include_sponsored_products: true,
          populate_response: true,
          limit: 65
        }]
      };
      getPersonalisationData(params);
    }
  }, [storeId]);

  (0, _react.useEffect)(function () {
    if (isSignedIn && postCode) {
      // Getting user storeId
      serviceEligibilityAction(postCode);
    }
  }, [isSignedIn, postCode]);

  if (!items.length) return null;

  var handleFavouriteClick = function handleFavouriteClick() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = item.id,
        _item$productDetails = item.productDetails;
    _item$productDetails = _item$productDetails === undefined ? {} : _item$productDetails;
    var isFavourite = _item$productDetails.isFavourite,
        brand = _item$productDetails.brand,
        name = _item$productDetails.name,
        deptId = item.taxonomyDetails.deptId,
        pricePerUnit = item.priceDetails.pricePerUnit;

    var params = {
      requestorigin: '',
      token: ''
    };
    var isFavouriteAdded = '';
    if (isFavourite) {
      params.payload = {
        items: [id],
        storeId: ''
      };
      personalisationActionsAPI.removeFavourites(params, profileId);
      isFavouriteAdded = false;
    } else {
      params.payload = {
        favouriteItems: [{
          skuId: id,
          deptId: deptId
        }]
      };
      personalisationActionsAPI.addFavourites(params, profileId);
      isFavouriteAdded = true;
    }

    var placement = metadata.placement,
        strategyId = metadata.strategyId,
        strategyMessage = metadata.strategyMessage;
    // trigger analytics on p13n product add/remove favourites

    (0, _analytics.trackSignalEvent)('P13NProductFavourites', {
      profileId: profileId,
      dateTimeStamp: new Date().toLocaleString(),
      isActive: isActive,
      lastLoginAt: lastLoginAt,
      operatingSystem: (0, _env.getCurrentOS)(),
      placement: placement,
      previousPageName: document.referrer || '',
      products: [{
        productId: id, productName: name, productPrice: pricePerUnit, productBrand: brand
      }],
      storeId: storeId,
      strategyId: strategyId,
      strategyMessage: strategyMessage,
      url: document.location.href,
      isFavouriteAdded: isFavouriteAdded
    });
  };

  var handleProductClick = function handleProductClick(_ref) {
    var productDetails = _ref.productDetails,
        priceDetails = _ref.priceDetails;
    var placement = metadata.placement,
        strategyId = metadata.strategyId,
        strategyMessage = metadata.strategyMessage;
    // trigger analytics on p13n product click

    (0, _analytics.trackSignalEvent)('P13NProductClick', {
      profileId: profileId,
      dateTimeStamp: new Date().toLocaleString(),
      isActive: isActive,
      lastLoginAt: lastLoginAt,
      operatingSystem: (0, _env.getCurrentOS)(),
      placement: placement,
      previousPageName: document.referrer || '',
      products: [{
        productId: productDetails.id,
        productName: productDetails.name,
        productPrice: priceDetails.pricePerUnit,
        productBrand: productDetails.brand
      }],
      storeId: storeId,
      strategyId: strategyId,
      strategyMessage: strategyMessage,
      url: document.location.href
    });
  };

  var headerTitle = _react2.default.createElement(_title2.default, null);

  var commonItemUrlQueryParam = _constants.P13N_MODULE_CMPID;

  return _react2.default.createElement(
    'div',
    {
      className: 'offers-grid',
      'data-module': name,
      'data-module-name': name,
      'data-module-id': moduleId,
      'data-module-type': type
    },
    _react2.default.createElement(_productList2.default, {
      handleProductClick: handleProductClick,
      title: headerTitle,
      items: items,
      handleFavouriteClick: handleFavouriteClick,
      commonItemUrlQueryParam: commonItemUrlQueryParam
    }),
    false && _react2.default.createElement(
      _button2.default
      // clickHandler={handleClick}
      ,
      { className: 'asda-btn--fluid view-offers_btn',
        category: 'primary'
      },
      'View All Your Offers'
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var profile = _ref2.profile,
      personalizedRecommendation = _ref2.personalizedRecommendation,
      mainContent = _ref2.cmsData.mainContent;
  var isSignedIn = profile.isSignedIn,
      profileId = profile.profileId,
      additionalInfo = profile.additionalInfo,
      postCode = profile.postCode,
      storeId = profile.storeId;

  var _ref3 = additionalInfo || {},
      isActive = _ref3.isActive,
      lastLoginAt = _ref3.lastLoginAt;

  var P13NModule = mainContent.find(function (content) {
    return content.type === moduleType;
  });
  var placementId = P13NModule && P13NModule.configs && P13NModule.configs.placementID || '';
  return {
    isSignedIn: isSignedIn,
    profileId: profileId,
    isActive: isActive,
    lastLoginAt: lastLoginAt,
    postCode: postCode,
    storeId: storeId,
    personalizedRecommendation: personalizedRecommendation,
    placementId: placementId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    serviceEligibilityAction: (0, _redux.bindActionCreators)(_actions.serviceEligibility, dispatch),
    personalisationActionsAPI: (0, _redux.bindActionCreators)(_personalizedRecommendation.actions, dispatch)
  };
};

P13N.propTypes = {
  isSignedIn: _propTypes.bool,
  profileId: _propTypes.string,
  isActive: _propTypes.string,
  lastLoginAt: _propTypes.number,
  postCode: _propTypes.string,
  storeId: _propTypes.string,
  moduleData: (0, _propTypes.shape)({ recordsPerPage: _propTypes.string }),
  personalizedRecommendation: (0, _propTypes.shape)({
    items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
    metadata: {
      placement: _propTypes.string,
      strategyId: _propTypes.string,
      strategyMessage: _propTypes.string
    }
  }),
  serviceEligibilityAction: _propTypes.func,
  personalisationActionsAPI: (0, _propTypes.shape)({
    loadRecommendations: _propTypes.func,
    removeFavourites: _propTypes.func,
    addFavourites: _propTypes.func,
    fetchFavouritesItemList: _propTypes.func,
    recommendationsAPISuccess: _propTypes.func,
    recommendationsAPIFail: _propTypes.func
  }),
  name: _propTypes.string,
  moduleId: _propTypes.string,
  type: _propTypes.string,
  placementId: _propTypes.string.isRequired
};

P13N.defaultProps = {
  isSignedIn: false,
  profileId: '',
  isActive: '',
  lastLoginAt: null,
  postCode: '',
  storeId: '',
  moduleData: {},
  personalizedRecommendation: {},
  serviceEligibilityAction: function serviceEligibilityAction() {},

  personalisationActionsAPI: {
    loadRecommendations: function loadRecommendations() {},
    removeFavourites: function removeFavourites() {},
    addFavourites: function addFavourites() {},
    fetchFavouritesItemList: function fetchFavouritesItemList() {},
    recommendationsAPISuccess: function recommendationsAPISuccess() {},
    recommendationsAPIFail: function recommendationsAPIFail() {}
  },
  name: null,
  moduleId: null,
  type: null
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(P13N);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defaultLayout = __webpack_require__(758);

var _defaultLayout2 = _interopRequireDefault(_defaultLayout);

__webpack_require__(857);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _defaultLayout2.default;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _header = __webpack_require__(759);

var _header2 = _interopRequireDefault(_header);

var _main = __webpack_require__(762);

var _main2 = _interopRequireDefault(_main);

var _item = __webpack_require__(763);

var _item2 = _interopRequireDefault(_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ProductList = function ProductList() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var className = props.className,
      children = props.children,
      type = props.type,
      title = props.title,
      mods = props.mods,
      items = props.items,
      handleFavouriteClick = props.handleFavouriteClick,
      handleProductClick = props.handleProductClick,
      rest = _objectWithoutProperties(props, ['className', 'children', 'type', 'title', 'mods', 'items', 'handleFavouriteClick', 'handleProductClick']);

  var blk = 'co-product-list';
  var baseClass = (0, _classNames2.default)({ blk: blk });
  var listClass = className + ' ' + baseClass;
  return _react2.default.createElement(
    'div',
    { className: listClass, 'data-type': type },
    _react2.default.createElement(_header2.default, { title: title, mix: className }),
    _react2.default.createElement(
      _main2.default,
      { mix: className, mods: mods },
      items.map(function (item, index) {
        var id = item.id;

        return id ? _react2.default.createElement(_item2.default, _extends({}, rest, {
          key: id,
          item: item,
          index: index,
          handleFavouriteClick: handleFavouriteClick,
          handleProductClick: handleProductClick
        })) : null;
      }),
      children
    )
  );
};

ProductList.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node,
  type: _propTypes.string,
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  mods: (0, _propTypes.arrayOf)(_propTypes.string),
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  handleFavouriteClick: _propTypes.func,
  handleProductClick: _propTypes.func,
  commonItemUrlQueryParam: _propTypes.string
};

ProductList.defaultProps = {
  className: '',
  children: null,
  type: null,
  title: '',
  mods: [],
  items: [],
  handleFavouriteClick: function handleFavouriteClick() {},
  handleProductClick: function handleProductClick() {},
  commonItemUrlQueryParam: ''
};

exports.default = ProductList;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAllLink = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'co-product-list';

var ViewAllLink = exports.ViewAllLink = function ViewAllLink(_ref) {
  var show = _ref.show;

  if (!show) return null;
  return _react2.default.createElement(
    _link2.default,
    { href: '/', className: blk + '__anchor' },
    'View All'
  );
};

ViewAllLink.propTypes = { show: _propTypes.bool };
ViewAllLink.defaultProps = { show: false };

var Header = function Header(_ref2) {
  var title = _ref2.title,
      showAllAction = _ref2.showAllAction,
      mix = _ref2.mix;

  if (!title) return null;
  return _react2.default.createElement(
    'div',
    { className: (0, _classNames2.default)({ blk: blk, elt: 'header', mix: mix }) },
    _react2.default.createElement(
      'h3',
      { className: (0, _classNames2.default)({ blk: blk, elt: 'title', mix: mix }) },
      title
    ),
    _react2.default.createElement(ViewAllLink, { mix: mix, show: showAllAction })
  );
};

Header.propTypes = {
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  showAllAction: _propTypes.bool,
  mix: _propTypes.string
};

Header.defaultProps = {
  title: '',
  showAllAction: false,
  mix: ''
};

exports.default = Header;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(761);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".asda-link{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:600;text-decoration:none}.asda-link--primary{color:#0073b1}.asda-link--primary:focus,.asda-link--primary:hover,.asda-link--secondary{text-decoration:underline}.asda-link--secondary{color:#3d3d3d}.asda-link--disabled,.asda-link:disabled{color:#767676;pointer-events:none}.asda-link--button{background:none;border:none;padding:0;outline:0}.asda-link--standalone{display:inline-block;padding:8px 16px}.asda-link--align-left{padding-left:0}.asda-link--align-right{padding-right:0}", ""]);

// exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'co-product-list';

var Main = function Main(_ref) {
  var className = _ref.className,
      children = _ref.children,
      mix = _ref.mix,
      mods = _ref.mods;

  var baseClass = (0, _classNames2.default)({
    blk: blk, elt: 'main-cntr', mix: mix, mods: mods
  });
  var containerClass = className + ' ' + baseClass;
  return _react2.default.createElement(
    'ul',
    { className: containerClass },
    children
  );
};

Main.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node,
  mix: _propTypes.string,
  mods: (0, _propTypes.arrayOf)(_propTypes.string)
};

Main.defaultProps = {
  className: '',
  children: null,
  mix: '',
  mods: []
};

exports.default = Main;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _utility = __webpack_require__(62);

var _product = __webpack_require__(516);

var _product2 = _interopRequireDefault(_product);

var _imageStickerVolume = __webpack_require__(841);

var _imageStickerVolume2 = _interopRequireDefault(_imageStickerVolume);

var _titleRatingBundlePromo = __webpack_require__(853);

var _titleRatingBundlePromo2 = _interopRequireDefault(_titleRatingBundlePromo);

var _priceQuantity = __webpack_require__(854);

var _priceQuantity2 = _interopRequireDefault(_priceQuantity);

__webpack_require__(855);

var _constants = __webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Item = function Item(props) {
  var context = props.context,
      className = props.className,
      propMods = props.mods,
      children = props.children,
      index = props.index,
      mix = props.mix,
      item = props.item,
      categoryId = props.categoryId,
      _handleFavouriteClick = props.handleFavouriteClick,
      _handleProductClick = props.handleProductClick,
      commonItemUrlQueryParam = props.commonItemUrlQueryParam;
  var cin = item.cin,
      id = item.id,
      images = item.images,
      productDetails = item.productDetails,
      quantityDetails = item.quantityDetails,
      promoDetails = item.promoDetails,
      ratingAndReview = item.ratingAndReview;
  var name = productDetails.name,
      isReplacement = productDetails.isReplacement,
      isFavourite = productDetails.isFavourite;
  var weight = quantityDetails.weight;

  var getClassName = function getClassName() {
    var mods = [context === 'modal' && 'modal-ctx', (0, _utility.getPageName)() === 'hp' && 'home'].concat(_toConsumableArray(propMods));
    var baseClass = (0, _classNames2.default)({ blk: _constants.BLOCK, mods: mods });
    return className + ' ' + baseClass;
  };

  var itemUrl = _constants.LINKTO + '/product/' + id + '?' + commonItemUrlQueryParam;

  var imageStickerVolumeProps = {
    cin: cin,
    id: id,
    index: index,
    images: images,
    name: name,
    weight: weight,
    productDetails: productDetails,
    promoDetails: promoDetails,
    isFavourite: isFavourite,
    handleFavouriteClick: function handleFavouriteClick() {
      return _handleFavouriteClick(item);
    },
    handleProductClick: function handleProductClick() {
      return _handleProductClick(item);
    },
    itemUrl: itemUrl
  };

  var titleRatingBundlePromoProps = {
    name: name,
    isReplacement: isReplacement,
    promoDetails: promoDetails,
    ratingAndReview: ratingAndReview,
    categoryId: categoryId,
    handleProductClick: function handleProductClick() {
      return _handleProductClick(item);
    },
    itemUrl: itemUrl
  };

  var priceQuantityDataProps = {
    item: item,
    propMods: propMods
  };

  return _react2.default.createElement(
    'li',
    { className: getClassName() + ' ' + mix, style: { order: index } },
    _react2.default.createElement(
      _product2.default,
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'col1', propMods: propMods }) },
        _react2.default.createElement(_imageStickerVolume2.default, _extends({}, imageStickerVolumeProps, {
          className: (0, _classNames2.default)({ blk: 'co-product', elt: 'image' })
        }))
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'col2', propMods: propMods }) },
        _react2.default.createElement(_titleRatingBundlePromo2.default, titleRatingBundlePromoProps)
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'col3', propMods: propMods }) },
        _react2.default.createElement(_priceQuantity2.default, _extends({}, priceQuantityDataProps, { index: index }))
      ),
      children
    )
  );
};

Item.propTypes = {
  context: _propTypes.string,
  className: _propTypes.string,
  mods: (0, _propTypes.arrayOf)(_propTypes.string),
  children: _propTypes.node,
  index: _propTypes.number,
  mix: _propTypes.string,
  item: (0, _propTypes.shape)({ id: _propTypes.string }),
  categoryId: _propTypes.string,
  handleFavouriteClick: _propTypes.func,
  handleProductClick: _propTypes.func,
  commonItemUrlQueryParam: _propTypes.string
};

Item.defaultProps = {
  context: '',
  className: '',
  mods: [],
  children: null,
  index: 0,
  mix: '',
  item: {},
  categoryId: '',
  handleFavouriteClick: function handleFavouriteClick() {},
  handleProductClick: function handleProductClick() {},

  commonItemUrlQueryParam: ''
};

exports.default = Item;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'co-product';

var Volume = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      value = _ref.value;
  return _react2.default.createElement(
    'span',
    { className: (0, _classNames2.default)({ className: className, blk: blk, elt: 'volume' }) },
    value
  );
});

Volume.propTypes = { className: _propTypes.string, value: _propTypes.string };
Volume.defaultProps = { className: '', value: '' };

exports.default = Volume;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Title = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      value = _ref.value,
      href = _ref.href,
      disableLink = _ref.disableLink,
      mix = _ref.mix,
      clickHandler = _ref.clickHandler;

  var blk = 'co-product';
  return _react2.default.createElement(
    'h3',
    {
      className: (0, _classNames2.default)({
        className: className,
        blk: blk,
        elt: 'title',
        mix: mix
      })
    },
    _react2.default.createElement(
      _link2.default,
      {
        className: (0, _classNames2.default)({
          blk: blk,
          elt: 'anchor',
          mods: [disableLink && 'disabled']
        }),
        'data-auto-id': 'linkProductTitle',
        asAnchor: true,
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        clickHandler: clickHandler
      },
      value
    )
  );
});

Title.propTypes = {
  value: _propTypes.string,
  href: _propTypes.string,
  disableLink: _propTypes.bool,
  className: _propTypes.string,
  mix: _propTypes.string,
  clickHandler: _propTypes.func
};

Title.defaultProps = {
  value: '',
  href: '',
  disableLink: false,
  className: '',
  mix: '',
  clickHandler: function clickHandler() {}
};

exports.default = Title;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _ratingStars = __webpack_require__(767);

__webpack_require__(779);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'co-product';

var Rating = function Rating(props) {
  var itemUrl = props.itemUrl,
      className = props.className,
      mix = props.mix,
      size = props.size,
      avgStarRating = props.avgStarRating,
      show = props.show,
      totalReviewCount = props.totalReviewCount,
      clickHandler = props.clickHandler;


  var reviewCount = totalReviewCount > 50 ? '50+' : totalReviewCount;
  if (!reviewCount || !show) return null;

  var getRatingPercent = function getRatingPercent() {
    return avgStarRating / 5 * 100;
  };

  var getCountText = function getCountText(reviews) {
    return ['(', reviews, ')'].join('');
  };

  var reviewCountClass = (0, _classNames2.default)({
    blk: blk,
    elt: 'review-count',
    mix: mix,
    mods: [size]
  });

  var ratingBaseClass = (0, _classNames2.default)({
    className: className || mix,
    blk: blk,
    elt: 'rating'
  });

  return _react2.default.createElement(
    _link2.default,
    {
      dataAutoId: 'linkProductRating',
      className: ratingBaseClass,
      href: itemUrl,
      asAnchor: true,
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: clickHandler
    },
    _react2.default.createElement(_ratingStars.RatingStars, {
      reviewCount: reviewCount,
      avgStarRating: avgStarRating,
      percentage: getRatingPercent(),
      mix: mix,
      size: size
    }),
    _react2.default.createElement(
      'span',
      { className: reviewCountClass, 'aria-hidden': 'true' },
      getCountText(reviewCount)
    )
  );
};

Rating.propTypes = {
  itemUrl: _propTypes.string,
  className: _propTypes.string,
  mix: _propTypes.string,
  size: _propTypes.string,
  avgStarRating: _propTypes.number,
  show: _propTypes.bool,
  totalReviewCount: _propTypes.number,
  clickHandler: _propTypes.func
};

Rating.defaultProps = {
  itemUrl: '',
  className: '',
  mix: undefined,
  size: undefined,
  avgStarRating: null,
  show: true,
  totalReviewCount: 0,
  clickHandler: function clickHandler() {}
};

exports.default = Rating;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stars = exports.RatingStars = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _range = __webpack_require__(768);

var _range2 = _interopRequireDefault(_range);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _adapters = __webpack_require__(774);

var _env = __webpack_require__(539);

__webpack_require__(777);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var blk = 'rating-stars';

var Stars = (0, _react.memo)(function (_ref) {
  var position = _ref.position,
      mix = _ref.mix,
      rest = _objectWithoutProperties(_ref, ['position', 'mix']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _classNames2.default)({
        blk: blk, elt: 'stars', mods: [position], mix: mix
      }),
      'aria-hidden': 'true'
    }),
    (0, _range2.default)(0, 5).map(function (i) {
      return _react2.default.createElement(
        'span',
        { key: 'rate-star-' + i, 'aria-hidden': 'true' },
        '\u2605'
      );
    })
  );
});

Stars.propTypes = {
  position: _propTypes.string,
  mix: _propTypes.string
};

Stars.defaultProps = {
  position: '',
  mix: ''
};

var RatingStars = function RatingStars(props) {
  var mix = props.mix,
      size = props.size,
      handleRatingClick = props.handleRatingClick,
      avgStarRating = props.avgStarRating,
      reviewCount = props.reviewCount,
      percentage = props.percentage;

  var isWindows = (0, _env.getCurrentOS)() === 'Windows';
  var displayBlackStars = avgStarRating === 5;
  var sizeMods = [size, isWindows && 'windows'];

  var getRatingWidth = function getRatingWidth() {
    return typeof percentage === 'number' ? { width: percentage + '%' } : undefined;
  };

  return _react2.default.createElement(
    'div',
    {
      onClick: handleRatingClick,
      onKeyPress: handleRatingClick,
      role: 'button',
      tabIndex: '0',
      className: (0, _classNames2.default)({ className: mix, blk: blk, mods: sizeMods }),
      'aria-label': avgStarRating + ' stars out of 5 based on ' + reviewCount + ' reviews, you will be taken to the reviews on clicking this'
    },
    _react2.default.createElement(Stars, { mix: mix, position: 'top', style: getRatingWidth() }),
    !displayBlackStars && _react2.default.createElement(Stars, { mix: mix, position: 'bottom' })
  );
};

RatingStars.propTypes = {
  mix: _propTypes.string,
  size: _propTypes.string,
  handleRatingClick: _propTypes.func,
  avgStarRating: _propTypes.number,
  reviewCount: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  percentage: _propTypes.number
};

RatingStars.defaultProps = {
  mix: undefined,
  size: undefined,
  handleRatingClick: function handleRatingClick() {},

  avgStarRating: 0,
  reviewCount: 0,
  percentage: undefined
};

var RatingStarsWithAdapter = (0, _adapters.showAdapter)(RatingStars);

exports.default = RatingStarsWithAdapter;
exports.RatingStars = RatingStars;
exports.Stars = Stars;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(769);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(770),
    isIterateeCall = __webpack_require__(771),
    toFinite = __webpack_require__(772);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(529),
    isArrayLike = __webpack_require__(535),
    isIndex = __webpack_require__(537),
    isObject = __webpack_require__(511);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(773);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(511),
    isSymbol = __webpack_require__(538);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showAdapter = undefined;

var _show = __webpack_require__(775);

var _show2 = _interopRequireDefault(_show);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.showAdapter = _show2.default;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var showAdapter = function showAdapter(Component) {
  var WithShow = function WithShow(_ref) {
    var show = _ref.show,
        rest = _objectWithoutProperties(_ref, ['show']);

    if (!show) return null;
    return _react2.default.createElement(Component, rest);
  };
  WithShow.propTypes = {
    show: _propTypes.bool
  };
  WithShow.defaultProps = {
    show: true
  };
  return WithShow;
};

exports.default = showAdapter;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentOS = function getCurrentOS() {
  var OSName = 'Unknown';
  var navUserAgent = navigator.userAgent || '';
  if (navUserAgent.indexOf('Win') !== -1) OSName = 'Windows';
  if (navUserAgent.indexOf('Mac') !== -1) OSName = 'Macintosh';
  if (navUserAgent.indexOf('like Mac') !== -1) OSName = 'iOS';
  if (navUserAgent.indexOf('Linux') !== -1) OSName = 'Linux';
  if (navUserAgent.indexOf('Android') !== -1) OSName = 'Android';

  return OSName;
};

exports.default = getCurrentOS;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(778);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_rating-stars.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_rating-stars.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".rating-stars{font-size:12px;width:60px;position:relative;padding:0;color:#767676}.rating-stars--large{font-size:16px;width:80px}.rating-stars--windows{font-size:14px}.rating-stars--windows.rating-stars--large{font-size:19px}.rating-stars__stars--top{color:#f7cc00;position:absolute;top:0;left:0;display:block;overflow:hidden;padding:0}.rating-stars__stars--bottom{padding:0;display:block;text-align:left}", ""]);

// exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(780);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".co-product__rating{display:flex;cursor:pointer;line-height:16px}.co-product__rating--product-slider{margin:auto}.co-product__rating:hover{text-decoration:none}@media (min-width:480px){.co-product__rating{justify-content:center}}.co-product__review-count{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;margin-left:2px;color:#3d3d3d}.co-product__review-count--large{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:400}@media (min-width:480px){.co-product__rating{margin:auto}}", ""]);

// exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoText = exports.default = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _string = __webpack_require__(782);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _componentsTags = __webpack_require__(823);

var _promoText = __webpack_require__(824);

var _promoText2 = _interopRequireDefault(_promoText);

__webpack_require__(825);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// helpers


var blk = 'co-product';

var Promo = function Promo(props) {
  var className = props.className,
      show = props.show,
      isBundle = props.isBundle,
      onClick = props.onClick,
      promoDetail = props.promoDetail,
      promoDetailFull = props.promoDetailFull,
      url = props.url,
      categoryId = props.categoryId,
      type = props.type,
      isLinkSave = props.isLinkSave,
      isMeatSticker = props.isMeatSticker,
      itemName = props.itemName,
      promoMods = props.mods,
      shouldHidePrice = props.shouldHidePrice;


  if (!show && !isBundle) return null;

  var getPromoType = function getPromoType() {
    if (isBundle) return 'bundle';

    if (isLinkSave && !isMeatSticker) return 'linksave';

    return type.toLowerCase();
  };

  var getEDLPLabel = function getEDLPLabel() {
    return getPromoType() === 'asda price' ? 'Low price every day, browse similar products to ' + itemName : '';
  };

  var getPromoConfig = function getPromoConfig() {
    switch (getPromoType()) {
      case 'bundle':
        return {
          name: 'Bundle',
          title: 'Bundle',
          mods: ['bundle'],
          url: url
        };
      case 'linksave':
        return {
          name: (0, _string.makeSentenceCase)(promoDetailFull || promoDetail),
          title: promoDetailFull || promoDetail,
          mods: ['link-save'],
          url: url
        };
      case 'rollback':
        return {
          name: 'RollBack',
          title: 'RollBack',
          mods: ['rollback'],
          url: url
        };
      case 'new':
        return {
          name: 'New',
          title: 'New',
          mods: ['new'],
          url: url
        };
      case 'asda price':
        return {
          name: _react2.default.createElement(_icon2.default, { name: 'price-every-day', asBrand: true }),
          title: '' + getEDLPLabel(),
          mods: ['staying-back'],
          url: url
        };
      case 'sale':
        var iconMods = [];
        if (url || categoryId) iconMods.push('link');
        return {
          name: _react2.default.createElement(_icon2.default, {
            className: (0, _classNames2.default)({ blk: blk, elt: 'sale-icon', mods: iconMods }),
            name: 'sale',
            color: 'white',
            size: 'large'
          }),
          title: 'Sale',
          mods: ['sale'],
          url: url
        };
      case 'no promo':
      default:
        return {
          name: 'no-promo'
        };
    }
  };

  var _getPromoConfig = getPromoConfig(),
      name = _getPromoConfig.name,
      mods = _getPromoConfig.mods,
      promoUrl = _getPromoConfig.url,
      title = _getPromoConfig.title;

  if (name === 'no-promo' || shouldHidePrice) return null;

  var tag = promoUrl ? 'link' : 'span';

  var handleClick = tag === 'link' ? onClick : null;
  var TagComponent = _componentsTags.componentsTags[tag];

  var tagClass = (0, _classNames2.default)({
    className: className,
    blk: blk,
    elt: 'promo',
    mods: [].concat(_toConsumableArray(mods), _toConsumableArray(promoMods))
  });

  return _react2.default.createElement(
    TagComponent,
    {
      ariaLabel: getEDLPLabel(),
      'data-auto-id': 'secondaryPromoBanner',
      className: tagClass,
      to: promoUrl,
      title: title,
      onClick: handleClick
    },
    _react2.default.createElement(
      _promoText2.default,
      { tag: tag },
      name
    )
  );
};

Promo.propTypes = {
  className: _propTypes.string,
  show: _propTypes.bool,
  isBundle: _propTypes.bool,
  onClick: _propTypes.func,
  promoDetail: _propTypes.string,
  promoDetailFull: _propTypes.string,
  url: _propTypes.string,
  categoryId: _propTypes.string,
  type: _propTypes.string,
  isLinkSave: _propTypes.bool,
  isMeatSticker: _propTypes.bool,
  itemName: _propTypes.string,
  mods: (0, _propTypes.arrayOf)(_propTypes.string),
  shouldHidePrice: _propTypes.bool
};

Promo.defaultProps = {
  className: '',
  show: true,
  isBundle: false,
  onClick: function onClick() {},

  promoDetail: '',
  promoDetailFull: '',
  url: '',
  categoryId: null,
  type: '',
  isLinkSave: false,
  isMeatSticker: false,
  itemName: '',
  mods: [],
  shouldHidePrice: false
};

exports.default = Promo;
exports.PromoText = _promoText2.default;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelCaseKeys = exports.toCamelCase = exports.pluralizeWord = exports.makeSentenceCase = exports.escapeHTMLFromSearchURL = exports.escapeHTML = exports.beautifyForSEO = exports.highlightKeyword = exports.removeSpecialChars = exports.shortenLongValues = exports.QueryString = undefined;

var _isArray = __webpack_require__(515);

var _isArray2 = _interopRequireDefault(_isArray);

var _keys = __webpack_require__(520);

var _keys2 = _interopRequireDefault(_keys);

var _camelCase = __webpack_require__(795);

var _camelCase2 = _interopRequireDefault(_camelCase);

var _queryString = __webpack_require__(813);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc shorten a collection of string values
 *
 * @param {array|object} coll collection of values to shorten
 * @param {number} cutoff threshold to shorten strings
 *
 * @returns {object|array} same as input
 */
var shortenLongValues = function shortenLongValues(coll, cutoff) {
  if ((0, _isArray2.default)(coll)) {
    return coll.map(function (str) {
      if (!str || typeof str !== 'string') return str;
      var short = str.substr(0, cutoff);
      var shouldShorten = str.length && short.length < str.length;
      return shouldShorten ? short + '...' : str;
    });
  }

  return (0, _keys2.default)(coll).reduce(function (acc, key) {
    var value = coll[key] || '';
    var short = value.substr(0, cutoff);
    var shouldShorten = value.length && short.length < value.length;
    acc[key] = shouldShorten ? short + '...' : value;
    return acc;
  }, {});
};

var removeSpecialChars = function removeSpecialChars() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/[^a-z]/gi, '');
};

/**
* @desc highlight a specific word in a given sentence
* @param input - sentence where to look for the word (or) characters
* @param charsToHightlight - the word (or) characters to find & hightlight
* @param hightlightClassName - the classname to highlight the word (or) characters if found
*/
var highlightKeyword = function highlightKeyword() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var charsToHightlight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var hightlightClassName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (input.trim() === '' || charsToHightlight.trim() === '') {
    return null;
  }

  return input.replace(new RegExp('(?![^&;]+;)(?!<[^<>]*)(' + charsToHightlight + ')(?![^<>]*>)(?![^&;]+;)', 'gi'), '<span class=' + hightlightClassName + '>$1</span>');
};

function beautifyForSEO(str) {
  return str.trim().toLowerCase().replace(/(<([^>]+)>)/ig, '').replace(/[^a-z0-9_. ]/g, '').replace(/_/g, '-').replace(/[ ]/g, '-').replace(/-+/g, '-').replace('pound', 'pound-');
}

var escapeHTMLMap = {
  '<': '&lt;',
  '>': '&gt;'
};
var escapeHTML = function escapeHTML() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var repl = function repl(s) {
    return escapeHTMLMap[s];
  };
  return str.replace(/[<>]/g, repl);
};
var escapeHTMLFromSearchURL = function escapeHTMLFromSearchURL() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var urlArray = url.split('/');
  var decodedSearchTerm = decodeURIComponent(urlArray[4]);
  if (!Object.keys(escapeHTMLMap).some(function (c) {
    return decodedSearchTerm.includes(c);
  })) {
    return url;
  }
  urlArray[4] = encodeURIComponent(escapeHTML(decodedSearchTerm));
  return urlArray.join('/');
};

/**
* @desc make phrases sentence case (not applicable to sentences)
* @param str - the phrase that needs to be in sentence case
*/
var makeSentenceCase = function makeSentenceCase(str) {
  if (typeof str !== 'string') return str;
  return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
};

/**
* @desc returns plural or singular noun
* @param plural - plural form of noun
* @param singular - singular form of noun
* @param count - count of entity
*/
var pluralizeWord = function pluralizeWord(count, singular, plural) {
  return count === 1 ? singular : plural;
};

function toCamelCase(str) {
  if (typeof str !== 'string') {
    return str;
  }
  return (0, _camelCase2.default)(str);
}

function camelCaseKeys(obj) {
  var keyNames = (0, _keys2.default)(obj);

  if (!keyNames.length) return obj;

  return keyNames.reduce(function (acc, key) {
    var value = obj[key];
    var camelCased = toCamelCase(key);
    acc[camelCased] = value;
    return acc;
  }, {});
}

exports.QueryString = _queryString2.default;
exports.shortenLongValues = shortenLongValues;
exports.removeSpecialChars = removeSpecialChars;
exports.highlightKeyword = highlightKeyword;
exports.beautifyForSEO = beautifyForSEO;
exports.escapeHTML = escapeHTML;
exports.escapeHTMLFromSearchURL = escapeHTMLFromSearchURL;
exports.makeSentenceCase = makeSentenceCase;
exports.pluralizeWord = pluralizeWord;
exports.toCamelCase = toCamelCase;
exports.camelCaseKeys = camelCaseKeys;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(784),
    isArguments = __webpack_require__(533),
    isArray = __webpack_require__(515),
    isBuffer = __webpack_require__(785),
    isIndex = __webpack_require__(537),
    isTypedArray = __webpack_require__(787);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(503),
    stubFalse = __webpack_require__(786);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(540)(module)))

/***/ }),
/* 786 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(788),
    baseUnary = __webpack_require__(789),
    nodeUtil = __webpack_require__(790);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(507),
    isLength = __webpack_require__(536),
    isObjectLike = __webpack_require__(514);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(527);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(540)(module)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(792),
    nativeKeys = __webpack_require__(793);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(794);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(796),
    createCompounder = __webpack_require__(543);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(517),
    upperFirst = __webpack_require__(798);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(510),
    arrayMap = __webpack_require__(541),
    isArray = __webpack_require__(515),
    isSymbol = __webpack_require__(538);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(799);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(800),
    hasUnicode = __webpack_require__(542),
    stringToArray = __webpack_require__(802),
    toString = __webpack_require__(517);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(801);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(803),
    hasUnicode = __webpack_require__(542),
    unicodeToArray = __webpack_require__(804);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 803 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 804 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 805 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(807),
    toString = __webpack_require__(517);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(808);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(810),
    hasUnicodeWord = __webpack_require__(811),
    toString = __webpack_require__(517),
    unicodeWords = __webpack_require__(812);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 810 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 811 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keys = __webpack_require__(520);

var _keys2 = _interopRequireDefault(_keys);

var _toPairs = __webpack_require__(814);

var _toPairs2 = _interopRequireDefault(_toPairs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QueryString = function () {
  function QueryString() {
    _classCallCheck(this, QueryString);
  }

  _createClass(QueryString, null, [{
    key: 'stringify',
    value: function stringify(hash, encode) {
      if (!hash || !(0, _keys2.default)(hash).length) {
        return '';
      }
      var hashKeys = (0, _keys2.default)(hash);
      return hashKeys.map(function (prop) {
        var key = encode ? encodeURIComponent(prop) : prop;
        var value = encode ? encodeURIComponent(hash[prop]) : hash[prop];
        return key + '=' + value;
      }).join('&');
    }
  }, {
    key: 'searchParams',
    value: function searchParams(hash) {
      // wrapper of URLSearchParams to generate url form encoded or query string
      var params = new URLSearchParams();
      (0, _toPairs2.default)(hash).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        params.append(key, value);
      });
      return params.toString();
    }
  }, {
    key: 'parse',
    value: function parse(string) {
      if (!string) {
        return {};
      }

      var stringToBeParsed = string;
      if (stringToBeParsed.indexOf('?') === 0) {
        stringToBeParsed = stringToBeParsed.slice(1);
      }
      var hash = {};
      var params = stringToBeParsed.split(/&/g);
      params.forEach(function (param) {
        var split = param.split('=');
        var key = split[0];
        var value = split[1];
        hash[key] = decodeURIComponent(value);
      });
      return hash;
    }
  }]);

  return QueryString;
}();

exports.default = QueryString;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(815),
    keys = __webpack_require__(520);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(816),
    getTag = __webpack_require__(817),
    mapToArray = __webpack_require__(821),
    setToPairs = __webpack_require__(822);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(541);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(818),
    Map = __webpack_require__(530),
    Promise = __webpack_require__(819),
    Set = __webpack_require__(531),
    WeakMap = __webpack_require__(820),
    baseGetTag = __webpack_require__(507),
    toSource = __webpack_require__(528);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(505),
    root = __webpack_require__(503);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(505),
    root = __webpack_require__(503);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(505),
    root = __webpack_require__(503);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 821 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 822 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentsTags = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(182);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var componentsTags = {
  link: function link(_ref) {
    var children = _ref.children,
        to = _ref.to,
        className = _ref.className,
        onClick = _ref.onClick,
        ariaLabel = _ref.ariaLabel;
    return _react2.default.createElement(
      _reactRouterDom.NavLink,
      {
        'aria-label': ariaLabel,
        to: to,
        onClick: onClick,
        className: className,
        'data-auto-id': 'linkPromo'
      },
      children
    );
  },
  span: function span(_ref2) {
    var children = _ref2.children,
        ariaLabel = _ref2.ariaLabel,
        rest = _objectWithoutProperties(_ref2, ['children', 'ariaLabel']);

    return _react2.default.createElement(
      'span',
      rest,
      children
    );
  }
};

exports.componentsTags = componentsTags;
componentsTags.link.propTypes = {
  to: _propTypes.string.isRequired,
  className: _propTypes.string,
  children: _propTypes.node,
  onClick: _propTypes.func.isRequired,
  ariaLabel: _propTypes.string.isRequired
};

componentsTags.link.defaultProps = {
  className: '',
  children: null
};

componentsTags.span.propTypes = {
  children: _propTypes.node,
  ariaLabel: _propTypes.string
};

componentsTags.span.defaultProps = {
  children: null,
  ariaLabel: ''
};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoText = function PromoText(_ref) {
  var show = _ref.show,
      children = _ref.children,
      tag = _ref.tag;

  if (!show) return null;
  var blk = 'co-product';
  var hyperlinkMod = tag === 'link' ? ['hyperlink'] : [];

  return _react2.default.createElement(
    'span',
    {
      className: (0, _classNames2.default)({ blk: blk, elt: 'promo-text', mods: hyperlinkMod })
    },
    children
  );
};

PromoText.propTypes = {
  show: _propTypes.bool,
  children: _propTypes.node,
  tag: _propTypes.string
};

PromoText.defaultProps = {
  show: true,
  children: null,
  tag: ''
};

exports.default = PromoText;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(826);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".co-product__promo{display:inline-flex;align-items:center;justify-content:center;padding:0 8px;border-radius:4px;height:20px;position:relative;margin-top:8px}.co-product__promo,.co-product__promo:hover{text-decoration:none}.co-product__promo-text{line-height:normal;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.co-product__promo-text--hyperlink{margin-bottom:2px;text-decoration:underline}.co-product__promo--bundle,.co-product__promo--link-save{background-color:#d43030;color:#fff}.co-product__promo--link-save{max-width:108px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.co-product__promo--rollback{background-color:#d43030;color:#fff;width:64px}.co-product__promo--new{background-color:#005a8b;color:#fff}.co-product__promo--sale{background-color:#d43030;color:#fff;padding:0 12px}.co-product__sale-icon{padding-top:4px}.co-product__sale-icon--link{padding-top:6px}.co-product__promo--staying-back{display:inline-block;width:95px;padding:0 5px;text-align:center}", ""]);

// exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricePerUOM = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      pricePerUOM = _ref.pricePerUOM,
      blk = _ref.blk,
      children = _ref.children;

  if (!pricePerUOM) return null;

  return _react2.default.createElement(
    'span',
    { className: (0, _classNames2.default)({ className: className, blk: blk, elt: 'price-per-uom' }) },
    children,
    '(' + pricePerUOM.toLowerCase() + ')'
  );
});

PricePerUOM.propTypes = {
  className: _propTypes.string,
  pricePerUOM: _propTypes.string,
  blk: _propTypes.string,
  children: _propTypes.node
};
PricePerUOM.defaultProps = {
  className: '',
  pricePerUOM: '',
  blk: 'co-product',
  children: null
};

exports.default = PricePerUOM;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WasPrice = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      wasPrice = _ref.wasPrice,
      showUom = _ref.showUom,
      pricePerUOM = _ref.pricePerUOM,
      blk = _ref.blk,
      showTextWas = _ref.showTextWas;

  if (!wasPrice) return null;
  var renderUom = function renderUom(price) {
    var indexOfUom = price.indexOf('/');
    return price.slice(indexOfUom);
  };
  return _react2.default.createElement(
    'span',
    {
      'aria-label': 'Was ' + wasPrice,
      className: (0, _classNames2.default)({ className: className, blk: blk, elt: 'was-price' })
    },
    showTextWas && 'was ',
    showUom ? wasPrice + ' ' + renderUom(pricePerUOM) : wasPrice
  );
});

WasPrice.propTypes = {
  className: _propTypes.string,
  wasPrice: _propTypes.string,
  showUom: _propTypes.bool,
  showTextWas: _propTypes.bool,
  pricePerUOM: _propTypes.string,
  blk: _propTypes.string
};

WasPrice.defaultProps = {
  className: '',
  wasPrice: '',
  pricePerUOM: '',
  showUom: false,
  showTextWas: false,
  blk: 'co-product'
};

exports.default = WasPrice;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'co-product';

var Price = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      pricePerUnit = _ref.pricePerUnit;
  return _react2.default.createElement(
    'strong',
    {
      'aria-label': 'Now ' + pricePerUnit,
      className: (0, _classNames2.default)({ className: className, blk: blk, elt: 'price' })
    },
    pricePerUnit
  );
});

Price.propTypes = {
  className: _propTypes.string,
  pricePerUnit: _propTypes.string
};
Price.defaultProps = {
  className: '',
  pricePerUnit: ''
};

exports.default = Price;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _price = __webpack_require__(544);

var _banner = __webpack_require__(831);

var _banner2 = _interopRequireDefault(_banner);

__webpack_require__(835);

__webpack_require__(837);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'link-save-banner';

var LinkSaveBanner = function LinkSaveBanner(props) {
  var className = props.className,
      isBundle = props.isBundle,
      bundleDiscount = props.bundleDiscount,
      promoOfferTypeCode = props.promoOfferTypeCode;

  var allMeatStickerTypes = [6, 8, 13, 15];
  if (!isBundle && !bundleDiscount && !(0, _price.priceLabelToNumber)(bundleDiscount) > 0 && allMeatStickerTypes.indexOf(Number(promoOfferTypeCode)) <= -1) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: (0, _classNames2.default)({ className: className, blk: blk }) },
    _react2.default.createElement(_banner2.default, props)
  );
};

LinkSaveBanner.propTypes = {
  className: _propTypes.string,
  isBundle: _propTypes.bool,
  bundleDiscount: _propTypes.number,
  promoOfferTypeCode: _propTypes.string
};

LinkSaveBanner.defaultProps = {
  className: '',
  isBundle: false,
  bundleDiscount: 0,
  promoOfferTypeCode: ''
};

exports.default = LinkSaveBanner;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _meatSticker = __webpack_require__(832);

var _meatSticker2 = _interopRequireDefault(_meatSticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'link-save-banner';

var breakpoints = {
  default: 320,
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1200
};

var makeMediaQueryPredicates = function makeMediaQueryPredicates(width) {
  var base = breakpoints.default,
      small = breakpoints.small,
      medium = breakpoints.medium,
      large = breakpoints.large,
      xlarge = breakpoints.xlarge;


  return {
    'default-up': width >= base,
    'default-only': width < small - 1,
    'small-up': width >= small,
    'small-only': width >= small && width < medium - 1,
    'small-down': width < medium - 1,
    'medium-up': width >= medium,
    'medium-only': width >= medium && width < large - 1,
    'medium-down': width < large - 1,
    'large-up': width >= large,
    'large-only': width >= large && width < xlarge - 1,
    'large-down': width < xlarge - 1,
    'xlarge-up': width >= xlarge
  };
};

var getBannerName = function getBannerName(_ref) {
  var isSmallView = _ref.isSmallView,
      mix = _ref.mix,
      alwaysShowLarge = _ref.alwaysShowLarge,
      responsive = _ref.responsive,
      elt = _ref.elt,
      _ref$mods = _ref.mods,
      mods = _ref$mods === undefined ? [] : _ref$mods;

  var largeView = (0, _classNames2.default)({
    blk: blk + '-large',
    elt: elt,
    mix: mix,
    mods: mods
  });
  var smallView = (0, _classNames2.default)({
    blk: blk + '-small',
    elt: elt,
    mix: mix,
    mods: mods
  });
  if (alwaysShowLarge) return largeView;
  if (!responsive || isSmallView) return smallView;
  return largeView;
};

var getModName = function getModName(disabled, url) {
  if (disabled || !url) return [];
  return ['hyperlink'];
};

var Banner = function Banner(props) {
  var mix = props.mix,
      disabled = props.disabled,
      responsive = props.responsive,
      url = props.url,
      alwaysShowLarge = props.alwaysShowLarge,
      clickHandler = props.clickHandler;

  var hyperlinkMod = getModName(disabled, url);
  var width = document.documentElement.clientWidth || window.innerWidth || 0;
  var ruleMap = makeMediaQueryPredicates(width);
  var isSmallView = ruleMap['default-only'];
  var anchorClass = getBannerName({
    isSmallView: isSmallView,
    mix: mix,
    alwaysShowLarge: alwaysShowLarge,
    responsive: responsive,
    elt: 'anchor',
    mods: hyperlinkMod
  });
  var baseName = getBannerName({ isSmallView: isSmallView, alwaysShowLarge: alwaysShowLarge, responsive: responsive });
  return _react2.default.createElement(
    _link2.default,
    {
      'data-auto-id': 'linkPromoDetail',
      asAnchor: true,
      className: anchorClass,
      href: url,
      target: '_blank',
      rel: 'noopener noreferrer',
      clickHandler: clickHandler
    },
    _react2.default.createElement(_meatSticker2.default, _extends({}, props, { baseName: baseName }))
  );
};

Banner.propTypes = {
  responsive: _propTypes.bool,
  url: _propTypes.string,
  disabled: _propTypes.bool,
  alwaysShowLarge: _propTypes.bool,
  mix: _propTypes.string,
  clickHandler: _propTypes.func
};

Banner.defaultProps = {
  responsive: false,
  url: '',
  disabled: false,
  alwaysShowLarge: false,
  mix: '',
  clickHandler: function clickHandler(x) {
    return x;
  }
};

exports.default = (0, _react.memo)(Banner);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _kebabCase = __webpack_require__(833);

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _linksaveConfig = __webpack_require__(834);

var _linksaveConfig2 = _interopRequireDefault(_linksaveConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldUseFallback = function shouldUseFallback(promoOfferTypeCode, promoQty, promoValue) {
  var CODE = promoOfferTypeCode ? Number(promoOfferTypeCode) : '';
  switch (CODE) {
    case 8:
      return false;
    case 13:
      return false;
    case 15:
      {
        return !(promoQty && promoValue);
      }
    default:
      return true;
  }
};

var MeatSticker = function MeatSticker(_ref) {
  var promoQty = _ref.promoQty,
      promoValue = _ref.promoValue,
      promoOfferTypeCode = _ref.promoOfferTypeCode,
      mix = _ref.mix,
      baseName = _ref.baseName;

  var elt = 'meat-sticker';
  if (!shouldUseFallback(promoOfferTypeCode, promoQty, promoValue)) {
    var formatContents = (0, _linksaveConfig2.default)(Number(promoOfferTypeCode), promoQty, promoValue);
    return _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: baseName, elt: elt }) },
      formatContents.map(function (linksave, index) {
        var key = (0, _kebabCase2.default)(linksave.content + '-' + index);
        var configClassName = (0, _classNames2.default)({
          blk: baseName,
          elt: 'config',
          mods: linksave.mods,
          mix: mix
        });
        return _react2.default.createElement(
          'span',
          { className: configClassName, key: key },
          linksave.content
        );
      }),
      _react2.default.createElement(
        'span',
        { className: (0, _classNames2.default)({ blk: baseName, elt: 'view-all', mix: mix }) },
        'View all'
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: (0, _classNames2.default)({ blk: baseName, elt: elt, mix: mix }) },
    _react2.default.createElement(
      'span',
      { className: (0, _classNames2.default)({ blk: baseName, elt: 'quantity', mix: mix }) },
      promoQty + ' for '
    ),
    _react2.default.createElement(
      'span',
      { className: (0, _classNames2.default)({ blk: baseName, elt: 'price', mix: mix }) },
      promoValue
    ),
    _react2.default.createElement(
      'span',
      { className: (0, _classNames2.default)({ blk: baseName, elt: 'view-all', mix: mix }) },
      'View all'
    )
  );
};

MeatSticker.propTypes = {
  mix: _propTypes.string,
  promoOfferTypeCode: _propTypes.string,
  promoQty: _propTypes.string,
  promoValue: _propTypes.string,
  baseName: _propTypes.string
};

MeatSticker.defaultProps = {
  mix: '',
  promoOfferTypeCode: '',
  promoQty: '',
  promoValue: '',
  baseName: ''
};

exports.default = (0, _react.memo)(MeatSticker);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(543);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @desc generate the content and classname for the meat sticker
 *
 * @param {number} promoOfferTypeCode type of linksave
 * @param {string} promoQty quantity of linksave
 * @param {string} promoValue value of linksave
 *
 * @returns {array} slices with content and classname
 */
var formatMeatSticker = function formatMeatSticker(promoOfferTypeCode, promoQty, promoValue) {
  var FONT_SMALL = 'font-small';
  var HEIGHT_NORMAL = 'height-normal';
  var INLINE_BLOCK = 'inline-block';
  var DOWN_LARGE = 'down-large';

  switch (promoOfferTypeCode) {
    case 8:
      {
        return [{
          content: 'Buy ' + promoQty + ' save ',
          mods: ['block', FONT_SMALL, 'center', HEIGHT_NORMAL]
        }, {
          content: promoValue,
          mods: ['block', 'font-large', 'up-small']
        }];
      }
    case 13:
      {
        return [{
          content: promoQty + ' ',
          mods: [INLINE_BLOCK, 'font-huge', HEIGHT_NORMAL, DOWN_LARGE, 'font-weight-semi-bold']
        }, {
          content: ' for ',
          mods: [INLINE_BLOCK, FONT_SMALL, DOWN_LARGE, 'margin-horizontal-small']
        }, {
          content: ' ' + promoValue,
          mods: [INLINE_BLOCK, 'font-huge', DOWN_LARGE, 'font-weight-semi-bold']
        }];
      }
    case 15:
      {
        var promoValueSize = promoValue.length > 5 ? 'font-large' : 'font-huge';
        return [{
          content: promoQty + ' for ',
          mods: ['block', 'font-normal', 'center', HEIGHT_NORMAL]
        }, {
          content: promoValue,
          mods: ['block', promoValueSize, 'up-small']
        }];
      }
    default:
      {
        return [{
          content: promoQty + ' for',
          mods: ['block', FONT_SMALL]
        }, {
          content: promoValue
        }];
      }
  }
};

exports.default = formatMeatSticker;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(836);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".link-save-banner-small__anchor{position:absolute;left:0;top:0;background-color:#d43030;color:#fff;display:inline-flex;align-items:center;justify-content:center;flex-grow:0;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:600;padding:0 8px;height:20px;text-decoration:none;border-radius:4px}.link-save-banner-small__anchor--hyperlink{text-decoration:underline}.link-save-banner-small__view-all{display:none}.link-save-banner-large__anchor{top:0;left:0;position:absolute;text-align:center;text-transform:none;min-width:56px;border-radius:0 4px 4px;background-color:#d43030;text-decoration:none;color:#fff;display:inline-flex;align-items:center;justify-content:center;flex-grow:0}.link-save-banner-large__anchor:hover{text-decoration:none}.link-save-banner-large__meat-sticker{height:56px;width:56px;position:relative}.link-save-banner-large__bundle-text{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;display:block;margin-top:2px}.link-save-banner-large__bundle-price{display:block;font-size:18px;line-height:20px;font-weight:700}.link-save-banner-large__quantity{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;display:block;margin-top:2px}.link-save-banner-large__price{display:block;font-size:22px;line-height:20px;margin-top:-4px;font-weight:700}.link-save-banner-large__view-all{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;display:block;text-decoration:underline;text-align:center;position:absolute;width:100%;bottom:5px}.link-save-banner-promo__anchor{left:auto;position:relative;top:auto}", ""]);

// exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(838);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_linksave-config.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_linksave-config.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".link-save-banner-large__config--block{display:block;width:56px}.link-save-banner-large__config--inline-block{display:inline-block}.link-save-banner-large__config--center{display:inline-flex;align-items:center;justify-content:center}.link-save-banner-large__config--height-normal{height:16px}.link-save-banner-large__config--margin-horizontal-small{margin:0 2px}.link-save-banner-large__config--up-small{margin-top:-3px}.link-save-banner-large__config--down-large{transform:translateY(10px)}.link-save-banner-large__config--font-huge{font-size:22px;font-weight:700}.link-save-banner-large__config--font-large{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:700}.link-save-banner-large__config--font-normal{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:600}.link-save-banner-large__config--font-small{font-size:11px;font-weight:600}.link-save-banner-large__config--font-weight-semi-bold{font-weight:600}", ""]);

// exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(840);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".co-product__volume{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:400;display:block;text-transform:lowercase}.co-product__bundled-item-count{display:block}.co-product__bundled-item-count,.co-product__title{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400}.co-product__title{line-height:1.15;padding-bottom:1px;margin:0}.co-product__title:first-letter{text-transform:capitalize}.co-product__anchor{font-size:14px;letter-spacing:.2px;line-height:16px;font-weight:400;color:#3d3d3d;text-decoration:none}.co-product__anchor:hover{text-decoration:underline}.co-product__lastPurchaseDate{font-size:14px;letter-spacing:.2px;line-height:16px;font-weight:600}.co-product__was-price{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;text-decoration:line-through;margin-right:2px}.co-product__price{font-size:18px;letter-spacing:.2px;line-height:24px;font-weight:600}.co-product__price-per-uom{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:400}@media (min-width:480px){.co-product__price{font-size:22px;letter-spacing:.3px;line-height:28px;font-weight:600}.co-product__price--pdp{font-size:28px;letter-spacing:.3px;line-height:36px;font-weight:600}.co-product__bundled-item-count{display:inline-block;margin-top:0}}", ""]);

// exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _product = __webpack_require__(516);

var _util = __webpack_require__(842);

var _favourites = __webpack_require__(843);

var _favourites2 = _interopRequireDefault(_favourites);

var _noImageAvailable = __webpack_require__(852);

var _noImageAvailable2 = _interopRequireDefault(_noImageAvailable);

var _constants = __webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageStickerVolume = function ImageStickerVolume(props) {
  var images = props.images,
      name = props.name,
      handleFavouriteClick = props.handleFavouriteClick,
      className = props.className,
      weight = props.weight,
      size = props.size,
      assetType = props.assetType,
      promoDetails = props.promoDetails,
      productDetails = props.productDetails,
      handleProductClick = props.handleProductClick,
      itemUrl = props.itemUrl;

  var _useState = (0, _react.useState)({
    altText: '',
    isLoading: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var imgClass = (0, _classNames2.default)({
    className: className,
    blk: _constants.BLOCK,
    elt: 'image',
    mods: [state.isLoading && 'load-effect']
  });

  var setAlt = function setAlt() {
    setState({
      altText: name || 'Not Available',
      isLoading: false
    });
  };

  var getScene7ImageUrl = function getScene7ImageUrl() {
    var scene7Host = images.scene7Host,
        assetId = images.scene7Id;

    var host = scene7Host;

    if (!host || !assetId) return '';
    var updatedAssetType = assetType;
    if (!assetType && size === 'default') {
      updatedAssetType = (0, _util.isRetinaDisplay)() ? '?$ProdList2x$' : '?$ProdList$';
    }

    return host + 'asdagroceries/' + assetId + updatedAssetType;
  };

  var setNoAvailableImage = function setNoAvailableImage(e) {
    e.target.src = _noImageAvailable2.default;
    setAlt();
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _link2.default,
      {
        asAnchor: true,
        href: itemUrl,
        target: '_blank',
        rel: 'noopener noreferrer',
        dataAutoId: 'linkProductImage',
        clickHandler: handleProductClick
      },
      _react2.default.createElement('img', {
        className: imgClass,
        alt: state.altText,
        onLoad: setAlt,
        importance: 'high',
        src: getScene7ImageUrl(),
        onError: setNoAvailableImage
      })
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'items-container' }) },
      _react2.default.createElement(_favourites2.default, {
        productDetails: productDetails,
        handleFavouriteClick: handleFavouriteClick
      }),
      _react2.default.createElement(
        'div',
        {
          className: (0, _classNames2.default)({
            blk: _constants.BLOCK,
            elt: 'volume-container',
            className: 'co-item__items'
          })
        },
        _react2.default.createElement(_product.Volume, { value: weight })
      )
    ),
    promoDetails.promoId ? _react2.default.createElement(_product.LinkSavePrimaryBanner, _extends({
      url: itemUrl,
      responsive: true,
      clickHandler: handleProductClick
    }, promoDetails)) : null
  );
};

ImageStickerVolume.propTypes = {
  images: (0, _propTypes.shape)({ default: _propTypes.string }).isRequired,
  name: _propTypes.string.isRequired,
  weight: _propTypes.string.isRequired,
  promoDetails: (0, _propTypes.shape)({ promoId: _propTypes.string }).isRequired,
  className: _propTypes.string,
  productDetails: (0, _propTypes.shape)({
    id: _propTypes.string
  }),
  size: _propTypes.string,
  assetType: _propTypes.string,
  handleFavouriteClick: _propTypes.func,
  handleProductClick: _propTypes.func,
  itemUrl: _propTypes.string.isRequired
};

ImageStickerVolume.defaultProps = {
  productDetails: {},
  size: 'default',
  className: '',
  assetType: '',
  handleFavouriteClick: function handleFavouriteClick() {},
  handleProductClick: function handleProductClick() {}
};

exports.default = ImageStickerVolume;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isRetinaDisplay = exports.isRetinaDisplay = function isRetinaDisplay() {
  if (window.matchMedia) {
    var media = "only screen and (min--moz-device-pixel-ratio: 1.3),\n                     only screen and (-o-min-device-pixel-ratio: 2.6/2),\n                     only screen and (-webkit-min-device-pixel-ratio: 1.3),\n                     only screen  and (min-device-pixel-ratio: 1.3),\n                     only screen and (min-resolution: 1.3dppx)";

    var mq = window.matchMedia(media);
    return mq && mq.matches || window.devicePixelRatio > 1;
  }

  return null; // can't detect retina
};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _button = __webpack_require__(506);

var _button2 = _interopRequireDefault(_button);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _constants = __webpack_require__(508);

__webpack_require__(850);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Favourites = function Favourites(props) {
  var productDetails = props.productDetails,
      className = props.className,
      handleFavouriteClick = props.handleFavouriteClick;

  var favClass = (0, _classNames2.default)({
    blk: _constants.fsl,
    elt: 'favourites-image',
    className: 'co-item__items'
  });
  var isFavourite = productDetails.isFavourite;


  return _react2.default.createElement(
    'div',
    {
      className: (0, _classNames2.default)({
        blk: _constants.fsl,
        elt: 'favourites-image-container',
        className: className || 'co-item__items'
      }),
      role: 'presentation',
      'data-auto-id': 'favourites'
    },
    _react2.default.createElement(
      'div',
      { className: 'context-wrapper' },
      _react2.default.createElement(
        _button2.default,
        {
          isIcon: true,
          category: 'plain',
          clickHandler: handleFavouriteClick,
          className: (0, _classNames2.default)({ blk: _constants.fsl, elt: 'favourites-button' })
        },
        isFavourite ? _react2.default.createElement(_icon2.default, { className: favClass, name: 'heart-filled', color: 'charcoal' }) : _react2.default.createElement(_icon2.default, { className: favClass, name: 'heart-outlined', color: 'charcoal' })
      )
    )
  );
};

Favourites.propTypes = {
  productDetails: (0, _propTypes.shape)({
    isFavourite: _propTypes.boolean
  }),
  className: _propTypes.string,
  handleFavouriteClick: _propTypes.func
};

Favourites.defaultProps = {
  productDetails: {},
  className: '',
  handleFavouriteClick: function handleFavouriteClick() {}
};

exports.default = Favourites;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _spinner = __webpack_require__(845);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'asda-btn';

var Loading = function Loading(_ref) {
  var loading = _ref.loading,
      loadingWithLabel = _ref.loadingWithLabel,
      outline = _ref.outline,
      category = _ref.category;

  if (loading && loadingWithLabel) {
    return _react2.default.createElement(_spinner2.default, {
      isCenter: false,
      size: 'small',
      category: outline ? category : category + '-light',
      className: (0, _classNames2.default)({ blk: blk, elt: 'spinner-with-label' })
    });
  }

  if (loading) {
    return _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({
          blk: blk,
          elt: 'spinner',
          mods: [!outline && category, outline && 'outline']
        })
      },
      _react2.default.createElement(_spinner2.default, { isCenter: false, size: 'small', category: outline ? category : category + '-light' })
    );
  }
  return null;
};

Loading.propTypes = {
  loading: _propTypes.bool,
  loadingWithLabel: _propTypes.bool,
  outline: _propTypes.bool,
  category: _propTypes.string
};

Loading.defaultProps = {
  loading: false,
  loadingWithLabel: false,
  outline: false,
  category: 'primary'
};

exports.default = Loading;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

__webpack_require__(846);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'asda-spinner';

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      category = _ref.category,
      size = _ref.size,
      isCenter = _ref.isCenter,
      withOverlay = _ref.withOverlay,
      overlayClassName = _ref.overlayClassName;

  var spinnerClass = (0, _classNames2.default)({
    blk: blk,
    className: className,
    mods: [category, size, isCenter && 'center']
  });

  if (withOverlay) {
    return _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: blk, elt: 'overlay', className: overlayClassName }) },
      _react2.default.createElement('div', { className: spinnerClass })
    );
  }

  return _react2.default.createElement('div', { className: spinnerClass });
};

Spinner.propTypes = {
  className: _propTypes.string,
  overlayClassName: _propTypes.string,
  category: (0, _propTypes.oneOf)(['primary', 'secondary', 'primary-light', 'secondary-light']),
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),
  isCenter: _propTypes.bool,
  withOverlay: _propTypes.bool
};

Spinner.defaultProps = {
  className: '',
  overlayClassName: '',
  category: 'primary',
  size: 'medium',
  isCenter: true,
  withOverlay: false
};

exports.default = (0, _react.memo)(Spinner);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(847);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, "@keyframes loading{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.asda-spinner{display:inline-block;border-radius:50%;border-width:2px;border-style:solid;animation:loading .7s infinite linear}.asda-spinner--center{display:block;margin:10px auto}.asda-spinner--primary{border-color:#68a51c;border-top-color:#fff}.asda-spinner--primary-light{border-color:#b4d28e;border-top-color:#fff}.asda-spinner--secondary{border-color:#0073b1;border-top-color:#fff}.asda-spinner--secondary-light{border-color:#7fb9d8;border-top-color:#fff}.asda-spinner--clear,.asda-spinner--clear-light{border-color:#ccc;border-top-color:#fff}.asda-spinner--small{width:20px;height:20px}.asda-spinner--medium{width:40px;height:40px}.asda-spinner--large{width:60px;height:60px}.asda-spinner__overlay{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center}", ""]);

// exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(849);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".asda-btn{border:none;border-radius:4px;display:inline-flex;align-items:center;justify-content:center;height:40px;padding:0 16px;text-align:center;text-decoration:none;user-select:none;cursor:pointer;position:relative;overflow:hidden;white-space:nowrap;font-size:18px;letter-spacing:.2px;line-height:24px;font-weight:600}.asda-btn:hover{box-shadow:0 2px 10px 0 rgba(61,61,61,.1)}.asda-btn--disabled,.asda-btn--loading,.asda-btn:disabled{pointer-events:none}.asda-btn--fluid{width:100%}.asda-btn--primary{background:#68a51c;color:#fff}.asda-btn--primary:hover{background:#538316}.asda-btn--primary--disabled,.asda-btn--primary:disabled{background:#b4d28e}.asda-btn--primary-outline{background:#fff;color:#68a51c;border:1px solid #68a51c}.asda-btn--primary-outline:hover{background:#fff;border-width:2px;padding:0 15px}.asda-btn--primary-outline--disabled,.asda-btn--primary-outline:disabled{border-color:#b4d28e;color:#b4d28e}.asda-btn--plain{background:none;color:#3d3d3d}.asda-btn--plain:hover{background:#f6f6f6;box-shadow:none}.asda-btn--secondary{background:#0073b1;color:#fff}.asda-btn--secondary:hover{background:#005a8b}.asda-btn--secondary--disabled,.asda-btn--secondary:disabled{background:#7fb9d8}.asda-btn--secondary-outline{background:#fff;color:#0073b1;border:1px solid #0073b1}.asda-btn--secondary-outline:hover{background:#fff;border-width:2px;padding:0 15px}.asda-btn--secondary-outline--disabled,.asda-btn--secondary-outline:disabled{border-color:#7fb9d8;color:#7fb9d8}.asda-btn--clear{background:#eee}.asda-btn--clear--disabled,.asda-btn--clear:disabled{color:#767676}.asda-btn--clear-outline{background:#fff;border:1px solid #ccc}.asda-btn--icon{padding:0 8px}.asda-btn--icon-outline:hover{padding:0 7px}.asda-btn__spinner{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;z-index:10}.asda-btn__spinner--primary{background:#68a51c}.asda-btn__spinner--secondary{background:#0073b1}.asda-btn__spinner--clear{background:#eee}.asda-btn__spinner--outline{background:#fff}.asda-btn__spinner-with-label{margin-right:8px}", ""]);

// exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(851);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_favs.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_favs.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".co-item{overflow:inherit}.co-item__items-container{display:flex;justify-content:left;align-items:flex-start;flex-grow:1}.co-item__items{width:50%}.co-item-fsl__favourites-image{height:30px;position:relative;cursor:pointer;width:50%;align-self:flex-end}.co-item-fsl__favourites-button{display:inline}.co-item-fsl__divider{border:none;border-bottom:1px solid #ccc}@media (min-width:480px){.co-item{overflow:inherit}.co-item-fsl__favourites-image{height:30px;width:30px}}", ""]);

// exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/dot_com_ui/img/no-image-available-ba91825aa6564c63ad0da366e7e4ba5a.gif";

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _product = __webpack_require__(516);

var _constants = __webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleRatingBundlePromo = function TitleRatingBundlePromo(_ref) {
  var promoDetails = _ref.promoDetails,
      ratingAndReview = _ref.ratingAndReview,
      name = _ref.name,
      categoryId = _ref.categoryId,
      mods = _ref.mods,
      handleProductClick = _ref.handleProductClick,
      itemUrl = _ref.itemUrl;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'title-container', mods: mods }) },
      _react2.default.createElement(_product.Title, {
        href: itemUrl,
        value: name,
        mods: true,
        clickHandler: handleProductClick
      })
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'rating-container' }) },
      _react2.default.createElement(_product.Rating, _extends({ clickHandler: handleProductClick, itemUrl: itemUrl }, ratingAndReview))
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'promo-container', mods: mods }) },
      _react2.default.createElement(_product.Promo, _extends({}, promoDetails, {
        itemName: name,
        categoryId: categoryId,
        mods: mods
      }))
    )
  );
};

TitleRatingBundlePromo.propTypes = {
  promoDetails: (0, _propTypes.shape)({ bundledItemCount: _propTypes.number }).isRequired,
  ratingAndReview: (0, _propTypes.shape)({ totalReviewCount: _propTypes.number }).isRequired,
  name: _propTypes.string.isRequired,
  categoryId: _propTypes.string,
  mods: (0, _propTypes.arrayOf)(_propTypes.string),
  handleProductClick: _propTypes.func,
  itemUrl: _propTypes.string.isRequired
};

TitleRatingBundlePromo.defaultProps = {
  categoryId: '',
  mods: [],
  handleProductClick: function handleProductClick() {}
};

exports.default = TitleRatingBundlePromo;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _product = __webpack_require__(516);

var _constants = __webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceQuantity = function PriceQuantity(props) {
  var mods = props.mods,
      item = props.item;
  var priceDetails = item.priceDetails,
      _item$promoDetails$ty = item.promoDetails.type,
      type = _item$promoDetails$ty === undefined ? '' : _item$promoDetails$ty;
  var _priceDetails$unit = priceDetails.unit,
      unit = _priceDetails$unit === undefined ? '' : _priceDetails$unit,
      wasPrice = priceDetails.wasPrice,
      shouldHidePrice = priceDetails.shouldHidePrice,
      isUnavailable = priceDetails.isUnavailable,
      availability = priceDetails.availability;

  var promoType = type.toLowerCase();
  var unitType = unit.toLowerCase();
  var isRollbackOrSale = ['rollback', 'sale'].indexOf(promoType) > -1 && !!wasPrice;
  var pricePerUomElt = 'price-per-uom-msg';

  var getUnavailText = function getUnavailText(stockType) {
    var statusMap = {
      O: 'OUT OF STOCK',
      I: 'ITEM UNAVAILABLE',
      C: 'COMING SOON'
    };
    return statusMap[stockType] || '';
  };

  var UnAvailText = getUnavailText(availability);

  var UnAvailEltClass = (0, _classNames2.default)({
    blk: _constants.PILL_BLOCK,
    className: (0, _classNames2.default)({ blk: _constants.UNAVAILABLE_BLOCK, elt: 'product-status' }),
    mods: ['light']
  });

  var unavailable = _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'unavailable-banner' },
      _react2.default.createElement(
        'span',
        { className: UnAvailEltClass },
        UnAvailText || 'ITEM UNAVAILABLE'
      )
    )
  );

  if (shouldHidePrice) {
    return _react2.default.createElement(
      _react.Fragment,
      null,
      ' ',
      _react2.default.createElement('div', { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'price-container' }) }),
      ' ',
      unavailable,
      ' '
    );
  }

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'price-container', mods: mods }) },
      isRollbackOrSale && ['each', 'weighted'].indexOf(unitType) > -1 && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_product.WasPrice, priceDetails),
        _react2.default.createElement(_product.Price, priceDetails),
        _react2.default.createElement(
          'p',
          { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: pricePerUomElt }) },
          _react2.default.createElement(_product.PricePerUOM, priceDetails)
        )
      ),
      isRollbackOrSale && unitType === 'both' && _react2.default.createElement(
        'span',
        { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'price-per-uom' }) },
        _react2.default.createElement(_product.Price, priceDetails),
        ' ',
        _react2.default.createElement(
          'p',
          { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: pricePerUomElt }) },
          _react2.default.createElement(_product.WasPrice, _extends({}, priceDetails, { showUom: true })),
          _react2.default.createElement(_product.PricePerUOM, priceDetails)
        )
      ),
      !isRollbackOrSale && _react2.default.createElement(
        'span',
        { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: 'price-per-uom' }) },
        _react2.default.createElement(_product.Price, priceDetails),
        _react2.default.createElement(
          'p',
          { className: (0, _classNames2.default)({ blk: _constants.BLOCK, elt: pricePerUomElt }) },
          _react2.default.createElement(_product.PricePerUOM, priceDetails)
        )
      )
    ),
    isUnavailable && unavailable
  );
};

PriceQuantity.propTypes = {
  item: (0, _propTypes.shape)({ id: _propTypes.string }).isRequired,
  mods: (0, _propTypes.arrayOf)(_propTypes.string)
};

PriceQuantity.defaultProps = {
  mods: []
};

exports.default = PriceQuantity;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".co-item{background:#fff;border-bottom:1px solid #ccc;padding:10px 0;position:relative;width:100%}.co-item:after,.co-item:before{content:\" \";display:table}.co-item:after{clear:both}.co-item--home{list-style-type:none}.co-item:first-child{border-top:1px solid #ccc}.co-item__add-to-existing-shopping-list-header{display:flex;align-items:center}.co-item__add-to-existing-shopping-list-header h5{font-size:15px}.co-item__col1{float:left;width:33.333333333333336%;text-align:center}.co-item__col2{padding-left:16px;text-align:left}.co-item__col2,.co-item__col3{float:left;width:66.66666666666666%}.co-item__featured-fav-label-container{position:relative;right:103px;bottom:24px;-webkit-backdrop-filter:blur(25px);backdrop-filter:blur(25px)}.co-item__featured-fav-label{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;position:absolute;top:0;right:0;line-height:12px;border-radius:4px 4px 0 0;background-color:#767676;border:0 solid #68a51c;padding:5px 7px 2px;font-weight:600;color:#fff;height:23px}.co-item--featured{padding-top:20px}.co-item__featured-label-container{margin-bottom:8px}.co-item__featured-label{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;position:absolute;top:0;right:0;line-height:12px;border-bottom:1px solid #eee;border-left:1px solid #eee;border-radius:0 0 0 2px;padding:1px 7px 2px;font-weight:600;text-transform:uppercase}.co-item__image{width:100%;min-width:100px;min-height:100px;max-width:130px;max-height:130px;object-fit:contain;display:inline-block}.co-item__volume-container{height:30px;display:flex;align-items:center;justify-content:center}.co-item__title-container{max-height:50px;overflow:hidden;text-overflow:ellipsis;margin-bottom:2px;white-space:normal;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}.co-item__rating-container{text-align:left}.co-item__bundled-item-count-container{margin-top:5px}.co-item__price-container{padding:8px 0}.co-item__price-per-uom-msg{margin:0}.co-item__price-per-uom{display:block}.co-item__co-button{float:left}.co-item__quantity-container{position:relative}.co-item__promo-icon-list--list-position{position:absolute;top:-2px;left:147px}.co-item__sponsored-label{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;border-radius:4px;background-color:#f6f6f6;right:0;padding:1px 4px;position:absolute;top:0}@media (max-width:767px){.co-item__promo-icon-list--list-position{top:26px;right:1px;left:auto}.co-item__promo-icon-list--sponsored{top:38px}.co-item__featured-label-container{margin-bottom:0}.co-item__col2--sponsored{margin-top:12px}.co-item__col3{padding:32px 0 0 16px}.co-item__col3--sponsored{padding-top:20px}.co-item__featured-fav-label-container{margin-bottom:22px;right:0;bottom:5px}.co-item__featured-fav-label{border-radius:4px}}.co-item--product-slider,.co-item--product-slider .co-item{width:33.33333%;margin:18px -2px 18px 1px;height:auto;overflow:inherit;border:1px solid #ccc;padding:0;text-align:center;position:relative}.co-item--product-slider .co-item__col1,.co-item--product-slider .co-item__col2,.co-item--product-slider .co-item__col3{float:none;width:auto;text-align:center}.co-item--product-slider .co-item__col3{padding:0 0 16px}.co-item--product-slider .co-item__image{min-width:130px;min-height:130px}.co-item--product-slider .co-item__col1{padding-top:8px}.co-item--product-slider .co-item__col2{padding:0}.co-item--product-slider .co-item__col2:after,.co-item--product-slider .co-item__col2:before{content:\" \";display:table}.co-item--product-slider .co-item__col2:after{clear:both}.co-item--product-slider .co-item__title-container{height:48px;margin:6px 10px 2px}.co-item--product-slider .co-item__rating-container{height:15px}.co-item--product-slider .co-item__promo-container{height:30px;display:flex;align-items:center;justify-content:center}.co-item--product-slider .co-item__bundled-item-count-container{height:16px;margin-top:0;margin-bottom:3px}.co-item--product-slider .co-item__price-container{height:60px}.co-item--product-slider .co-item__price-per-uom{display:block}.co-item--product-slider .co-item__co-button{float:none}.co-item--product-slider .co-item__quantity-container{position:static}.co-item--product-slider .co-item__promo-icon-list--list-position{top:26px;right:1px;left:auto}.co-item--product-slider .co-item--modal-ctx{width:50%}.co-item--product-slider .co-item__new-quantity-container{display:flex;justify-content:center}.context-wrapper{position:relative;display:inline-flex}@media (min-width:480px){.co-item{width:33.33333%;margin:18px -2px 18px 1px;height:auto;overflow:inherit;border:1px solid #ccc;padding:0;text-align:center;position:relative}.co-item__col1,.co-item__col2,.co-item__col3{float:none;width:auto;text-align:center}.co-item__col3{padding:0 0 16px}.co-item__image{min-width:130px;min-height:130px}.co-item__col1{padding-top:8px}.co-item__col2{padding:0}.co-item__col2:after,.co-item__col2:before{content:\" \";display:table}.co-item__col2:after{clear:both}.co-item__title-container{height:48px;margin:6px 10px 2px}.co-item__rating-container{height:15px}.co-item__promo-container{height:30px;display:flex;align-items:center;justify-content:center}.co-item__bundled-item-count-container{height:16px;margin-top:0;margin-bottom:3px}.co-item__price-container{height:60px}.co-item__price-per-uom{display:block}.co-item__co-button{float:none}.co-item__quantity-container{position:static}.co-item__promo-icon-list--list-position{top:26px;right:1px;left:auto}.co-item--modal-ctx{width:50%}.co-item__new-quantity-container{display:flex;justify-content:center}.co-item__col2--sponsored{margin-top:0}}@media (min-width:768px){.co-item{width:25%}.co-item--modal-ctx{width:33.33333%}}@media (min-width:768px) and (max-width:1023px){.co-item__featured-fav-label-container{right:122px}}@media (min-width:1024px) and (max-width:1279px){.co-item__featured-fav-label-container{right:103px}}@media (min-width:1024px){.co-item{width:20%}.co-item--home{width:16.66667%}.co-item--modal-ctx{width:33.33333%}}@media (min-width:1280px){.site-width .co-item{width:16.66667%}.site-width .co-item--home{width:14.28571%}.site-width .co-item--modal-ctx{width:33.33333%}}@keyframes productImageLoading{0%{background-position:0 100%}to{background-position:100% 0}}.co-item__image--load-effect{background-size:70%;background-image:linear-gradient(90deg,#f6f6f6,#fff,#f6f6f6);animation:productImageLoading 1s infinite linear alternate}.unavailable-banner{display:inline-block;text-align:center}.unavailable-banner__product-status{text-transform:none;margin:0 8px}.asda-pill,.unavailable-banner__future-date{font-weight:600}.asda-pill{padding:2px 16px;border-radius:10px;text-transform:uppercase;display:inline-flex;align-items:center;font-size:12px;letter-spacing:.1px;line-height:16px}.asda-pill--light{background-color:#eee;color:#767676}", ""]);

// exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(858);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".co-product-list{padding:10px 10px 0;position:relative;margin-bottom:20px}.co-product-list__main-cntr{width:100%;display:flex;flex-wrap:wrap;min-height:207px;background:#fff;justify-content:center}.co-product-list__main-cntr:after,.co-product-list__main-cntr:before{content:\" \";display:table}.co-product-list__main-cntr:after{clear:both}.co-product-list__header{font-size:18px;letter-spacing:.2px;line-height:24px;font-weight:600;height:40px}.co-product-list__header:after,.co-product-list__header:before{content:\" \";display:table}.co-product-list__header:after{clear:both}.co-product-list__title{font-size:18px;letter-spacing:.2px;line-height:24px;font-weight:600;line-height:40px}.co-product-list__anchor{display:none}.lazy-indicator__co_spinner{position:relative}.co-product-list--panel-mode{padding-top:0}.co-product-list--panel-mode .co-product-list__main-cntr{border-top:none}.co-product-list--panel-mode .co-product-list__header{border-style:solid none}@media (min-width:480px){.co-product-list{padding:0}.co-product-list__main-cntr{min-height:367px;padding:0}.co-product-list__header{margin-bottom:0}.co-product-list__anchor{line-height:inherit;display:block;float:right}.co-product-list--panel-mode{padding-top:0}}", ""]);

// exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePersonalisationData = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _price = __webpack_require__(544);

var parsePersonalisationData = exports.parsePersonalisationData = function parsePersonalisationData(favouritesItemIds) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _response$modules = response.modules;
  _response$modules = _response$modules === undefined ? [{}] : _response$modules;

  var _response$modules2 = _slicedToArray(_response$modules, 1),
      _response$modules2$ = _response$modules2[0],
      _response$modules2$$m = _response$modules2$.metadata.placement,
      placement = _response$modules2$$m === undefined ? '' : _response$modules2$$m,
      _response$modules2$$m2 = _response$modules2$.module_data;

  _response$modules2$$m2 = _response$modules2$$m2 === undefined ? [{}] : _response$modules2$$m2;

  var _response$modules2$$m3 = _slicedToArray(_response$modules2$$m2, 1),
      _response$modules2$$m4 = _response$modules2$$m3[0],
      _response$modules2$$m5 = _response$modules2$$m4.list_data,
      items = _response$modules2$$m5 === undefined ? [] : _response$modules2$$m5,
      _response$modules2$$m6 = _response$modules2$$m4.list_metadata,
      _response$modules2$$m7 = _response$modules2$$m6.strategy_id,
      strategy_id = _response$modules2$$m7 === undefined ? '' : _response$modules2$$m7,
      _response$modules2$$m8 = _response$modules2$$m6.strategy_message,
      strategy_message = _response$modules2$$m8 === undefined ? '' : _response$modules2$$m8;

  var isUnavailable = function isUnavailable(availability) {
    return availability ? ['O', 'I', 'C'].includes(availability) : true;
  };
  var shouldHidePrice = function shouldHidePrice(salePrice, pricePerUnit, onSale) {
    var salePriceNum = (0, _price.priceLabelToNumber)(salePrice);
    var priceNum = (0, _price.priceLabelToNumber)(pricePerUnit);
    return !!pricePerUnit && priceNum < 0.01 || onSale && salePriceNum < 0.01;
  };
  var processedItems = items.map(function (itemObj) {
    var _itemObj$list_item = itemObj.list_item,
        itemId = _itemObj$list_item.item_id,
        isBundle = _itemObj$list_item.is_bundle,
        _itemObj$list_item$it = _itemObj$list_item.item,
        item = _itemObj$list_item$it === undefined ? {} : _itemObj$list_item$it,
        _itemObj$list_item$pr = _itemObj$list_item.price,
        itemPrice = _itemObj$list_item$pr === undefined ? {} : _itemObj$list_item$pr,
        _itemObj$list_item$in = _itemObj$list_item.inventory,
        inventory = _itemObj$list_item$in === undefined ? {} : _itemObj$list_item$in,
        _itemObj$list_item$pr2 = _itemObj$list_item.promotion_info,
        promotionInfo = _itemObj$list_item$pr2 === undefined ? [{}] : _itemObj$list_item$pr2;
    var cin = item.cin,
        name = item.name,
        brand = item.brand,
        bundleItemCount = item.bundle_item_count,
        bundleItemQuantity = item.bundle_item_quantity,
        _item$taxonomy_info = item.taxonomy_info;
    _item$taxonomy_info = _item$taxonomy_info === undefined ? {} : _item$taxonomy_info;
    var aisleId = _item$taxonomy_info.aisle_id,
        deptId = _item$taxonomy_info.dept_id,
        aisleName = _item$taxonomy_info.aisleName,
        deptName = _item$taxonomy_info.dept_name,
        primaryShelf = _item$taxonomy_info.primary_shelf,
        shelfName = _item$taxonomy_info.shelf_name,
        shelfId = _item$taxonomy_info.shelf_id,
        categoryId = _item$taxonomy_info.category_id,
        categoryName = _item$taxonomy_info.category_name,
        categoryType = _item$taxonomy_info.category_type,
        _item$rating_review = item.rating_review;
    _item$rating_review = _item$rating_review === undefined ? {} : _item$rating_review;
    var totalReviewCount = _item$rating_review.total_review_count,
        avgStarRating = _item$rating_review.avg_star_rating,
        _item$images = item.images;
    _item$images = _item$images === undefined ? {} : _item$images;
    var scene7Host = _item$images.scene7_host,
        scene7Id = _item$images.scene7_id,
        _item$icons = item.icons,
        icons = _item$icons === undefined ? [] : _item$icons,
        _item$extended_item_i = item.extended_item_info;
    _item$extended_item_i = _item$extended_item_i === undefined ? {} : _item$extended_item_i;
    var weight = _item$extended_item_i.weight;
    var bundleDiscount = itemPrice.bundle_discount,
        bundledItems = itemPrice.bundled_items,
        _itemPrice$price_info = itemPrice.price_info;
    _itemPrice$price_info = _itemPrice$price_info === undefined ? {} : _itemPrice$price_info;
    var price = _itemPrice$price_info.price,
        pricePerUom = _itemPrice$price_info.price_per_uom,
        salesUnit = _itemPrice$price_info.sales_unit,
        avgWeight = _itemPrice$price_info.avg_weight,
        salePrice = _itemPrice$price_info.sale_price,
        isOnSale = itemPrice.is_on_sale;
    var _inventory$availabili = inventory.availability_info;
    _inventory$availabili = _inventory$availabili === undefined ? {} : _inventory$availabili;
    var maxQuantity = _inventory$availabili.max_quantity,
        availability = _inventory$availabili.availability;
    var _promotionInfo$ = promotionInfo[0],
        _promotionInfo$$base_ = _promotionInfo$.base_promotion;
    _promotionInfo$$base_ = _promotionInfo$$base_ === undefined ? {} : _promotionInfo$$base_;
    var itemPromoType = _promotionInfo$$base_.item_promo_type,
        _promotionInfo$$rollb = _promotionInfo$.rollback;
    _promotionInfo$$rollb = _promotionInfo$$rollb === undefined ? {} : _promotionInfo$$rollb;
    var wasPrice = _promotionInfo$$rollb.was_price,
        _promotionInfo$$links = _promotionInfo$.linksave;
    _promotionInfo$$links = _promotionInfo$$links === undefined ? {} : _promotionInfo$$links;
    var meatStickerDetails = _promotionInfo$$links.meat_sticker_details,
        promoDetail = _promotionInfo$$links.promo_detail,
        promoId = _promotionInfo$$links.promo_id,
        promoOfferType = _promotionInfo$$links.promo_offer_type,
        promoQuantity = _promotionInfo$$links.promo_quantity,
        promoValue = _promotionInfo$$links.promo_value;

    var isLinkSave = promoDetail !== '' && (promoOfferType > 0 || promoOfferType < 16);
    var allMeatStickerTypes = [6, 8, 13, 15];
    var isMeatSticker = allMeatStickerTypes.includes(parseInt(promoOfferType, 10));
    return {
      id: itemId,
      cin: cin,
      productDetails: {
        id: itemId,
        name: name,
        description: '',
        brand: brand,
        isFavourite: favouritesItemIds.includes(itemId)
      },
      ratingAndReview: {
        avgStarRating: avgStarRating,
        totalReviewCount: totalReviewCount
      },
      images: {
        scene7Id: scene7Id,
        scene7Host: scene7Host
      },
      priceDetails: {
        pricePerUnit: price,
        pricePerUOM: pricePerUom,
        wasPrice: wasPrice,
        unit: salesUnit,
        salePrice: salePrice,
        isUnavailable: isUnavailable(availability),
        shouldHidePrice: shouldHidePrice(salePrice, price, isOnSale),
        availability: availability
      },
      promoDetails: {
        bundledItemCount: bundleItemCount,
        bundledItemQuantity: bundleItemQuantity,
        bundleItems: bundledItems,
        isBundle: isBundle,
        bundleDiscount: bundleDiscount,
        meatStickerDetails: meatStickerDetails,
        promoDetail: promoDetail,
        promoId: promoId,
        promoOfferTypeCode: promoOfferType,
        promoQty: promoQuantity,
        promoValue: promoValue,
        type: itemPromoType,
        onSale: isOnSale,
        isLinkSave: isLinkSave,
        isMeatSticker: isMeatSticker
      },
      quantityDetails: {
        type: salesUnit,
        weight: weight,
        averageWeight: avgWeight,
        maxQty: maxQuantity
      },
      taxonomyDetails: {
        aisleId: aisleId,
        aisleName: aisleName,
        catId: categoryId,
        catName: categoryName,
        catType: categoryType,
        deptId: deptId,
        deptName: deptName,
        primaryShelfName: primaryShelf,
        shelfId: shelfId,
        shelfName: shelfName
      },
      iconDetails: {
        infoIcons: icons
      }
    };
  });
  return {
    items: processedItems,
    metadata: {
      placement: placement, strategyId: strategy_id, strategyMessage: strategy_message
    }
  };
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var favouritesListParser = exports.favouritesListParser = function favouritesListParser(data) {
  return data.payload && data.payload.itemList ? data.payload.itemList.split(',') : [];
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _tooltip = __webpack_require__(862);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Title = function Title() {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  return _react2.default.createElement(
    'div',
    { className: 'offers-title' },
    _react2.default.createElement(_icon2.default, { name: 'circlePound' }),
    _react2.default.createElement(
      'span',
      null,
      'Offers we found for you'
    ),
    _react2.default.createElement(
      _tooltip2.default,
      {
        dataAutoId: 'offerInfoIcon',
        category: 'primary',
        message: 'We chose these offers just for you based on your shopping history',
        show: showTooltip,
        closeHandler: function closeHandler() {
          return setShowTooltip(false);
        },
        isAdvanced: true,
        className: 'offers-title__tooltip'
      },
      _react2.default.createElement(_icon2.default, { onClickHandler: function onClickHandler() {
          return setShowTooltip(!showTooltip);
        }, name: 'info' })
    )
  );
};

exports.default = Title;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _useClickAway = __webpack_require__(863);

var _useClickAway2 = _interopRequireDefault(_useClickAway);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

var _tooltipContent = __webpack_require__(864);

var _tooltipContent2 = _interopRequireDefault(_tooltipContent);

__webpack_require__(867);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'tooltip-wrapper';

var Tooltip = function Tooltip(_ref) {
  var dataAutoId = _ref.dataAutoId,
      category = _ref.category,
      size = _ref.size,
      title = _ref.title,
      message = _ref.message,
      position = _ref.position,
      align = _ref.align,
      isAdvanced = _ref.isAdvanced,
      textNoWrap = _ref.textNoWrap,
      children = _ref.children,
      className = _ref.className,
      isError = _ref.isError,
      onHover = _ref.onHover,
      show = _ref.show,
      closeHandler = _ref.closeHandler;

  var tooltipRef = (0, _react.useRef)(null);
  (0, _useClickAway2.default)(tooltipRef, closeHandler);
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classNames2.default)({ blk: blk, mods: [onHover && 'on-hover'] }),
      'aria-label': 'information-tooltip',
      role: 'presentation',
      ref: tooltipRef
    },
    show && _react2.default.createElement(_tooltipContent2.default, {
      dataAutoId: dataAutoId,
      category: category,
      size: size,
      title: title,
      message: message,
      position: position,
      align: align,
      isAdvanced: isAdvanced,
      className: className,
      isError: isError,
      closeHandler: closeHandler,
      textNoWrap: textNoWrap

    }),
    children
  );
};

Tooltip.propTypes = {
  dataAutoId: _propTypes.string,
  category: (0, _propTypes.oneOf)(['primary', 'secondary']),
  size: (0, _propTypes.oneOf)(['regular', 'small']),
  title: _propTypes.string,
  message: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  position: (0, _propTypes.oneOf)(['top', 'bottom']),
  align: (0, _propTypes.oneOf)(['left', 'center', 'right']),
  isAdvanced: _propTypes.bool,
  isError: _propTypes.bool,
  show: _propTypes.bool,
  textNoWrap: _propTypes.bool,
  onHover: _propTypes.bool,
  children: _propTypes.node,
  className: _propTypes.string,
  closeHandler: _propTypes.func
};

Tooltip.defaultProps = {
  dataAutoId: '',
  category: 'primary',
  size: 'regular',
  title: '',
  message: '',
  position: 'top',
  align: 'center',
  isAdvanced: false,
  isError: false,
  show: false,
  textNoWrap: false,
  onHover: false,
  children: null,
  className: '',
  closeHandler: function closeHandler() {}
};

exports.default = (0, _react.memo)(Tooltip);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useClickAway;

var _react = __webpack_require__(10);

function useClickAway(ref, callBackFunction) {
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callBackFunction();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _classNames = __webpack_require__(501);

var _classNames2 = _interopRequireDefault(_classNames);

__webpack_require__(865);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blk = 'tooltip-content';

var TooltipContent = function TooltipContent(_ref) {
  var dataAutoId = _ref.dataAutoId,
      category = _ref.category,
      size = _ref.size,
      title = _ref.title,
      message = _ref.message,
      position = _ref.position,
      align = _ref.align,
      isAdvanced = _ref.isAdvanced,
      textNoWrap = _ref.textNoWrap,
      className = _ref.className,
      isError = _ref.isError,
      closeHandler = _ref.closeHandler;

  var rotate = position === 'bottom' ? '180' : '0';
  var arrowColor = category === 'primary' ? 'charcoal' : 'white';
  var closeColor = category === 'primary' ? 'white' : 'charcoal';

  var _useState = (0, _react.useState)('- 0px'),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipValue = _useState2[0],
      setTooltipValue = _useState2[1];

  var _useState3 = (0, _react.useState)('- 0px'),
      _useState4 = _slicedToArray(_useState3, 2),
      caretValue = _useState4[0],
      setCaretValue = _useState4[1];

  var ref = (0, _react.useRef)();

  (0, _react.useEffect)(function () {
    // Auto position tooltip if causes overflow when align is center
    var toastNode = ref.current;
    var rect = toastNode.getBoundingClientRect();
    var currentClientWidth = document.documentElement.clientWidth;
    var isCausingOverflow = rect.left < 0 || rect.width + rect.left > currentClientWidth;
    if (isCausingOverflow) {
      var extra = currentClientWidth - (rect.left < 0 ? rect.width : rect.width + rect.left);
      setTooltipValue(extra < 0 ? '- ' + Math.abs(extra) + 'px' : '+ ' + extra + 'px');
      setCaretValue(extra < 0 ? '+ ' + Math.abs(extra) + 'px' : '- ' + extra + 'px');
    }
  }, []);

  return _react2.default.createElement(
    'div',
    {
      ref: ref,
      className: (0, _classNames2.default)({
        blk: blk, elt: 'wrapper', className: className, mods: [isAdvanced && 'advanced', position, align]
      }),
      'data-auto-id': dataAutoId,
      style: align === 'center' ? { transform: 'translateX(calc(-50% ' + tooltipValue + '))' } : {}
    },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classNames2.default)({
          blk: blk,
          elt: 'container',
          mods: [category, isAdvanced && 'advanced', textNoWrap && 'text-no-wrap', size, isError && 'error', !title && 'no-title']
        })
      },
      isAdvanced && _react2.default.createElement(
        'div',
        { className: (0, _classNames2.default)({ blk: blk, elt: 'header', mods: [!title && 'no-title'] }) },
        title && _react2.default.createElement(
          'span',
          { className: (0, _classNames2.default)({ blk: blk, elt: 'title' }) },
          title
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: (0, _classNames2.default)({ blk: blk, elt: 'close-button' }),
            onClick: closeHandler
          },
          _react2.default.createElement(_icon2.default, {
            size: 'tiny',
            color: closeColor,
            name: 'close'
          })
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        message
      )
    ),
    _react2.default.createElement(_icon2.default, {
      name: 'caret-down',
      color: arrowColor,
      rotate: rotate,
      className: (0, _classNames2.default)({ blk: blk, elt: 'arrow', mods: [position, align] }),
      style: align === 'center' ? { left: 'calc(50% - 15px ' + caretValue + ')' } : {}
    })
  );
};

TooltipContent.propTypes = {
  dataAutoId: _propTypes.string,
  category: (0, _propTypes.oneOf)(['primary', 'secondary']),
  size: (0, _propTypes.oneOf)(['regular', 'small']),
  title: _propTypes.string,
  message: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  position: (0, _propTypes.oneOf)(['top', 'bottom']),
  align: (0, _propTypes.oneOf)(['left', 'center', 'right']),
  isAdvanced: _propTypes.bool,
  isError: _propTypes.bool,
  textNoWrap: _propTypes.bool,
  className: _propTypes.string,
  closeHandler: _propTypes.func
};

TooltipContent.defaultProps = {
  dataAutoId: '',
  category: 'primary',
  size: 'regular',
  title: '',
  message: '',
  position: 'top',
  align: 'center',
  isAdvanced: false,
  isError: false,
  textNoWrap: false,
  className: '',
  closeHandler: function closeHandler() {}
};

exports.default = (0, _react.memo)(TooltipContent);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(866);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".tooltip-content__wrapper{position:absolute;z-index:70}.tooltip-content__wrapper--advanced{max-width:282px}.tooltip-content__wrapper--top{bottom:100%;padding-bottom:9px}.tooltip-content__wrapper--bottom{top:100%;padding-top:9px}.tooltip-content__wrapper--left{left:0}.tooltip-content__wrapper--center{left:50%;transform:translateX(-50%)}.tooltip-content__wrapper--right{right:0}.tooltip-content__container{box-shadow:0 0 10px 0 rgba(61,61,61,.3);border-radius:4px;overflow:hidden;padding:8px}.tooltip-content__container--primary{background:#3d3d3d;color:#fff}.tooltip-content__container--secondary{background:#fff}.tooltip-content__container--regular{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:400}.tooltip-content__container--advanced,.tooltip-content__container--small{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400}.tooltip-content__container--text-no-wrap{white-space:nowrap;padding:8px 16px}.tooltip-content__container--error{color:#d43030}.tooltip-content__container--no-title{display:flex;flex-direction:row-reverse}.tooltip-content__header{display:flex;align-items:center;justify-content:space-between;padding-bottom:4px}.tooltip-content__header--no-title{align-items:flex-start}.tooltip-content__title{font-weight:700}.tooltip-content__close-button{cursor:pointer;background:none;border:none;display:flex;align-items:center;justify-content:center;height:18px;width:18px}.tooltip-content__arrow{position:absolute;bottom:-9px}.tooltip-content__arrow--top{bottom:-9px}.tooltip-content__arrow--bottom{top:-9px}.tooltip-content__arrow--left{left:0}.tooltip-content__arrow--center{left:calc(50% - 15px)}.tooltip-content__arrow--right{left:calc(100% - 30px)}", ""]);

// exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(868);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./_style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".tooltip-wrapper{position:relative;line-height:normal;display:block;height:30px}.tooltip-wrapper--on-hover .tooltip-content__wrapper{display:none}.tooltip-wrapper--on-hover:hover .tooltip-content__wrapper{display:block}", ""]);

// exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(870);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./personalizedRecommendation-offers.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./personalizedRecommendation-offers.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".offers-grid{min-height:300px;margin:10px auto;-webkit-overflow-scrolling:touch;padding:16px}.offers-title{display:flex;align-items:center;width:50%}.offers-title__tooltip{width:max-content}.view-offers_btn{width:288px}@media (min-width:961px){.offers-grid{display:block;height:auto;max-width:1024px}.offers-title{transform:translateX(96px)}}@media (min-width:1201px){.offers-grid{max-width:1170px}.offers-title{transform:translateX(96px)}}@media (max-width:767px){.offers-title{width:100%}}", ""]);

// exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CMS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(872);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _redux = __webpack_require__(78);

var _cmsState = __webpack_require__(79);

var _header = __webpack_require__(873);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(894);

var _footer2 = _interopRequireDefault(_footer);

var _mainContent = __webpack_require__(898);

var _mainContent2 = _interopRequireDefault(_mainContent);

var _secondaryNav = __webpack_require__(905);

var _secondaryNav2 = _interopRequireDefault(_secondaryNav);

var _MetaTags = __webpack_require__(912);

var _MetaTags2 = _interopRequireDefault(_MetaTags);

var _analytics = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

window.jQuery = _jquery2.default;
window.$ = _jquery2.default;

var CMS = exports.CMS = function (_Component) {
  _inherits(CMS, _Component);

  function CMS() {
    _classCallCheck(this, CMS);

    return _possibleConstructorReturn(this, (CMS.__proto__ || Object.getPrototypeOf(CMS)).apply(this, arguments));
  }

  _createClass(CMS, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCMSData();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var newLocation = this.props.location;
      var location = prevProps.location;

      if (location.pathname !== newLocation.pathname) {
        this.getCMSData();
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var anchorTag = e.target.closest('a');
      var divTag = e.target.closest('div[data-module-name]');
      if (anchorTag && divTag) {
        (0, _analytics.trackSignalEvent)('triggerOmnitureBannerLinkClick', {
          trackingCode: anchorTag.dataset && anchorTag.dataset.trackingcode ? anchorTag.dataset.trackingcode : '',
          moduleName: divTag.dataset && divTag.dataset.moduleName ? divTag.dataset.moduleName : ''
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var metaData = this.props.pageContent.metaContent;
      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          tabIndex: '0',
          role: 'button',
          onKeyDown: function onKeyDown() {},
          onClick: this.handleClick
        },
        metaData ? _react2.default.createElement(_MetaTags2.default, _extends({}, this.props, { pageContent: metaData.configs })) : null,
        _react2.default.createElement(_header2.default, this.props),
        _react2.default.createElement(_secondaryNav2.default, this.props),
        _react2.default.createElement(_mainContent2.default, this.props),
        _react2.default.createElement(_footer2.default, this.props)
      );
    }
  }, {
    key: 'getCMSData',
    value: function getCMSData() {
      var cmsActions = this.props.cmsActions;

      cmsActions.loadCms();
    }
  }]);

  return CMS;
}(_react.Component);

CMS.propTypes = {
  className: _propTypes.string.isRequired,
  cmsComponents: (0, _propTypes.shape)({}).isRequired,
  pageContent: (0, _propTypes.shape)({}).isRequired,
  location: (0, _propTypes.shape)({}),
  cmsActions: (0, _propTypes.shape)({
    loadCms: _propTypes.func
  })
};

CMS.defaultProps = {
  location: '',
  cmsActions: {
    loadCms: function loadCms(x) {
      return x;
    }
  }
};

var mapStateToProps = function mapStateToProps(_ref) {
  var ui = _ref.ui,
      cmsData = _ref.cmsData;
  return {
    pageContent: cmsData,
    ui: ui
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    cmsActions: (0, _redux.bindActionCreators)(_cmsState.actions, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CMS);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _redux = __webpack_require__(78);

var _search = __webpack_require__(186);

var _asdaCom = __webpack_require__(874);

var _asdaCom2 = _interopRequireDefault(_asdaCom);

var _privacyCentre = __webpack_require__(887);

var _privacyCentre2 = _interopRequireDefault(_privacyCentre);

var _babyClub = __webpack_require__(890);

var _babyClub2 = _interopRequireDefault(_babyClub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = exports.Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'header',
        { className: 'header' },
        this.renderHeader(this.props.appName)
      );
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader(appName) {
      switch (appName) {
        case 'asda-com':
          return _react2.default.createElement(_asdaCom2.default, this.props);
        case 'privacy-centre':
          return _react2.default.createElement(_privacyCentre2.default, this.props);
        case 'baby-club':
          return _react2.default.createElement(_babyClub2.default, this.props);
        default:
          return _react2.default.createElement(_asdaCom2.default, this.props);
      }
    }
  }]);

  return Header;
}(_react.Component);

Header.propTypes = {
  appName: _propTypes.string
};

Header.defaultProps = {
  appName: 'asda-com'
};

var getAppName = function getAppName() {
  var privacyCentre = window.location.pathname.split('/')[1] === 'privacy';
  var babyClub = window.location.pathname.split('/')[1] === 'baby-club';
  if (privacyCentre) {
    return 'privacy-centre';
  }
  if (babyClub) {
    return 'baby-club';
  }
  return 'asda-com';
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    searchRedirects: state.searchRedirects,
    appName: getAppName()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    searchRedirectsActions: (0, _redux.bindActionCreators)(_search.actions, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _Logo = __webpack_require__(521);

var _Logo2 = _interopRequireDefault(_Logo);

var _TopNav = __webpack_require__(877);

var _TopNav2 = _interopRequireDefault(_TopNav);

var _search = __webpack_require__(882);

var _search2 = _interopRequireDefault(_search);

var _HamburgerMenu = __webpack_require__(522);

var _HamburgerMenu2 = _interopRequireDefault(_HamburgerMenu);

__webpack_require__(885);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable import/no-named-as-default */


var Header = function Header(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(
    'div',
    { className: 'header-wrapper' },
    _react2.default.createElement(_HamburgerMenu2.default, null),
    _react2.default.createElement(_Logo2.default, props),
    _react2.default.createElement(_search2.default, props),
    _react2.default.createElement(_TopNav2.default, null)
  );
};

exports.default = Header;

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 16.75 134 52.25\" enable-background=\"new 0 16.75 134 52.25\" xml:space=\"preserve\"><path fill=\"#FFFFFF\" d=\"M131.529,65.957h1.809v-1.695h-1.809V65.957z M127.742,65.957h1.697v-2.1c0-1.355,0.69-2.002,1.817-2.002 h0.089v-1.685c-1.005-0.041-1.562,0.468-1.906,1.25v-1.146h-1.697V65.957L127.742,65.957z M122.482,62.672 c0.133-0.732,0.592-1.207,1.293-1.207c0.713,0,1.16,0.488,1.262,1.207H122.482z M123.941,66.082c1.084,0,1.887-0.4,2.442-1.057 l-0.969-0.816c-0.472,0.412-0.883,0.582-1.449,0.582c-0.76,0-1.295-0.381-1.463-1.113h4.16c0.014-0.148,0.022-0.297,0.022-0.424 c0-1.609-0.916-3.082-2.912-3.082c-1.737,0-2.955,1.334-2.955,2.957v0.021C120.82,64.887,122.146,66.082,123.941,66.082 M118.762,66.051c0.568,0,0.982-0.125,1.34-0.328v-1.291c-0.246,0.127-0.522,0.199-0.838,0.199c-0.379,0-0.547-0.18-0.547-0.551 v-2.426h1.406v-1.377h-1.406v-1.451h-1.693v1.451h-0.717v1.377h0.717v2.691C117.023,65.66,117.725,66.051,118.762,66.051 M114.236,66.051c0.568,0,0.979-0.125,1.338-0.328v-1.291c-0.244,0.127-0.525,0.199-0.836,0.199c-0.381,0-0.547-0.18-0.547-0.551 v-2.426h1.404v-1.377h-1.404v-1.451h-1.695v1.451h-0.713v1.377h0.713v2.691C112.496,65.66,113.199,66.051,114.236,66.051 M107.027,62.672c0.135-0.732,0.592-1.207,1.297-1.207c0.711,0,1.158,0.488,1.26,1.207H107.027z M108.49,66.082 c1.082,0,1.885-0.4,2.443-1.057l-0.972-0.816c-0.469,0.412-0.881,0.582-1.45,0.582c-0.759,0-1.294-0.381-1.462-1.113h4.16 c0.013-0.148,0.022-0.297,0.022-0.424c0-1.609-0.914-3.082-2.909-3.082c-1.742,0-2.959,1.334-2.959,2.957v0.021 C105.365,64.887,106.693,66.082,108.49,66.082 M101.443,64.695c-0.791,0-1.449-0.625-1.449-1.566v-0.021 c0-0.942,0.658-1.567,1.449-1.567s1.461,0.625,1.461,1.567v0.021C102.904,64.08,102.234,64.695,101.443,64.695 M101.879,66.063 c1.416,0,2.721-1.037,2.721-2.934v-0.021c0-1.896-1.328-2.936-2.721-2.936c-0.881,0-1.449,0.393-1.863,0.922v-2.871H98.32v7.734 h1.695v-0.742C100.418,65.67,100.977,66.063,101.879,66.063 M89.842,62.672c0.137-0.732,0.594-1.207,1.295-1.207 c0.715,0,1.162,0.488,1.26,1.207H89.842z M91.305,66.082c1.082,0,1.887-0.4,2.443-1.057l-0.971-0.816 c-0.469,0.412-0.883,0.582-1.451,0.582c-0.758,0-1.293-0.381-1.461-1.113h4.162c0.01-0.148,0.021-0.297,0.021-0.424 c0-1.609-0.916-3.082-2.911-3.082c-1.74,0-2.955,1.334-2.955,2.957v0.021C88.182,64.887,89.51,66.082,91.305,66.082 M84.109,66 h1.541l2.352-5.723H86.24l-1.35,3.803l-1.339-3.803h-1.797L84.109,66z M79.322,65.957h1.695v-5.68h-1.695V65.957z M79.279,59.652 h1.785v-1.43h-1.785V59.652z M72.834,65.957h5.611v-1.484H74.55v-5.932h-1.717L72.834,65.957L72.834,65.957z M66.387,65.957h1.808 v-1.695h-1.808V65.957z M61.958,67.684c1.014,0,1.505-0.434,1.963-1.59l2.297-5.816h-1.762l-1.304,3.867l-1.362-3.867h-1.796 l2.343,5.699c-0.144,0.287-0.301,0.373-0.59,0.373c-0.222,0-0.502-0.096-0.726-0.225l-0.568,1.166 C60.886,67.535,61.345,67.684,61.958,67.684 M55.595,62.672c0.134-0.732,0.592-1.207,1.294-1.207c0.714,0,1.16,0.488,1.26,1.207 H55.595z M57.057,66.082c1.082,0,1.885-0.4,2.443-1.057l-0.972-0.816c-0.468,0.412-0.881,0.582-1.45,0.582 c-0.758,0-1.293-0.381-1.461-1.113h4.161c0.011-0.148,0.022-0.297,0.022-0.424c0-1.609-0.915-3.082-2.911-3.082 c-1.74,0-2.956,1.334-2.956,2.957v0.021C53.934,64.887,55.261,66.082,57.057,66.082 M47.444,65.957h1.695v-3.168 c0-0.764,0.413-1.154,1.059-1.154c0.647,0,1.026,0.391,1.026,1.154v3.168h1.695v-3.678c0-1.303-0.747-2.107-2.03-2.107 c-0.859,0-1.361,0.434-1.751,0.91v-0.805h-1.695L47.444,65.957L47.444,65.957z M43.179,64.695c-0.938,0-1.572-0.73-1.572-1.566 v-0.021c0-0.838,0.58-1.547,1.55-1.547c0.938,0,1.572,0.729,1.572,1.568v0.021C44.729,63.986,44.15,64.695,43.179,64.695 M43.157,66.082c1.863,0,3.246-1.324,3.246-2.953v-0.021c0-1.631-1.372-2.936-3.224-2.936c-1.863,0-3.246,1.324-3.246,2.957v0.021 C39.934,64.781,41.305,66.082,43.157,66.082 M29.8,65.957h1.695v-3.168c0-0.764,0.391-1.154,1.027-1.154 c0.635,0,0.992,0.391,0.992,1.154v3.168h1.695v-3.168c0-0.764,0.391-1.154,1.026-1.154c0.637,0,0.993,0.391,0.993,1.154v3.168h1.695 V62.26c0-1.367-0.758-2.088-2.019-2.088c-0.814,0-1.439,0.318-1.963,0.9c-0.312-0.572-0.904-0.9-1.685-0.9 c-0.858,0-1.372,0.434-1.762,0.91v-0.805H29.8V65.957z M21.323,62.672c0.134-0.732,0.591-1.207,1.294-1.207 c0.713,0,1.16,0.488,1.26,1.207H21.323z M22.784,66.082c1.082,0,1.885-0.4,2.442-1.057l-0.97-0.816 c-0.469,0.412-0.882,0.582-1.45,0.582c-0.758,0-1.294-0.381-1.461-1.113h4.161c0.012-0.148,0.022-0.297,0.022-0.424 c0-1.609-0.915-3.082-2.911-3.082c-1.741,0-2.957,1.334-2.957,2.957v0.021C19.661,64.887,20.988,66.082,22.784,66.082 M15.589,66 h1.539l2.354-5.723H17.72l-1.35,3.803l-1.339-3.803h-1.795L15.589,66z M9.854,64.949c-0.546,0-0.926-0.254-0.926-0.688V64.24 c0-0.51,0.447-0.783,1.171-0.783c0.413,0,0.792,0.084,1.082,0.211v0.285C11.182,64.537,10.646,64.949,9.854,64.949 M9.341,66.063 c0.826,0,1.394-0.285,1.808-0.721v0.615h1.639v-3.295c0-0.764-0.2-1.389-0.646-1.813c-0.423-0.402-1.092-0.636-2.019-0.636 c-1.014,0-1.662,0.181-2.32,0.455l0.423,1.229c0.547-0.189,1.005-0.308,1.652-0.308c0.848,0,1.282,0.371,1.282,1.037v0.097 c-0.424-0.138-0.858-0.232-1.461-0.232c-1.417,0-2.41,0.572-2.41,1.813v0.021C7.289,65.449,8.215,66.063,9.341,66.063 M3.663,66.063 c1.685,0,2.867-0.826,2.867-2.299v-0.021c0-1.293-0.893-1.832-2.476-2.226c-1.35-0.328-1.685-0.486-1.685-0.975v-0.021 c0-0.358,0.345-0.646,1.004-0.646c0.658,0,1.339,0.274,2.03,0.729l0.893-1.229c-0.792-0.602-1.762-0.941-2.9-0.941 c-1.595,0-2.732,0.89-2.732,2.234v0.021c0,1.473,1.015,1.887,2.588,2.266c1.305,0.32,1.573,0.531,1.573,0.943v0.022 c0,0.435-0.424,0.697-1.127,0.697c-0.893,0-1.628-0.351-2.332-0.899L0.35,64.877C1.287,65.67,2.48,66.063,3.663,66.063\"></path><path fill=\"#FFFFFF\" d=\"M105.432,39.926l3.592-11.833l3.584,11.833H105.432z M79.193,43.826h-2.207V27.435h2.178 c3.299,0,6.969,1.365,6.969,8.157C86.133,41.607,82.883,43.826,79.193,43.826 M20.98,39.926l3.666-11.969l3.598,11.969H20.98z M115.543,18.929h-12.314l-7.02,20.299c0.313-1.686,0.367-3.033,0.367-3.619c0-8.503-4.879-16.68-16.342-16.68H67.072l0.037,20.192 c-1.136-5.737-6.385-7.274-12.912-9.256c-2.439-0.751-3.778-1.942-3.29-3.054c0.417-0.969,1.913-1.273,3.729-1.022 c2.77,0.396,4.98,1.322,7.109,2.477l2.909-7.2c-0.656-0.322-5.37-3.148-11.276-3.148c-8.239,0-13.5,4.014-13.5,9.937 c0,5.279,3.254,8.349,9.24,10.067c6.436,1.865,8.069,2.615,7.875,4.465c-0.167,1.594-4.157,3.535-13.919-2.463l-2.9,5.994 l-8.953-26.989h-12.31L7.279,52.479h9.702l1.513-4.752h12.233l1.448,4.752h10.186l-1.155-3.281 c3.444,1.988,7.715,3.808,12.822,3.808c7.828,0,12.057-4.269,13.067-8.358v7.834h13.125c7.823,0,11.918-3.728,14.057-7.713 l-2.685,7.713h9.695l1.573-4.752h12.222l1.405,4.752h10.199L115.543,18.929z\"></path></svg>"

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 42\"><g fill=\"none\" fill-rule=\"nonzero\"><path fill=\"#FD0\" d=\"M113.414 7.476c.109-.146.224-.301.355-.467 2.552-3.258 1.332 1.218 4.42.724 1.881-.3 4.032-3.304.455-4.344-2.72-.792-5.09 2.106-6.08 3.559.281.158.558.328.83.514l.02.014\"></path><path fill=\"#020302\" d=\"M111.48 29.135h-8.143c-2.15 0-3.222-.76-3.222-2.282 0-1.491 2.3-2.235 6.902-2.235 2.884 0 5.338-.84 7.363-2.516 2.148-1.8 3.22-4.142 3.22-7.031 0-2.67-1.011-4.906-3.036-6.707-.365-.321-.749-.618-1.15-.89a10.736 10.736 0 0 0-.848-.526h-.003a10.209 10.209 0 0 0-5.04-1.286c-2.7 0-5.06.87-7.087 2.608-2.147 1.866-3.22 4.13-3.22 6.802 0 1.77.367 3.385 1.104 4.842.828 1.646 1.994 2.764 3.497 3.354v.092c-3.467.747-5.2 2.408-5.2 4.985 0 2.547 1.335 4.081 4.003 4.61.522.186 1.642.278 3.36.278 1.35 0 3.067-.046 5.153-.138 4.724-.28 7.088.838 7.088 3.352 0 1.118-.629 2.097-1.887 2.935l1.381 1.91c2.637-1.396 3.957-3.555 3.957-6.474 0-3.788-2.73-5.681-8.192-5.681m-8.191-18.817c.983-1.738 2.348-2.608 4.097-2.608 1.747 0 3.114.854 4.094 2.562.83 1.428 1.244 3.105 1.244 5.03 0 1.893-.415 3.555-1.244 4.983-.982 1.707-2.347 2.562-4.094 2.562-1.718 0-3.069-.855-4.05-2.562-.828-1.428-1.243-3.09-1.243-4.983 0-1.895.4-3.554 1.196-4.986M140.932 17.866c-.184-3.29-1.028-6.024-2.53-8.198-1.781-2.545-4.204-3.817-7.271-3.817-3.713 0-6.566 1.125-8.56 3.375-1.995 2.252-2.993 5.271-2.993 9.057 0 3.354 1.076 6.025 3.222 8.011 2.057 1.956 4.756 2.935 8.1 2.935 2.854 0 5.185-.807 6.996-2.424l-1.198-1.628c-1.318 1.117-2.975 1.677-4.97 1.677-2.27 0-4.048-.824-5.338-2.47-1.196-1.518-1.794-3.476-1.794-5.868v-.65h16.336zM130.671 7.761c3.618 0 5.383 2.715 5.29 8.15h-11.364c.213-5.433 2.24-8.15 6.077-8.15h-.003zM51.078 17.866c-.183-3.29-1.026-6.024-2.53-8.198-1.78-2.545-4.204-3.817-7.27-3.817-3.713 0-6.566 1.125-8.561 3.375-1.995 2.252-2.991 5.271-2.991 9.057 0 3.354 1.074 6.025 3.22 8.011 2.056 1.956 4.755 2.935 8.1 2.935 2.853 0 5.185-.807 6.996-2.424l-1.197-1.628c-1.32 1.117-2.976 1.677-4.97 1.677-2.27 0-4.05-.824-5.339-2.47-1.195-1.518-1.792-3.476-1.792-5.868v-.65h16.334zM40.817 7.761c3.62 0 5.384 2.715 5.292 8.15H34.742c.214-5.433 2.24-8.15 6.076-8.15h-.001zm54.258-1.445c-.813-.715-1.787-1.07-2.923-1.07-2.116 0-3.912.774-5.384 2.328a9.193 9.193 0 0 0-2.347 4.33h-.09V5.99h-4.787v18.676c0 .962-.222 1.608-.669 1.933-.443.325-1.156.488-2.137.488h-.277v2.003h11.322v-2.003h-.462c-.89 0-1.534-.061-1.932-.186-.706-.218-1.059-.684-1.059-1.397V20.52c0-2.826.506-5.51 1.52-8.057 1.318-3.321 3.174-4.983 5.567-4.983h.091v.092c-.828.53-1.243 1.274-1.243 2.237 0 .807.284 1.459.851 1.954.57.499 1.252.746 2.05.746 2.087 0 3.13-1.132 3.13-3.4 0-1.147-.408-2.078-1.221-2.793zm-30.79-.513c-3.282 0-5.906 1.133-7.868 3.4-1.872 2.142-2.808 4.906-2.808 8.29 0 3.384.936 6.147 2.808 8.289 1.962 2.267 4.586 3.4 7.869 3.4 3.282 0 5.906-1.133 7.869-3.4 1.871-2.142 2.807-4.905 2.807-8.289 0-3.384-.936-6.148-2.807-8.29-1.963-2.267-4.587-3.4-7.87-3.4zm0 21.516c-3.773 0-5.66-3.275-5.66-9.826 0-6.52 1.887-9.781 5.66-9.781 3.774 0 5.66 3.261 5.66 9.781 0 6.55-1.886 9.826-5.66 9.826zM148.525 24.105a3.056 3.056 0 0 0-2.118-.837 3.11 3.11 0 0 0-2.162.837c-.613.562-.92 1.243-.92 2.05 0 .839.307 1.537.92 2.095.614.56 1.336.838 2.162.838.83 0 1.544-.278 2.142-.838.597-.558.896-1.258.896-2.095 0-.807-.307-1.49-.92-2.05M17.652 17.783h1.97c2.21 0 3.317.465 3.317 2.018v1.196c0 1.999-.775 3.272-2.322 4.385-1.435 1.037-3.007 1.555-5.245 1.555-1.712 0-3.274-.38-4.682-1.138-3.315-1.718-4.972-5.014-4.972-10.977 0-3.488.621-6.062 1.864-8.262 1.63-2.88 4.171-4.323 7.626-4.323 2.622 0 4.818.747 6.587 2.238l1.449-1.9c-2.098-1.567-4.723-2.35-7.87-2.35-4.447 0-8.15 1.528-11.105 4.587C1.423 7.744 0 11.285 0 15.428c0 3.894 1.311 7.077 3.936 9.553 2.982 2.832 6.602 4.248 10.857 4.248 3.92 0 7.043-1.163 9.364-3.488 1.38-1.39 2.084-2.995 2.111-4.814l.084-5.017h-8.7v1.875-.002z\"></path></g></svg>"

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopNav = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(37);

var _utility = __webpack_require__(62);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _Profile = __webpack_require__(545);

var _Profile2 = _interopRequireDefault(_Profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopNav = exports.TopNav = function TopNav() {
  return _react2.default.createElement(
    'div',
    { className: 'top-nav' },
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        { className: 'top-nav-btn' },
        _react2.default.createElement(
          _link2.default,
          {
            href: _constants.CUST_HELP_URL,
            className: 'profile-link',
            asAnchor: true
          },
          _react2.default.createElement(_icon2.default, { name: 'help', size: 'medium' }),
          'Help'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'top-nav-btn' },
        _react2.default.createElement(
          _link2.default,
          {
            href: _constants.STORE_LOC_URL + '?' + _constants.STORE_LOC_CMPID.replace('page-name', (0, _utility.getPageName)()),
            asAnchor: true
          },
          _react2.default.createElement(_icon2.default, { name: 'map-pin-filled', size: 'medium' }),
          'Find a store'
        )
      ),
      _react2.default.createElement(_Profile2.default, null)
    )
  );
};

exports.default = TopNav;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountMenu = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactOnclickoutside = __webpack_require__(879);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _link = __webpack_require__(504);

var _link2 = _interopRequireDefault(_link);

var _button = __webpack_require__(506);

var _button2 = _interopRequireDefault(_button);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _constants = __webpack_require__(37);

__webpack_require__(880);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountMenu = function AccountMenu(_ref) {
  var signOut = _ref.signOut,
      setShowAccountMenu = _ref.setShowAccountMenu;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var signOutClickHandler = function signOutClickHandler() {
    setLoading(true);
    signOut().then(function () {
      return setLoading(false);
    });
  };
  AccountMenu.handleClickOutside = function () {
    return setShowAccountMenu(false);
  };
  return _react2.default.createElement(
    'div',
    { className: 'account-menu' },
    _react2.default.createElement('div', { className: 'arrow-up' }),
    _react2.default.createElement(
      'div',
      { className: 'account-menu__header' },
      'Your Account'
    ),
    _react2.default.createElement(
      'div',
      { className: 'account-menu__body' },
      _react2.default.createElement(
        'ul',
        { className: 'account-menu__list' },
        _react2.default.createElement(
          'li',
          { className: 'account-menu__list__item' },
          _react2.default.createElement(
            _link2.default,
            {
              href: _constants.ACCOUNT_LINK,
              asAnchor: true,
              className: 'profile-link',
              dataAutoId: 'btnAccountSettings'
            },
            _react2.default.createElement(_icon2.default, { name: 'settings', size: 'medium' }),
            'Account settings'
          )
        )
      ),
      _react2.default.createElement(
        _button2.default,
        {
          clickHandler: signOutClickHandler,
          className: 'asda-btn--fluid sign-out_btn',
          category: 'secondary',
          loading: loading
        },
        'Sign out'
      )
    )
  );
};

AccountMenu.propTypes = {
  signOut: _propTypes.func.isRequired,
  setShowAccountMenu: _propTypes.func.isRequired
};

var clickOutsideConfig = {
  handleClickOutside: function handleClickOutside() {
    return AccountMenu.handleClickOutside;
  }
};

var withOnClickOutside = (0, _reactOnclickoutside2.default)(AccountMenu, clickOutsideConfig);

exports.default = withOnClickOutside;
exports.AccountMenu = AccountMenu;

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(881);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".top-nav .account-menu{width:248px;height:auto;box-shadow:0 0 10px 0 rgba(61,61,61,.2);background-color:#fff;position:absolute;top:48px;right:0;border-radius:4px}.top-nav .account-menu .arrow-up{width:0;height:0;border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:12px solid #fff;position:absolute;top:-12px;left:112px}.top-nav .account-menu__header{width:100%;height:52px;border-bottom:1px solid #ccc;padding:16px;font-size:18px;font-family:fontSemiBold,sans-serif}.top-nav .account-menu__body{padding:16px}.top-nav .account-menu__list{width:100%;height:auto;font-size:16px;font-family:fontSemiBold,sans-serif;padding:0;margin-bottom:16px}.top-nav .account-menu__list__item{width:100%;height:24px;display:block;padding:0}", ""]);

// exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _constants = __webpack_require__(37);

var _utility = __webpack_require__(62);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

__webpack_require__(883);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(_ref) {
  var sites = _ref.searchRedirects.sites,
      laodSearchRedirects = _ref.searchRedirectsActions.laodSearchRedirects;

  (0, _react.useEffect)(function () {
    laodSearchRedirects();
  }, [laodSearchRedirects]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      term = _useState2[0],
      setTerm = _useState2[1];

  var _useState3 = (0, _react.useState)('groceries'),
      _useState4 = _slicedToArray(_useState3, 2),
      site = _useState4[0],
      setSite = _useState4[1];

  var searchKeywordInRedirects = function searchKeywordInRedirects(sites, inputValue) {
    var siteMatched = null;
    if (!sites) return null;
    sites.map(function (site) {
      if (inputValue === site.toGHS) {
        siteMatched = { toGHS: inputValue };
      } else if (inputValue === site.toGeorge) {
        siteMatched = { toGeorge: inputValue };
      } else if (site.toOther && inputValue === site.toOther.otherKeyword) {
        siteMatched = site.toOther;
      }
      return false;
    });
    return siteMatched;
  };
  var generateCmpId = function generateCmpId(searchTerm, selectedSite, isRedirect, otherSiteTo) {
    var cmpid = '';
    var path = window.location.pathname.split('/');
    var pageName = path[path.length - 1] || 'hp';
    var searchTermE = searchTerm.replace(/\s+/g, '-').toLowerCase();
    var searchTermR = isRedirect ? 'search-redirect-' + searchTermE : 'search-' + searchTermE;
    if (selectedSite === 'groceries') {
      cmpid = '?cmpid=ahc-_-ghs-_-asdacom-_-' + pageName + '-_-' + searchTermR;
    } else if (selectedSite === 'george') {
      cmpid = '&cmpid=ahc-_-geor-_-asdacom-_-' + pageName + '-_-' + searchTermR;
    } else {
      cmpid = '?cmpid=ahc-_-' + otherSiteTo + '-_-asdacom-_-' + pageName + '-_-' + searchTermR;
    }
    return cmpid;
  };
  var submit = function submit(localSite, localTerm) {
    if (!localTerm.trim()) return false;
    var url = null;
    var siteMatched = searchKeywordInRedirects(sites, localTerm) || {};
    var toGHS = siteMatched.toGHS,
        toGeorge = siteMatched.toGeorge,
        otherKeyword = siteMatched.otherKeyword,
        otherSiteTo = siteMatched.otherSiteTo,
        otherLink = siteMatched.otherLink;

    var groceriesUrl = '' + _constants.GROCERIES_SEARCH_URL + localTerm;
    var georgeUrl = '' + _constants.GEORGE_SEARCH_URL + localTerm;
    var noRedirect = (0, _utility.isEmpty)(siteMatched);
    if (localSite === "good-living") {
      url = '' + _constants.GOOD_LIVING_SEARCH_URL + localTerm;
    } else if (noRedirect) {
      url = localSite === 'groceries' ? groceriesUrl : georgeUrl;
      url += generateCmpId(localTerm, localSite, false);
    } else if (toGHS) {
      url = groceriesUrl + generateCmpId(localTerm, 'groceries', true);
    } else if (toGeorge) {
      url = georgeUrl + generateCmpId(localTerm, 'george', true);
    } else if (otherKeyword) {
      url = otherLink + generateCmpId(localTerm, 'other', true, otherSiteTo);
    }
    window.location = url;
    return null;
  };
  return _react2.default.createElement(
    'form',
    {
      className: 'search-box',
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        submit(site, term);
      }
    },
    _react2.default.createElement(
      'select',
      {
        className: 'search-select',
        value: site,
        onChange: function onChange(e) {
          return setSite(e.target.value);
        }
      },
      _react2.default.createElement(
        'option',
        { value: 'groceries' },
        'in Groceries'
      ),
      _react2.default.createElement(
        'option',
        { value: 'george' },
        'in George'
      ),
      _react2.default.createElement(
        'option',
        { value: 'good-living' },
        'in Good living'
      )
    ),
    _react2.default.createElement('input', {
      type: 'search',
      className: 'search-input',
      value: term,
      onChange: function onChange(e) {
        return setTerm(e.target.value);
      },
      placeholder: 'Search for...'
    }),
    _react2.default.createElement(
      'button',
      {
        className: 'search-button',
        onClick: function onClick(e) {
          e.preventDefault();
          submit(site, term);
        },
        type: 'submit'
      },
      _react2.default.createElement(_icon2.default, { name: 'search', color: 'white' })
    )
  );
};

Search.propTypes = {
  searchRedirects: (0, _propTypes.shape)({
    sites: (0, _propTypes.arrayOf)((0, _propTypes.shape)())
  }),
  searchRedirectsActions: (0, _propTypes.shape)({
    laodSearchRedirects: _propTypes.func
  })
};

Search.defaultProps = {
  searchRedirects: {
    sites: []
  },
  searchRedirectsActions: {
    laodSearchRedirects: function laodSearchRedirects(x) {
      return x;
    }
  }
};

exports.default = Search;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(884);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".search-box{position:fixed;top:60px;width:calc(100% - 31px);height:42px;margin:0;border:1px solid #ccc;border-radius:4px;transition:border .2s ease,box-shadow .2s ease}.search-box:hover{box-shadow:0 2px 10px 0 rgba(61,61,61,.1);cursor:default}.search-box .search-input{width:calc(100% - 172px);height:40px;border:none;padding:11px 19px 11px 14px;border-left:1px solid #ccc!important;cursor:default;font-style:normal;font-weight:400;font-size:16px;line-height:17.6px}.search-box .search-input:focus{outline-width:0}.search-box .search-select{width:108px;height:20px;float:left;right:calc(10% + 4px);font-size:14px;color:#3d3d3d;cursor:default;appearance:auto!important;border:none!important;margin:10px 12px;border-radius:unset;padding:0!important;font-style:normal;font-weight:600;line-height:20px}.search-box .search-select:focus{outline-width:0}.search-box .search-button{width:40px;height:40px;border-top-right-radius:4px;border-bottom-right-radius:4px;border-color:#68a51c;color:#fff;background-color:#68a51c;cursor:pointer;float:right;box-shadow:none;border:none}.search-box .search-button:focus{outline-color:#78be20}@media (min-width:961px){.search-box{width:calc(50% - 116px);position:relative;top:0}.search-box .search-input{width:calc(100% - 172px)}.search-box .search-select{right:44px}.search-box .search-button{width:40px}}", ""]);

// exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(886);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./header.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, "header{background-color:#fff;box-shadow:0 2px 4px 0 #cdcdcd;position:fixed;width:100%;top:0;z-index:2001}.header-wrapper{height:112px;margin:0 auto;padding:16px;display:flex;justify-content:space-between;position:relative}#logo{flex-shrink:0;display:flex;height:24px;margin:4px 10% 9px 8px}#logo .asda-icon--large{width:auto}#logo .asda-icon--large svg{width:auto;height:24px}.menu-hamburger{text-align:center;align-self:flex-start}.search-bar{position:absolute;z-index:10;transform:scaleY(0);transition:transform .3s ease;transform-origin:top;width:100%;height:60px;top:60px;background-color:#ebf1f5;left:0}.search-bar.open{transform:scaleY(1);border-top:2px solid #cdcdcd}.search-form{display:flex;height:100%;justify-content:space-around;align-items:center}.search-form .icon-drop-down{position:absolute;right:12px;top:17px;height:7px;width:7px}.search-form .icon-search{position:absolute;right:0;left:auto;top:0;font-size:15px;cursor:pointer;padding:12px}.search-combo{width:48%;height:40px;position:relative}.search-select{width:100%;height:40px;padding:0 8px;color:#191919;font-size:16px;border:1px solid #b9b9b9;outline-color:#78be20;appearance:none;border-radius:0;background:#fff}.search-term{height:40px;width:48%;position:relative}.search-field{width:100%;height:100%;font-size:16px;outline-color:#78be20;border:1px solid #b9b9b9;padding:10px}.search-field.invalid{border-color:#da291c}.search-error-message{color:#da291c;background-color:#fff;font-size:.75em;font-family:fontRegular,sans-serif;padding:15px 10px;height:40px;z-index:200;position:relative;user-select:none}.search-error-message .close{position:absolute;top:15px;right:15px;width:14px;height:14px;cursor:pointer;color:#000}.top-nav{font-size:18px;position:relative;height:40px}.top-nav ul{list-style:none;margin:0;color:#191919}.top-nav ul li{padding:0 5px;float:right}.top-nav ul li a{font-size:18px}.top-nav .profile-link{display:none}.icon-pin{display:flex;justify-content:center;margin-bottom:2px}.top-nav-btn a,.top-nav-btn button{align-items:center;background:#fff;border:none;cursor:pointer;color:#191919;display:flex}.top-nav-btn a span,.top-nav-btn button span{font-family:fontRegular,sans-serif;margin-left:5px;color:#191919}.find-store-mobile-text{display:inline}.find-store-text{display:none}@media (min-width:481px){#logo{margin:4px 10px}.header-wrapper{padding:10px;justify-content:flex-start}.menu-hamburger{padding:0 5px}.top-nav{margin-left:auto}.top-nav ul{display:flex;font-size:18px;align-items:center;height:40px}.top-nav ul li{border-left:1px solid #eee;display:flex;padding:0 8px 0 16px;font-size:12px;flex-shrink:0;text-decoration:none}.top-nav ul li:first-child{border-left:0}.top-nav ul li span{margin-right:4px}.top-nav ul li a{margin:auto;text-decoration:none;color:#fff;display:flex;font-size:18px}.top-nav ul li a:hover,.top-nav ul li a:link,.top-nav ul li a:visited{color:inherit}.top-nav ul li:not(:first-child){display:flex}.top-nav ul li span{margin-left:5px}.top-nav ul li.sign-in_btn{padding:0;height:40px}.top-nav ul li.sign-in_btn .asda-btn--primary:disabled{background:#fff}.top-nav ul li.sign-in_btn a{height:40px;color:#fff}.top-nav .profile-link{display:flex;padding-right:12px}}@media (min-width:961px){header{box-shadow:none}.header-wrapper{height:72px;max-width:1024px;padding:10px 0;padding:16px 0}.menu-hamburger{display:none}#logo{margin:0 32px 0 0}#logo .asda-icon--large svg{height:40px}.search-select{width:100%;height:100%;border-radius:4px;color:#565555}.search-combo{width:36%;height:40px;margin-right:8px}.search-form .icon-drop-down{top:18px}.search-field{width:100%;height:100%;border-radius:4px}.search-term{height:40px;width:75%}.search-bar{width:40%;transform:translate(0);transition:none;position:static;background:#fff}.search-bar.open{transform:translate(0);border-top:none}.top-nav ul li{font-size:18px;height:24px;width:auto;margin-right:8px;margin-left:0}.top-nav ul li.sign-in_btn{padding:0;height:40px}.top-nav ul li.sign-in_btn a{height:40px;color:#fff}.top-nav ul li:hover span{text-decoration:underline}}@media (min-width:1201px){.header-wrapper{max-width:1150px}}@media (min-width:768px){.layout__section{min-height:640px}.layout__title{font-size:28px;letter-spacing:.3px;line-height:36px;font-weight:600}}@media (min-width:1024px){.layout__section{display:flex}.layout__main{flex:1 1 auto}}@media (min-width:1280px){.site-width.layout__section{margin:0 auto;max-width:1392px;padding:0 16px}.site-width.layout__main{flex:1 1 auto}}.header[data-apply-onetrust=true],.header[data-apply-onetrust=true]~button.menu-close,.header[data-apply-onetrust=true]~nav.main-nav{margin-top:70px}.header[data-apply-onetrust=true]~.main-content{margin-top:184px}@media (max-width:1041px){.header[data-apply-onetrust=true],.header[data-apply-onetrust=true]~button.menu-close,.header[data-apply-onetrust=true]~nav.main-nav{margin-top:87px}.header[data-apply-onetrust=true]~.main-content{margin-top:201px}}@media (max-width:1023px){.header[data-apply-onetrust=true],.header[data-apply-onetrust=true] .search-box,.header[data-apply-onetrust=true]~button.menu-close,.header[data-apply-onetrust=true]~nav.main-nav{margin-top:112px}.header[data-apply-onetrust=true]~.main-content{margin-top:226px}}@media (max-width:662px){.header[data-apply-onetrust=true],.header[data-apply-onetrust=true] .search-box,.header[data-apply-onetrust=true]~button.menu-close,.header[data-apply-onetrust=true]~nav.main-nav{margin-top:129px}.header[data-apply-onetrust=true]~.main-content{margin-top:226px}}@media (max-width:505px){.header[data-apply-onetrust=true],.header[data-apply-onetrust=true] .search-box,.header[data-apply-onetrust=true]~button.menu-close,.header[data-apply-onetrust=true]~nav.main-nav{margin-top:148px}.header[data-apply-onetrust=true]~.main-content{margin-top:261px}}@media (max-width:355px){.header[data-apply-onetrust=true],.header[data-apply-onetrust=true] .search-box,.header[data-apply-onetrust=true]~button.menu-close,.header[data-apply-onetrust=true]~nav.main-nav{margin-top:167px}.header[data-apply-onetrust=true]~.main-content{margin-top:280px}}.onetrust-consent-sdk-box[data-apply-ot-banner-popup=true] .onetrust-pc-dark-filter.ot-hide{display:block!important}.onetrust-consent-sdk-box #onetrust-banner-sdk:focus{outline-color:none!important;outline-width:0!important}.onetrust-consent-sdk-box #onetrust-banner-sdk{background-color:#fff!important;max-width:500px;min-width:500px;width:100%;top:23%;left:50%!important;transform:translate(-50%,-25%);padding:16px 22px 16px 24px;border-radius:2px;z-index:2147483646!important}.onetrust-consent-sdk-box #onetrust-banner-sdk #onetrust-accept-btn-handler{background-color:#0073b1;border-color:#0073b1;color:#fff;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:700;border-radius:4px}.onetrust-consent-sdk-box #onetrust-banner-sdk #onetrust-pc-btn-handler{background-color:#fff;border:1px solid #0073b1;color:#0073b1;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:700;border-radius:4px}.onetrust-consent-sdk-box #onetrust-banner-sdk #onetrust-group-container button{color:#0073b1;display:inline}.onetrust-consent-sdk-box #onetrust-banner-sdk #onetrust-policy-title,.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-dpd-title{width:100%!important;font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:600}.onetrust-consent-sdk-box #onetrust-banner-sdk #onetrust-policy-text{width:100%!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;line-height:1.5}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-b-addl-desc{width:100%!important;border-right:none;color:#000}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-dpd-content .ot-dpd-desc{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;line-height:1.5}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-dpd-container{width:100%!important;padding:0!important}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row{display:flex;flex-direction:column}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-group-container{width:100%}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-group-container h3,.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-group-container p{color:#000}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-button-group-parent{position:relative!important;width:100%;left:auto!important;top:auto;transform:translateY(0);right:0}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-button-group-parent #onetrust-button-group{display:flex;justify-content:space-evenly}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-button-group-parent #onetrust-button-group #onetrust-accept-btn-handler,.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container .ot-sdk-row #onetrust-button-group-parent #onetrust-button-group #onetrust-pc-btn-handler{margin-right:0;max-width:112px;width:100%;margin-top:1em}.onetrust-consent-sdk-box #onetrust-banner-sdk #onetrust-policy{margin:0}.onetrust-consent-sdk-box #onetrust-pc-sdk{background-color:#fff!important;color:#000;max-width:500px!important;min-width:100%;padding:7px 16px 25px}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-pc-content{overflow-x:hidden}.onetrust-consent-sdk-box #onetrust-pc-sdk :focus{outline:none!important}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-anchor,.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-fltr-cnt{background-color:#fff!important}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-fltr-cnt{width:auto}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-sel-blk{background-color:#fff}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-pc-header{padding:0}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-category-title,.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-pc-content,.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-pc-title{color:#000!important;width:auto;margin:0;padding:0;font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:600;padding-bottom:5px}.onetrust-consent-sdk-box #onetrust-pc-sdk #onetrust-group-container button{color:#0073b1}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-pc-desc,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-accordion-layout .ot-cat-header{color:#000!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;line-height:1.5!important;min-height:20px}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-lst-title span{color:#000!important;font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:600;line-height:1.5}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-name{color:#000!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;font-weight:400!important;line-height:1.5}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-pc-desc{margin-bottom:10px}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-pc-desc .privacy-notice-link{color:#0073b1;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:700;text-decoration:none}.onetrust-consent-sdk-box #onetrust-pc-sdk #accept-recommended-btn-handler,.onetrust-consent-sdk-box #onetrust-pc-sdk #filter-apply-handler,.onetrust-consent-sdk-box #onetrust-pc-sdk #filter-cancel-handler,.onetrust-consent-sdk-box #onetrust-pc-sdk .save-preference-btn-handler{background-color:#0073b1!important;border-color:#0073b1!important;color:#fff!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:700;margin-bottom:10px;border-radius:4px;margin-right:25px}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-cat-grp{margin-top:0}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-acc-grpdesc,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-label-txt,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-subgrp-desc,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-subgrp h5,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-dets p,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-dets span,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-disc h4{color:#000!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;font-size:12px!important}.onetrust-consent-sdk-box #onetrust-pc-sdk #clear-filters-handler,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-dets h4,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-pur h4{color:#000!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:700}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-ven-link,.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-vlst-cntr a{color:#0073b1!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;padding:0}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-vlst-cntr button{color:#0073b1!important;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-tgl input:checked+.ot-switch .ot-switch-nob{background-color:#0073b1;border:1px solid #fff}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-tgl input:checked+.ot-switch .ot-switch-nob:before{background-color:#fff;border-color:#fff;width:9px;height:9px}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-switch{width:28px;height:11px;padding:1px 1px 1px 4px}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-switch-nob:before{background-color:#fff;width:9px;height:9px;border-radius:5.5px}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-switch-nob{background-color:#767676;border-radius:5.5px;padding-left:1px}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-acc-hdr{min-height:auto}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-always-active{color:#000;font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:600}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-pc-footer-logo a{margin-right:25px}.onetrust-consent-sdk-box #onetrust-pc-sdk #filter-btn-handler{width:30px;height:30px;border-radius:4px;background-color:#538316}.onetrust-consent-sdk-box #onetrust-pc-sdk #ot-sel-blk{background-color:#fff!important}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-chkbox label:before{border:1px solid #538316}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-chkbox input:checked~label:before{background-color:#538316}.onetrust-consent-sdk-box #onetrust-pc-sdk .ot-plus-minus{width:15px;height:15px}.onetrust-consent-sdk-box #onetrust-pc-sdk #vendor-search-handler{border-radius:4px}@media (min-width:1024px){.onetrust-consent-sdk-box #onetrust-banner-sdk{height:fit-content!important}}@media (min-width:768px) and (max-width:1023px){.onetrust-consent-sdk-box #onetrust-banner-sdk{top:23%;max-width:452px;min-width:452px;height:fit-content!important}}@media (max-width:767px){.onetrust-consent-sdk-box #onetrust-banner-sdk{top:28%;max-width:480px;min-width:325px;height:fit-content!important}.onetrust-consent-sdk-box #onetrust-banner-sdk .ot-sdk-container{padding:0}}@media (min-width:768px){.onetrust-consent-sdk-box #onetrust-pc-sdk{min-width:500px!important}}", ""]);

// exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _Logo = __webpack_require__(521);

var _Logo2 = _interopRequireDefault(_Logo);

var _HamburgerMenu = __webpack_require__(522);

var _HamburgerMenu2 = _interopRequireDefault(_HamburgerMenu);

__webpack_require__(888);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var homeUrl = _ref.homeUrl;
  return _react2.default.createElement(
    'div',
    { className: 'header-wrapper' },
    _react2.default.createElement(_HamburgerMenu2.default, null),
    _react2.default.createElement(
      _Logo2.default,
      { homeUrl: homeUrl },
      _react2.default.createElement(
        'span',
        { className: 'p-centre' },
        'Privacy Centre'
      )
    )
  );
}; /* eslint-disable import/no-named-as-default */


Header.propTypes = {
  homeUrl: _propTypes.string
};

Header.defaultProps = {
  homeUrl: '/privacy'
};

exports.default = Header;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(889);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./header.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".privacy .header-wrapper{justify-content:flex-start;height:64px}.header-wrapper .p-centre{font-size:14px;letter-spacing:.3px;color:#666;font-weight:500;margin-left:10px;line-height:1;padding-top:10px}@media (min-width:768px){.privacy .header-wrapper{height:72px;max-width:1024px;padding:10px 0}.privacy .header-wrapper #logo{margin-left:10px}.privacy .menu-hamburger{display:none}.header-wrapper .p-centre{font-size:24px;letter-spacing:.5px;padding-top:18px}}@media (min-width:1201px){.privacy .header-wrapper{max-width:1150px}}", ""]);

// exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _Logo = __webpack_require__(521);

var _Logo2 = _interopRequireDefault(_Logo);

var _HamburgerMenu = __webpack_require__(522);

var _HamburgerMenu2 = _interopRequireDefault(_HamburgerMenu);

var _TopNav = __webpack_require__(891);

var _TopNav2 = _interopRequireDefault(_TopNav);

__webpack_require__(892);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
var Header = function Header(_ref) {
  var homeUrl = _ref.homeUrl;
  return _react2.default.createElement(
    'div',
    { className: 'header-wrapper' },
    _react2.default.createElement(_HamburgerMenu2.default, null),
    _react2.default.createElement(_Logo2.default, { homeUrl: homeUrl }),
    _react2.default.createElement(_TopNav2.default, null)
  );
};

Header.propTypes = {
  homeUrl: _propTypes.string
};

Header.defaultProps = {
  homeUrl: '/baby-club'
};

exports.default = Header;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopNav = undefined;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(181);

var _utility = __webpack_require__(62);

var _constants = __webpack_require__(37);

var _Profile = __webpack_require__(545);

var _Profile2 = _interopRequireDefault(_Profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopNav = exports.TopNav = function TopNav() {
  return _react2.default.createElement(
    'div',
    { className: 'top-nav' },
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        { className: 'find-store' },
        _react2.default.createElement(
          'a',
          {
            href: _constants.STORE_LOC_URL + '?' + _constants.STORE_LOC_CMPID.replace('page-name', (0, _utility.getPageName)())
          },
          _react2.default.createElement('i', { className: 'icon-pin' }),
          'Find a store'
        )
      ),
      _react2.default.createElement(_Profile2.default, { isBabyClubHeader: true })
    )
  );
};

exports.default = (0, _reactRedux.connect)()(TopNav);

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(893);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./header.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".baby-club .header-wrapper{justify-content:flex-start;height:64px;padding:12px 16px}.baby-club .header-wrapper #logo{align-items:flex-start}.baby-club .header-wrapper #logo .asda-icon--large svg{height:40px}.baby-club .header-wrapper .top-nav{margin-left:auto}.baby-club .header-wrapper .top-nav .find-store{display:none}.baby-club .header-wrapper .baby-club-name{letter-spacing:.3px;color:#68a51c;font-weight:500;margin-left:6px;line-height:1;padding-top:10px;font-family:fontRegular,sans-serif;font-size:16px}.baby-club .header-wrapper .baby-login{float:right}.baby-club .top-nav.baby-nav{font-size:16px;margin:0 0 2px;font-weight:700;font-family:fontRegular,sans-serif;display:none}.baby-club .top-nav.baby-nav ul{list-style:none;margin:0;color:#191919}.baby-club .top-nav.baby-nav ul li{padding:5px 20px;float:right}.baby-club .top-nav.baby-nav ul li .icon-pin{float:left;padding:2px 5px 0 0}.baby-club .top-nav.baby-nav ul li:last-child{display:none;border-right:none}@media (min-width:481px){.baby-club .header-wrapper .baby-club-name{letter-spacing:.3px;color:#68a51c;font-weight:500;margin-left:10px;line-height:1;padding-top:16px;font-family:fontRegular,sans-serif;font-size:20px}.baby-club .header-wrapper .baby-login{float:right}.baby-club .header-wrapper .top-nav .find-store{display:block;margin-right:8px}}@media (min-width:768px){.baby-club .baby-club-name{font-size:30px;letter-spacing:-.5px;padding-top:25px}.baby-club .top-nav.baby-nav{margin-left:auto;display:block}.baby-club .top-nav.baby-nav ul{display:flex;font-size:16px;align-items:center;height:50px}.baby-club .top-nav.baby-nav ul li{border-left:2px solid #fff;display:flex}.baby-club .top-nav.baby-nav ul li a{margin:auto;text-decoration:none;color:#fff}.baby-club .top-nav.baby-nav ul li a:hover,.baby-club .top-nav.baby-nav ul li a:link,.baby-club .top-nav.baby-nav ul li a:visited{color:inherit}.baby-club .top-nav.baby-nav ul li:not(:first-child){display:flex}.baby-club .top-nav.baby-nav ul li.find-store{font-size:12px;flex-shrink:0;text-decoration:none}.baby-club .top-nav.baby-nav ul li.find-store i{font-size:14px}.baby-club .top-nav.baby-nav ul li.find-store span{margin-left:5px}.baby-club .top-nav.baby-nav ul li.grey-bg{background-color:#485152;height:50px;color:#fff;width:130px}.baby-club .top-nav.baby-nav ul li.green-bg{background-color:#78be20;height:50px;width:80px}.baby-club .top-nav.baby-nav ul li:first-child{display:flex;border-right:none}.baby-club .top-nav.baby-nav ul li:nth-child(2),.baby-club .top-nav.baby-nav ul li:nth-child(3){display:none}}@media (min-width:961px){.baby-club .header-wrapper{height:72px;max-width:1024px;padding:10px 0}.baby-club .header-wrapper #logo{margin-left:10px}.baby-club .header-wrapper #logo img{width:179px;height:53px}.baby-club .header-wrapper #logo .asda-icon--large svg{height:52px}.baby-club .header-wrapper .top-nav ul li:first-child{display:flex}.baby-club .header-wrapper .top-nav ul li:nth-child(2),.baby-club .header-wrapper .top-nav ul li:nth-child(3){display:block}.baby-club .header-wrapper .baby-club-name{font-size:24px;letter-spacing:-.4px;padding-top:18px}}@media (min-width:1201px){.baby-club .header-wrapper{max-width:1150px}.baby-club .header-wrapper .top-nav.baby-nav ul li:last-child{padding-right:0}}", ""]);

// exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _CMSModules = __webpack_require__(523);

var _CMSModules2 = _interopRequireDefault(_CMSModules);

__webpack_require__(895);

var _MiniFooter = __webpack_require__(897);

var _MiniFooter2 = _interopRequireDefault(_MiniFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Footer = function Footer(props) {
  var data = props.pageContent,
      rest = _objectWithoutProperties(props, ['pageContent']);

  return _react2.default.createElement(
    'footer',
    null,
    data ? _react2.default.createElement(_CMSModules2.default, _extends({}, rest, { contents: data.footerContent })) : null,
    _react2.default.createElement(_MiniFooter2.default, null)
  );
};

Footer.propTypes = {
  pageContent: (0, _propTypes.shape)({}).isRequired
};

exports.default = Footer;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(896);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./footer.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./footer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, "footer{background:#383838;font-family:fontRegular,sans-serif;font-size:14px;clear:both}#main-footer,#mini-footer{margin:0 auto;max-width:1024px}#main-footer{padding:20px 0}.footer-content .footer-plus-icon{margin-left:30px;background:#fff;opacity:.8;padding:0 5px;border-radius:14px;font-size:16px;cursor:pointer;color:#767676;font-weight:700}.footer-content h3{display:inline-block;color:#78be20;font-size:14px;font-weight:400;margin-left:20px;line-height:25px}.footer-content ul{list-style:none;display:none}.footer-content li{line-height:36px;margin-left:20px}.footer-content li a{color:#fff;text-decoration:none}.footer-content li a:hover{color:#78be20}.footer-content.open ul{display:block;margin:0 55px}.copy-right{padding-bottom:30px;text-align:center}.copy-right p{font-size:13px;color:#fff}.footer-social{display:flex;justify-content:space-around}.footer-social a{text-decoration:none;font-size:32px;color:#fff}.footer-logo-wapper{margin:30px auto;text-align:center;width:120px;height:35px;background-repeat:no-repeat;background-image:linear-gradient(transparent,transparent),url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA5Ni4xIDI4LjMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDk2LjEgMjguMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNzksMTcuNmwyLjktOS41bDIuOSw5LjVINzl6IE01Ny45LDIwLjhoLTEuOFY3LjZoMS44YzIuNywwLDUuNiwxLjEsNS42LDYuNkM2My41LDE5LDYwLjgsMjAuOCw1Ny45LDIwLjgKCSBNMTEsMTcuNkwxNCw4bDIuOSw5LjZIMTF6IE04Ny4xLDAuN2gtOS45TDcxLjUsMTdjMC4zLTEuNCwwLjMtMi40LDAuMy0yLjljMC02LjgtMy45LTEzLjQtMTMuMi0xMy40SDQ4LjFWMTcKCWMtMC45LTQuNi01LjEtNS45LTEwLjQtNy40Yy0yLTAuNi0zLTEuNi0yLjYtMi41YzAuMy0wLjgsMS41LTEsMy0wLjhjMi4yLDAuMyw0LDEuMSw1LjcsMmwyLjMtNS44QzQ1LjYsMi4yLDQxLjgsMCwzNywwCgljLTYuNiwwLTEwLjksMy4yLTEwLjksOGMwLDQuMiwyLjYsNi43LDcuNCw4LjFjNS4yLDEuNSw2LjUsMi4xLDYuMywzLjZjLTAuMSwxLjMtMy4zLDIuOC0xMS4yLTJsLTIuMSw0LjhMMTkuMywwLjhIOS40TDAsMjcuOGg3LjgKCUw5LDI0aDkuOGwxLjIsMy44aDguMmwtMC45LTIuNmMyLjgsMS42LDYuMiwzLjEsMTAuMywzLjFjNi4zLDAsOS43LTMuNCwxMC41LTYuN3Y2LjNoMTAuNmM2LjMsMCw5LjYtMywxMS4zLTYuMmwtMi4yLDYuMmg3LjgKCWwxLjMtMy44aDkuOGwxLjEsMy44SDk2TDg3LjEsMC43eiIvPgo8L3N2Zz4K)}@media (min-width:481px){#main-footer .footer-wrapper{display:flex;justify-content:flex-start;flex-wrap:wrap;margin:0 32px}.footer-content{flex-basis:50%}.footer-content .footer-plus-icon{display:none}.footer-content h3{margin-left:0;font-size:22px;display:block}.footer-content ul{display:block}.footer-content ul li{margin-left:0}#mini-footer{display:flex;padding:20px 0}.footer-logo-wapper{order:-1;margin:0 auto 0 0;flex-shrink:1;flex-basis:24%;text-align:left}.footer-social{flex-basis:51%;justify-content:flex-start}.footer-social a{margin-right:20px}.copy-right{padding:0;flex-basis:25%}.copy-right p{text-align:left;color:#fff}}@media (min-width:768px){.footer-content{flex-basis:33%}}@media (min-width:961px){.footer-content{flex-basis:25%}}@media (min-width:1201px){#main-footer .footer-wrapper{margin:0}#main-footer,#mini-footer{max-width:1150px}}", ""]);

// exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiniFooter = function MiniFooter() {
  return _react2.default.createElement(
    "div",
    { id: "mini-footer" },
    _react2.default.createElement(
      "div",
      { className: "footer-social" },
      _react2.default.createElement(
        "a",
        {
          href: "https://www.facebook.com/Asda",
          className: "social-link social-link-facebook ",
          target: "_blank",
          rel: "noopener noreferrer"
        },
        _react2.default.createElement("i", { className: "icon-facebook" })
      ),
      _react2.default.createElement(
        "a",
        {
          href: "https://twitter.com/asda/",
          className: "social-link social-link-twitter",
          target: "_blank",
          rel: "noopener noreferrer"
        },
        _react2.default.createElement("i", { className: "icon-twitter" })
      ),
      _react2.default.createElement(
        "a",
        {
          href: "https://www.instagram.com/asda/",
          className: "social-link social-link-instagram",
          target: "_blank",
          rel: "noopener noreferrer"
        },
        _react2.default.createElement("i", { className: "icon-instagram" })
      ),
      _react2.default.createElement(
        "a",
        {
          href: "https://www.pinterest.com/asda/",
          className: "social-link social-link-pintrest",
          target: "_blank",
          rel: "noopener noreferrer"
        },
        _react2.default.createElement("i", { className: "icon-pintrest" })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "footer-logo-wapper" },
      _react2.default.createElement("div", { className: "footer-logo" })
    ),
    _react2.default.createElement(
      "div",
      { className: "copy-right" },
      _react2.default.createElement(
        "p",
        null,
        "\xA9 ASDA",
        new Date().getFullYear()
      )
    )
  );
};

exports.default = MiniFooter;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _CMSModules = __webpack_require__(523);

var _CMSModules2 = _interopRequireDefault(_CMSModules);

var _loader = __webpack_require__(899);

var _loader2 = _interopRequireDefault(_loader);

__webpack_require__(902);

var _observer = __webpack_require__(904);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */


var MainContent = function MainContent(props) {
  var data = props.pageContent,
      dispatch = props.dispatch,
      rest = _objectWithoutProperties(props, ['pageContent', 'dispatch']);

  (0, _react.useEffect)(function () {
    var boxElList = document.querySelectorAll('div[data-module]');
    var observer = new IntersectionObserver((0, _observer.observerCallback)(), _observer.options);
    boxElList.forEach(function (el) {
      observer.observe(el);
    });
  }, []);

  return _react2.default.createElement(
    'div',
    { className: 'main-content' },
    _react2.default.createElement('div', {
      className: 'menu-overlay',
      onClick: function onClick() {
        return dispatch({ type: 'TOGGLE_NAV' });
      }
    }),
    data ? _react2.default.createElement(_CMSModules2.default, _extends({}, rest, { contents: data.mainContent })) : null
  );
};

exports.MainContent = MainContent;
MainContent.propTypes = {
  pageContent: (0, _propTypes.shape)({}).isRequired,
  dispatch: _propTypes.func.isRequired
};

exports.default = (0, _loader2.default)('pageContent')((0, _reactRedux.connect)()(MainContent));

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(900);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-prototype-builtins */


var LoaderHOC = function LoaderHOC(propName) {
  return function (WrappedComponent) {
    return function (_Component) {
      _inherits(LoaderHOC, _Component);

      function LoaderHOC() {
        _classCallCheck(this, LoaderHOC);

        return _possibleConstructorReturn(this, (LoaderHOC.__proto__ || Object.getPrototypeOf(LoaderHOC)).apply(this, arguments));
      }

      _createClass(LoaderHOC, [{
        key: 'isEmpty',
        value: function isEmpty(prop) {
          return prop === null || prop === undefined || prop.mainContent && prop.mainContent.hasOwnProperty('length') && prop.mainContent.length === 0 || prop.hasOwnProperty('length') && prop.length === 0 || prop.constructor === Object && Object.keys(prop).length === 0;
        }
      }, {
        key: 'render',
        value: function render() {
          return this.isEmpty(this.props[propName]) || this.props[propName].isFetching ? _react2.default.createElement(
            'div',
            { className: 'main-content' },
            _react2.default.createElement(
              'div',
              { id: 'loading' },
              _react2.default.createElement(
                'div',
                { className: 'animation' },
                _react2.default.createElement('div', { className: 'circle' }),
                _react2.default.createElement('div', { className: 'circle' }),
                _react2.default.createElement('div', { className: 'circle' }),
                _react2.default.createElement('div', { className: 'circle' })
              )
            )
          ) : _react2.default.createElement(WrappedComponent, this.props);
        }
      }]);

      return LoaderHOC;
    }(_react.Component);
  };
};

exports.default = LoaderHOC;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(901);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./loader.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./loader.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, "@keyframes circle1{0%{left:0;top:0;width:40px;height:40px;z-index:100}25%{left:70px;top:0;width:40px;height:40px;z-index:100}50%{left:140px;top:0;width:40px;height:40px;z-index:100}75%{left:140px;top:20px;width:0;height:0;z-index:0}76%{left:20px;top:20px;width:0;height:0;z-index:0}to{left:0;top:0;width:40px;height:40px;z-index:100}}@keyframes circle2{0%{left:70px;top:0;width:40px;height:40px;z-index:100}25%{left:140px;top:0;width:40px;height:40px;z-index:100}50%{left:140px;top:20px;width:0;height:0;z-index:0}51%{left:20px;top:20px;width:0;height:0;z-index:0}75%{left:0;top:0;width:40px;height:40px;z-index:100}to{left:70px;top:0;width:40px;height:40px;z-index:100}}@keyframes circle3{0%{left:140px;top:0;width:40px;height:40px;z-index:100}25%{left:140px;top:20px;width:0;height:0;z-index:0}26%{left:20px;top:20px;width:0;height:0;z-index:0}50%{left:0;top:0;width:40px;height:40px;z-index:100}75%{left:70px;top:0;width:40px;height:40px;z-index:100}to{left:140px;top:0;width:40px;height:40px;z-index:100}}@keyframes circle4{0%{left:20px;top:20px;width:0;height:0;z-index:0}25%{left:0;top:0;width:40px;height:40px;z-index:100}50%{left:70px;top:0;width:40px;height:40px;z-index:100}75%{left:140px;top:0;width:40px;height:40px;z-index:100}to{left:140px;top:20px;width:0;height:0;z-index:0}}#loading{display:block;margin:0 auto;padding:calc(50vh - 141px) 0 calc(50vh - 80px);width:180px;height:40px}#loading,#loading .animation{position:relative}#loading .animation .circle{position:absolute;background-color:#d9dddf;border-radius:100%;border:1px solid #d9dddf;animation-name:circle1;animation-duration:1.1s;animation-iteration-count:infinite}#loading .animation .circle:nth-child(2){background-color:#b8babd;border-color:#b8babd;animation-name:circle2}#loading .animation .circle:nth-child(3){background-color:#a3a3ab;border-color:#a3a3ab;animation-name:circle3}#loading .animation .circle:nth-child(4){background-color:#efefef;border-color:#efefef;animation-name:circle4}", ""]);

// exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(903);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./main-content.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./main-content.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".main-content{margin-top:112px;min-height:550px}.baby-club .main-content,.privacy .main-content{margin-top:65px}body.no-scroll{overflow:hidden}@media (min-width:768px){.baby-club .main-content,.privacy .main-content{margin-top:121px}}@media (min-width:961px){.wrapper{max-width:1024px}.main-content{margin-top:121px}.menu-overlay{display:none}}@media (min-width:1201px){.wrapper{max-width:1150px}}", ""]);

// exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTargetElement = exports.observerCallback = exports.options = undefined;

var _analytics = __webpack_require__(114);

var options = exports.options = {
  root: document.querySelector(".home-page"),
  rootMargin: '0px',
  threshold: 0.9
};

var observerCallback = exports.observerCallback = function observerCallback(entries, observer) {
  var visited = {};

  return function (entries, observer) {

    entries.forEach(function (entry) {
      var dataModuleId = entry.target.getAttributeNode("data-module-id").value;
      if (entry.isIntersecting && !visited[dataModuleId]) {
        visited[dataModuleId] = 'visited';
        (0, _analytics.triggerScrollDepth)();
      }
    });
  };
};

var createTargetElement = exports.createTargetElement = function createTargetElement(el) {
  return document.querySelector(el);
};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */


var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _redux = __webpack_require__(78);

var _CMSModules = __webpack_require__(523);

var _CMSModules2 = _interopRequireDefault(_CMSModules);

var _bodyClass = __webpack_require__(906);

var _bodyClass2 = _interopRequireDefault(_bodyClass);

var _MobileProfile = __webpack_require__(907);

var _MobileProfile2 = _interopRequireDefault(_MobileProfile);

var _button = __webpack_require__(506);

var _button2 = _interopRequireDefault(_button);

var _actions = __webpack_require__(183);

var profileActions = _interopRequireWildcard(_actions);

var _icon = __webpack_require__(502);

var _icon2 = _interopRequireDefault(_icon);

var _utility = __webpack_require__(62);

var _constants = __webpack_require__(37);

__webpack_require__(910);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondaryNav = exports.SecondaryNav = function SecondaryNav(props) {
  var isOpen = props.ui.leftNavOpen,
      data = props.pageContent,
      dispatch = props.dispatch,
      ui = props.ui,
      signOut = props.signOut,
      isSignedIn = props.isSignedIn;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var wrapperRef = (0, _react.useRef)(null);
  var signOutClickHandler = function signOutClickHandler() {
    setLoading(true);
    signOut().then(function () {
      return dispatch({ type: 'TOGGLE_NAV' });
    });
  };
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        dispatch({ type: "CLOSE_LEFT_NAV" });
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  (0, _react.useEffect)(function () {
    if (isOpen) {

      var firstEl = document.querySelector(".menu-close");
      var lastEl = isSignedIn ? document.querySelector(".asda-btn--fluid") : document.getElementById("help");

      firstEl.focus();

      var keydownHandlerLast = function keydownHandlerLast(e) {
        var evt = e || window.event;
        var keyCode = evt.which || evt.keyCode;
        if (keyCode === 9) {
          if (evt.preventDefault) evt.preventDefault();else evt.returnValue = false;
          firstEl.focus();
        }
      };

      var keydownHandlerFirst = function keydownHandlerFirst(e) {
        var evt = e || window.event;
        var keyCode = evt.which || evt.keyCode;
        if (keyCode === 9 && evt.shiftKey) {
          if (evt.preventDefault) evt.preventDefault();else evt.returnValue = false;
          lastEl.focus();
        }
      };

      if (lastEl.addEventListener) lastEl.addEventListener('keydown', keydownHandlerLast, false);
      if (firstEl.addEventListener) firstEl.addEventListener('keydown', keydownHandlerFirst, false);
    }
  }, [isOpen]);

  var isBabyClubHeader = (0, _utility.getRequestOriginFromUrl)() === 'btc';
  return _react2.default.createElement(
    _bodyClass2.default,
    { noScroll: isOpen },
    isOpen ? _react2.default.createElement('div', { className: 'background-shadow' }) : null,
    isOpen ? _react2.default.createElement(
      _button2.default,
      {
        className: 'menu-close',
        isIcon: true,
        clickHandler: function clickHandler() {
          return dispatch({ type: 'TOGGLE_NAV' });
        }
      },
      _react2.default.createElement(_icon2.default, {
        name: 'close',
        size: 'large',
        color: 'white'
      })
    ) : null,
    _react2.default.createElement(
      'nav',
      { className: isOpen ? 'main-nav open' : 'main-nav', ref: wrapperRef },
      _react2.default.createElement(_MobileProfile2.default, { isBabyClubHeader: isBabyClubHeader }),
      _react2.default.createElement(
        'div',
        { className: 'main-nav-section' },
        data ? _react2.default.createElement(_CMSModules2.default, _extends({}, props, {
          contents: data.secondaryNav,
          ui: ui
        })) : null,
        _react2.default.createElement(
          'ul',
          { className: 'extended-menu', role: 'none' },
          _react2.default.createElement(
            'li',
            { className: 'custom-link' },
            _react2.default.createElement(
              'a',
              { className: '', id: 'help', href: _constants.CUST_HELP_URL },
              'Help'
            )
          ),
          isSignedIn ? _react2.default.createElement(
            'li',
            { className: 'custom-link' },
            _react2.default.createElement(
              'a',
              { className: '', href: _constants.ACCOUNT_LINK },
              'Account'
            )
          ) : null
        )
      ),
      isSignedIn ? _react2.default.createElement(
        'div',
        { className: 'main-nav__footer' },
        _react2.default.createElement(
          _button2.default,
          {
            clickHandler: signOutClickHandler,
            className: 'asda-btn--fluid',
            category: 'secondary',
            loading: loading
          },
          'Sign out'
        )
      ) : null
    )
  );
};

SecondaryNav.propTypes = {
  ui: (0, _propTypes.shape)({
    leftNavOpen: _propTypes.bool
  }).isRequired,
  pageContent: (0, _propTypes.shape)({}).isRequired,
  dispatch: _propTypes.func.isRequired,
  signOut: _propTypes.func.isRequired,
  isSignedIn: _propTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(_ref) {
  var profile = _ref.profile;
  return {
    isSignedIn: profile.isSignedIn
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    signOut: (0, _redux.bindActionCreators)(profileActions.signOut, dispatch),
    dispatch: dispatch
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SecondaryNav);

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(10);

var _propTypes = __webpack_require__(12);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodyClass = function (_Component) {
  _inherits(BodyClass, _Component);

  function BodyClass() {
    _classCallCheck(this, BodyClass);

    return _possibleConstructorReturn(this, (BodyClass.__proto__ || Object.getPrototypeOf(BodyClass)).apply(this, arguments));
  }

  _createClass(BodyClass, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // IE11 classList.toggle is not working as expected.
      if (!this.isIE11()) {
        document.body.classList.toggle('no-scroll', this.props.noScroll);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // IE11 classList.toggle is not working as expected.
      if (!this.isIE11()) {
        document.body.classList.toggle('no-scroll', nextProps.noScroll);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.classList.remove('no-scroll');
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }, {
    key: 'isIE11',
    value: function isIE11() {
      return !!window.MSInputMethodContext && !!document.documentMode;
    }
  }]);

  return BodyClass;
}(_react.Component);

BodyClass.propTypes = {
  noScroll: _propTypes.bool,
  children: _propTypes.node.isRequired
};

BodyClass.defaultProps = {
  noScroll: false
};

exports.default = BodyClass;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _reactRedux = __webpack_require__(181);

var _button = __webpack_require__(506);

var _button2 = _interopRequireDefault(_button);

var _constants = __webpack_require__(37);

__webpack_require__(908);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileProfile = function MobileProfile(_ref) {
  var isSignedIn = _ref.isSignedIn,
      firstName = _ref.firstName,
      isBabyClubMember = _ref.isBabyClubMember,
      isBabyClubHeader = _ref.isBabyClubHeader;
  return _react2.default.createElement(
    'div',
    { className: 'mobile-profile' },
    isSignedIn && _react2.default.createElement(
      _react.Fragment,
      null,
      isBabyClubHeader && !isBabyClubMember ? _react2.default.createElement(
        _button2.default,
        {
          href: _constants.BTC_REGISTER_LINK,
          className: 'full',
          category: 'secondary',
          asAnchor: true
        },
        'Join Asda Baby club'
      ) : _react2.default.createElement(
        'h3',
        null,
        'Hi ',
        firstName || 'there'
      )
    ),
    !isSignedIn ? _react2.default.createElement(
      _react.Fragment,
      null,
      !isBabyClubHeader && _react2.default.createElement(
        _button2.default,
        {
          href: _constants.REGISTER_LINK,
          category: 'secondary',
          asAnchor: true
        },
        'Register'
      ),
      _react2.default.createElement(
        _button2.default,
        {
          href: _constants.SIGNIN_LINK,
          className: isBabyClubHeader ? 'full' : 'mobile-right',
          category: 'secondary',
          asAnchor: true
        },
        isBabyClubHeader ? 'Join Asda Baby club' : 'Sign in'
      )
    ) : null
  );
};

MobileProfile.propTypes = {
  isSignedIn: _propTypes.bool.isRequired,
  firstName: _propTypes.string,
  isBabyClubMember: _propTypes.bool.isRequired,
  isBabyClubHeader: _propTypes.bool
};

MobileProfile.defaultProps = {
  firstName: '',
  isBabyClubHeader: false
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var profile = _ref2.profile;
  var firstName = profile.profile.additionalInfo.firstName,
      isSignedIn = profile.isSignedIn,
      isBabyClubMember = profile.isBabyClubMember;

  return {
    isSignedIn: isSignedIn,
    firstName: firstName,
    isBabyClubMember: isBabyClubMember
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MobileProfile);

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(909);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".mobile-profile{width:100%;height:64px;padding:12px 16px;border-bottom:1px solid #eee;margin:0}.mobile-profile h3{margin:0;padding:8px 0}.mobile-profile .asda-btn{width:116px;margin:0 8px 0 0}.mobile-profile .asda-btn.mobile-right{margin:0 0 0 8px}.mobile-profile .asda-btn.full{width:100%}@media (min-width:768px){.mobile-profile{display:none}}", ""]);

// exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(911);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(499)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./navigation.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js??ref--1-3!./navigation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498)(undefined);
// imports


// module
exports.push([module.i, ".main-nav{width:280px;transform:translateX(-280px);transition:transform .3s ease;z-index:4000;position:fixed;background:#fff;top:0;left:0;box-shadow:2px 2px 4px 0 rgba(0,0,0,.26);font-family:fontRegular,sans-serif;display:none}@media (min-width:961px){.main-nav{z-index:2000}}.main-nav.open{transform:translateX(0);height:100%;display:block}.main-nav.open+.main-content .menu-overlay{position:fixed;top:0;width:100%;height:100%;opacity:.4;background-color:#191919;z-index:1500}.main-nav.open .main-nav-section{overflow-y:scroll;padding-bottom:200px;height:100%}.main-nav.open .main-nav-section .sub-menu-container div{width:100%}.main-nav.open .main-nav-section .sub-menu-container div a{cursor:pointer}.main-nav.open .main-nav-section .sub-menu-container div a:after{font-family:asda-dot-com-icons!important;content:\"\\E900\";position:absolute;right:16px;top:8px}.main-nav.open .main-nav-section .sub-menu-container div a #icon{display:none}.main-nav.open .main-nav-section .sub-menu-container.active{background:#fff;height:100%!important}.main-nav.open .main-nav-section .sub-menu-container.active .sub-menu{text-shadow:.8px 0 0 currentColor}.main-nav ul{margin:0}.main-nav ul li{height:18px;letter-spacing:-.3px;color:#191919;font-size:13px;margin-bottom:16px;display:flex;align-items:center;position:relative}.main-nav ul li.sub-menu{display:none}.main-nav ul li .icon-chevron-right.reverse{padding:0 20px;line-height:40px;cursor:pointer;transform:rotate(180deg);display:inline-block}.main-nav ul li a{display:block;padding:0 16px;width:100%;font-size:18px}.main-nav ul li a.selected,.main-nav ul li a:hover{background-color:#e9e9e9;text-shadow:.8px 0 0 currentColor}.main-nav ul.extended-menu li,.main-nav ul:nth-last-child(2) li{height:40px;font-size:18px;margin-bottom:0}.main-nav ul.extended-menu li{padding:8px 0}.main-nav ul.extended-menu li:first-child{border-top:1px solid #eee}.main-nav__footer{width:100%;height:72px;padding:16px;position:fixed;bottom:0;box-shadow:0 -2px 4px 0 rgba(0,0,0,.2);background-color:#fff}.main-nav .submenu-nav{display:none}.background-shadow{width:calc(100% - 280px);height:100vh;background-color:rgba(0,0,0,.6);position:absolute;top:0;right:0;z-index:3000;transition:background-color .3s ease}.menu-close{position:absolute;left:280px;top:0;background:transparent;z-index:4000}@media (min-width:321px){.sub-menu-container button{width:100%;height:57px;border:none;text-align:left;border-bottom:1px solid #eee;background:#fff;display:flex;align-items:center;position:fixed;top:0;left:0;padding:0 16px;z-index:4000}.sub-menu-container button span{margin-right:16px}.sub-menu-container .submenu-nav li{border:none;width:100%;min-width:100px;height:fit-content}.sub-menu-container .submenu-nav li:first-child{margin-top:20px}.sub-menu-container .submenu-nav li:last-child{margin-bottom:50px}.sub-menu-container .submenu-nav.open{overflow-y:scroll;height:calc(100% - 60px);display:block;width:100%;transition:transform .3s ease;z-index:4000;position:fixed;background:#fff;top:57px;left:0;font-family:fontRegular,sans-serif}}@media (min-width:250px){.sub-menu-container button{width:100%;height:57px;border:none;text-align:left;border-bottom:1px solid #eee;background:#fff;display:flex;align-items:center;position:fixed;top:0;left:0;padding:0 16px;z-index:4000}.sub-menu-container button span{margin-right:16px}.sub-menu-container .submenu-nav li{border:none;width:100%;min-width:100px;height:fit-content}.sub-menu-container .submenu-nav li:first-child{margin-top:20px}.sub-menu-container .submenu-nav li:last-child{margin-bottom:50px}.sub-menu-container .submenu-nav.open{overflow-y:scroll;height:calc(100% - 60px);display:block;width:100%;transition:transform .3s ease;z-index:4000;position:fixed;background:#fff;top:57px;left:0;font-family:fontRegular,sans-serif}}@media (min-width:768px){.privacy .main-nav{display:block;background-color:#f6f6f6;transform:translateX(0);transition:none;font-size:18px;position:fixed;top:72px;width:100%;max-height:48px}.privacy .main-nav ul{margin:0 auto;padding:0;list-style:none;display:flex;align-items:center;justify-content:space-between;max-width:1190px;height:50px}.privacy .main-nav ul:first-child{display:flex}.privacy .main-nav ul:first-child li{margin:0}.privacy .main-nav ul.extended-menu{display:none}.privacy .main-nav ul:nth-child(2){margin-top:-2px;margin-bottom:0}.privacy .main-nav ul .sub-menu-container div{width:100%}.privacy .main-nav ul .sub-menu-container div a{cursor:pointer;display:flex;align-items:center;justify-content:center}.privacy .main-nav ul .sub-menu-container div a:after{font-family:asda-dot-com-icons!important;content:\"\\E900\";position:absolute;right:16px;top:8px}.privacy .main-nav ul .sub-menu-container div a #icon{display:flex;align-items:center}.privacy .main-nav ul .sub-menu-container div a #icon svg{height:15px;width:15px}.privacy .main-nav ul .sub-menu-container div a .submenu-hamburger-label{margin-right:12px}.privacy .main-nav ul .sub-menu-container.active{background:#fff;height:100%!important}.privacy .main-nav ul .sub-menu-container.active .sub-menu{text-shadow:.8px 0 0 currentColor}.privacy .main-nav ul .sub-menu-container .submenu-nav{justify-content:space-between;overflow-y:auto;max-height:500px}.privacy .main-nav ul .sub-menu-container .submenu-nav li{border:none;width:100%;min-width:100px;height:fit-content}.privacy .main-nav ul .sub-menu-container .submenu-nav li:first-child{margin-top:20px}.privacy .main-nav ul .sub-menu-container .submenu-nav li:last-child{margin-bottom:0}.privacy .main-nav ul .sub-menu-container .submenu-nav li:last-child a{padding:6px 16px 16px}.privacy .main-nav ul .sub-menu-container .submenu-nav li a{width:100%;height:100%;color:#3d3d3d;font-size:18px;border:none;padding:6px 16px;text-align:start;display:block}.privacy .main-nav ul .sub-menu-container .submenu-nav li a:hover{background-color:#f6f6f6;text-shadow:.8px 0 0 currentColor}.privacy .main-nav ul li{width:100%;height:50px;padding:0;font-size:18px;letter-spacing:-.3px;display:flex;align-items:center}.privacy .main-nav ul li.sub-menu{display:flex;width:100%}.privacy .main-nav ul li.sub-menu.active a .submenu-hamburger-inner,.privacy .main-nav ul li.sub-menu.active a .submenu-hamburger-inner:after,.privacy .main-nav ul li.sub-menu.active a .submenu-hamburger-inner:before,.privacy .main-nav ul li.sub-menu:hover a .submenu-hamburger-inner,.privacy .main-nav ul li.sub-menu:hover a .submenu-hamburger-inner:after,.privacy .main-nav ul li.sub-menu:hover a .submenu-hamburger-inner:before{background-color:#000}.privacy .main-nav ul li.sub-menu .sub-nav{display:flex;align-items:center;justify-content:center}.privacy .main-nav ul li:first-child a{border-left:1px solid #767676}.privacy .main-nav ul li a{border-right:1px solid #767676;text-decoration:none;color:#3d3d3d;text-align:center;line-height:24px;height:24px;display:flex;justify-content:center;align-items:center}.privacy .main-nav ul li a.selected{height:100%;display:flex;justify-content:center;align-items:center;border:none;background-color:#e9e9e9;color:#191919;font-weight:500}.privacy .main-nav ul li a.selected:hover{background-color:#e9e9e9}.privacy .main-nav ul li a:after{display:none}.privacy .main-nav ul li a:hover{background-color:#fff;text-decoration:underline}.privacy .main-nav ul li a span{z-index:4001}.privacy .main-nav ul li:hover{height:100%;background-color:#fff}}@media (min-width:961px){.main-nav{display:block;background-color:#f6f6f6;transform:translateX(0);transition:none;font-size:18px;position:fixed;top:72px;width:100%;max-height:48px}.main-nav ul:nth-last-child(2) li:first-child,.main-nav ul:nth-last-child(2) li:nth-child(3),.main-nav ul:nth-last-child(2) li:nth-last-child(2){border-bottom:0}.main-nav ul{margin:0 auto;padding:0;list-style:none;display:flex;align-items:center;justify-content:space-between;max-width:1190px;height:50px}.main-nav ul:first-child{display:flex}.main-nav ul:first-child li{margin:0}.main-nav ul.extended-menu{display:none}.main-nav ul:nth-child(2){margin-top:-2px;margin-bottom:0}.main-nav ul .sub-menu-container div{width:100%}.main-nav ul .sub-menu-container div a{cursor:pointer;display:flex;align-items:center;justify-content:center}.main-nav ul .sub-menu-container div a:after{font-family:asda-dot-com-icons!important;content:\"\\E900\";position:absolute;right:16px;top:8px}.main-nav ul .sub-menu-container div a #icon{display:flex;align-items:center}.main-nav ul .sub-menu-container div a #icon svg{height:15px;width:15px}.main-nav ul .sub-menu-container div a .submenu-hamburger-label{margin-right:12px}.main-nav ul .sub-menu-container.active{background:#fff;height:100%!important}.main-nav ul .sub-menu-container.active .sub-menu{text-shadow:.8px 0 0 currentColor}.main-nav ul .sub-menu-container .submenu-nav{justify-content:space-between;overflow-y:auto;max-height:500px}.main-nav ul .sub-menu-container .submenu-nav li{border:none;width:100%;min-width:100px;height:fit-content}.main-nav ul .sub-menu-container .submenu-nav li:first-child{margin-top:20px}.main-nav ul .sub-menu-container .submenu-nav li:last-child{margin-bottom:0}.main-nav ul .sub-menu-container .submenu-nav li:last-child a{padding:6px 16px 16px}.main-nav ul .sub-menu-container .submenu-nav li a{width:100%;height:100%;color:#3d3d3d;font-size:18px;border:none;padding:6px 16px;text-align:start;display:block}.main-nav ul .sub-menu-container .submenu-nav li a:hover{background-color:#f6f6f6;text-shadow:.8px 0 0 currentColor}.main-nav ul li{height:50px;padding:0;font-size:18px;letter-spacing:-.3px;align-items:center}.main-nav ul li,.main-nav ul li.sub-menu{width:100%;display:flex}.main-nav ul li.sub-menu.active a .submenu-hamburger-inner,.main-nav ul li.sub-menu.active a .submenu-hamburger-inner:after,.main-nav ul li.sub-menu.active a .submenu-hamburger-inner:before,.main-nav ul li.sub-menu:hover a .submenu-hamburger-inner,.main-nav ul li.sub-menu:hover a .submenu-hamburger-inner:after,.main-nav ul li.sub-menu:hover a .submenu-hamburger-inner:before{background-color:#000}.main-nav ul li.sub-menu .sub-nav{display:flex;align-items:center;justify-content:center}.main-nav ul li:first-child a{border-left:1px solid #767676}.main-nav ul li a{border-right:1px solid #767676;text-decoration:none;color:#3d3d3d;text-align:center;line-height:24px;height:24px}.main-nav ul li a,.main-nav ul li a.selected{display:flex;justify-content:center;align-items:center}.main-nav ul li a.selected{height:100%;border:none;background-color:#e9e9e9;color:#191919;font-weight:500}.main-nav ul li a.selected:hover{background-color:#e9e9e9}.main-nav ul li a:after{display:none}.main-nav ul li a:hover{background-color:#fff;text-decoration:underline}.main-nav ul li a span{z-index:4001}.main-nav ul li:hover{height:100%;background-color:#fff}.main-nav__footer{display:none}.submenu-hamburger{position:relative;display:inline-block;width:22px;height:15px;margin-right:15px}.submenu-hamburger-inner{top:2px}.submenu-hamburger-inner,.submenu-hamburger-inner:before{position:absolute;width:22px;height:3px;background-color:#fff}.submenu-hamburger-inner:before{display:block;content:\"\";top:6px}.submenu-hamburger-inner:after{background-color:#fff;position:absolute;width:22px;height:3px;display:block;content:\"\";top:12px}.sub-menu-container button{display:none}.sub-menu-container .submenu-nav{background-color:#fff;width:100%}.sub-menu-container .submenu-nav.open{display:flex;flex-direction:column;position:absolute;top:47px;height:fit-content;background-color:#fff}.main-nav-section{max-width:1024px;margin:0 auto}.background-shadow{display:none}.background-shadow-large{width:100%;height:100vh;background-color:rgba(0,0,0,.6);position:absolute;top:48px;right:0;z-index:3000;transition:background-color .3s ease}}@media (min-width:1201px){.main-nav-section{max-width:1150px}.background-shadow{display:none}.background-shadow-large{width:100%;height:100vh;background-color:rgba(0,0,0,.6);position:absolute;top:48px;right:0;z-index:3000;transition:background-color .3s ease}}", ""]);

// exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(913);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _propTypes = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MetaTags = function MetaTags(_ref) {
  var data = _ref.pageContent;
  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    _react2.default.createElement(
      'title',
      null,
      data.title
    ),
    _react2.default.createElement('meta', { name: 'description', content: data.metaDescription }),
    _react2.default.createElement('meta', { property: 'og:title', content: data.title }),
    _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
    _react2.default.createElement('meta', { property: 'og:url', content: window.location.href }),
    _react2.default.createElement('meta', { property: 'og:site_name', content: 'www.asda.com' }),
    _react2.default.createElement('meta', { property: 'og:description', content: data.metaDescription })
  );
};

MetaTags.propTypes = {
  pageContent: (0, _propTypes.shape)({
    metaDescription: _propTypes.string,
    title: _propTypes.string
  })
};

MetaTags.defaultProps = {
  pageContent: {
    metaDescription: '',
    title: 'Asda.com'
  }
};

exports.default = MetaTags;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(914);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(917);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(918);

var _HelmetConstants = __webpack_require__(546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(10);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(915));
var shallowEqual = _interopDefault(__webpack_require__(916));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 916 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(115);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ })
]));


// WEBPACK FOOTER //
// dot_com_ui/js/0-bundle-b618f8a399618261f59e.js